webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/babel-polyfill/lib/index.js");
	module.exports = __webpack_require__("./js/bootstrap.js");


/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "../node_modules/core-js/shim.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/es6.symbol.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.create.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.define-property.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.define-properties.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.get-prototype-of.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.keys.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.get-own-property-names.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.freeze.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.seal.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.prevent-extensions.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.is-frozen.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.is-sealed.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.is-extensible.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.assign.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.is.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.set-prototype-of.js");
	__webpack_require__("../node_modules/core-js/modules/es6.object.to-string.js");
	__webpack_require__("../node_modules/core-js/modules/es6.function.bind.js");
	__webpack_require__("../node_modules/core-js/modules/es6.function.name.js");
	__webpack_require__("../node_modules/core-js/modules/es6.function.has-instance.js");
	__webpack_require__("../node_modules/core-js/modules/es6.parse-int.js");
	__webpack_require__("../node_modules/core-js/modules/es6.parse-float.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.constructor.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.to-fixed.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.to-precision.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.epsilon.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.is-finite.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.is-integer.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.is-nan.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.is-safe-integer.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.max-safe-integer.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.min-safe-integer.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.parse-float.js");
	__webpack_require__("../node_modules/core-js/modules/es6.number.parse-int.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.acosh.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.asinh.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.atanh.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.cbrt.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.clz32.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.cosh.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.expm1.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.fround.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.hypot.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.imul.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.log10.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.log1p.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.log2.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.sign.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.sinh.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.tanh.js");
	__webpack_require__("../node_modules/core-js/modules/es6.math.trunc.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.from-code-point.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.raw.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.trim.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.iterator.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.code-point-at.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.ends-with.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.repeat.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.starts-with.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.anchor.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.big.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.blink.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.bold.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.fixed.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.fontcolor.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.fontsize.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.italics.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.link.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.small.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.strike.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.sub.js");
	__webpack_require__("../node_modules/core-js/modules/es6.string.sup.js");
	__webpack_require__("../node_modules/core-js/modules/es6.date.now.js");
	__webpack_require__("../node_modules/core-js/modules/es6.date.to-json.js");
	__webpack_require__("../node_modules/core-js/modules/es6.date.to-iso-string.js");
	__webpack_require__("../node_modules/core-js/modules/es6.date.to-string.js");
	__webpack_require__("../node_modules/core-js/modules/es6.date.to-primitive.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.is-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.from.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.of.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.join.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.slice.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.sort.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.for-each.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.map.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.filter.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.some.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.every.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.reduce.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.reduce-right.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.index-of.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.last-index-of.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.copy-within.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.fill.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.find-index.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.species.js");
	__webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.constructor.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.to-string.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.flags.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.match.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.replace.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.search.js");
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.split.js");
	__webpack_require__("../node_modules/core-js/modules/es6.promise.js");
	__webpack_require__("../node_modules/core-js/modules/es6.map.js");
	__webpack_require__("../node_modules/core-js/modules/es6.set.js");
	__webpack_require__("../node_modules/core-js/modules/es6.weak-map.js");
	__webpack_require__("../node_modules/core-js/modules/es6.weak-set.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.array-buffer.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.data-view.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.int8-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.uint8-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.int16-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.uint16-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.int32-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.uint32-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.float32-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.typed.float64-array.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.apply.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.construct.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.define-property.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.delete-property.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.enumerate.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.get.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.get-prototype-of.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.has.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.is-extensible.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.own-keys.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.prevent-extensions.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.set.js");
	__webpack_require__("../node_modules/core-js/modules/es6.reflect.set-prototype-of.js");
	__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
	__webpack_require__("../node_modules/core-js/modules/es7.string.at.js");
	__webpack_require__("../node_modules/core-js/modules/es7.string.pad-start.js");
	__webpack_require__("../node_modules/core-js/modules/es7.string.pad-end.js");
	__webpack_require__("../node_modules/core-js/modules/es7.string.trim-left.js");
	__webpack_require__("../node_modules/core-js/modules/es7.string.trim-right.js");
	__webpack_require__("../node_modules/core-js/modules/es7.string.match-all.js");
	__webpack_require__("../node_modules/core-js/modules/es7.symbol.async-iterator.js");
	__webpack_require__("../node_modules/core-js/modules/es7.symbol.observable.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.define-getter.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.define-setter.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.lookup-getter.js");
	__webpack_require__("../node_modules/core-js/modules/es7.object.lookup-setter.js");
	__webpack_require__("../node_modules/core-js/modules/es7.map.to-json.js");
	__webpack_require__("../node_modules/core-js/modules/es7.set.to-json.js");
	__webpack_require__("../node_modules/core-js/modules/es7.system.global.js");
	__webpack_require__("../node_modules/core-js/modules/es7.error.is-error.js");
	__webpack_require__("../node_modules/core-js/modules/es7.math.iaddh.js");
	__webpack_require__("../node_modules/core-js/modules/es7.math.isubh.js");
	__webpack_require__("../node_modules/core-js/modules/es7.math.imulh.js");
	__webpack_require__("../node_modules/core-js/modules/es7.math.umulh.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.define-metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.delete-metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.get-metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.get-metadata-keys.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.get-own-metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.has-metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.has-own-metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.reflect.metadata.js");
	__webpack_require__("../node_modules/core-js/modules/es7.asap.js");
	__webpack_require__("../node_modules/core-js/modules/es7.observable.js");
	__webpack_require__("../node_modules/core-js/modules/web.timers.js");
	__webpack_require__("../node_modules/core-js/modules/web.immediate.js");
	__webpack_require__("../node_modules/core-js/modules/web.dom.iterable.js");
	module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js");

/***/ },

/***/ "../node_modules/core-js/modules/es6.symbol.js":
/***/ function(module, exports, __webpack_require__) {

	
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , has            = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , DESCRIPTORS    = __webpack_require__("../node_modules/core-js/modules/_descriptors.js")
	  , $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , redefine       = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , META           = __webpack_require__("../node_modules/core-js/modules/_meta.js").KEY
	  , $fails         = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , shared         = __webpack_require__("../node_modules/core-js/modules/_shared.js")
	  , setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")
	  , uid            = __webpack_require__("../node_modules/core-js/modules/_uid.js")
	  , wks            = __webpack_require__("../node_modules/core-js/modules/_wks.js")
	  , wksExt         = __webpack_require__("../node_modules/core-js/modules/_wks-ext.js")
	  , wksDefine      = __webpack_require__("../node_modules/core-js/modules/_wks-define.js")
	  , keyOf          = __webpack_require__("../node_modules/core-js/modules/_keyof.js")
	  , enumKeys       = __webpack_require__("../node_modules/core-js/modules/_enum-keys.js")
	  , isArray        = __webpack_require__("../node_modules/core-js/modules/_is-array.js")
	  , anObject       = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toIObject      = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , toPrimitive    = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , createDesc     = __webpack_require__("../node_modules/core-js/modules/_property-desc.js")
	  , _create        = __webpack_require__("../node_modules/core-js/modules/_object-create.js")
	  , gOPNExt        = __webpack_require__("../node_modules/core-js/modules/_object-gopn-ext.js")
	  , $GOPD          = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js")
	  , $DP            = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , $keys          = __webpack_require__("../node_modules/core-js/modules/_object-keys.js")
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f  = $propertyIsEnumerable;
	  __webpack_require__("../node_modules/core-js/modules/_object-gops.js").f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__("../node_modules/core-js/modules/_library.js")){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("../node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },

/***/ "../node_modules/core-js/modules/_global.js":
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },

/***/ "../node_modules/core-js/modules/_has.js":
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },

/***/ "../node_modules/core-js/modules/_export.js":
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , core      = __webpack_require__("../node_modules/core-js/modules/_core.js")
	  , hide      = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , redefine  = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , ctx       = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },

/***/ "../node_modules/core-js/modules/_core.js":
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
	module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js")
	  , toPrimitive    = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , document = __webpack_require__("../node_modules/core-js/modules/_global.js").document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , hide      = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , has       = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , SRC       = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_meta.js":
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__("../node_modules/core-js/modules/_uid.js")('meta')
	  , isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , has      = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , setDesc  = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },

/***/ "../node_modules/core-js/modules/_set-to-string-tag.js":
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , has = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , TAG = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks')
	  , uid        = __webpack_require__("../node_modules/core-js/modules/_uid.js")
	  , Symbol     = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },

/***/ "../node_modules/core-js/modules/_wks-ext.js":
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__("../node_modules/core-js/modules/_wks.js");

/***/ },

/***/ "../node_modules/core-js/modules/_wks-define.js":
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , core           = __webpack_require__("../node_modules/core-js/modules/_core.js")
	  , LIBRARY        = __webpack_require__("../node_modules/core-js/modules/_library.js")
	  , wksExt         = __webpack_require__("../node_modules/core-js/modules/_wks-ext.js")
	  , defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },

/***/ "../node_modules/core-js/modules/_library.js":
/***/ function(module, exports) {

	module.exports = false;

/***/ },

/***/ "../node_modules/core-js/modules/_keyof.js":
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__("../node_modules/core-js/modules/_object-keys.js")
	  , toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js")
	  , enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , toIObject    = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false)
	  , IE_PROTO     = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js")
	  , defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , toLength  = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , toIndex   = __webpack_require__("../node_modules/core-js/modules/_to-index.js");
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_to-index.js":
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys')
	  , uid    = __webpack_require__("../node_modules/core-js/modules/_uid.js");
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },

/***/ "../node_modules/core-js/modules/_enum-keys.js":
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js")
	  , gOPS    = __webpack_require__("../node_modules/core-js/modules/_object-gops.js")
	  , pIE     = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-gops.js":
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-create.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , dPs         = __webpack_require__("../node_modules/core-js/modules/_object-dps.js")
	  , enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js")
	  , IE_PROTO    = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__("../node_modules/core-js/modules/_dom-create.js")('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__("../node_modules/core-js/modules/_html.js").appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },

/***/ "../node_modules/core-js/modules/_object-dps.js":
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , getKeys  = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
	
	module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_html.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("../node_modules/core-js/modules/_global.js").document && document.documentElement;

/***/ },

/***/ "../node_modules/core-js/modules/_object-gopn-ext.js":
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , gOPN      = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },

/***/ "../node_modules/core-js/modules/_object-gopn.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js")
	  , hiddenKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-gopd.js":
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__("../node_modules/core-js/modules/_object-pie.js")
	  , createDesc     = __webpack_require__("../node_modules/core-js/modules/_property-desc.js")
	  , toIObject      = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , toPrimitive    = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , has            = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js")
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.create.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__("../node_modules/core-js/modules/_object-create.js")});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.define-property.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_descriptors.js"), 'Object', {defineProperty: __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.define-properties.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_descriptors.js"), 'Object', {defineProperties: __webpack_require__("../node_modules/core-js/modules/_object-dps.js")});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , $getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/_object-sap.js":
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , core    = __webpack_require__("../node_modules/core-js/modules/_core.js")
	  , fails   = __webpack_require__("../node_modules/core-js/modules/_fails.js");
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.get-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , $getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },

/***/ "../node_modules/core-js/modules/_object-gpo.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , toObject    = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , IE_PROTO    = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.keys.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , $keys    = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.get-own-property-names.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getOwnPropertyNames', function(){
	  return __webpack_require__("../node_modules/core-js/modules/_object-gopn-ext.js").f;
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.freeze.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , meta     = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.seal.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , meta     = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.prevent-extensions.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , meta     = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.is-frozen.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.is-sealed.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.is-extensible.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
	
	__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.assign.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__("../node_modules/core-js/modules/_object-assign.js")});

/***/ },

/***/ "../node_modules/core-js/modules/_object-assign.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__("../node_modules/core-js/modules/_object-keys.js")
	  , gOPS     = __webpack_require__("../node_modules/core-js/modules/_object-gops.js")
	  , pIE      = __webpack_require__("../node_modules/core-js/modules/_object-pie.js")
	  , toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , IObject  = __webpack_require__("../node_modules/core-js/modules/_iobject.js")
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.is.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	$export($export.S, 'Object', {is: __webpack_require__("../node_modules/core-js/modules/_same-value.js")});

/***/ },

/***/ "../node_modules/core-js/modules/_same-value.js":
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.set-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__("../node_modules/core-js/modules/_set-proto.js").set});

/***/ },

/***/ "../node_modules/core-js/modules/_set-proto.js":
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__("../node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.object.to-string.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js")
	  , test    = {};
	test[__webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__("../node_modules/core-js/modules/_redefine.js")(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },

/***/ "../node_modules/core-js/modules/_classof.js":
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js")
	  , TAG = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.function.bind.js":
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.P, 'Function', {bind: __webpack_require__("../node_modules/core-js/modules/_bind.js")});

/***/ },

/***/ "../node_modules/core-js/modules/_bind.js":
/***/ function(module, exports, __webpack_require__) {

	
	var aFunction  = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , isObject   = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , invoke     = __webpack_require__("../node_modules/core-js/modules/_invoke.js")
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_invoke.js":
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.function.name.js":
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js")
	  , has        = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__("../node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.function.has-instance.js":
/***/ function(module, exports, __webpack_require__) {

	
	var isObject       = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , HAS_INSTANCE   = __webpack_require__("../node_modules/core-js/modules/_wks.js")('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__("../node_modules/core-js/modules/_object-dp.js").f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es6.parse-int.js":
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $parseInt = __webpack_require__("../node_modules/core-js/modules/_parse-int.js");
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },

/***/ "../node_modules/core-js/modules/_parse-int.js":
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__("../node_modules/core-js/modules/_global.js").parseInt
	  , $trim     = __webpack_require__("../node_modules/core-js/modules/_string-trim.js").trim
	  , ws        = __webpack_require__("../node_modules/core-js/modules/_string-ws.js")
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },

/***/ "../node_modules/core-js/modules/_string-trim.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , defined = __webpack_require__("../node_modules/core-js/modules/_defined.js")
	  , fails   = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , spaces  = __webpack_require__("../node_modules/core-js/modules/_string-ws.js")
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },

/***/ "../node_modules/core-js/modules/_string-ws.js":
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },

/***/ "../node_modules/core-js/modules/es6.parse-float.js":
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $parseFloat = __webpack_require__("../node_modules/core-js/modules/_parse-float.js");
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },

/***/ "../node_modules/core-js/modules/_parse-float.js":
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__("../node_modules/core-js/modules/_global.js").parseFloat
	  , $trim       = __webpack_require__("../node_modules/core-js/modules/_string-trim.js").trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__("../node_modules/core-js/modules/_string-ws.js") + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.constructor.js":
/***/ function(module, exports, __webpack_require__) {

	
	var global            = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , has               = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , cof               = __webpack_require__("../node_modules/core-js/modules/_cof.js")
	  , inheritIfRequired = __webpack_require__("../node_modules/core-js/modules/_inherit-if-required.js")
	  , toPrimitive       = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , fails             = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , gOPN              = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f
	  , gOPD              = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f
	  , dP                = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , $trim             = __webpack_require__("../node_modules/core-js/modules/_string-trim.js").trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__("../node_modules/core-js/modules/_object-create.js")(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__("../node_modules/core-js/modules/_redefine.js")(global, NUMBER, $Number);
	}

/***/ },

/***/ "../node_modules/core-js/modules/_inherit-if-required.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , setPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_set-proto.js").set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.to-fixed.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export      = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toInteger    = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , aNumberValue = __webpack_require__("../node_modules/core-js/modules/_a-number-value.js")
	  , repeat       = __webpack_require__("../node_modules/core-js/modules/_string-repeat.js")
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_a-number-value.js":
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_string-repeat.js":
/***/ function(module, exports, __webpack_require__) {

	
	var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , defined   = __webpack_require__("../node_modules/core-js/modules/_defined.js");
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.to-precision.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export      = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $fails       = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , aNumberValue = __webpack_require__("../node_modules/core-js/modules/_a-number-value.js")
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.epsilon.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.is-finite.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , _isFinite = __webpack_require__("../node_modules/core-js/modules/_global.js").isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.is-integer.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Number', {isInteger: __webpack_require__("../node_modules/core-js/modules/_is-integer.js")});

/***/ },

/***/ "../node_modules/core-js/modules/_is-integer.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.is-nan.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.is-safe-integer.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , isInteger = __webpack_require__("../node_modules/core-js/modules/_is-integer.js")
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.max-safe-integer.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.min-safe-integer.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.parse-float.js":
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $parseFloat = __webpack_require__("../node_modules/core-js/modules/_parse-float.js");
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },

/***/ "../node_modules/core-js/modules/es6.number.parse-int.js":
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $parseInt = __webpack_require__("../node_modules/core-js/modules/_parse-int.js");
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.acosh.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , log1p   = __webpack_require__("../node_modules/core-js/modules/_math-log1p.js")
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_math-log1p.js":
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.asinh.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.atanh.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.cbrt.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , sign    = __webpack_require__("../node_modules/core-js/modules/_math-sign.js");
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_math-sign.js":
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.clz32.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.cosh.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.expm1.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $expm1  = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },

/***/ "../node_modules/core-js/modules/_math-expm1.js":
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.fround.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , sign      = __webpack_require__("../node_modules/core-js/modules/_math-sign.js")
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.hypot.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.imul.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.log10.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.log1p.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {log1p: __webpack_require__("../node_modules/core-js/modules/_math-log1p.js")});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.log2.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.sign.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {sign: __webpack_require__("../node_modules/core-js/modules/_math-sign.js")});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.sinh.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , expm1   = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js")
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.tanh.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , expm1   = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js")
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.math.trunc.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.from-code-point.js":
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toIndex        = __webpack_require__("../node_modules/core-js/modules/_to-index.js")
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.raw.js":
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , toLength  = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.trim.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__("../node_modules/core-js/modules/_string-trim.js")('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.iterator.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $at  = __webpack_require__("../node_modules/core-js/modules/_string-at.js")(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__("../node_modules/core-js/modules/_iter-define.js")(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },

/***/ "../node_modules/core-js/modules/_string-at.js":
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , defined   = __webpack_require__("../node_modules/core-js/modules/_defined.js");
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_iter-define.js":
/***/ function(module, exports, __webpack_require__) {

	
	var LIBRARY        = __webpack_require__("../node_modules/core-js/modules/_library.js")
	  , $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , redefine       = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , hide           = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , has            = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , Iterators      = __webpack_require__("../node_modules/core-js/modules/_iterators.js")
	  , $iterCreate    = __webpack_require__("../node_modules/core-js/modules/_iter-create.js")
	  , setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")
	  , getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , ITERATOR       = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_iterators.js":
/***/ function(module, exports) {

	module.exports = {};

/***/ },

/***/ "../node_modules/core-js/modules/_iter-create.js":
/***/ function(module, exports, __webpack_require__) {

	
	var create         = __webpack_require__("../node_modules/core-js/modules/_object-create.js")
	  , descriptor     = __webpack_require__("../node_modules/core-js/modules/_property-desc.js")
	  , setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__("../node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.code-point-at.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $at     = __webpack_require__("../node_modules/core-js/modules/_string-at.js")(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.ends-with.js":
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toLength  = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , context   = __webpack_require__("../node_modules/core-js/modules/_string-context.js")
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js")
	  , defined  = __webpack_require__("../node_modules/core-js/modules/_defined.js");
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , cof      = __webpack_require__("../node_modules/core-js/modules/_cof.js")
	  , MATCH    = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , context  = __webpack_require__("../node_modules/core-js/modules/_string-context.js")
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.repeat.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__("../node_modules/core-js/modules/_string-repeat.js")
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.starts-with.js":
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	
	var $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toLength    = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , context     = __webpack_require__("../node_modules/core-js/modules/_string-context.js")
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.anchor.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_string-html.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , fails   = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , defined = __webpack_require__("../node_modules/core-js/modules/_defined.js")
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.big.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.3 String.prototype.big()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.blink.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.4 String.prototype.blink()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.bold.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.5 String.prototype.bold()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.fixed.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.fontcolor.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.fontsize.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.italics.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.9 String.prototype.italics()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.link.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.small.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.11 String.prototype.small()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.strike.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.12 String.prototype.strike()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.sub.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.13 String.prototype.sub()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.string.sup.js":
/***/ function(module, exports, __webpack_require__) {

	
	// B.2.3.14 String.prototype.sup()
	__webpack_require__("../node_modules/core-js/modules/_string-html.js")('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.date.now.js":
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },

/***/ "../node_modules/core-js/modules/es6.date.to-json.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toObject    = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
	
	$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.date.to-iso-string.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , fails   = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.date.to-string.js":
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__("../node_modules/core-js/modules/_redefine.js")(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },

/***/ "../node_modules/core-js/modules/es6.date.to-primitive.js":
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__("../node_modules/core-js/modules/_hide.js")(proto, TO_PRIMITIVE, __webpack_require__("../node_modules/core-js/modules/_date-to-primitive.js"));

/***/ },

/***/ "../node_modules/core-js/modules/_date-to-primitive.js":
/***/ function(module, exports, __webpack_require__) {

	
	var anObject    = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.is-array.js":
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Array', {isArray: __webpack_require__("../node_modules/core-js/modules/_is-array.js")});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.from.js":
/***/ function(module, exports, __webpack_require__) {

	
	var ctx            = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toObject       = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , call           = __webpack_require__("../node_modules/core-js/modules/_iter-call.js")
	  , isArrayIter    = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js")
	  , toLength       = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js")
	  , getIterFn      = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");
	
	$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_iter-detect.js")(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },

/***/ "../node_modules/core-js/modules/_iter-call.js":
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },

/***/ "../node_modules/core-js/modules/_is-array-iter.js":
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__("../node_modules/core-js/modules/_iterators.js")
	  , ITERATOR   = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_create-property.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , createDesc      = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },

/***/ "../node_modules/core-js/modules/core.get-iterator-method.js":
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__("../node_modules/core-js/modules/_classof.js")
	  , ITERATOR  = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator')
	  , Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
	module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },

/***/ "../node_modules/core-js/modules/_iter-detect.js":
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.of.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.join.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__("../node_modules/core-js/modules/_iobject.js") != Object || !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_strict-method.js":
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.slice.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export    = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , html       = __webpack_require__("../node_modules/core-js/modules/_html.js")
	  , cof        = __webpack_require__("../node_modules/core-js/modules/_cof.js")
	  , toIndex    = __webpack_require__("../node_modules/core-js/modules/_to-index.js")
	  , toLength   = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.sort.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , toObject  = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , fails     = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.for-each.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $forEach = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(0)
	  , STRICT   = __webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , IObject  = __webpack_require__("../node_modules/core-js/modules/_iobject.js")
	  , toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , asc      = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , isArray  = __webpack_require__("../node_modules/core-js/modules/_is-array.js")
	  , SPECIES  = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.map.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $map    = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(1);
	
	$export($export.P + $export.F * !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.filter.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $filter = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(2);
	
	$export($export.P + $export.F * !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.some.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $some   = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(3);
	
	$export($export.P + $export.F * !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.every.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $every  = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(4);
	
	$export($export.P + $export.F * !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.reduce.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $reduce = __webpack_require__("../node_modules/core-js/modules/_array-reduce.js");
	
	$export($export.P + $export.F * !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_array-reduce.js":
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , toObject  = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , IObject   = __webpack_require__("../node_modules/core-js/modules/_iobject.js")
	  , toLength  = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.reduce-right.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $reduce = __webpack_require__("../node_modules/core-js/modules/_array-reduce.js");
	
	$export($export.P + $export.F * !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.index-of.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export       = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $indexOf      = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.last-index-of.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export       = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toIObject     = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , toInteger     = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , toLength      = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("../node_modules/core-js/modules/_strict-method.js")($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.copy-within.js":
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__("../node_modules/core-js/modules/_array-copy-within.js")});
	
	__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('copyWithin');

/***/ },

/***/ "../node_modules/core-js/modules/_array-copy-within.js":
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	
	var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , toIndex  = __webpack_require__("../node_modules/core-js/modules/_to-index.js")
	  , toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.fill.js":
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.P, 'Array', {fill: __webpack_require__("../node_modules/core-js/modules/_array-fill.js")});
	
	__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('fill');

/***/ },

/***/ "../node_modules/core-js/modules/_array-fill.js":
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	
	var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , toIndex  = __webpack_require__("../node_modules/core-js/modules/_to-index.js")
	  , toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $find   = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.find-index.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $find   = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.species.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_set-species.js")('Array');

/***/ },

/***/ "../node_modules/core-js/modules/_set-species.js":
/***/ function(module, exports, __webpack_require__) {

	
	var global      = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , dP          = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js")
	  , SPECIES     = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.array.iterator.js":
/***/ function(module, exports, __webpack_require__) {

	
	var addToUnscopables = __webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")
	  , step             = __webpack_require__("../node_modules/core-js/modules/_iter-step.js")
	  , Iterators        = __webpack_require__("../node_modules/core-js/modules/_iterators.js")
	  , toIObject        = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__("../node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },

/***/ "../node_modules/core-js/modules/_iter-step.js":
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.constructor.js":
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , inheritIfRequired = __webpack_require__("../node_modules/core-js/modules/_inherit-if-required.js")
	  , dP                = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , gOPN              = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f
	  , isRegExp          = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js")
	  , $flags            = __webpack_require__("../node_modules/core-js/modules/_flags.js")
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && (!CORRECT_NEW || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  re2[__webpack_require__("../node_modules/core-js/modules/_wks.js")('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__("../node_modules/core-js/modules/_redefine.js")(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__("../node_modules/core-js/modules/_set-species.js")('RegExp');

/***/ },

/***/ "../node_modules/core-js/modules/_flags.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.to-string.js":
/***/ function(module, exports, __webpack_require__) {

	
	__webpack_require__("../node_modules/core-js/modules/es6.regexp.flags.js");
	var anObject    = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , $flags      = __webpack_require__("../node_modules/core-js/modules/_flags.js")
	  , DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js")
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__("../node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.flags.js":
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g')__webpack_require__("../node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__("../node_modules/core-js/modules/_flags.js")
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.match.js":
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },

/***/ "../node_modules/core-js/modules/_fix-re-wks.js":
/***/ function(module, exports, __webpack_require__) {

	
	var hide     = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , fails    = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , defined  = __webpack_require__("../node_modules/core-js/modules/_defined.js")
	  , wks      = __webpack_require__("../node_modules/core-js/modules/_wks.js");
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.replace.js":
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.search.js":
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.regexp.split.js":
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function(defined, SPLIT, $split){
	  
	  var isRegExp   = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js")
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.promise.js":
/***/ function(module, exports, __webpack_require__) {

	
	var LIBRARY            = __webpack_require__("../node_modules/core-js/modules/_library.js")
	  , global             = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , ctx                = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , classof            = __webpack_require__("../node_modules/core-js/modules/_classof.js")
	  , $export            = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , isObject           = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , aFunction          = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , anInstance         = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	  , forOf              = __webpack_require__("../node_modules/core-js/modules/_for-of.js")
	  , speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js")
	  , task               = __webpack_require__("../node_modules/core-js/modules/_task.js").set
	  , microtask          = __webpack_require__("../node_modules/core-js/modules/_microtask.js")()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__("../node_modules/core-js/modules/_wks.js")('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);
	__webpack_require__("../node_modules/core-js/modules/_set-species.js")(PROMISE);
	Wrapper = __webpack_require__("../node_modules/core-js/modules/_core.js")[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("../node_modules/core-js/modules/_iter-detect.js")(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_an-instance.js":
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },

/***/ "../node_modules/core-js/modules/_for-of.js":
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , call        = __webpack_require__("../node_modules/core-js/modules/_iter-call.js")
	  , isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js")
	  , anObject    = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toLength    = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , getIterFn   = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js")
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },

/***/ "../node_modules/core-js/modules/_species-constructor.js":
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , SPECIES   = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },

/***/ "../node_modules/core-js/modules/_task.js":
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , invoke             = __webpack_require__("../node_modules/core-js/modules/_invoke.js")
	  , html               = __webpack_require__("../node_modules/core-js/modules/_html.js")
	  , cel                = __webpack_require__("../node_modules/core-js/modules/_dom-create.js")
	  , global             = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },

/***/ "../node_modules/core-js/modules/_microtask.js":
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , macrotask = __webpack_require__("../node_modules/core-js/modules/_task.js").set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_redefine-all.js":
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.map.js":
/***/ function(module, exports, __webpack_require__) {

	
	var strong = __webpack_require__("../node_modules/core-js/modules/_collection-strong.js");
	
	// 23.1 Map Objects
	module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },

/***/ "../node_modules/core-js/modules/_collection-strong.js":
/***/ function(module, exports, __webpack_require__) {

	
	var dP          = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , create      = __webpack_require__("../node_modules/core-js/modules/_object-create.js")
	  , redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")
	  , ctx         = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	  , anInstance  = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	  , defined     = __webpack_require__("../node_modules/core-js/modules/_defined.js")
	  , forOf       = __webpack_require__("../node_modules/core-js/modules/_for-of.js")
	  , $iterDefine = __webpack_require__("../node_modules/core-js/modules/_iter-define.js")
	  , step        = __webpack_require__("../node_modules/core-js/modules/_iter-step.js")
	  , setSpecies  = __webpack_require__("../node_modules/core-js/modules/_set-species.js")
	  , DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js")
	  , fastKey     = __webpack_require__("../node_modules/core-js/modules/_meta.js").fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },

/***/ "../node_modules/core-js/modules/_collection.js":
/***/ function(module, exports, __webpack_require__) {

	
	var global            = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , $export           = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , redefine          = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , redefineAll       = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")
	  , meta              = __webpack_require__("../node_modules/core-js/modules/_meta.js")
	  , forOf             = __webpack_require__("../node_modules/core-js/modules/_for-of.js")
	  , anInstance        = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	  , isObject          = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , fails             = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , $iterDetect       = __webpack_require__("../node_modules/core-js/modules/_iter-detect.js")
	  , setToStringTag    = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")
	  , inheritIfRequired = __webpack_require__("../node_modules/core-js/modules/_inherit-if-required.js");
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.set.js":
/***/ function(module, exports, __webpack_require__) {

	
	var strong = __webpack_require__("../node_modules/core-js/modules/_collection-strong.js");
	
	// 23.2 Set Objects
	module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },

/***/ "../node_modules/core-js/modules/es6.weak-map.js":
/***/ function(module, exports, __webpack_require__) {

	
	var each         = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(0)
	  , redefine     = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , meta         = __webpack_require__("../node_modules/core-js/modules/_meta.js")
	  , assign       = __webpack_require__("../node_modules/core-js/modules/_object-assign.js")
	  , weak         = __webpack_require__("../node_modules/core-js/modules/_collection-weak.js")
	  , isObject     = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },

/***/ "../node_modules/core-js/modules/_collection-weak.js":
/***/ function(module, exports, __webpack_require__) {

	
	var redefineAll       = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")
	  , getWeak           = __webpack_require__("../node_modules/core-js/modules/_meta.js").getWeak
	  , anObject          = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , isObject          = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , anInstance        = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	  , forOf             = __webpack_require__("../node_modules/core-js/modules/_for-of.js")
	  , createArrayMethod = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")
	  , $has              = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.weak-set.js":
/***/ function(module, exports, __webpack_require__) {

	
	var weak = __webpack_require__("../node_modules/core-js/modules/_collection-weak.js");
	
	// 23.4 WeakSet Objects
	__webpack_require__("../node_modules/core-js/modules/_collection.js")('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.array-buffer.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export      = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $typed       = __webpack_require__("../node_modules/core-js/modules/_typed.js")
	  , buffer       = __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js")
	  , anObject     = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toIndex      = __webpack_require__("../node_modules/core-js/modules/_to-index.js")
	  , toLength     = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , isObject     = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , ArrayBuffer  = __webpack_require__("../node_modules/core-js/modules/_global.js").ArrayBuffer
	  , speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js")
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__("../node_modules/core-js/modules/_set-species.js")(ARRAY_BUFFER);

/***/ },

/***/ "../node_modules/core-js/modules/_typed.js":
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , hide   = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , uid    = __webpack_require__("../node_modules/core-js/modules/_uid.js")
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },

/***/ "../node_modules/core-js/modules/_typed-buffer.js":
/***/ function(module, exports, __webpack_require__) {

	
	var global         = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , DESCRIPTORS    = __webpack_require__("../node_modules/core-js/modules/_descriptors.js")
	  , LIBRARY        = __webpack_require__("../node_modules/core-js/modules/_library.js")
	  , $typed         = __webpack_require__("../node_modules/core-js/modules/_typed.js")
	  , hide           = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , redefineAll    = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")
	  , fails          = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , anInstance     = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	  , toInteger      = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	  , toLength       = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , gOPN           = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f
	  , dP             = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f
	  , arrayFill      = __webpack_require__("../node_modules/core-js/modules/_array-fill.js")
	  , setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.data-view.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	$export($export.G + $export.W + $export.F * !__webpack_require__("../node_modules/core-js/modules/_typed.js").ABV, {
	  DataView: __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js").DataView
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.int8-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/_typed-array.js":
/***/ function(module, exports, __webpack_require__) {

	
	if(__webpack_require__("../node_modules/core-js/modules/_descriptors.js")){
	  var LIBRARY             = __webpack_require__("../node_modules/core-js/modules/_library.js")
	    , global              = __webpack_require__("../node_modules/core-js/modules/_global.js")
	    , fails               = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	    , $export             = __webpack_require__("../node_modules/core-js/modules/_export.js")
	    , $typed              = __webpack_require__("../node_modules/core-js/modules/_typed.js")
	    , $buffer             = __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js")
	    , ctx                 = __webpack_require__("../node_modules/core-js/modules/_ctx.js")
	    , anInstance          = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	    , propertyDesc        = __webpack_require__("../node_modules/core-js/modules/_property-desc.js")
	    , hide                = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	    , redefineAll         = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")
	    , toInteger           = __webpack_require__("../node_modules/core-js/modules/_to-integer.js")
	    , toLength            = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	    , toIndex             = __webpack_require__("../node_modules/core-js/modules/_to-index.js")
	    , toPrimitive         = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	    , has                 = __webpack_require__("../node_modules/core-js/modules/_has.js")
	    , same                = __webpack_require__("../node_modules/core-js/modules/_same-value.js")
	    , classof             = __webpack_require__("../node_modules/core-js/modules/_classof.js")
	    , isObject            = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	    , toObject            = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	    , isArrayIter         = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js")
	    , create              = __webpack_require__("../node_modules/core-js/modules/_object-create.js")
	    , getPrototypeOf      = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	    , gOPN                = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f
	    , getIterFn           = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js")
	    , uid                 = __webpack_require__("../node_modules/core-js/modules/_uid.js")
	    , wks                 = __webpack_require__("../node_modules/core-js/modules/_wks.js")
	    , createArrayMethod   = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")
	    , createArrayIncludes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")
	    , speciesConstructor  = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js")
	    , ArrayIterators      = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js")
	    , Iterators           = __webpack_require__("../node_modules/core-js/modules/_iterators.js")
	    , $iterDetect         = __webpack_require__("../node_modules/core-js/modules/_iter-detect.js")
	    , setSpecies          = __webpack_require__("../node_modules/core-js/modules/_set-species.js")
	    , arrayFill           = __webpack_require__("../node_modules/core-js/modules/_array-fill.js")
	    , arrayCopyWithin     = __webpack_require__("../node_modules/core-js/modules/_array-copy-within.js")
	    , $DP                 = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	    , $GOPD               = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js")
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.uint8-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/babel-polyfill/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	
	__webpack_require__("../node_modules/core-js/shim.js");
	
	__webpack_require__("../node_modules/regenerator-runtime/runtime.js");
	
	__webpack_require__("../node_modules/core-js/fn/regexp/escape.js");
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.int16-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.uint16-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.int32-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.uint32-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.float32-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.float64-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.apply.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , anObject  = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , rApply    = (__webpack_require__("../node_modules/core-js/modules/_global.js").Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.construct.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , create     = __webpack_require__("../node_modules/core-js/modules/_object-create.js")
	  , aFunction  = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , anObject   = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , isObject   = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , fails      = __webpack_require__("../node_modules/core-js/modules/_fails.js")
	  , bind       = __webpack_require__("../node_modules/core-js/modules/_bind.js")
	  , rConstruct = (__webpack_require__("../node_modules/core-js/modules/_global.js").Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.define-property.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , anObject    = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.delete-property.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , gOPD     = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.enumerate.js":
/***/ function(module, exports, __webpack_require__) {

	
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__("../node_modules/core-js/modules/_iter-create.js")(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.get.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js")
	  , getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , has            = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , isObject       = __webpack_require__("../node_modules/core-js/modules/_is-object.js")
	  , anObject       = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js")
	  , $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.get-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , getProto = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.has.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.is-extensible.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , anObject      = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.own-keys.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__("../node_modules/core-js/modules/_own-keys.js")});

/***/ },

/***/ "../node_modules/core-js/modules/_own-keys.js":
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js")
	  , gOPS     = __webpack_require__("../node_modules/core-js/modules/_object-gops.js")
	  , anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , Reflect  = __webpack_require__("../node_modules/core-js/modules/_global.js").Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.prevent-extensions.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , anObject           = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.set.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__("../node_modules/core-js/modules/_object-dp.js")
	  , gOPD           = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js")
	  , getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , has            = __webpack_require__("../node_modules/core-js/modules/_has.js")
	  , $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , createDesc     = __webpack_require__("../node_modules/core-js/modules/_property-desc.js")
	  , anObject       = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , isObject       = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },

/***/ "../node_modules/core-js/modules/es6.reflect.set-prototype-of.js":
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , setProto = __webpack_require__("../node_modules/core-js/modules/_set-proto.js");
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');

/***/ },

/***/ "../node_modules/core-js/modules/es7.string.at.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $at     = __webpack_require__("../node_modules/core-js/modules/_string-at.js")(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.string.pad-start.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $pad    = __webpack_require__("../node_modules/core-js/modules/_string-pad.js");
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_string-pad.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , repeat   = __webpack_require__("../node_modules/core-js/modules/_string-repeat.js")
	  , defined  = __webpack_require__("../node_modules/core-js/modules/_defined.js");
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },

/***/ "../node_modules/core-js/modules/es7.string.pad-end.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $pad    = __webpack_require__("../node_modules/core-js/modules/_string-pad.js");
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.string.trim-left.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__("../node_modules/core-js/modules/_string-trim.js")('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },

/***/ "../node_modules/core-js/modules/es7.string.trim-right.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__("../node_modules/core-js/modules/_string-trim.js")('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },

/***/ "../node_modules/core-js/modules/es7.string.match-all.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , defined     = __webpack_require__("../node_modules/core-js/modules/_defined.js")
	  , toLength    = __webpack_require__("../node_modules/core-js/modules/_to-length.js")
	  , isRegExp    = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js")
	  , getFlags    = __webpack_require__("../node_modules/core-js/modules/_flags.js")
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__("../node_modules/core-js/modules/_iter-create.js")($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.symbol.async-iterator.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_wks-define.js")('asyncIterator');

/***/ },

/***/ "../node_modules/core-js/modules/es7.symbol.observable.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_wks-define.js")('observable');

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , ownKeys        = __webpack_require__("../node_modules/core-js/modules/_own-keys.js")
	  , toIObject      = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , gOPD           = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js")
	  , createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__("../node_modules/core-js/modules/_object-keys.js")
	  , toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js")
	  , isEnum    = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.define-getter.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export         = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toObject        = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , aFunction       = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , $defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("../node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/_object-forced-pam.js":
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__("../node_modules/core-js/modules/_library.js")|| !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__("../node_modules/core-js/modules/_global.js")[K];
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.define-setter.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export         = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toObject        = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , aFunction       = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , $defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("../node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.lookup-getter.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export                  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toObject                 = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , toPrimitive              = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , getPrototypeOf           = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("../node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.object.lookup-setter.js":
/***/ function(module, exports, __webpack_require__) {

	
	var $export                  = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , toObject                 = __webpack_require__("../node_modules/core-js/modules/_to-object.js")
	  , toPrimitive              = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js")
	  , getPrototypeOf           = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("../node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.map.to-json.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__("../node_modules/core-js/modules/_collection-to-json.js")('Map')});

/***/ },

/***/ "../node_modules/core-js/modules/_collection-to-json.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js")
	  , from    = __webpack_require__("../node_modules/core-js/modules/_array-from-iterable.js");
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_array-from-iterable.js":
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },

/***/ "../node_modules/core-js/modules/es7.set.to-json.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__("../node_modules/core-js/modules/_collection-to-json.js")('Set')});

/***/ },

/***/ "../node_modules/core-js/modules/es7.system.global.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'System', {global: __webpack_require__("../node_modules/core-js/modules/_global.js")});

/***/ },

/***/ "../node_modules/core-js/modules/es7.error.is-error.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , cof     = __webpack_require__("../node_modules/core-js/modules/_cof.js");
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.math.iaddh.js":
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.math.isubh.js":
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.math.imulh.js":
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.math.umulh.js":
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.define-metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject                  = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/_metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__("../node_modules/core-js/modules/es6.map.js")
	  , $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , shared  = __webpack_require__("../node_modules/core-js/modules/_shared.js")('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__("../node_modules/core-js/modules/es6.weak-map.js")));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.delete-metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject               = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.get-metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject               = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , getPrototypeOf         = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.get-metadata-keys.js":
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__("../node_modules/core-js/modules/es6.set.js")
	  , from                    = __webpack_require__("../node_modules/core-js/modules/_array-from-iterable.js")
	  , metadata                = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject                = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , getPrototypeOf          = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.get-own-metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject               = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject                = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.has-metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject               = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , getPrototypeOf         = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js")
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.has-own-metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject               = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.reflect.metadata.js":
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__("../node_modules/core-js/modules/_metadata.js")
	  , anObject                  = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , aFunction                 = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },

/***/ "../node_modules/core-js/modules/es7.asap.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , microtask = __webpack_require__("../node_modules/core-js/modules/_microtask.js")()
	  , process   = __webpack_require__("../node_modules/core-js/modules/_global.js").process
	  , isNode    = __webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },

/***/ "../node_modules/core-js/modules/es7.observable.js":
/***/ function(module, exports, __webpack_require__) {

	
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , global      = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , core        = __webpack_require__("../node_modules/core-js/modules/_core.js")
	  , microtask   = __webpack_require__("../node_modules/core-js/modules/_microtask.js")()
	  , OBSERVABLE  = __webpack_require__("../node_modules/core-js/modules/_wks.js")('observable')
	  , aFunction   = __webpack_require__("../node_modules/core-js/modules/_a-function.js")
	  , anObject    = __webpack_require__("../node_modules/core-js/modules/_an-object.js")
	  , anInstance  = __webpack_require__("../node_modules/core-js/modules/_an-instance.js")
	  , redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")
	  , hide        = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , forOf       = __webpack_require__("../node_modules/core-js/modules/_for-of.js")
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__("../node_modules/core-js/modules/_set-species.js")('Observable');

/***/ },

/***/ "../node_modules/core-js/modules/web.timers.js":
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , $export    = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , invoke     = __webpack_require__("../node_modules/core-js/modules/_invoke.js")
	  , partial    = __webpack_require__("../node_modules/core-js/modules/_partial.js")
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },

/***/ "../node_modules/core-js/modules/_partial.js":
/***/ function(module, exports, __webpack_require__) {

	
	var path      = __webpack_require__("../node_modules/core-js/modules/_path.js")
	  , invoke    = __webpack_require__("../node_modules/core-js/modules/_invoke.js")
	  , aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },

/***/ "../node_modules/core-js/modules/_path.js":
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("../node_modules/core-js/modules/_global.js");

/***/ },

/***/ "../node_modules/core-js/modules/web.immediate.js":
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $task   = __webpack_require__("../node_modules/core-js/modules/_task.js");
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },

/***/ "../node_modules/core-js/modules/web.dom.iterable.js":
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js")
	  , redefine      = __webpack_require__("../node_modules/core-js/modules/_redefine.js")
	  , global        = __webpack_require__("../node_modules/core-js/modules/_global.js")
	  , hide          = __webpack_require__("../node_modules/core-js/modules/_hide.js")
	  , Iterators     = __webpack_require__("../node_modules/core-js/modules/_iterators.js")
	  , wks           = __webpack_require__("../node_modules/core-js/modules/_wks.js")
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },

/***/ "../node_modules/regenerator-runtime/runtime.js":
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "../node_modules/core-js/fn/regexp/escape.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/core.regexp.escape.js");
	module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").RegExp.escape;

/***/ },

/***/ "../node_modules/core-js/modules/core.regexp.escape.js":
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__("../node_modules/core-js/modules/_export.js")
	  , $re     = __webpack_require__("../node_modules/core-js/modules/_replacer.js")(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },

/***/ "../node_modules/core-js/modules/_replacer.js":
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },

/***/ "./js/bootstrap.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	window.main = true;
	
	if (!window.prefetch) {
	    angular.bootstrap(document.body, ['app']);
	    __webpack_require__("./js/app.js");
	}

/***/ },

/***/ "./js/app.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./css/app.less");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _route = __webpack_require__("./pages/xo-checkout/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_logger.$logger.info('app_bootstrap', {
	    hash: window.location.hash
	});
	
	var xoCheckoutRoute = new _route2['default']();
	
	xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);
	
	window.bootstrap = true;
	
	_logger.$logger;
	
	_middleware.$Middleware;

/***/ },

/***/ "./css/app.less":
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select>span{display:block;padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:''}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#soldOut{width:0;min-width:320px;min-height:500px;min-height:70vh}#soldOut,#soldOut #soldouticon{text-align:center;margin:0 auto;position:relative}#soldOut #soldouticon{display:inline-block;margin-top:35%}#soldOut .left_section{width:40px;height:44px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-160px -252px;background-repeat:no-repeat;background-color:#fff;float:left}#soldOut .text_lines{float:left;border-top:2px solid #c72e2e;border-bottom:2px solid #c72e2e;box-sizing:border-box;line-height:39px}#soldOut #text{font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:18px;color:#c72f2e;white-space:nowrap}#soldOut #rightSection{float:left}#soldOut .shape-right{display:inline-block;width:14px;height:45px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-187px -306px;background-repeat:no-repeat;background-color:#fff}#soldOut .soldOutMessage{width:343px;height:auto;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:24px;color:#2c2e2f;line-height:normal;margin-top:20px;float:left;max-width:290px;margin-left:10%;overflow-wrap:break-word}#soldOut #continueButtons{margin-bottom:150px}#soldOut #Continue-Shopping{margin-top:60px;max-width:345px}#soldOut #Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut #Continue-ShoppingCart{margin-top:25.5px;background-color:#e1e7eb;border-color:#e1e7eb;color:#323232}#soldOut #Continue-ShoppingCart:hover{text-decoration:underline}#soldOut .optionLine{width:100%;margin-top:19.5px;height:10px;border-bottom:1px solid #d8d8d8;text-align:center;background-color:inherit}#soldOut .optionText{font-size:13px;background-color:#fff;line-height:13px;padding:0 5px;color:#6c7378;font-weight:400}.merchantHeader{max-width:940px!important}@media (min-width:0) and (max-width:21em){#soldOut #soldouticon{margin-right:10%}#soldOut .left_section{margin-left:inherit}#soldOut .soldOutMessage{margin-left:0;margin-bottom:30px;max-width:280px}#continueButtons{margin-bottom:0!important}#soldOut #Continue-Shopping{margin:40px 10% 40px 0;margin-bottom:0;max-width:280px}#soldOut #Continue-ShoppingCart{margin:25.5px 10% 40px 0;max-width:280px}.optionLine{max-width:280px;margin-left:0}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:21em) and (max-width:23.438em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 10% 120px;margin-bottom:0;max-width:280px}#soldOut #Continue-ShoppingCart{margin:25.5px 10% 120px;max-width:280px}#continueButtons{margin-bottom:0!important}.optionLine{max-width:280px;margin-left:10%}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 10% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:23.438em) and (max-width:27.188em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 5% 131px;margin-bottom:0;max-width:280px}#soldOut #Continue-ShoppingCart{margin:25.5px 5% 131px;max-width:280px}#continueButtons{margin-bottom:0!important}.optionLine{max-width:280px;margin-left:5%}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 5% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}#shoppingCart{font-size:13px;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;background-color:#fff}#shoppingCart :focus{outline-style:solid;outline-color:#009cde;outline-width:2px}#shoppingCart .header{border-bottom:1px solid #e3e3e3;padding-top:15px;padding-bottom:20px}#shoppingCart #headerText{font-size:15px;font-weight:500;display:inline}#shoppingCart #cartContents{min-height:500px;min-height:70vh}#shoppingCart .continueLink{display:inline;position:relative;font-size:13px;top:1px;float:right}#shoppingCart a:focus,#shoppingCart a:hover{cursor:pointer}#shoppingCart .options{color:#6c7378}#shoppingCart .key{font-weight:500}#shoppingCart .remove{padding-top:4px;display:block}#shoppingCart .frontArrow{top:7px;right:0;position:relative}#shoppingCart .frontArrow,#shoppingCart .frontArrow.disabled,#shoppingCart .frontArrow.disabled:focus,#shoppingCart .frontArrow.disabled:hover{background-position:-196px -181px}#shoppingCart .arrow{display:none;margin:5px 0 0 5px;vertical-align:middle;width:12px;height:10px;cursor:pointer;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px -10px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#shoppingCart .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#shoppingCart .downward{background-position:-23px 0}#shoppingCart .guestText{font-weight:300;font-size:14px;color:#2b2b2b}#shoppingCart .formatCurrency{-webkit-font-smoothing:antialiased;text-decoration:inherit}#shoppingCart .formatCurrency .currencyCode{display:none;font-size:1em}#shoppingCart .optionLine{width:100%;height:10px;border-bottom:1px solid #d8d8d8;text-align:center;margin:auto;background-color:inherit}#shoppingCart .optionText{font-size:13px;background-color:#f7f9fa;line-height:13px;padding:0 5px;font-weight:300}#shoppingCart .row,#shoppingCart .total{width:100%;display:table}#shoppingCart .total{font-weight:700;padding:8px 0 20px}#shoppingCart .total .formatCurrency .currencyCode{display:inherit}#shoppingCart .memberCheckout{text-align:center;padding-bottom:20px;padding-top:5px}#shoppingCart .guestCheckout{text-align:center;padding-top:25px;padding-bottom:15px}#shoppingCart .wrapword{white-space:-moz-pre-wrap!important;white-space:-webkit-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;white-space:pre-wrap;word-wrap:break-word;word-break:break-all;white-space:normal}#shoppingCart #items{width:62%;margin-top:30px;display:inline-table}#shoppingCart #items .row{padding:25px 0;border-bottom:1px solid #e3e3e3}#shoppingCart #items .nameOfItem{width:100%;max-height:26em;font-weight:500;display:block;word-wrap:break-word}#shoppingCart #items .nameOfItem,#shoppingCart #items .nameOfItem.ellipsisEffect{overflow:hidden;padding-right:10px;-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}#shoppingCart #items .nameOfItem.ellipsisEffect{max-height:20px;text-overflow:ellipsis}#shoppingCart #items .nowrap{white-space:nowrap}#shoppingCart #items .itemNumber{width:100%;max-height:26em;display:block;color:#6c7378;word-wrap:break-word}#shoppingCart #items .itemNumber,#shoppingCart #items .itemNumber.ellipsisEffect{overflow:hidden;padding-right:10px;-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}#shoppingCart #items .itemNumber.ellipsisEffect{max-height:20px;text-overflow:ellipsis}#shoppingCart #items .hide{max-height:0!important}#shoppingCart #items .hide,#shoppingCart #items .showItem{-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}#shoppingCart #items .showItem{max-height:999999px}#shoppingCart #items .hideDetails,#shoppingCart #items .showItem.hideItem{max-height:0;overflow:hidden;-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}#shoppingCart #items .hideDetails.showDetails{max-height:350px;-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}#shoppingCart #items .rowHead{padding-top:15px;padding-bottom:14px}#shoppingCart #items .itemDetails{clear:both}#shoppingCart .lessDetails,#shoppingCart .moreLessDetails{display:block;clear:both}#shoppingCart #orderSummary{width:32%;display:inline-table;margin-top:30px;float:right;background-color:#f7f9fa;-webkit-transition:transform .1s linear;transition:transform .1s linear;transform:translateY(0)}#shoppingCart #orderSummary .row{width:100%;padding:3.5px 0;display:table}#shoppingCart #orderSummary .firstRow{width:100%;padding:15px 0 3.5px;display:table}#shoppingCart #orderSummary .rowHead{padding-top:15px;padding-bottom:14px;border-bottom:1px solid #e3e3e3}#shoppingCart #orderSummary .rowHead .formatCurrency .currencyCode{display:inherit}#shoppingCart #orderSummary .lastRow{width:100%;padding:8px 0 20px;display:table}#shoppingCart #orderSummary .lastRow .formatCurrency .currencyCode{display:inherit}#shoppingCart #orderSummary .checkoutButtons{float:none;padding:0!important;border-top:1px solid #e3e3e3}#shoppingCart #orderSummary .checkoutButtons .paypal-button{padding-bottom:2px}#shoppingCart #orderSummary .checkoutButtons .paypal-button-widget{display:block}#shoppingCart #orderSummary .checkoutButtons .paypal-button-tag-content{display:none}#shoppingCart #orderSummary .orderTotal{font-weight:700;display:none}#shoppingCart .alignCenter{text-align:center}#shoppingCart .alignDirection{text-align:right}#shoppingCart div .col{float:left;min-height:1px;overflow:visible}#shoppingCart .description,#shoppingCart .quantity{width:30%}#shoppingCart .price{width:15%;text-align:left;margin-left:10px}#shoppingCart .itemTotalCost{width:20%}#shoppingCart .summaryElement{padding-left:20px;width:40%}#shoppingCart .summaryElementHead{padding-left:20px;width:70%}#shoppingCart .summaryElementCost{padding-right:20px;width:60%}#shoppingCart .buttonsContainer{padding:20px 12% 25px;min-width:226px}#shoppingCart h4{font-size:13px;font-family:HelveticaNeueBold,HelveticaNeue-Bold,Helvetica Neue Bold,HelveticaNeue,Helvetica Neue,sans-serif}#shoppingCart #quantity{text-align:center}#shoppingCart #quantity div{width:37px;display:inline;border:1px solid #cbd2d6;padding:7px 10px;vertical-align:-7px}#shoppingCart #quantity a{font-size:13px}#shoppingCart #quantity input{border:none;width:inherit}#shoppingCart .stepper{color:#2c2e2f}#shoppingCart a#incr{margin-right:-1px;margin-left:-1px;font-size:15px}#shoppingCart a#decr{font-size:15px}#shoppingCart *{box-sizing:border-box}@media (max-width:60em) and (min-width:50em){#shoppingCart #items{width:53%}}@media (max-width:50em) and (min-width:20em){#shoppingCart #items{width:50%}#shoppingCart .itemPrice,#shoppingCart .price{display:none}#shoppingCart .row{padding:15px 0;border-bottom:0}#shoppingCart .moreLessDetails{display:block;clear:both}#shoppingCart .description,#shoppingCart .quantity{width:35%}#shoppingCart .price{width:15%;padding-right:20px}#shoppingCart .itemTotalCost{width:30%}#shoppingCart .buttonsContainer{padding:20px 4% 25px}}@media (max-width:30em) and (min-width:0){#shoppingCart #items{display:block;overflow-y:scroll;width:100%;margin-top:0}#shoppingCart #items .itemPrice,#shoppingCart #items .rowHead{display:none}#shoppingCart #items .row{padding:15px 0;border-bottom:0;border-top:5px solid #f7f9fa}#shoppingCart #items .itemDetails{padding:0 20px}#shoppingCart #items .moreLessDetails{display:block;clear:both}#shoppingCart #items .lessDetails{padding:0 20px}#shoppingCart .pushDown{transform:translateY(41px)}#shoppingCart .optionLine{width:222px}#shoppingCart #orderSummary{width:100%;float:left;background-color:#fff;position:fixed;bottom:41px;left:0;right:0}#shoppingCart #orderSummary .row{border:none}#shoppingCart #orderSummary .rowHead{border-top:1px solid #e3e3e3;padding-top:20px;padding-bottom:20px}#shoppingCart #orderSummary .firstRow{padding-top:0}#shoppingCart #orderSummary .checkoutButtons{border-top:1px solid #e3e3e3;background-color:#fff}#shoppingCart #orderSummary .optionText{background-color:#fff}#shoppingCart #orderSummary .details-expand{max-height:0;background-color:#f7f9fa;-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in;overflow:hidden}#shoppingCart #orderSummary .details-expand.expansion{max-height:350px;-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}#shoppingCart #orderSummary .transparent{background-color:#f7f9fa;background-color:rgba(247,249,250,.85)}#shoppingCart #orderSummary .orderTotal{display:inline-block}#shoppingCart #orderSummary .buttonsContainer{padding-bottom:20px;width:100%}#shoppingCart #orderSummary .opaque{background-color:#fff}#shoppingCart .summaryElementHead{width:40%}#shoppingCart #cartContents{min-height:0}#shoppingCart .transparentBgr{background:transparent!important}#shoppingCart .arrow{display:inline-block}#shoppingCart .header{padding-top:15px}#shoppingCart .description{width:35%;padding-left:20px}#shoppingCart .quantity{width:40%}#shoppingCart .price{width:15%;padding-right:20px}#shoppingCart .itemTotalCost{width:25%;padding-right:20px}#shoppingCart [dir=ltr] .itemTotalCost{float:right!important}#shoppingCart .tileArrow:after{content:\"^\"}#shoppingCart .itemTotal{font-weight:500}}@media (max-height:40em) and (min-height:0){#shoppingCart .buttonsContainer{padding:5px 4%}#shoppingCart .memberCheckout{padding-bottom:5px}#shoppingCart .guestCheckout{padding-top:15px;padding-bottom:10px}}[dir=rtl] #shoppingCart .continueLink{float:left}[dir=rtl] #shoppingCart .frontArrow,[dir=rtl] #shoppingCart .frontArrow.disabled,[dir=rtl] #shoppingCart .frontArrow.disabled:focus,[dir=rtl] #shoppingCart .frontArrow.disabled:hover{background-position:-196px -220px}[dir=rtl] #shoppingCart div.col{float:right}[dir=rtl] #shoppingCart .alignDirection{text-align:left}[dir=rtl] #shoppingCart #items{background-color:#fff;float:right}[dir=rtl] #shoppingCart #items .itemNumber,[dir=rtl] #shoppingCart #items .itemNumber.ellipsisEffect,[dir=rtl] #shoppingCart #items .nameOfItem,[dir=rtl] #shoppingCart #items .nameOfItem.ellipsisEffect{padding-left:10px;padding-right:0}[dir=rtl] #shoppingCart #items .itemTotalCost{text-align:left;padding-left:10px}[dir=rtl] #shoppingCart #items .moreLessDetails{clear:none}[dir=rtl] #shoppingCart #orderSummary{float:left}[dir=rtl] #shoppingCart #orderSummary .summaryElementHead{float:right;padding-left:0;padding-right:20px}[dir=rtl] #shoppingCart #orderSummary .summaryElement{padding-left:0;padding-right:20px}[dir=rtl] #shoppingCart #orderSummary .summaryElementCost{padding-right:0;padding-left:20px}@media (max-width:30em) and (min-width:0){[dir=rtl] #shoppingCart #items .moreLessDetails{display:block;clear:both}[dir=rtl] #shoppingCart #items .lessDetails{padding:0 20px}[dir=rtl] #shoppingCart #items .itemTotalCost{float:left;padding-right:0;padding-left:20px}[dir=rtl] #shoppingCart #items .description{padding-left:0;padding-right:20px}[dir=rtl] #shoppingCart .price{padding-right:0;padding-left:20px}}[dir=rtl] #shoppingCart .paypal-button-content{direction:ltr}[dir=rtl] .shopping-cart-container .footerLinks{float:right}[dir=rtl] .shopping-cart-container .headerWrapper{margin-right:0!important}.shopping-cart-container .headerWrapper{margin-left:0!important}.shopping-cart-container .merchantHeader{border-bottom:1px solid #e3e3e3}.shopping-cart-container .footer{position:static;max-width:940px!important;background-color:#fff;margin-top:50px!important;margin-bottom:50px!important;border-top:1px solid #d4d9dc}.shopping-cart-container .footerWrapper{width:100%!important;padding-top:10px}.shopping-cart-container .footerLinks{float:left}.shopping-cart-container div#wrapper{border:none;max-width:1000px;min-height:540px;min-height:70vh}@media (max-width:30em) and (min-width:0){.shopping-cart-container .cartBody{background-color:#f7f9fa!important}.shopping-cart-container .header{padding:0 20px}.shopping-cart-container #contents{padding:0!important}.shopping-cart-container .footer{margin-top:0!important;margin-bottom:0!important;position:fixed;left:0;right:0;bottom:0!important;padding-left:15px!important;padding-right:15px!important}.shopping-cart-container .poweredBy{display:none}}#emptyCart .header{border-bottom:1px solid #e3e3e3;padding-top:15px;padding-bottom:20px}#emptyCart #headerText{font-size:15px;font-weight:500;display:inline}#emptyCart .emptyCartContainer{margin-top:25%;margin-bottom:25%;text-align:center}#emptyCart .message{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:24px;font-weight:300;color:#2c2e2f;width:80%;margin-left:auto;margin-right:auto}#emptyCart .confirmation{font-size:1.5em;text-align:center;color:#2c2e2f}#emptyCart .btn{height:44px;margin-top:30px;width:380px}#emptyCart .btn:focus,#emptyCart .btn:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#emptyCart *{box-sizing:border-box}@media (max-width:30em) and (min-width:0){#emptyCart .btn{width:80%}#emptyCart .emptyCartContainer{margin-top:50%}}@media (max-width:30em) and (min-width:0){.shopping-cart-container .header{padding:0 20px}.shopping-cart-container #contents{padding:0!important}}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}@media (min-width:41.3125em){section#genericMessage .container{width:400px}.genericMessage.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericMessage.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericMessage{height:450px;background:none}section#genericMessage .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericMessage .title{font-size:1.5em;margin-bottom:15px}section#genericMessage .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericMessage .secondaryMessage{color:#979797;line-height:20px}section#genericMessage .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericMessage .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericMessage .cancelLink{margin-top:20px}.spinnerBtn .spinner{margin:8px 0 0;height:25px;width:25px;position:static;display:inline-block;z-index:10;padding:0;background-color:transparent;border-width:1.5px;border-style:solid;border-radius:100%;border-color:#009cde #fff #fff;top:0;left:50%;opacity:1;filter:alpha(opacity=100);-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear}.loading #main{opacity:.1}.spinner{height:100%;width:100%;position:absolute;top:0;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url('https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png') no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .loadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100;outline:none}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.modal-wrapper .modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.8;z-index:150}.modal-wrapper .modal-dialog{overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal-wrapper .modal-content{display:block;position:absolute;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.modal-wrapper .modal-default{height:auto;width:200px;padding:30px;background-color:#fff;background-clip:padding-box}.modal-wrapper .modal-default .close{position:absolute;top:15px;right:20px;width:19px;height:19px;padding:0;font-size:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.modal-wrapper .modal-default .close{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.modal-wrapper .modal-default .close:focus,.modal-wrapper .modal-default .close:hover{background-position:-223px -22px;text-decoration:none}.modal-wrapper .popLink{word-break:break-all;font-size:.8em}@font-face{font-family:consumer-icons;src:url('https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.eot');src:url('https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.eot?#iefix') format('embedded-opentype'),url('https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.woff') format('woff'),url('https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.ttf') format('truetype'),url('https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.svg#69ac2c9fc1e0803e59e06e93859bed03') format('svg');font-style:normal;font-weight:400}.icon{font-family:consumer-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-small:before{font-size:1.58rem}.icon-medium:before{font-size:2.6rem}.icon-large:before{font-size:7.8rem}.icon-burger-small:before{content:\"\\E000\"}.icon-slider-small:before{content:\"\\E001\"}.icon-slider-half-small:before{content:\"\\E002\"}.icon-close-small:before{content:\"\\E003\"}.icon-add-small:before{content:\"\\E004\"}.icon-arrow-down-small:before{content:\"\\E005\"}.icon-arrow-up-small:before{content:\"\\E006\"}.icon-arrow-left-small:before{content:\"\\E007\"}.icon-arrow-right-small:before{content:\"\\E008\"}.icon-arrow-down-half-small:before{content:\"\\E009\"}.icon-arrow-up-half-small:before{content:\"\\E010\"}.icon-arrow-left-half-small:before{content:\"\\E011\"}.icon-arrow-right-half-small:before{content:\"\\E012\"}.icon-clear-half-small:before{content:\"\\E013\"}.icon-checkmark-small:before{content:\"\\E014\"}.icon-checkmark-small-bold:before{content:\"\\E015\"}.icon-action-arrow-half-small:before{content:\"\\E016\"}.icon-tooltip-outline-small:before{content:\"\\E017\"}.icon-tooltip-small:before{content:\"\\E018\"}.icon-info-small:before{content:\"\\E019\"}.icon-positive-small:before{content:\"\\E020\"}.icon-attention-small:before{content:\"\\E021\"}.icon-critical-small:before{content:\"\\E022\"}.icon-info-large:before{content:\"\\E023\"}.icon-positive-large:before{content:\"\\E024\"}.icon-attention-large:before{content:\"\\E025\"}.icon-critical-large:before{content:\"\\E026\"}.icon-pp-logo:before{content:\"\\E029\"}.icon-visa-logo:before{content:\"\\E030\"}.icon-mastercard-logo:before{content:\"\\E031\"}.icon-maestro-logo:before{content:\"\\E032\"}.icon-amex-logo:before{content:\"\\E033\"}.icon-discover-logo:before{content:\"\\E034\"}.icon-card-half-solid:before{content:\"\\E035\"}.icon-bank-half-solid:before{content:\"\\E036\"}.icon-profile-large:before{content:\"\\E037\"}.icon-profile-add-large:before{content:\"\\E038\"}.icon-notification-small:before{content:\"\\E039\"}.icon-settings-small:before{content:\"\\E040\"}.icon-profile-small:before{content:\"\\E041\"}.icon-funnel-small:before{content:\"\\E042\"}.icon-delete-small:before{content:\"\\E043\"}.icon-edit-small:before{content:\"\\E044\"}.icon-lock-small:before{content:\"\\E045\"}.icon-pdf-small:before{content:\"\\E046\"}.icon-contact-small:before{content:\"\\E047\"}.icon-undo-small:before{content:\"\\E048\"}.icon-cancel-small:before{content:\"\\E049\"}.icon-simple-list-small:before{content:\"\\E050\"}.icon-detailed-list-small:before{content:\"\\E051\"}.icon-print-small:before{content:\"\\E052\"}.icon-camera-small:before{content:\"\\E053\"}.icon-info-outline-small:before{content:\"\\E054\"}.icon-us-dollar-outline-small:before{content:\"\\E055\"}.icon-calendar-half-small:before{content:\"\\E056\"}.icon-hiper-logo:before{content:\"\\E057\"}.icon-hipercard-logo:before{content:\"\\E058\"}.icon-elo-logo:before{content:\"\\E059\"}.icon-star-small:before{content:\"\\E060\"}.icon-jcb-logo:before{content:\"\\E061\"}.icon-attention-outline-small:before{content:\"\\E062\"}.icon-unionpay-logo:before{content:\"\\E063\"}.icon-search-small:before{content:\"\\E064\"}.icon-desktop-small:before{content:\"\\E065\"}.icon-mobile-small:before{content:\"\\E066\"}.icon-laptop-small:before{content:\"\\E067\"}.icon-tablet-small:before{content:\"\\E068\"}.icon-send-money:before{content:\"\\E500\"}.icon-request-money:before{content:\"\\E501\"}.icon-photo:before{content:\"\\E502\"}.icon-gift-cards:before{content:\"\\E503\"}.icon-credit-card:before{content:\"\\E504\"}.icon-truck:before{content:\"\\E505\"}.icon-email:before{content:\"\\E506\"}.icon-email-solid:before{content:\"\\E507\"}.icon-bank-check:before{content:\"\\E508\"}.icon-calendar:before{content:\"\\E509\"}.icon-holiday:before{content:\"\\E510\"}.icon-gift:before{content:\"\\E511\"}.icon-wallet:before{content:\"\\E512\"}.icon-play-video:before{content:\"\\E513\"}.icon-heart:before{content:\"\\E514\"}.icon-shield:before{content:\"\\E515\"}.icon-tunes:before{content:\"\\E516\"}.icon-invoice:before{content:\"\\E517\"}.icon-shopping-bag:before{content:\"\\E518\"}.icon-phone:before{content:\"\\E519\"}.icon-phone-solid:before{content:\"\\E520\"}.icon-tag:before{content:\"\\E521\"}.icon-delivery:before{content:\"\\E522\"}.icon-questionmark:before{content:\"\\E523\"}.icon-cut-coupons:before{content:\"\\E524\"}.icon-register:before{content:\"\\E525\"}.icon-house:before{content:\"\\E526\"}.icon-gift-card:before{content:\"\\E527\"}.icon-messages:before{content:\"\\E528\"}.icon-add-money:before{content:\"\\E529\"}.icon-send-check:before{content:\"\\E530\"}.icon-paypal-me:before{content:\"\\E531\"}.icon-pp-logo-outline:before{content:\"\\E532\"}.icon-money-bag:before{content:\"\\E533\"}.icon-chip-pin:before{content:\"\\E534\"}.icon-boleto-ready:before{content:\"\\E535\"}.icon-boleto-topup:before{content:\"\\E536\"}.icon-clock-pay:before{content:\"\\E537\"}.icon-speeding-cart:before{content:\"\\E538\"}.icon-international-transfer:before{content:\"\\E539\"}.errorTooltip{background-color:#c72e2e;border-radius:5px;color:#fff;display:none;padding:7px;position:absolute;top:49px;z-index:2;font-size:.8em}.errorTooltip.fixed{position:relative;top:0;margin-bottom:10px}.errorTooltipRequired{z-index:3}.validated .ng-invalid:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid:focus~.errorTooltipRuleSpecific{display:block!important}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~.errorTooltipRuleSpecific,.validated .ignoreValidation input[type=checkbox].ng-invalid~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRuleSpecific{display:none!important}.validated .ng-invalid-required:focus:not([type=checkbox])~.errorTooltipRequired,.validated input[type=checkbox].ng-invalid.hasErrorTooltipRuleSpecific:focus~.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid:focus:not(.hasErrorTooltipRuleSpecific)~.errorTooltipRequired{display:block!important}.validated input[type=checkbox].ng-invalid+.errorTooltipRequired+.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{top:35px;left:-20px}.validated .errorTooltip:empty{display:none!important}.backendError:focus~.errorTooltipRuleSpecific{display:block}.custom-select-container>select.backendError+span.custom-select>span,.inputField input.backendError,.validated .ng-invalid,.validated input.ng-invalid:active,.validated input.ng-invalid:focus,input.backendError{border:1px solid #c72e2e}.toolTip{display:none;font-size:.8em;color:#2c2e2f}.toolTip.balloon{position:absolute;z-index:2;padding:7px;text-align:left;border:1px solid #e1e7eb;border-radius:5px;background:#e1e7eb}.toolTip.displayInline{font-size:.9em;padding:10px 30px;font-size:.85em}.highZindexTooltip .toolTip.balloon{z-index:3}.left{left:0}.right{right:0}@media (min-width:42em){.mobileApp header{display:none}.mobileApp #wrapper{margin:0;max-width:inherit;width:100%}.mobileApp .paypalHeader{width:100%}.mobileApp .footer{max-width:inherit}.mobileApp section .row-fluid .span14{width:100%}.mobileApp .feedback,.mobileApp section .row-fluid .span10{display:none}}@keyframes pulse{0%{transform:scale(1);-webkit-transform:scale(1)}50%{transform:scale(1.1);-webkit-transform:scale(1.1)}to{transform:scale(1);-webkit-transform:scale(1)}}@-webkit-keyframes pulse{0%{transform:scale(1);-webkit-transform:scale(1)}50%{transform:scale(1.1);-webkit-transform:scale(1.1)}to{transform:scale(1);-webkit-transform:scale(1)}}.pulseAnimation{animation-name:pulse;animation-duration:1s;animation-iteration-count:1;animation-delay:0s;-webkit-animation-name:pulse;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-delay:0s}@keyframes shake{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}10%,30%,50%,70%,90%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}20%,40%,60%,80%{-webkit-transform:translateX(10px);transform:translateX(10px)}}@-webkit-keyframes shake{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}10%,30%,50%,70%,90%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}20%,40%,60%,80%{-webkit-transform:translateX(10px);transform:translateX(10px)}}.shakeAnimation{animation-name:shake;animation-duration:1s;animation-iteration-count:1;animation-delay:0s;-webkit-animation-name:shake;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-delay:0s}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 33px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1182px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.error .custom-select.active>span,.error .custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.framed ul.footerLinks:before{width:12px;height:12px;margin:3px 10px 10px 0;display:block;float:left;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;content:''}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.framed ul.footerLinks:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.framed .btn.escapeHatch{width:22px;height:20px;border:0;margin-left:0;display:inline-block;background-image:url('https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png');background-size:200px;background-position:-151px -35px;background-color:transparent;cursor:pointer}.framed #closeButton{width:11px;height:14px;padding:0;position:fixed;top:29px;right:20px;display:block;z-index:5;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-44px 1px;-webkit-tap-highlight-color:rgba(0,0,0,.2);text-indent:-999em;overflow:hidden}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.framed #closeButton{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}@media (max-width:30em) and (min-width:0){.framed .DE footerLinks,.framed .footerLinks,.framed .fr.FR .footerLinks{width:45%}.framed .copyright,.framed .DE .copyright{float:left;width:28%}.framed .paypalHeaderWrapper .paypalHeader{padding-bottom:15px}.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}.framed .paypalHeaderWrapper .logo{margin:18px 0 0}.framed .spinner{position:fixed}.framed .spinner .spinWrap{position:fixed;top:50%;height:48px;margin-top:-24px}.framed .footer{padding:5px 22px}.framed .secureIcon{display:none}}@media (max-width:41.3125em){.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}}.buy-now-container{width:480px;margin:0 auto}@media (max-width:30em){.buy-now-container{width:100%}}.buy-now-container.error-page{width:auto}.buy-now-container #wrapper{width:100%;border:1px solid #e3e3e3}.buy-now-container #contents,.buy-now-container #main{padding:0}.buy-now-container .openbutton-wrapper{padding-top:25px}.buy-now-container .header{background-color:#f2f3f4;border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3;padding:10px;text-align:center;height:auto;word-wrap:break-word}.buy-now-container .form-wrap{padding:25px}.buy-now-container .form-wrap form{margin-bottom:45px}@media (max-width:30em){.buy-now-container .form-wrap{padding:25px 10px}}.buy-now-container .inputField input{border:1px solid #9da3a6}.buy-now-container .inputField input[disabled]{cursor:not-allowed;background-color:#f2f3f4;border:1px solid #9da3a6}.buy-now-container .amount-col,.buy-now-container .quantity-col{box-sizing:border-box}.buy-now-container .amount-col{width:70%;float:left;padding-right:10px}@media (max-width:30em){.buy-now-container .amount-col{width:100%;padding-right:0}}.buy-now-container .quantity-col{width:30%;float:left}@media (max-width:30em){.buy-now-container .quantity-col{width:100%}}.buy-now-container .continue-btn{width:100%}.buy-now-container .cancel-link{text-align:center}.buy-now-container .description-txt{text-align:center;margin-bottom:1em}.buy-now-container .input-group{position:relative;display:table;border-collapse:separate}@media (max-width:30em){.buy-now-container .input-group{margin-bottom:10px}}.buy-now-container .input-group .input-group-addon,.buy-now-container .input-group input{display:table-cell}.buy-now-container #itemPrice{border-top-right-radius:0;border-bottom-right-radius:0;width:100%;margin:0}.buy-now-container .currency{width:1%;vertical-align:middle;border-top-right-radius:4px;border-bottom-right-radius:4px;padding:0 14px;color:#6c7378;border:1px solid #9da3a6;border-left:0}.buy-now-container .powered-by{color:#6c7378;text-align:center;font-style:italic;line-height:2em}.buy-now-container .powered-by .logo{background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v15.png\");background-repeat:no-repeat;width:112px;height:29px;display:inline-block;vertical-align:middle;margin-left:5px}.buy-now-container .footer{margin:0 auto;padding:0;width:100%;border:0;box-sizing:border-box}.buy-now-container .footer .cancelUrl,.buy-now-container .footer .poweredBy{display:none}.buy-now-container .footer .footerWrapper{padding-top:10px;margin:0;width:100%}.buy-now-container .footer .footerLinks{width:70%;text-align:left;float:left}@media (max-width:30em) and (min-width:0){.buy-now-container .footer{padding:0 10px!important}.buy-now-container .footer .footerLinks{width:65%}}[dir=rtl] .buy-now-container .inputField.floatingLabel label{right:14px;transform-origin:right top 0;left:auto}[dir=rtl] .buy-now-container .inputField.ltrOverride .errorTooltip{right:0}[dir=rtl] .buy-now-container .validated .inputField.floatingLabel input.ng-invalid{padding-top:16px;padding-right:14px;padding-left:34px;background-position:10px}[dir=rtl] .buy-now-container .currency{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px;border-left:1px solid #9da3a6;border-right:0}[dir=rtl] .buy-now-container #itemPrice{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:4px;border-bottom-right-radius:4px}[dir=rtl] .buy-now-container .amount-col{float:right;padding-right:0;padding-left:10px}@media (max-width:30em){[dir=rtl] .buy-now-container .amount-col{padding-left:0}}[dir=rtl] .buy-now-container .quantity-col{float:left}[dir=rtl] .buy-now-container .footer .footerLinks{float:right}[dir=rtl]{direction:rtl;unicode-bidi:embed}[dir=rtl] .ltrOverride{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .row-fluid>[class*=span]{float:right}[dir=rtl] .row-fluid>.span10{float:left;margin-left:0}[dir=rtl] .paypalHeaderWrapper .logo{float:right;margin-right:5px}[dir=rtl] input::-webkit-input-placeholder{direction:rtl}[dir=rtl] input:-moz-placeholder,[dir=rtl] input::-moz-placeholder{direction:rtl;text-align:right}[dir=rtl] input:-ms-input-placeholder{direction:rtl}[dir=rtl] .msg-desc .icon,[dir=rtl] .msg-error .icon,[dir=rtl] .msg-info .icon,[dir=rtl] .msg-success .icon,[dir=rtl] .msg-warning .icon{left:auto;right:0}[dir=rtl] .msgPage ul{padding:0 25px 0 0}[dir=rtl] .merchantHeader .merchantName{text-align:right}[dir=rtl] .cartContainer{float:left;right:auto;left:0;margin-left:0}[dir=rtl] #transactionCart{float:left}[dir=rtl] #transactionCart .arrow{margin:5px 5px 0 0}[dir=rtl] #transactionCart .cartIcon{margin:0 0 0 6px}[dir=rtl] #transactionDetails.cart .hasNoItems #transactionCart,[dir=rtl] .hasNoItems.transactionDetails #transactionCart,[dir=rtl] .hasNoItems.transactionDetails:active #transactionCart,[dir=rtl] .hasNoItems.transactionDetails:focus #transactionCart{background-position:right 9px;padding-right:27px;padding-left:0}[dir=rtl] .transctionCartDetails{left:43.42553193%;right:auto}[dir=rtl] .transctionCartDetails .pointer{right:auto;left:38px}[dir=rtl] .transctionCartDetails .detail-extras .amounts .itemPrice,[dir=rtl] .transctionCartDetails .detail-items .items .itemPrice,[dir=rtl] .transctionCartDetails .subTotal .itemPrice{text-align:left}[dir=rtl] .transctionCartDetails .detail-extras .amounts .itemName,[dir=rtl] .transctionCartDetails .detail-items .items .itemName,[dir=rtl] .transctionCartDetails .subTotal .itemName{text-align:right}[dir=rtl] .cartContainer .hasAmount .pointer{right:auto;left:57px}[dir=rtl] .emailField input,[dir=rtl] .passwordField input{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .checkbox input[type=checkbox]~label{padding-left:0;background-position:right 0;margin-right:-5px;padding-right:40px}[dir=rtl] .checkbox.error input[type=checkbox]:focus~label,[dir=rtl] .checkbox.error input[type=checkbox]~label{background-position:right -600px}[dir=rtl] .checkbox input[type=checkbox]:checked~label{background-position:right -400px}[dir=rtl] .checkbox input[type=checkbox]:focus:checked~label{background-position:right -4801px}[dir=rtl] .checkbox input[type=checkbox]:focus~label{background-position:right -4601px}[dir=rtl] .validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,[dir=rtl] .validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:right 0}[dir=rtl] .validated input[type=checkbox].ng-invalid~label{background-position:right -600px}[dir=rtl] .validated input[type=radio].ng-invalid+label,[dir=rtl] .validated input[type=radio].ng-invalid:focus+label{background-position:right -2200px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]~label{background-position:right -2600px}[dir=rtl] .sCheckbox.checkbox.error input[type=checkbox]:focus~label,[dir=rtl] .sCheckbox.checkbox.error input[type=checkbox]~label{background-position:right -3200px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:right -3000px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:right -5409px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:right -2800px}[dir=rtl] .radioButton input[type=radio]~label{padding-left:0;background-position:right -1600px;margin-right:-5px;padding-right:40px}[dir=rtl] .radioButton.error input[type=radio]+label,[dir=rtl] .radioButton.error input[type=radio]:focus+label{background-position:right -2200px}[dir=rtl] .radioButton.warning input[type=radio]+label,[dir=rtl] .radioButton.warning input[type=radio]:focus+label{background-position:right -7405px}[dir=rtl] .radioButton input[type=radio]:checked+label{background-position:right -2000px}[dir=rtl] .radioButton input[type=radio]:focus:checked+label{background-position:right -6010px}[dir=rtl] .radioButton input[type=radio]:focus+label{background-position:right -1800px}[dir=rtl] .inputField label{text-align:right}[dir=rtl] .dropdown.billingAddress a{float:left}[dir=rtl] .allFundingInstrumentsList li .fsIcon{margin:18px 15px 0 10px}[dir=rtl] .validated select.backendError+.custom-select>span,[dir=rtl] .validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat left 10px center;background-size:18px}[dir=rtl] .validated div.inputField:not(.ltrOverride).error input,[dir=rtl] .validated div.inputField:not(.ltrOverride) input.backendError,[dir=rtl] .validated div.inputField:not(.ltrOverride) input.ng-invalid{background-size:18px;background-position:10px;padding:0 14px 0 29px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){[dir=rtl] .inputField.error input,[dir=rtl] .validated .inputField input.backendError,[dir=rtl] .validated .inputField input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat 98% left;background-size:18px;background-position:10px}[dir=rtl] .validated select.backendError+.custom-select>span,[dir=rtl] .validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat left 10px center;background-size:18px}}[dir=rtl] .fsIcons{padding-right:0;float:right;margin-left:10px}[dir=rtl] div.inputField:not(.ltrOverride) .inputField input{padding-right:10px}[dir=rtl] div.inputField:not(.ltrOverride) #securityCode.creditCard,[dir=rtl] div.inputField:not(.ltrOverride) .ccard,[dir=rtl] div.inputField:not(.ltrOverride) .creditCardField .creditCard{left:10px;right:inherit}[dir=rtl] .verifyHelp{text-indent:100%;white-space:nowrap;overflow:hidden}[dir=rtl] .toolTip.balloon{text-align:right;top:125px}[dir=rtl] #payUponInvoice .edits{padding:7px 10px 4px 0}[dir=rtl] .cardType.split{float:left}[dir=rtl] .creditCardField.split,[dir=rtl] div#phoneTypeSelection{float:right}[dir=rtl] .custom-select>span{background-position:left 5px top -1182px;padding:7px 13px 7px 30px}[dir=rtl] .error .custom-select.active>span,[dir=rtl] .error .custom-select>span{background-position:left 10px center}[dir=rtl] .emailHelper{left:10px;right:inherit}[dir=rtl] .footer .languageToggleDisplay #langDropdownBlock{right:-50px;left:5px}[dir=rtl] .footer .languageToggleDisplay #langDropdownBlock.bottom>.arrow:after{margin-left:0;margin-right:-10px}[dir=rtl] .footer .languageToggleDisplay .changeLanguage{margin:5px 5px 0 0}[dir=rtl] .footer .cancelUrl{float:right}[dir=rtl] .footer .footerWrapper{float:left;text-align:left}[dir=rtl] .footer .footerWrapper .footerLinks{background-position:100%;padding-right:0;width:auto}[dir=rtl] .footer .footerWrapper .footerLinks li{padding-right:0;padding-left:12px}[dir=rtl] .footer .footerWrapper .copyright{width:auto;padding-right:10px}[dir=rtl] .poweredBy{float:left}[dir=rtl] .poweredBy .text{float:right;margin-top:12px}[dir=rtl] .paywith .method{float:right}[dir=rtl] .paywith .method .name{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .paywith .methodAmount{float:left}[dir=rtl] .paywith .conversion,[dir=rtl] .paywith .methodAmount .currencyCode{text-align:left}[dir=rtl] .paywith .billingTxt{text-align:right}[dir=rtl] #paymentMethod .edits,[dir=rtl] #shippingAddress .edits{right:auto;left:-9px}[dir=rtl] .sidebar{left:0;right:-357px}[dir=rtl] .trayOpen #main{margin-left:-327px}[dir=rtl] #disclaimerWithBmlCta span{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] #main{float:left;margin-right:0}[dir=rtl] .trayOpen .maskMember .trayViewMask{left:38px}[dir=rtl] #selectFunding .checkIcon,[dir=rtl] #selectFunding .infoIcon,[dir=rtl] #selectShipping .checkIcon,[dir=rtl] #selectShipping .infoIcon{left:15px;right:auto}[dir=rtl] #manageFunding .fsIcon,[dir=rtl] #selectFunding .fsIcon{float:right}[dir=rtl] #closeCart{float:left;margin:15px 0 0 15px}[dir=rtl] .languageToggleDisplay{left:0;right:auto}[dir=rtl] .languageToggleDisplay .displayText{margin-right:0}[dir=rtl] .languageToggleDisplay .changeLanguage{margin:5px 10px 0 0}[dir=rtl] .aside .close{left:10px;right:auto}[dir=rtl] .aside .backArrow{right:10px}[dir=rtl] .aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -256px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){[dir=rtl] .aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}[dir=rtl] .aside .backArrow:focus:before,[dir=rtl] .aside .backArrow:hover:before{background-position:-232px -278px}[dir=rtl] .right{left:0;float:left}[dir=rtl] .left{float:right}[dir=rtl] #selectShipping .subHeader .rightIcon,[dir=rtl] .subHeader .rightIcon{float:left!important;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -220px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){[dir=rtl] #selectShipping .subHeader .rightIcon,[dir=rtl] .subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}[dir=rtl] #selectShipping .subHeader .rightIcon:focus,[dir=rtl] #selectShipping .subHeader .rightIcon:hover,[dir=rtl] .subHeader .rightIcon:focus,[dir=rtl] .subHeader .rightIcon:hover{background-position:-200px -235px}[dir=rtl] #selectShipping .subHeader .leftIcon,[dir=rtl] .subHeader .leftIcon{float:right!important;margin:4px 0 0 6px}[dir=rtl] #addCard .addNewBillingAddress{float:left}[dir=rtl] .creditCardInput .cardIcon,[dir=rtl] .creditCardInput .expirationField{float:right}[dir=rtl] .creditCardInput .cvvField{float:left}[dir=rtl] .inputField.noFloatingLabel label{right:14px;left:auto;text-align:right}[dir=rtl] #manageFunding .manageLinks{position:absolute;top:25px;left:0;right:auto}[dir=rtl] #manageFunding .manageLinks .updateButton{padding:0 0 0 10px}[dir=rtl] #manageFunding .manageLinks .deleteButton{padding:0 10px 0 15px}[dir=rtl] #manageFunding .infoIcon{right:auto;left:15px}[dir=rtl] #manageFunding .confirm{left:0;right:auto;transform:translate(-100%)}[dir=rtl] #manageFunding .slideIn{transform:translate(0)}[dir=rtl] #manageFunding .slide{transform:translate(6%)}[dir=rtl] #deleteShipping .delete{left:0;right:auto;-webkit-transform:translate(0);transform:translate(0)}[dir=rtl] #deleteShipping .delete.slideOut{-webkit-transform:translate(-102%);transform:translate(-102%)}[dir=rtl] #deleteShipping .msgIcon{right:auto;left:15px}[dir=rtl] #deleteShipping .slide{transform:translate(15%)}[dir=rtl] #deleteShipping .confirm{-webkit-transform:translate(-102%);transform:translate(-102%)}[dir=rtl] #deleteShipping .confirm.slidein{-webkit-transform:translate(0);transform:translate(0)}[dir=rtl] .overlayWrapper{right:auto}[dir=rtl] #langDropdownBlock{left:-15px;right:auto}[dir=rtl] #langDropdownBlock.bottom>.arrow:after{margin:0 -10px 0 0}[dir=rtl] #shippingAddress .frontArrow,[dir=rtl] .paywith .frontArrow{left:0;right:auto;background-position:-200px -216px}[dir=rtl] .footer .footerWrapper .copyright{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .footer .footerWrapper .copyright .secureIcon{float:left;margin:3px 8px 0 0}@media (max-width:41.25em){[dir=rtl] .trayOpen .sidebar{right:-327px}[dir=rtl] .trayOpen .maskMember .trayViewMask{left:32px}[dir=rtl] .footer .footerWrapper .footerLinks{float:right;width:50%;text-align:right}[dir=rtl] .footer .footerWrapper .footerLinks li{padding-left:0;margin-left:10px;margin-right:0}[dir=rtl] .footer .footerWrapper .copyright{float:left}[dir=rtl] .transctionCartDetails{left:0;right:auto;width:320px}}@media (max-width:30em) and (min-width:0){[dir=rtl] .footer li{margin-right:0}[dir=rtl] .footer .footerWrapper .footerLinks{width:48%;padding-right:0}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/css-loader/lib/css-base.js":
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ "../node_modules/style-loader/addStyles.js":
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ "./components/xo-beaver/dist/logger.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-beaver/dist/level.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver', ['beaver.level']).factory('$Logger', function ($injector, $http, $window, $interval, $timeout, $log, $q, $rootScope, $logLevel, $consoleLogLevel) {
	
	        var logger = {};
	        var HERMES_DEV_COOKIE = 'hermesdev';
	
	        angular.forEach($logLevel, function (level) {
	            logger[level] = function (event, payload, settings) {
	                return this.log(level, event, payload, settings);
	            };
	        });
	
	        var hostname = $window.location && $window.location.hostname || '';
	
	        var uniqueEvents = [];
	
	        angular.extend(logger, {
	
	            autoLog: [$logLevel.WARNING, $logLevel.ERROR],
	            flushInterval: 10 * 60 * 1000,
	            heartbeatInterval: 5000,
	            sizeLimit: 300,
	            debounceInterval: 10,
	            uri: '/api/log',
	            hearbeatMaxThreshold: 50,
	
	            deploy: {
	                isLocal: function isLocal() {
	                    return hostname === 'localhost' || hostname === 'localhost.paypal.com';
	                },
	
	                isStage: function isStage() {
	                    return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
	                },
	
	                isLive: function isLive() {
	                    return hostname === 'www.paypal.com';
	                }
	            },
	
	            init: function init() {
	                var self = this;
	
	                this.buffer = [];
	
	                var previousBeforeUnloadHandler = $window.onbeforeunload;
	
	                $window.onbeforeunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_beforeunload');
	
	                    if (previousBeforeUnloadHandler) {
	                        return previousBeforeUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                var previousUnloadHandler = $window.onunload;
	
	                $window.onunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_unload')._flush(true);
	
	                    self.done();
	
	                    if (previousUnloadHandler) {
	                        return previousUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                this.heartbeat();
	                this.daemon();
	            },
	
	            heartbeat: function heartbeat() {
	                var self = this;
	
	                if (!window.enablePerformance) {
	                    return;
	                }
	
	                function timestamp() {
	                    var perf = window.performance;
	
	                    return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
	                }
	
	                var howBusy = {
	                    lastSampledTime: timestamp(),
	                    lastLag: 0,
	                    maxLag: 0,
	                    dampendedLag: 0
	                };
	
	                var count = 0;
	
	                $interval(function () {
	
	                    if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
	                        count = 0;
	                    }
	
	                    if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
	                        return;
	                    }
	
	                    count += 1;
	
	                    var payload = {
	                        count: count
	                    };
	
	                    var now = timestamp();
	
	                    howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
	                    howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
	                    howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
	                    howBusy.lastSampledTime = now;
	
	                    payload.lastLag = howBusy.lastLag.toFixed(4);
	                    payload.maxLag = howBusy.maxLag.toFixed(4);
	                    payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
	                    payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);
	
	                    if (howBusy.lastLag > 10000) {
	                        self.info('toobusy', {}, {
	                            noConsole: true,
	                            unique: true
	                        });
	                    }
	
	                    self.info('heartbeat', payload, {
	                        noConsole: true
	                    });
	                }, this.heartbeatInterval);
	            },
	
	            done: function done() {
	                this.isDone = true;
	            },
	
	            addPerformanceData: function addPerformanceData(payload) {
	
	                if (window.enablePerformance) {
	                    var performance = window.performance;
	                    var timing = window.performance.timing || {};
	                    var now = performance.now();
	
	                    if (window.clientStartTime && angular.isUndefined(payload.client_elapsed)) {
	                        payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
	                    }
	
	                    if (timing.connectEnd && timing.navigationStart && angular.isUndefined(payload.req_elapsed)) {
	                        payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	                    }
	                }
	            },
	
	            addLocaleData: function addLocaleData(payload) {
	
	                var context = {};
	
	                try {
	                    context = $injector.get('$metaBuilder').buildContext();
	                } catch (err) {
	                    return; // Continue without adding locale data
	                }
	                if (context.locale && context.locale.country) {
	                    payload.site_cntry = context.locale.country;
	                }
	            },
	
	            /* jslint maxcomplexity: false */
	            log: function log(level, event, payload, settings) {
	
	                var self = this;
	
	                payload = payload || {};
	
	                if (angular.isArray(payload) || !angular.isObject(payload)) {
	                    payload = {
	                        payload: payload
	                    };
	                }
	                settings = settings || {};
	
	                if (settings.unique) {
	                    var hash = event + ':' + angular.toJson(payload);
	
	                    if (uniqueEvents.indexOf(hash) > -1) {
	                        return self;
	                    }
	                    uniqueEvents.push(hash);
	                }
	
	                payload.pageID = window.meta && window.meta.pageID;
	
	                this.addPerformanceData(payload);
	                this.addLocaleData(payload);
	
	                self.print(level, event, payload, settings);
	
	                if (this.buffer.length >= this.sizeLimit) {
	                    if (this.buffer.length === this.sizeLimit) {
	                        return self.enqueue('info', 'logger_max_buffer_length');
	                    }
	                    return self;
	                }
	
	                return self.enqueue(level, event, payload, settings);
	            },
	
	            getTimestamp: function getTimestamp() {
	                var now = Date.now();
	
	                return window.logOffset ? window.logOffset + now : now;
	            },
	
	            enqueue: function enqueue(level, event, payload, settings) {
	
	                payload = payload || {};
	                settings = settings || {};
	
	                var data = {
	                    level: level,
	                    event: event,
	                    timestamp: this.getTimestamp(),
	                    payload: payload
	                };
	
	                this.buffer.push(data);
	
	                // If the log level is classified as autolog, then flush the data
	                if (this.autoLog.indexOf(level) > -1) {
	                    this.flush();
	                }
	
	                return this;
	            },
	
	            shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {
	
	                if (settings.noConsole) {
	                    return false;
	                }
	
	                if (window.meta && window.meta.corp) {
	                    return true;
	                }
	
	                if (this.deploy.isLocal() || this.deploy.isStage()) {
	                    return true;
	                }
	
	                var cookies = window.cookies || {};
	
	                if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
	                    return true;
	                }
	
	                return false;
	            },
	
	            print: function print(level, event, payload, settings) {
	
	                if (!this.shouldPrintLogsToConsole(settings)) {
	                    return;
	                }
	
	                var args = [event];
	
	                if (payload) {
	                    args.push(payload);
	
	                    if (payload.stack || payload.error || payload.warning) {
	                        args.push('\n\n', payload.stack || payload.error || payload.warning);
	                    }
	                }
	
	                $log[$consoleLogLevel[level] || 'info'].apply($log, args);
	            },
	
	            flush: function flush(immediate) {
	                var self = this;
	
	                if (!this.buffer.length) {
	                    return $q.when();
	                }
	
	                if (immediate) {
	                    return $q.when(this._flush());
	                }
	
	                if (self.debouncer_timeout) {
	                    $timeout.cancel(self.debouncer_timeout);
	                }
	
	                self.debouncer_timeout = $timeout(function () {
	
	                    var resolver = self.debouncer_resolver;
	
	                    delete self.debouncer_promise;
	                    delete self.debouncer_resolver;
	                    delete self.debouncer_timeout;
	
	                    self._flush().then(function () {
	                        resolver();
	                    });
	                }, this.debounceInterval);
	
	                self.debouncer_promise = self.debouncer_promise || $q(function (resolver) {
	                    self.debouncer_resolver = resolver;
	                });
	
	                return self.debouncer_promise;
	            },
	
	            _flush: function _flush(sync) {
	                var self = this;
	
	                if (!self.buffer.length) {
	                    return $q.when();
	                }
	
	                var meta = {};
	
	                try {
	                    meta = $injector.get('$metaBuilder').build();
	                } catch (err) {
	                    // @TODO - Log error
	                }
	
	                var req = this.ajax('post', $window.config.urls.baseUrl + this.uri, {
	                    data: {
	                        events: self.buffer
	                    },
	                    meta: meta
	                }, sync);
	
	                self.buffer = [];
	
	                return req;
	            },
	
	            ajax: function ajax(method, url, json, sync) {
	
	                return $q(function (resolve) {
	                    var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
	                    var req = new XRequest('MSXML2.XMLHTTP.3.0');
	
	                    req.open(method.toUpperCase(), url, !sync);
	                    req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	                    req.setRequestHeader('Content-type', 'application/json');
	                    req.onreadystatechange = function () {
	                        if (req.readyState > 3) {
	                            resolve();
	                        }
	                    };
	                    req.send(angular.toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
	                });
	            },
	
	            daemon: function daemon() {
	                this.stop();
	
	                var self = this;
	
	                this.timer = $interval(function () {
	                    self.flush();
	                }, this.flushInterval);
	            },
	
	            stop: function stop() {
	                if (this.timer) {
	                    $interval.cancel(this.timer);
	                }
	            }
	        });
	
	        function Logger(val) {
	            angular.extend(this, val);
	            this.init();
	        }
	
	        Logger.prototype = logger;
	        Logger.prototype.constructor = Logger;
	
	        return Logger;
	    }).factory('$logger', function ($Logger) {
	        return new $Logger();
	    }).run(function ($logger) {
	        angular.forEach(window.beaconQueue, function (payload) {
	            $logger.log(payload.level, payload.event, payload);
	        });
	
	        window.beacon = function (level, events, payload) {
	            angular.forEach(events, function (event) {
	                $logger.log(level, event, payload);
	            });
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/logger.js"))

/***/ },

/***/ "./components/xo-beaver/dist/level.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver.level', []).factory('$logLevel', function () {
	
	        return {
	            INFO: 'info',
	            DEBUG: 'debug',
	            ERROR: 'error',
	            WARN: 'warn',
	            ALERT: 'alert'
	        };
	    }).factory('$consoleLogLevel', function () {
	
	        return {
	            info: 'info',
	            debug: 'debug',
	            error: 'error',
	            warn: 'warn',
	            alert: 'info'
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/level.js"))

/***/ },

/***/ "./pages/xo-checkout/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("./components/angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-tracking/dist/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	__webpack_require__("./pages/xo-landing/route.js");
	
	__webpack_require__("./pages/xo-generic-error/route.js");
	
	__webpack_require__("./pages/xo-generic-message/route.js");
	
	__webpack_require__("./pages/xo-openbutton/route.js");
	
	__webpack_require__("./pages/xo-shopping-cart/route.js");
	
	__webpack_require__("./pages/xo-empty-cart/route.js");
	
	__webpack_require__("./pages/xo-inventory-soldout/route.js");
	
	__webpack_require__("./pages/xo-checkout/directive.js");
	
	var _constants = __webpack_require__("./js/lib/constants.js");
	
	var _customUtil = __webpack_require__("./js/lib/customUtil.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
	
	    path: 'checkout',
	    directive: 'xo-checkout',
	    titleContent: 'base.payPal',
	    defaultState: 'checkout.landing',
	    middleware: _middleware.$Middleware,
	    children: [{
	        name: '$LandingRoute'
	    }, {
	        name: '$GenericErrorRoute'
	    }, {
	        name: '$GenericMessageRoute'
	    }, {
	        name: '$xoSoldOutPageRoute'
	    }, {
	        name: '$ShoppingCartRoute'
	    }, {
	        name: '$EmptyCartRoute'
	    }, {
	        name: '$xoOpenButtonRoute'
	    }],
	    resolve: {
	        action: function action() {
	            var xClickParams = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams);
	
	            if (xClickParams.wa_type === _constants.BUYNOW_WA_TYPE) {
	                _angular.$rootScope.isOpenButton = true;
	            } else {
	                _angular.$rootScope.isShoppingCart = true;
	            }
	        }
	    }
	});
	
	
	_squid.$meta;
	
	_index.$Route;
	
	_middleware.$Middleware;
	
	_constants.BUYNOW_WA_TYPE;
	
	_customUtil.customUtil;
	
	_angular.$rootScope;
	module.exports = exports['default'];

/***/ },

/***/ "./js/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _error = __webpack_require__("./js/lib/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _fallback = __webpack_require__("./js/lib/fallback.js");
	
	Object.keys(_fallback).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _fallback[key];
	    }
	  });
	});
	
	var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");
	
	Object.keys(_metaBuilder).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _metaBuilder[key];
	    }
	  });
	});
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	Object.keys(_middleware).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _middleware[key];
	    }
	  });
	});
	
	var _security = __webpack_require__("./js/lib/security.js");
	
	Object.keys(_security).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _security[key];
	    }
	  });
	});

/***/ },

/***/ "./js/lib/error.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$forbiddenHandler = $forbiddenHandler;
	exports.$exceptionHandler = $exceptionHandler;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _fallback = __webpack_require__("./js/lib/fallback.js");
	
	function constructEventName(toState, fromState) {
	    var from = fromState.name.replace(/\./g, '_') || 'start';
	    var to = toState.name.replace(/\./g, '_') || 'end';
	
	    return 'state_change_' + from + '_to_' + to;
	}
	
	function $forbiddenHandler(err) {
	    _logger.$logger.warn('forbidden_handler');
	    if (!err.transient) {
	        _index.$AuthModel.instance().invalidate();
	        _uiRouter.$state.go('checkout.login');
	    }
	}
	
	var ERROR_HANDLERS = [{
	    type: _squid.$FallbackError,
	    handler: _fallback.$fallbackErrorHandler
	}, {
	    type: _squid.$Forbidden,
	    handler: $forbiddenHandler
	}];
	
	function $exceptionHandler(err, cause) {
	
	    if (_angular.$rootScope.ERROR_STATE) {
	
	        if (_angular.$rootScope.ERROR_PREVENTED) {
	            throw err;
	        }
	
	        return;
	    }
	
	    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
	        if (err instanceof errorHandler.type) {
	            errorHandler.handler(err);
	
	            return true;
	        }
	    });
	
	    if (handled) {
	        return;
	    } else if (!err.transient) {
	        _angular.$rootScope.ERROR_STATE = err;
	    }
	
	    var errType = (err.constructor.name || 'error').toLowerCase();
	    var errName = 'ui_unhandled_' + errType;
	    var errMsg = err.message || '';
	
	    if (errMsg.indexOf('infdig') > -1) {
	        errName = 'infinite_digest';
	    } else if (errMsg.indexOf('inprog') > -1) {
	        errName = 'digest_inprog';
	    } else if (errMsg.indexOf('badparse') > -1) {
	        errName = 'sanitize_badparse';
	    } else if (errMsg.match(/^[\w_]+$/)) {
	        errName = 'ui_unhandled_' + errMsg;
	    }
	
	    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
	        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
	            errName = 'ui_unhandled_framework_error';
	        }
	    }
	
	    if (err.transient) {
	        errName += '_transient';
	    }
	
	    var payload = {
	        error: err.stack || err.toString(),
	        message: errMsg,
	        cause: cause && cause.toString(),
	        state: _uiRouter.$state.current.name,
	        url: window.location.toString()
	    };
	
	    angular.extend(payload, err.payload || {});
	
	    _logger.$logger.error(errName, payload);
	
	    // emit the error object for subscribers like xo-tracking
	    var event = _angular.$rootScope.$emit('unhandled_error', {
	        err: err,
	        route: (_uiRouter.$state || {}).current,
	        message: payload.error,
	        code: payload.cause
	    });
	
	    if (event.defaultPrevented) {
	        _angular.$rootScope.ERROR_PREVENTED = true;
	        throw err;
	    } else if (!err.transient) {
	        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
	            reason: errName
	        }));
	    }
	}
	
	_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
	    // Set prevent default to avoid angular UI router to keep looping back to same state
	    event.preventDefault();
	    $exceptionHandler(err, constructEventName(toState, fromState));
	});
	
	_angular.$rootScope.$on('$windowError', function (event, details) {
	    _logger.$logger.error('window_error', details, {
	        unique: true
	    });
	});
	
	angular.value("$forbiddenHandler", $forbiddenHandler);
	angular.value("$exceptionHandlerLazy", $exceptionHandler);
	_angular.$rootScope;
	
	_uiRouter.$state;
	
	_squid.$util;
	
	_squid.$FallbackError;
	
	_squid.$Forbidden;
	
	_logger.$logger;
	
	_index.$AuthModel;
	
	_fallback.$fallbackErrorHandler;

/***/ },

/***/ "./components/squid/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _ng = __webpack_require__("./components/squid/dist/ng/index.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _paypal = __webpack_require__("./components/squid/dist/paypal/index.js");
	
	Object.keys(_paypal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _paypal[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/ng/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _core = __webpack_require__("./components/squid/dist/ng/core.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _route = __webpack_require__("./components/squid/dist/ng/route.js");
	
	Object.keys(_route).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _route[key];
	    }
	  });
	});
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/ng/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/ng/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _module = __webpack_require__("./components/squid/dist/ng/module.js");
	
	Object.keys(_module).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _module[key];
	    }
	  });
	});
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _events = __webpack_require__("./components/squid/dist/ng/events.js");
	
	Object.keys(_events).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _events[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/ng/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/ng/core.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.use({
	    on: function on() {
	        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
	    },
	    once: function once(name, handler) {
	        var cancel = _core.$event.on(name, function () {
	            cancel();
	            handler.apply(this, arguments);
	        }, true);
	
	        return cancel;
	    },
	    emit: function emit() {
	        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
	    },
	    broadcast: function broadcast() {
	        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
	    }
	});
	
	_core.$promise.use(_angular.$q);
	
	_angular.$q;
	
	_angular.$rootScope;
	
	_core.$event;
	
	_core.$promise;

/***/ },

/***/ "./components/squid/dist/core/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _api = __webpack_require__("./components/squid/dist/core/api.js");
	
	Object.keys(_api).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api[key];
	    }
	  });
	});
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	Object.keys(_class).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _class[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	Object.keys(_event).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _event[key];
	    }
	  });
	});
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	Object.keys(_integration).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _integration[key];
	    }
	  });
	});
	
	var _model = __webpack_require__("./components/squid/dist/core/model.js");
	
	Object.keys(_model).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _model[key];
	    }
	  });
	});
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	Object.keys(_promise).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _promise[key];
	    }
	  });
	});
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	Object.keys(_util).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _util[key];
	    }
	  });
	});
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	Object.keys(_loader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _loader[key];
	    }
	  });
	});
	
	var _dom = __webpack_require__("./components/squid/dist/core/dom.js");
	
	Object.keys(_dom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _dom[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/core/api.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$Api = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.$getLatestCorrelationID = $getLatestCorrelationID;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	 API
	 ---
	
	 This layer is responsible for handling api requests. It has a number of responsibilities:
	
	 - Caching responses
	 - Transparently returning data that has been preloaded into the initial page response
	 - Instrumentation
	 - Batching multiple api calls into a single http request
	 - Handling multiple types of responses and dispatching to the correct handlers
	 - Emitting loading events for all http calls
	 */
	
	_config.$meta.headers = _config.$meta.headers || {};
	_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];
	
	// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
	function cookiesEnabled() {
	    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
	}
	
	// Cache for api responses, when cache: true
	var cache = {};
	
	var latestCorrelationID = _config.$meta.correlationId;
	
	// Window load promise
	var windowLoad = _util.$util.memoize(function () {
	    return _promise.$promise.resolver(function (resolve) {
	        if (document.readyState === 'complete') {
	            resolve();
	        } else {
	            window.addEventListener('load', resolve);
	        }
	    });
	});
	
	// Buffer for batch requests made within the same frame
	var batchQueue = {};
	
	// Backwards compat
	window.pre = {};
	
	// Transient cache resolvers
	var transientCache = {};
	
	// Transient cache resolvers
	var transientCacheResolvers = {};
	
	// Metabuilder
	var metaBuilder = void 0;
	
	// Add to transientCache
	window.preload = function (method, url, data, name) {
	
	    if (name) {
	        window.pre[name] = {
	            method: method,
	            uri: url,
	            res: data
	        };
	    }
	
	    var key = method + ':' + url;
	    var resolvers = transientCacheResolvers[key] || [];
	
	    transientCache[key] = data;
	
	    while (resolvers.length) {
	        resolvers.pop().call();
	    }
	};
	
	// Preload complete
	var preloadComplete = false;
	
	window.preloadComplete = function () {
	    preloadComplete = true;
	    Object.keys(transientCacheResolvers).forEach(function (key) {
	        var resolvers = transientCacheResolvers[key] || [];
	        while (resolvers.length) {
	            resolvers.pop().call();
	        }
	    });
	};
	
	_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');
	
	var $Api = exports.$Api = _class.$Class.extend('$Api', {
	
	    // Cache any GET responses indefinitely
	    cache: false,
	
	    // Http timeout for all requests
	    timeout: 45000,
	
	    // Default number of attempts on aborted requests and 500 server errors
	    getAttempts: 3,
	    postAttempts: 1,
	
	    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
	    action: function action(_action, options) {
	        options.action = _action;
	        return this.post(options);
	    },
	
	    // GET on a resource myapi.retrieve() -> GET /my/api
	    retrieve: function retrieve(options) {
	        options.method = 'get';
	        return this.call(options);
	    },
	
	    // POST on a resource myapi.retrieve() -> POST /my/api
	    post: function post(options) {
	        options.method = 'post';
	        return this.call(options);
	    },
	
	    // Generic handler for calling an api and dispatching requests to the right place
	    call: function call(options) {
	        var self = this;
	
	        // Set up request options and params. `options` is an object which should contain everything
	        // the request needs to run and handle the response
	
	        options.api = this;
	        options.uri = this.getURI(options.model, options.action);
	        options.params = options.params || {};
	        options.cache = options.cache || self.cache && options.method === 'get';
	        options.name = this.buildAPIName(options);
	        options.meta = this.buildMeta();
	        options.transientError = options.transientError || false;
	        options.cacheKey = _util.$util.buildURL(options.uri, options.params);
	
	        _logger.$logger.info(options.name + '_call', {
	            name: options.name,
	            method: options.method,
	            uri: options.uri
	        });
	
	        if (!options.silent) {
	            _event.$event.emit('loading');
	        }
	
	        // Decide where to get the response
	        return _promise.$promise.first([
	
	        // If caching is enabled and we have the data in local cache, use the cache
	        function () {
	            if (options.cache && cache[options.cacheKey]) {
	                return cache[options.cacheKey];
	            }
	        },
	
	        // Otherwise if we have transient cache data for this api, we can use that
	        function () {
	            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {
	
	                // The reason we use self.attemptRequest here is so any errors in the cached response
	                // can trigger the retry code path, as if it were a regular request
	                return self.attemptRequest(options);
	            });
	        },
	
	        // If we're in batch mode, queue up a batch request
	        function () {
	            if (options.batch) {
	                return self.batchRequest(options);
	            }
	        },
	
	        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
	        function () {
	            return self.attemptRequest(options);
	        }])['finally'](function () {
	
	            if (!options.silent) {
	                _event.$event.emit('loaded');
	            }
	        }).then(function (res) {
	
	            // Cache the response if we need to
	            if (options.cache) {
	                cache[options.cacheKey] = res;
	            }
	
	            // Handle the response
	            return self.handleResponse(res.data, options);
	        }, function (err) {
	
	            // $BatchShortCircuit will be thrown if:
	            //
	            // 1. batch api call B depends on api call A, but-
	            // 2. api call A fails
	            //
	            // In which case we end up in a situation where had it been a regular chain of events,
	            // api B would never have been called in the first place.
	            //
	            // One possibility here is to return $unresolved, which prevents the promise from ever
	            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
	            // corner cases.
	            //
	            // Instead we opt to simply reject the promise, and not call any of the response handlers
	
	            if (err instanceof _error.$BatchShortCircuit) {
	                return _promise.$promise.reject(err);
	            }
	
	            // Otherwise, handle the error normally
	            return self.handleErrorResponse(err, options);
	        });
	    },
	
	    // Set up a batch request for processing in the next frame
	    batchRequest: function batchRequest(options) {
	
	        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
	        // layer is to combine multiple atomic api calls into a single http request, without forcing
	        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
	        //
	        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
	        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
	        // individual api call to the correct handler.
	        //
	        // The way this is implemented is to place each response in the transient api cache, then to yield
	        // control to the regular api request handler, which will handle instrumentation and retries
	
	        // For quick dev-time feedback...
	        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
	        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);
	
	        var name = options.batch.name;
	        var id = options.batch.id;
	
	        // Add the batch request options to the batchQueue for processing on the next frame
	        var batch = batchQueue[name] = batchQueue[name] || {};
	        batch[id] = options;
	
	        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
	        return this.buildBatchRequest(name).then(function (results) {
	
	            // We get back a mapping of id->response, so we now extract the response for our api
	            // call. If we have no response, we can assume the call was never made, and short circuit.
	            return results[id].then(function (result) {
	                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
	            });
	        });
	    },
	
	    // Process all of the accumulated batch api requests
	    buildBatchRequest: _promise.$promise.debounce(function (name) {
	
	        var self = this;
	        var batch = batchQueue[name];
	        var batchIds = _class.$Class.keys(batch);
	        var batchData = {};
	        var headers = {};
	
	        delete batchQueue[name];
	
	        // If we have just a single request, we can short-circuit and just hit that api
	
	        if (batchIds.length === 1) {
	
	            var batchId = batchIds[0];
	            var opts = batch[batchId];
	
	            var results = {};
	            results[batchId] = opts.api.attemptRequest(opts);
	            return results;
	        }
	
	        // Build the request to send to the server side. This is an mapping of id->request, each containing
	        // the method, uri, data, and dependencies for each api.
	        //
	        // Specifying a dependency for an api essentially means the back-end will only
	        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            batchData[id] = {
	                method: options.method,
	                uri: options.api.getURI(options.model, options.action, true),
	                data: options.data,
	                params: options.params,
	                dependencies: options.batch.dependencies
	            };
	
	            _util.$util.extend(headers, options.headers);
	        });
	
	        // Unfortunate circular dependency... $Api depends on another api.
	        //
	        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
	        // does not respond the first time, our batch request can still get through.
	
	        return $batchApi.action(name, {
	            data: batchData,
	            headers: headers
	        }).then(function (res) {
	
	            // The final response will be a mapping of id->response-promise.
	            //
	            // However, we do not treat this data as our final response. Instead, we simply use it to
	            // prime our transient cache, then proceed to jump to our regular request handler. This will
	            // take care of retries and instrumentation as if this were a regular request.
	            //
	            // Note that a retry for $batchApi is different to a retry for an individual api. If
	            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
	            // can just retry the individual api call.
	
	            return self.handleBatchResponse(batch, res.data);
	        });
	    }),
	
	    // Process the responses for all of the batch requests we sent to the server
	    handleBatchResponse: function handleBatchResponse(batch, data) {
	
	        var self = this;
	
	        var promises = {};
	
	        // Loop over each individual api response contained in the batch response, and process the result
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            // Store each response promise so we can check and wait for api dependencies
	
	            promises[id] = _promise.$promise.run(function () {
	
	                // Check if all of the dependencies are present for our individual api call. To do this
	                // we must wait until the dependent api call is entirely complete, including any retries.
	
	                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {
	
	                    if (!batch[depName]) {
	                        _logger.$logger.info('missing_batch_dependency', {
	                            dependency: depName,
	                            available: Object.keys(batch).join('|')
	                        });
	                    }
	
	                    return !batch[depName] || promises[depName].then(function (dependency) {
	                        return dependency && dependency.data && dependency.data.ack === 'success';
	                    });
	                });
	
	                // If our dependencies are present, we can continue, otherwise we are not interested in
	                // the result of the individual api call - if its dependency is not present, it will not be.
	
	                return _promise.$promise.providing(depsPresent, function () {
	
	                    // If there is data returned for the individual call, add it to the transient cache
	
	                    return _promise.$promise.providing(data[id], function (result) {
	
	                        self.addTransientCacheData(options.method, options.api.getURI(options.model, options.action), result);
	                    }).then(function () {
	
	                        // Regardless of whether or not there is data, we can now attempt the request.
	                        // This will either get the data from the transient cache, or make an http call,
	                        // and handle any retries that need to be made.
	
	                        return options.api.attemptRequest(options);
	                    });
	                });
	            });
	        });
	
	        return promises;
	    },
	
	    // Handle the request and any retries, using either the transient cache or http calls
	    attemptRequest: function attemptRequest(options) {
	        var self = this;
	
	        var attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
	
	        // We allow a certain number of attempts/retries for each api call
	        return _promise.$promise.attempt(attempts, function (remaining) {
	
	            // Query the transient cache
	            return self.getTransientCacheResponse(options).then(function (res) {
	
	                // If we can get a response from the transient cache, then use it
	                if (res) {
	                    return res;
	                }
	
	                // Otherwise resort to making an http call
	                return self.getHttpResponse(options);
	            })['catch'](function (res) {
	
	                // If our request was aborted without even a status code, force a single retry
	                if ((!res || !res.status) && attempts === 1) {
	
	                    _logger.$logger.warn('api_retry_aborted', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // If our request was 401 denied (probably due to a CSRF error), force a single retry
	                if (res.status === 401) {
	
	                    _logger.$logger.warn('api_retry_401', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // Set the correct response and ack for 401
	                if (res.status === 401) {
	                    return {
	                        data: {
	                            ack: 'permission_denied'
	                        }
	                    };
	                }
	
	                // If we have any remaining retries, log and reject
	                if (remaining) {
	
	                    _logger.$logger.warn('api_retry', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return _promise.$promise.reject(res);
	                }
	
	                // Otherwise reject the request with the appropriate error
	
	                // We got ack=error in the response
	                if (res && res.data && res.data.ack === 'error') {
	                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
	                        name: options.name,
	                        method: options.method,
	                        uri: options.uri,
	                        stack: res.data.stack,
	                        transient: options.transientError
	                    }));
	                }
	
	                // We got a response error status
	                else if (res && res.status) {
	                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    } else if (res && res.error) {
	                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    }
	
	                    // The request was aborted
	                    else {
	                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
	                                uri: options.uri,
	                                transient: options.transientError
	                            }));
	                        }
	            });
	        });
	    },
	
	    // Get an api response via http
	    getHttpResponse: function getHttpResponse(options) {
	        var self = this;
	
	        var startTime = _util.$util.now();
	
	        var request = this.http(options);
	
	        return request['finally'](function () {
	
	            // Calculate the end-to-end duration of the request from the client's perspective
	            options.duration = _util.$util.now() - startTime;
	        })['catch'](function (res) {
	
	            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
	            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
	                return res;
	            }
	
	            return _promise.$promise.reject(res);
	        }).then(function (res) {
	            self.saveResponseState(res);
	
	            var loggerPayload = {
	                name: options.name,
	                method: options.method,
	                uri: options.uri,
	                server: res.data.server,
	                time: options.duration,
	                duration: options.duration,
	                corrid: res && res.headers('Paypal-Debug-Id')
	            };
	
	            // In certain browsers we can match up this api call to the performance data from the browser
	            if (window.performance && window.performance.getEntries) {
	                _util.$util.forEach(window.performance.getEntries(), function (resource) {
	                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
	                        _util.$util.extend(loggerPayload, resource);
	                    }
	                });
	            }
	
	            _logger.$logger.info('api_response', loggerPayload);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return res;
	        }, function (res) {
	            self.saveResponseState(res);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return _promise.$promise.reject(res);
	        });
	    },
	
	    setTransientCache: function setTransientCache(data) {
	        throw new Error('NotImplemented');
	    },
	
	    // Get an individual api response from the transient cache, as an object
	    getTransientCacheData: function getTransientCacheData(options, pop) {
	
	        if (!_config.$config.enablePreload) {
	            return _promise.$promise.resolve();
	        }
	
	        var preMethod = options.method.toLowerCase();
	        var preUri = _util.$util.buildURL(options.uri, options.params);
	
	        var key = preMethod + ':' + preUri;
	
	        return _promise.$promise.resolver(function (resolve) {
	
	            function res() {
	                var data = transientCache[key];
	                if (pop) {
	                    delete transientCache[key];
	                }
	                resolve(data);
	            }
	
	            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
	            transientCacheResolvers[key].push(res);
	
	            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
	                return res();
	            }
	
	            windowLoad().then(res);
	        });
	    },
	
	    // Check if the transient cache has the data for a particular api
	    hasTransientCacheData: function hasTransientCacheData(options) {
	        return this.getTransientCacheData(options, false).then(function (data) {
	            return Boolean(data);
	        });
	    },
	
	    // Add data to the transient cache
	    addTransientCacheData: function addTransientCacheData(method, uri, data) {
	        window.preload(method, uri, data);
	    },
	
	    // Get an individual api response from transient cache, as a res promise with the correct status code
	    getTransientCacheResponse: function getTransientCacheResponse(options) {
	
	        return this.getTransientCacheData(options, true).then(function (data) {
	
	            // Preload data does not come with a response code, so massage it into a response promise
	            if (data) {
	                if (data.ack === 'error') {
	                    return _promise.$promise.reject({
	                        status: 500,
	                        data: data
	                    });
	                } else if (data.ack === 'permission_denied') {
	                    return _promise.$promise.reject({
	                        status: 401,
	                        data: data
	                    });
	                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
	                    return {
	                        status: 400,
	                        data: data
	                    };
	                } else {
	                    return {
	                        status: 200,
	                        data: data
	                    };
	                }
	            }
	
	            // Log a cache miss if we are currently in the first-page load
	            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
	                    _logger.$logger.info('preload_cache_miss', {
	                        uri: options.uri
	                    });
	                }
	        });
	    },
	
	    getHeaders: function getHeaders(options) {
	
	        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
	            _logger.$logger.warn('missing_csrf_jwt');
	        }
	
	        var headers = {
	            'X-Requested-With': 'XMLHttpRequest',
	            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
	        };
	
	        if (!cookiesEnabled()) {
	            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
	        }
	
	        if (options.headers) {
	            _util.$util.extend(headers, options.headers);
	        }
	
	        return headers;
	    },
	    http: function http(options) {
	        return this.httpJQuery(options);
	    },
	
	
	    /*
	     // Raw http call
	    httpAngular: function(options) {
	         let request = {
	            method: options.method,
	            url: options.uri,
	            data: {
	                data: options.data,
	                meta: options.meta
	            },
	            headers: this.getHeaders(options),
	            params: options.params,
	            requestType: 'json',
	            responseType: 'json',
	            timeout: this.timeout
	        };
	         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
	            request.params.meta = JSON.stringify(options.meta);
	        }
	         return $http(request);
	    },
	     */
	
	    httpJQuery: function httpJQuery(options) {
	
	        var request = {
	            method: options.method,
	            data: options.method === 'get' ? options.params : JSON.stringify({
	                data: options.data,
	                meta: options.meta || {}
	            }),
	            headers: this.getHeaders(options),
	            timeout: this.timeout
	        };
	
	        if (options.method === 'post') {
	            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
	        } else if (options.method === 'get') {
	            request.data.meta = JSON.stringify(options.meta);
	        }
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            function getRes(res, data) {
	                return {
	                    status: res.status,
	                    data: data,
	                    headers: function headers(name) {
	                        return res.getResponseHeader(name);
	                    }
	                };
	            }
	
	            request.success = function (data, status, res) {
	                return resolve(getRes(res, data));
	            };
	
	            request.error = function (res) {
	                if (res && res.status) {
	                    if (res.status >= 400) {
	                        return reject(getRes(res, res.responseJSON));
	                    } else {
	                        return resolve(getRes(res, res.responseJSON));
	                    }
	                }
	
	                return reject({
	                    status: 0,
	                    headers: _util.$util.noop,
	                    error: res && res.statusText
	                });
	            };
	
	            _jquery2['default'].ajax(options.uri, request);
	        });
	    },
	
	    // Save cookies and jwt-csrf token from the response
	    saveResponseState: function saveResponseState(res) {
	
	        if (res.headers('x-csrf-jwt')) {
	            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
	            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
	            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
	        }
	
	        if (res.headers('X-cookies')) {
	
	            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');
	
	            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
	            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
	        }
	
	        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
	    },
	
	    // Dispatch the response to the correct handlers
	    handleResponse: function handleResponse(res, options) {
	        var loggerName = 'ui_' + options.name;
	
	        var loggerPayload = {
	            name: options.name,
	            method: options.method,
	            uri: options.uri,
	            time: options.duration,
	            duration: options.duration
	        };
	
	        // Here we dispatch the response to the correct handler based on the ack.
	        //
	        // ack=success     -> options.success()
	        // ack=error       -> options.error()
	        // ack=validation  -> options.validation()
	        // ack=contingency -> options.contingencies[contingency]()
	        //
	        // Why do this rather than just rejecting the promise with a custom error?
	        //
	        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
	        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
	        //    every error they want to. This is exacerbated by the fact that there is no single thread
	        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
	        //
	        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
	        // and the global error handler will be invoked. The api responses are also given as promises.
	
	        var resultModel = options.resultModel || options.model;
	
	        /* jshint maxcomplexity: 17 */
	        return _promise.$promise.call(function () {
	
	            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack
	
	            if (res.data && resultModel) {
	
	                if (resultModel.populate) {
	                    resultModel.populate(res.data);
	                } else {
	                    _util.$util.extend(resultModel, res.data);
	                }
	            }
	
	            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
	                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
	                    return _util.$util.extend(resultModel, children);
	                });
	            }
	        }).then(function () {
	
	            // Handle each ack type, throw errors accordingly
	
	            if (res.ack === 'success') {
	                _logger.$logger.info(loggerName + '_success', loggerPayload);
	
	                if (options.success) {
	                    if (options.success instanceof Function) {
	                        return options.success(res.data);
	                    }
	                    return options.success;
	                }
	
	                return res;
	            }
	
	            if (options.failSilently) {
	                return;
	            }
	
	            if (res.ack === 'contingency') {
	                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
	                    contingency: res.contingency
	                }));
	
	                if (!res.contingency) {
	                    throw new _error.$ApiError('expected_contingency_name', {
	                        api: options.name
	                    });
	                }
	
	                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	
	                if (resultModel) {
	                    resultModel.errorData = res.errorData || {};
	                }
	
	                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);
	
	                _util.$util.extend(contingency, res.errorData);
	
	                if (handler) {
	                    if (handler instanceof Function) {
	                        return handler(contingency.message, contingency);
	                    }
	                    return handler;
	                }
	
	                throw contingency;
	            } else if (res.ack === 'validation') {
	                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
	                    validation: res.validation
	                }));
	
	                if (options.validation) {
	                    return options.validation(res.validation);
	                }
	
	                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else if (res.ack === 'permission_denied') {
	                _logger.$logger.info(loggerName + '_denied', loggerPayload);
	
	                throw new _error.$Forbidden(options.uri + ': forbidden', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else {
	                _logger.$logger.info(loggerName + '_noack', loggerPayload);
	
	                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            }
	        });
	    },
	
	    // Handle http error responses (ack=error or unhandled errors)
	    handleErrorResponse: function handleErrorResponse(err, options) {
	
	        return _promise.$promise.run(function () {
	
	            // If the caller provides an error handler, let them handle it
	            if (options.error) {
	                return options.error(err);
	            }
	
	            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
	            // this will always end up in the global error handler due to how angular promises work.
	            throw err;
	        });
	    },
	
	    // Build the uri for the api call
	    getURI: function getURI(model, action, relative) {
	        var self = this;
	
	        // build the uri as a seriest of segments
	        var uri = [];
	
	        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {
	
	            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})
	
	            key = key.slice(2);
	            key = key.substring(0, key.length - 1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                return '';
	            }
	
	            return '/' + component;
	        }).replace(/:[\w\.]+/g, function (key) {
	
	            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})
	
	            key = key.slice(1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
	            }
	
	            return component;
	        }));
	
	        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
	        if (action) {
	            uri.push(action);
	        }
	
	        // Add the extension (e.g. for doing a GET on a .json resource)
	        if (this.ext) {
	            uri[uri.length - 1] += '.' + this.ext;
	        }
	
	        // Join the uri segments and strip any extra slashes
	        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');
	
	        // Add on the base uri, e.g. /webapps/hermes
	        if (!relative) {
	            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
	        }
	
	        return uri;
	    },
	
	    // Attach meta data provided by the parent app
	    buildMeta: function buildMeta() {
	        if (metaBuilder) {
	            return metaBuilder();
	        }
	    },
	
	    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
	    buildAPIName: function buildAPIName(options) {
	        var self = this;
	        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
	        replace(/\//g, '_'). // Replace remaining '/' with '_'
	        replace(/\?(.*)/, ''). // Remove everything after '?'
	        replace(/[^a-zA-Z0-9_]/g, '');
	        apiName = options.action ? apiName + '_' + options.action : apiName;
	        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
	        return apiName;
	    }
	});
	
	$Api.reopenClass({
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	$Api.registerMetaBuilder = function (builder) {
	    metaBuilder = builder;
	};
	
	var $batchApi = new $Api({
	    uri: '/api/batch',
	    postAttempts: 3
	});
	
	function $getLatestCorrelationID() {
	    return latestCorrelationID;
	}
	
	angular.value("$Api", $Api);
	angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
	_logger.$logger;
	
	_event.$event;
	
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	
	_config.$config;
	
	_config.$meta;
	
	_error.$Contingency;
	
	_error.$Forbidden;
	
	_error.$ApiError;
	
	_error.$BatchShortCircuit;
	
	_loader.$loader;

/***/ },

/***/ "./components/squid/dist/core/event.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$event = undefined;
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var handlers = {};
	
	var customEventEmitter = void 0;
	
	var $event = exports.$event = {
	    use: function use(eventEmitter) {
	        customEventEmitter = eventEmitter;
	
	        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var eventName = _ref;
	
	            if (handlers[eventName]) {
	                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                    var _ref2;
	
	                    if (_isArray2) {
	                        if (_i2 >= _iterator2.length) break;
	                        _ref2 = _iterator2[_i2++];
	                    } else {
	                        _i2 = _iterator2.next();
	                        if (_i2.done) break;
	                        _ref2 = _i2.value;
	                    }
	
	                    var handler = _ref2;
	
	                    customEventEmitter.on(eventName, handler);
	                }
	            }
	        }
	    },
	    on: function on(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.on(eventName, method);
	        }
	
	        handlers[eventName] = handlers[eventName] || [];
	        handlers[eventName].push(method);
	
	        var cancelled = false;
	
	        function cancel() {
	            if (!cancelled) {
	                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
	                cancelled = true;
	            }
	        }
	
	        cancel.cancel = cancel;
	        return cancel;
	    },
	    once: function once(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.once(eventName, method);
	        }
	
	        var listener = $event.on(eventName, function () {
	            listener.cancel();
	            return method.apply(this, arguments);
	        });
	
	        return listener;
	    },
	    emit: function emit(eventName) {
	
	        if (customEventEmitter) {
	            var _customEventEmitter;
	
	            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
	        }
	
	        var event = {
	            preventDefault: function preventDefault() {
	                event.defaultPrevented = true;
	            }
	        };
	
	        if (handlers[eventName]) {
	            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	                var _ref3;
	
	                if (_isArray3) {
	                    if (_i3 >= _iterator3.length) break;
	                    _ref3 = _iterator3[_i3++];
	                } else {
	                    _i3 = _iterator3.next();
	                    if (_i3.done) break;
	                    _ref3 = _i3.value;
	                }
	
	                var handler = _ref3;
	
	                handler.apply.apply(handler, [this, event].concat(Array.prototype.slice.call(arguments)));
	            }
	        }
	
	        return event;
	    },
	    broadcast: function broadcast(eventName) {
	
	        if (customEventEmitter) {
	            var _customEventEmitter2;
	
	            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
	        }
	
	        return $event.emit.apply($event, arguments);
	    },
	
	
	    refCount: function refCount($scope, start, stop) {
	        return _promise.$promise.resolver(function (resolve) {
	
	            var count = 0;
	
	            function res() {
	                if (!count) {
	
	                    if (cancelStartListener && cancelStopListener) {
	                        cancelStartListener();
	                        cancelStopListener();
	                    }
	
	                    return resolve();
	                }
	            }
	
	            var cancelStartListener = $scope.$on(start, function (event, data) {
	                count += 1;
	            });
	
	            var cancelStopListener = $scope.$on(stop, function (event, data) {
	                setTimeout(function () {
	                    count -= 1;
	                    res();
	                }, 50);
	            });
	
	            setTimeout(res, 50);
	        });
	    },
	
	    compose: function compose(start, end, startAll, endAll) {
	
	        var count = 0;
	
	        $event.on(start, function () {
	
	            if (!count) {
	                setTimeout(function () {
	                    $event.emit(startAll);
	                });
	            }
	
	            count += 1;
	        });
	
	        $event.on(end, function () {
	
	            setTimeout(function () {
	                count -= 1;
	
	                if (!count) {
	                    $event.emit(endAll);
	                }
	            }, 50);
	        });
	
	        return {
	            getCount: function getCount() {
	                return count;
	            },
	            isActive: function isActive() {
	                return Boolean(count);
	            },
	            reset: function reset() {
	                count = 0;
	            }
	        };
	    }
	};
	
	angular.value("$event", $event);
	_promise.$promise;

/***/ },

/***/ "./components/squid/dist/core/promise.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$promise = $promise;
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var Promise = window.Promise;
	
	function $promise(obj) {
	    return Promise.resolve(obj);
	}
	
	_util.$util.extend($promise, {
	    use: function use(CustomPromise) {
	        Promise = CustomPromise;
	    },
	    resolver: function resolver(method) {
	        return new Promise(method);
	    },
	    resolve: function resolve(value) {
	        return Promise.resolve(value);
	    },
	    reject: function reject(value) {
	        return Promise.reject(value);
	    },
	
	
	    run: function run(method) {
	        return Promise.resolve().then(method);
	    },
	
	    call: function call(method) {
	        return Promise.resolve().then(method);
	    },
	
	    sequential: function sequential(methods) {
	
	        var prom = Promise.resolve();
	
	        _util.$util.forEach(methods, function (method) {
	            prom = prom.then(method);
	        });
	
	        return prom;
	    },
	
	    sleep: function sleep(time) {
	        return new Promise(function (resolve) {
	            setTimeout(resolve, time);
	        });
	    },
	
	    map: function map(items, method) {
	
	        var promises = void 0;
	
	        if (items instanceof Array) {
	            promises = [];
	        } else if (items instanceof Object) {
	            promises = {};
	        } else {
	            return Promise.resolve();
	        }
	
	        return this.all(_util.$util.map(items, function (item, key) {
	
	            promises[key] = Promise.resolve(item).then(function (result) {
	                return method(result, key, promises);
	            });
	
	            return promises[key];
	        }));
	    },
	
	    all: function all(items) {
	
	        if (items instanceof Array) {
	            return Promise.all(items);
	        } else if (items instanceof Object) {
	            return this.hash(items);
	        }
	
	        return Promise.resolve([]);
	    },
	
	    hash: function hash(obj) {
	        var results = {};
	
	        return Promise.all(_util.$util.map(obj, function (item, key) {
	            return Promise.resolve(item).then(function (result) {
	                results[key] = result;
	            });
	        })).then(function () {
	            return results;
	        });
	    },
	
	    extend: function extend(obj, hash) {
	        return this.hash(hash || {}).then(function (data) {
	            _util.$util.extend(obj, data);
	        });
	    },
	
	    attempt: function attempt(attempts, method) {
	
	        attempts -= 1;
	
	        return Promise.resolve().then(function () {
	            return method(attempts);
	        })['catch'](function (err) {
	
	            if (attempts) {
	                return $promise.attempt(attempts, method);
	            }
	
	            return Promise.reject(err);
	        });
	    },
	
	    debounce: function debounce(method, time) {
	
	        var timeout = void 0;
	        var resolvers = {};
	
	        return function () {
	
	            var self = this;
	            var args = arguments;
	            var key = JSON.stringify(args);
	
	            resolvers[key] = resolvers[key] || [];
	
	            return new Promise(function (resolve) {
	                resolvers[key].push(resolve);
	                clearTimeout(timeout);
	
	                timeout = setTimeout(function () {
	
	                    var result = method.apply(self, args);
	
	                    _util.$util.forEach(resolvers[key], function (resolver) {
	                        resolver(result);
	                    });
	
	                    delete resolvers[key];
	                }, time);
	            });
	        };
	    },
	
	    every: function every(collection, handler) {
	        return this.map(collection, function (item) {
	            return handler(item);
	        }).then(function (results) {
	            return _util.$util.every(results);
	        });
	    },
	
	    providing: function providing(condition, handler) {
	        return Promise.resolve(condition).then(function (result) {
	            if (result) {
	                return handler(result);
	            }
	        });
	    },
	
	    until: function until(condition, pollTime, timeout, alwaysResolve) {
	
	        return new Promise(function (resolve, reject) {
	            if (condition()) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (condition()) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, pollTime);
	
	            if (timeout) {
	                setTimeout(function () {
	                    clearInterval(interval);
	                    return alwaysResolve ? resolve() : reject();
	                }, timeout);
	            }
	        });
	    },
	
	    first: function first(handlers) {
	
	        var prom = $promise.resolve();
	        var result = void 0;
	
	        _util.$util.forEach(handlers, function (handler) {
	            prom = prom.then(function () {
	                return result || handler();
	            }).then(function (handlerResult) {
	                result = handlerResult;
	                return result;
	            });
	        });
	
	        return prom;
	    }
	});
	
	angular.value("$promise", $promise);
	_util.$util;

/***/ },

/***/ "./components/squid/dist/core/util.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$unresolved = exports.$util = undefined;
	exports.$getRedirectUrl = $getRedirectUrl;
	exports.$dispatch = $dispatch;
	exports.$experiment = $experiment;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _base = __webpack_require__("./components/base64/base64.min.js");
	
	var base64 = _interopRequireWildcard(_base);
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var redirected = false;
	var paramCache = {};
	
	// incase base64 has been CJS packed, it will export itself
	if (typeof window.atob === 'undefined' || typeof window.btoa === 'undefined') {
	    window.atob = base64.atob;
	    window.btoa = base64.btoa;
	}
	
	var $util = exports.$util = {
	
	    forEach: function forEach(collection, method) {
	        if (collection instanceof Array) {
	            for (var i = 0; i < collection.length; i++) {
	                method(collection[i], i);
	            }
	        } else if (collection instanceof Object) {
	            for (var key in collection) {
	                if (collection.hasOwnProperty(key)) {
	                    method(collection[key], key);
	                }
	            }
	        }
	    },
	
	    idleTimeout: function idleTimeout(time) {
	        setTimeout(function () {
	            _logger.$logger.info('page_idle');
	            $util.reload();
	        }, time);
	    },
	
	
	    reload: function reload() {
	        _logger.$logger.info('reload');
	        _event.$event.emit('loading');
	        window.location.reload();
	    },
	
	    redirect: function redirect(url, options) {
	
	        if (url.toLowerCase().indexOf('javascript:') !== -1) {
	            // eslint-disable-line
	            _logger.$logger.error('unsafe_redirect_url', {
	                url: url
	            });
	            throw new Error('Unsafe redirect url: ' + url);
	        }
	
	        _logger.$logger.info('redirect', {
	            url: url
	        });
	
	        _event.$event.on('$stateChangeStart', function (event) {
	            _logger.$logger.info('state_change_after_redirect');
	            event.preventDefault();
	        });
	
	        function redir() {
	
	            if (redirected) {
	                return;
	            }
	
	            _logger.$logger.info('redirect', {
	                url: url
	            });
	
	            window.onunload = window.onbeforeunload = function () {};
	
	            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false) {
	                window.top.location = url;
	            } else {
	                window.location = url;
	            }
	
	            redirected = true;
	        }
	
	        _event.$event.emit('loading');
	
	        _logger.$logger.flush().then(redir);
	        setTimeout(redir, 500);
	
	        _logger.$logger.done();
	    },
	
	    cookiesEnabled: function cookiesEnabled() {
	        var cookiesEnabled = void 0;
	
	        document.cookie = '_cookiecheck=1';
	        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
	        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	
	        return cookiesEnabled;
	    },
	
	    storageEnabled: function storageEnabled(api) {
	        try {
	            window[api].setItem('__feature_test__', '0');
	            window[api].removeItem('__feature_test__');
	            return true;
	        } catch (e) {
	            return false;
	        }
	    },
	
	    sessionStorageEnabled: function sessionStorageEnabled() {
	        return this.storageEnabled('sessionStorage');
	    },
	
	    localStorageEnabled: function localStorageEnabled() {
	        return this.storageEnabled('localStorage');
	    },
	
	    params: function params(string) {
	
	        if (typeof string !== 'string') {
	            string = this.queryString().slice(1);
	        }
	
	        var params = {};
	
	        if (!string) {
	            return params;
	        }
	
	        if (paramCache[string]) {
	            return paramCache[string];
	        }
	
	        $util.forEach(string.split('&'), function (pair) {
	            pair = pair.split('=');
	
	            if (pair[0] && pair[1]) {
	                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	            }
	        });
	
	        paramCache[string] = params;
	
	        return params;
	    },
	
	    queryString: function queryString() {
	        if (window.location.search) {
	            return window.location.search;
	        } else {
	            var string = window.location.href;
	            var idx = string.indexOf('&');
	            var rIdx = string.lastIndexOf('#');
	
	            if (idx) {
	                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
	            }
	        }
	        return '';
	    },
	
	    queryStringSplice: function queryStringSplice(qs, insert, remove) {
	        if (qs.indexOf('?') === 0) {
	            qs = qs.slice(1);
	        }
	
	        var params = $util.extend(this.params(qs), insert);
	
	        $util.forEach(remove, function (key) {
	            delete params[key];
	        });
	
	        return '?' + this.paramToQueryString(params);
	    },
	
	    extend: function extend(obj, source) {
	
	        if (!source) {
	            return obj;
	        }
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                obj[key] = source[key];
	            }
	        }
	
	        return obj;
	    },
	
	
	    paramToQueryString: function paramToQueryString(params) {
	        return this.filter(this.map(Object.keys(params).sort(), function (key) {
	            if (!params[key]) {
	                return;
	            }
	
	            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	        })).join('&');
	    },
	
	    param: function $param(name) {
	        return this.params()[name];
	    },
	
	    hashParam: function hashParam(name) {
	        return this.params(window.location.hash.slice(1))[name];
	    },
	
	    base64Decode: function base64Decode(encodedString) {
	        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
	    },
	
	    /*
	     * decodeAndParse :
	     * 1 - Base64Decode
	     * 2 - URI Decode
	     * 3 - Split string into a nvp object
	     * return obj
	     */
	    decodeAndParse: function decodeAndParse(encodedString) {
	        if (encodedString) {
	            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
	        }
	    },
	
	    assert: function $assert(value, message, payload) {
	        if (!value) {
	            throw new Error(message, payload || {});
	        }
	    },
	
	    map: function $map(array, method) {
	
	        array = array || [];
	
	        var results = void 0;
	
	        if (array instanceof Array) {
	            results = [];
	
	            $util.forEach(array, function () {
	                results.push(method.apply(this, arguments));
	            });
	
	            return results;
	        } else if (array instanceof Object) {
	
	            results = {};
	
	            $util.forEach(array, function (val, key) {
	                results[key] = method.apply(this, arguments);
	            });
	
	            return results;
	        } else {
	            throw new Error('$util.map expects array or object');
	        }
	    },
	
	    filter: function $filter(array, method) {
	        method = method || Boolean;
	        var results = [];
	
	        $util.forEach(array, function (item) {
	            if (method.apply(this, arguments)) {
	                results.push(item);
	            }
	        });
	
	        return results;
	    },
	
	    find: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return array[i];
	            }
	        }
	    },
	
	    findIndex: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return i;
	            }
	        }
	    },
	
	    range: function range(start, end) {
	        if (!end) {
	            end = start;
	            start = 0;
	        }
	
	        var result = [];
	
	        for (var i = start; i < end; i++) {
	            result.push(i);
	        }
	
	        return result;
	    },
	
	    pad: function $pad(string, n, char) {
	
	        n = n || 0;
	        char = char || '0';
	
	        var padding = Array(n + 1).join(char.toString());
	
	        return (padding + string).slice(-n);
	    },
	
	    some: function $some(array, method) {
	        var result = void 0;
	
	        $util.forEach(array, function (item, key) {
	            if (!result) {
	                result = method(item, key);
	            }
	        });
	
	        return result;
	    },
	
	    every: function $every(array, method) {
	        method = method || Boolean;
	
	        var result = true;
	
	        $util.forEach(array, function (item) {
	            if (!method(item)) {
	                result = false;
	            }
	        });
	
	        return result;
	    },
	
	    reduce: function $reduce(array, method, intial) {
	        $util.forEach(array, function (item) {
	            intial = method(intial, item);
	        });
	
	        return intial;
	    },
	
	    isPopup: function isPopup() {
	        return _integration.$integration.isPopup();
	    },
	
	    isIFrame: function isIFrame() {
	        return _integration.$integration.isIFrame();
	    },
	
	    buildURL: function buildURL(url, params) {
	        /*
	         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
	         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
	         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
	         */
	        this.assert(url, 'buildURL :: expected url');
	
	        var paramKeys = Object.keys(params || {});
	
	        if (JSON.stringify(params) === '{}') {
	            return url;
	        }
	
	        if (!paramKeys.length) {
	            return url;
	        }
	
	        if (url.indexOf('?') === -1) {
	            url += '?';
	        } else {
	            url += '&';
	        }
	
	        url += this.paramToQueryString(params);
	
	        return url;
	    },
	
	    paypalURL: function paypalURL(url, params) {
	        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;
	
	        return this.buildURL(url, params);
	    },
	
	    override: function override(obj, methodName, handler) {
	        var existing = obj[methodName];
	
	        obj[methodName] = function () {
	            if (existing) {
	                try {
	                    existing.apply(obj, arguments);
	                } catch (err) {
	                    _logger.$logger.error(methodName + 'event_error', {
	                        error: err.toString
	                    });
	                }
	            }
	
	            return handler.apply(obj, arguments);
	        };
	    },
	
	    result: function result(method) {
	        return method();
	    },
	
	    memoize: function memoize(method) {
	        var result = void 0;
	        var called = false;
	
	        function memoized() {
	            if (!called) {
	                result = method.apply(this, arguments);
	            }
	            called = true;
	            return result;
	        }
	
	        memoized.flush = function () {
	            called = false;
	        };
	
	        return memoized;
	    },
	
	    now: function now() {
	        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
	    },
	
	    bindObject: function bindObject(obj, self) {
	        return $util.map(obj, function (method) {
	            return method.bind(self);
	        });
	    },
	
	    hashStr: function hashStr(str) {
	        var hash = 0,
	            i = void 0,
	            chr = void 0,
	            len = void 0;
	        if (str.length === 0) {
	            return hash;
	        }
	        for (i = 0, len = str.length; i < len; i++) {
	            chr = str.charCodeAt(i);
	            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
	            // Convert to 32bit integer
	            hash |= 0; // eslint-disable-line no-bitwise
	        }
	        return Math.abs(hash);
	    },
	
	    hash: function hash() {
	        return this.hashStr(Math.random());
	    },
	
	    popup: function popup(name, url, options, callback) {
	
	        callback = $util.once(callback);
	
	        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
	            return key + '=' + options[key];
	        }).join(', '));
	
	        var interval = void 0;
	
	        function checkWindowClosed() {
	            if (win.closed) {
	                clearInterval(interval);
	                callback();
	            }
	        }
	
	        interval = setInterval(checkWindowClosed, 50);
	        setTimeout(checkWindowClosed);
	
	        try {
	            (function () {
	                var close = win.close;
	                win.close = function () {
	                    close.apply(this, arguments);
	                    checkWindowClosed();
	                };
	            })();
	        } catch (err) {
	            // pass
	        }
	
	        return win;
	    },
	
	    unique: function unique(collection) {
	        return collection.filter(function (value, index, self) {
	            return self.indexOf(value) === index;
	        });
	    },
	
	    monkeyPatch: function monkeyPatch(mod, prop, method) {
	        var original = mod[prop];
	
	        mod[prop] = function () {
	            var _this = this,
	                _arguments = arguments;
	
	            return method.call(this, arguments, function (self, args) {
	                if (original) {
	                    return original.apply(self || _this, args || _arguments);
	                }
	            });
	        };
	    },
	    once: function once(method) {
	        var called = false;
	
	        return function () {
	            if (!called) {
	                called = true;
	                return method.apply(this, arguments);
	            }
	        };
	    },
	    camelToDasherize: function camelToDasherize(string) {
	        return string.replace(/([A-Z])/g, function (g) {
	            return '-' + g.toLowerCase();
	        });
	    },
	    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
	        return string.replace(/([a-z][A-Z])/g, function (g) {
	            return g[0] + '_' + g[1];
	        }).toUpperCase();
	    },
	    dasherizeToCamel: function dasherizeToCamel(string) {
	        return string.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	    },
	
	
	    parentWindow: function parentWindow() {
	        if (window.opener) {
	            return window.opener;
	        } else if (window.parent !== window) {
	            return window.parent;
	        }
	    },
	
	    hasRTL: function hasRTL(str) {
	        return new RegExp('[\u0590-\u07BF]').test(str);
	    },
	    noop: function noop() {}
	};
	
	var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };
	
	function $getRedirectUrl(product, params) {
	    var url = '';
	    var urlParams = $util.params();
	
	    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
	        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
	    }
	
	    url += _config.$config.urls.fallbackUrl[product];
	
	    $util.extend(urlParams, params || {});
	
	    // cmd is a reserved slingshot param
	    if (urlParams.cmd) {
	        delete urlParams.cmd;
	    }
	
	    return $util.buildURL(url, urlParams);
	}
	
	function $dispatch(product, params, stateChange) {
	    $util.assert(product, 'expected product');
	
	    _logger.$logger.log('info', 'dispatch', {
	        product: product
	    });
	
	    _event.$event.emit('loading');
	
	    var url = '';
	
	    url = $getRedirectUrl(product, params);
	
	    // fire an event for xo-tracking to listen to and do fpti logging
	    if (stateChange) {
	        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
	    }
	
	    return $util.redirect(url);
	}
	
	function $experiment(name, sample, id, loggerPayload) {
	
	    var throttle = $util.hashStr(name + '_' + id) % 100;
	
	    var group = void 0;
	
	    if ($util.param(name) === 'true') {
	        group = 'test_forced';
	    } else if ($util.param(name) === 'false') {
	        group = 'control_forced';
	    } else if (throttle < sample) {
	        group = 'test';
	    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
	        // eslint-disable-line no-extra-parens
	        group = 'control';
	    } else {
	        group = 'throttle';
	    }
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: name,
	        pxp_trtmnt_id: group
	    });
	
	    _logger.$logger.info(name + '_' + group, loggerPayload || {});
	
	    if (group === 'test' || group === 'test_forced') {
	        return true;
	    } else if (group === 'control') {
	        return false;
	    }
	}
	
	angular.value("$util", $util);
	angular.value("$unresolved", $unresolved);
	angular.value("$getRedirectUrl", $getRedirectUrl);
	angular.value("$dispatch", $dispatch);
	angular.value("$experiment", $experiment);
	_event.$event;
	
	_logger.$logger;
	
	_config.$config;
	
	_config.$meta;
	
	_integration.$integration;

/***/ },

/***/ "./components/base64/base64.min.js":
/***/ function(module, exports, __webpack_require__) {

	!function(){function t(t){this.message=t}var r= true?exports:this,e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";t.prototype=new Error,t.prototype.name="InvalidCharacterError",r.btoa||(r.btoa=function(r){for(var o,n,a=String(r),i=0,c=e,d="";a.charAt(0|i)||(c="=",i%1);d+=c.charAt(63&o>>8-i%1*8)){if(n=a.charCodeAt(i+=.75),n>255)throw new t("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");o=o<<8|n}return d}),r.atob||(r.atob=function(r){var o=String(r).replace(/=+$/,"");if(o.length%4==1)throw new t("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,a,i=0,c=0,d="";a=o.charAt(c++);~a&&(n=i%4?64*n+a:a,i++%4)?d+=String.fromCharCode(255&n>>(-2*i&6)):0)a=e.indexOf(a);return d})}();


/***/ },

/***/ "./components/squid/dist/core/config.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var $meta = exports.$meta = window.meta || {};
	var $cookies = exports.$cookies = window.cookies || {};
	var $config = exports.$config = window.config || {};
	angular.value("$meta", $meta);
	angular.value("$cookies", $cookies);
	angular.value("$config", $config);

/***/ },

/***/ "./components/squid/dist/core/integration.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var $DEFAULT = exports.$DEFAULT = 'DEFAULT';
	
	var $CONTEXT = exports.$CONTEXT = {
	
	    // Full page checkout
	    FULLPAGE: 'FULLPAGE',
	
	    // Checkout in popup
	    POPUP: 'POPUP',
	
	    // Checkout in lightbox (iframe)
	    LIGHTBOX: 'LIGHTBOX',
	
	    // Web view
	    WEBVIEW: 'WEBVIEW',
	
	    // Native checkout
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
	};
	
	var $integration = exports.$integration = {
	
	    flow: $DEFAULT,
	
	    init: function init(flow, config) {
	        this.config = config || {};
	
	        if (flow) {
	            this.setFlow(flow);
	        }
	
	        this.setContext(this.getContext());
	    },
	    getContext: function getContext() {
	
	        if (this.isIFrame()) {
	            return $CONTEXT.LIGHTBOX;
	        } else if (this.isPopup()) {
	            return $CONTEXT.POPUP;
	        } else {
	            return $CONTEXT.FULLPAGE;
	        }
	    },
	    isPopup: function isPopup() {
	        return Boolean(window.opener);
	    },
	    isIFrame: function isIFrame() {
	        return window.top !== window.self;
	    },
	    setContext: function setContext(context) {
	        _logger.$logger.info('integration_context_' + context);
	        this.context = context;
	    },
	    setFlow: function setFlow(flow) {
	        _logger.$logger.info('integration_flow_' + flow);
	        this.flow = flow;
	    },
	    is: function is(context, flow) {
	        return this.isContext(context) && this.isFlow(flow);
	    },
	    isContext: function isContext(context) {
	        return this.context === context;
	    },
	    isFlow: function isFlow(flow) {
	        return this.flow === flow;
	    },
	    getConfig: function getConfig(key) {
	
	        this.context = this.getContext();
	
	        if (!this.config) {
	            return;
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {
	
	            return this.config[this.context][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {
	
	            return this.config[this.context][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][key];
	        }
	    },
	    error: function error(message) {
	        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
	    }
	};
	
	angular.value("$integration", $integration);
	_logger.$logger;

/***/ },

/***/ "./components/squid/dist/core/class.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 Class
	 -----
	
	 A class pattern, adding sugar on top of javascript prototypes
	
	 ### Basic Usage
	
	 let MyClass = Class.extend({
	 foo: 'bar';
	 });
	
	 myInstance = new MyClass({
	 hello: 'world'
	 });
	
	 console.log(myInstance.foo, myInstance.hello)
	
	 In this example, `foo` becomes a property on `MyClass`'s prototype,
	 and `hello` becomes a property on `myInstance`.
	
	 ### Default Object Methods
	
	 - `init()`: Called after the object is first instantiated, with all properties available
	
	 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default
	
	 e.g. `myInstance.get('foo.bar.baz', 'some_default');`
	
	 Default return value is undefined
	
	 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep
	
	 e.g. `myInstance.set('foo.bar.baz', 'some_value');`
	
	 Error is thrown if no object is found to set the value on
	
	 - `setProperties(<object>)`: Set all the properties from an object onto your object
	
	 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`
	
	 Can not be used with nested properties
	
	 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair
	
	 */
	
	// Object Create
	// -------------
	//
	// Shim for Object.create, if it is not supported by our browser
	//
	// let myPrototype = {foo: 'bar'}
	// let myObject = create(myPrototype)
	
	// Create an empty anonymous constructor with no side effects, for re-use later
	var EmptyConstructor = function EmptyConstructor() {};
	
	var create = Object.create || function create(obj) {
	
	    // Set a temporary prototype
	    EmptyConstructor.prototype = obj;
	
	    // Create an object using our temporary constructor/prototype
	    var instance = new EmptyConstructor();
	
	    // Reset the prototype for next time
	    EmptyConstructor.prototype = null;
	
	    // Return our new object, created without side effects
	    return instance;
	};
	
	function _extend(obj, source) {
	
	    if (!source) {
	        return obj;
	    }
	
	    for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	            obj[key] = source[key];
	        }
	    }
	
	    return obj;
	}
	
	// Is Object
	// ---------
	//
	// Check of a let is an object or not
	//
	// isobject({}) -> true
	// isobject('foo') -> false
	
	function isobject(obj) {
	    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
	}
	
	// Transpose properties
	// -------------------------------------------------------------------
	//
	// Transpose properties from a list of objects onto a recipient object
	//
	// let recipient = {};
	// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
	// recipient -> {a: 1, b: 2, c:3}
	
	function transpose(recipient, args) {
	
	    // Loop through all args
	    for (var i = 0; i < args.length; i++) {
	        var ob = args[i];
	
	        // Ignore anything that is not an object
	        if (!isobject(ob)) {
	            continue;
	        }
	
	        // Loop through all keys in our object
	        for (var key in ob) {
	
	            // Ignore any prototypal properties
	            if (!ob.hasOwnProperty(key)) {
	                continue;
	            }
	
	            var item = ob[key];
	
	            // Give the function a name
	            if (item instanceof Function) {
	                item.__name__ = key;
	            }
	
	            recipient[key] = item;
	        }
	    }
	}
	
	// Construct a Class
	// -----------------
	//
	// This is the primary constructor for all $Class objects
	
	function construct() {
	    // eslint-disable-line no-unused-vars
	
	    // Call any custom constructor;
	    if (this.construct) {
	        var ob = this.construct.apply(this, arguments);
	
	        // If we get a new object back, return that to the user
	        if (isobject(ob)) {
	            return ob;
	        }
	    }
	
	    // Load any provided properties directly onto the object
	    transpose(this, arguments);
	
	    // Initialize the object
	    if (this.init) {
	        this.init();
	    }
	}
	
	// Reopen an object
	// ----------------
	//
	// Add properties to the constructor's prototype
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopen({
	//       type: 'animal',
	//     });
	//
	//     let cat = new Animal;
	//     console.log(cat.type);
	function reopen() {
	
	    // Add some more properies to our prototype
	    transpose(this.prototype, arguments);
	
	    return this;
	}
	
	// Reopen a class
	// --------------
	//
	// Add properties to the constructor. These will propogate through future extends
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopenClass({
	//       fromCache: function(id) {
	//         return cache[id] || new this({id: id});
	//       }
	//     }
	//
	//     let cat = Animal.fromCache('cat_54');
	
	function reopenClass() {
	
	    // Add some more properies to our class
	    transpose(this, arguments);
	
	    // Add to __classmethods__
	    transpose(this.__classmethods__, arguments);
	
	    return this;
	}
	
	function isChild(Cls) {
	    return Cls && Cls.prototype instanceof this;
	}
	
	// Generate a new class
	// --------------------
	//
	// Generate a new constructor, with the specified name, and attach all static and prototypal methods
	
	var id = 0;
	
	function extend(name) {
	
	    var Cls = void 0,
	        className = void 0,
	        args = void 0,
	        argsLength = void 0,
	        startIndex = void 0;
	
	    // Accept an optional class name
	    if (typeof name === 'string') {
	
	        // Guard against javascript injection
	        if (!name.match(/^[\w$][\w\d]*$/)) {
	            throw new Error('Class name can not include special characters: ' + name);
	        }
	
	        // Use the provided name and slice out the first argument
	        className = name;
	        argsLength = arguments.length && arguments.length - 1;
	        startIndex = 1;
	    } else {
	
	        // Otherwise default to the parent name, or 'Object' if generating our first class
	        className = this.name || 'Object';
	        argsLength = arguments.length;
	        startIndex = 0;
	    }
	
	    args = new Array(argsLength);
	    for (var i = startIndex; i < arguments.length; i++) {
	        args[i - startIndex] = arguments[i];
	    }
	
	    // Dynamically create our constructor with a custom name
	    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval
	
	    // Store the class name for future reference
	    Cls.__name__ = className;
	
	    // Set up a classmethods object. These will be inherited through subsequent extend() calls
	    Cls.__classmethods__ = {
	        extend: extend,
	        reopen: reopen,
	        reopenClass: reopenClass,
	        isChild: isChild
	    };
	
	    id += 1;
	    Cls.id = id;
	
	    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
	    if (this && this !== window) {
	
	        // Inherit everything from superclass prototype
	        Cls.prototype = create(this.prototype);
	
	        // Re-set the constructor, which is overwritten by create
	        Cls.prototype.constructor = Cls;
	
	        // Add a reference to the superclass prototype for super method calls
	        Cls.prototype._super = this.prototype;
	
	        // Inherit any class methods from the superclass
	        _extend(Cls.__classmethods__, this.__classmethods__);
	    }
	
	    // Add the class methods to our existing class
	    _extend(Cls, Cls.__classmethods__);
	
	    // Load any provided properties onto the constructor's prototype
	    transpose(Cls.prototype, args);
	
	    // Temporary: allow access from console/debugger
	    if (className.indexOf('$') === 0) {
	        window[className] = Cls;
	    } else {
	        window['$' + className] = Cls;
	    }
	
	    return Cls;
	}
	
	// Multi-layer get
	// ---------------
	//
	// Recursively gets a deep path from an object, returning a default value if any level is not found
	//
	// let obj = {bar: {baz: 1}}
	// get(obj, 'bar.baz', 'default') -> 1
	// get(obj, 'aaa.bbb', 'default') -> default
	
	function _get(item, path, def) {
	
	    if (!path) {
	        return def;
	    }
	
	    path = path.split('.');
	
	    // Loop through each section of our key path
	    for (var i = 0; i < path.length; i++) {
	
	        // If we have an object, we can get the key
	        if (isobject(item)) {
	            item = item[path[i]];
	            // Otherwise, we should return the default (undefined if not provided)
	        } else {
	            return def;
	        }
	    }
	
	    // If our final result is undefined, we should return the default
	    return item === undefined ? def : item;
	}
	
	// Multi-layer set
	// ---------------
	//
	// Recursively sets a deep path from an object
	//
	// let obj = {bar: {baz: 1}}
	// set(obj, 'bar.baz', 2)
	// obj.bar.baz -> 1
	
	function _set(item, path, value) {
	    path = path.split('.');
	
	    // Loop through each section of our key path except the last
	    for (var i = 0; i < path.length - 1; i++) {
	
	        // Get the next item down
	        item = item[path[i]];
	
	        // If we have an object, we're good
	        if (isobject(item)) {
	            continue;
	            // Otherwise, there's nothing to set our key on
	        } else {
	            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
	        }
	    }
	
	    // Do the set on the retrieved object with our value
	    item[path[path.length - 1]] = value;
	}
	
	// Loop through object
	// -------------------
	//
	// Loop an object and apply a function for each key/value
	//
	// let ob = {a: 1, b: 2, c: 3}
	// each(ob, console.log) -> a 1  b 2  c 3
	
	function each(ob, callback) {
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            callback.call(ob, key, ob[key]);
	        }
	    }
	}
	
	// Gey keys of object
	// ------------------
	//
	// Shim for Object.keys if it does not already exist
	//
	// let ob = {a: 1, b: 2, c: 3}
	// keys(ob) -> ['a', 'b', 'c']
	
	function _keys(ob) {
	
	    if (Object.keys) {
	        return Object.keys(ob);
	    }
	
	    var result = [];
	
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            result.push(key);
	        }
	    }
	
	    return result;
	}
	
	// Create a base class that can be inherited from
	// ----------------------------------------------
	//
	// This is the public interface to the Class module.
	// All classes with extend from Class and be provided with a set of base convenience methods.
	
	var $Class = exports.$Class = extend('Class', {
	
	    init: function init() {
	        // Empty init class, so calls to _super can be safely made
	    },
	
	    get: function get(path, def) {
	        return _get(this, path, def);
	    },
	
	    set: function set(path, value) {
	        _set(this, path, value);
	    },
	
	    setProperties: function setProperties() {
	        transpose(this, arguments);
	    },
	
	    forEach: function forEach(callback) {
	        each(this, callback);
	    },
	
	    keys: function keys() {
	        return _keys(this);
	    }
	});
	
	$Class.get = _get;
	$Class.set = _set;
	$Class.keys = _keys;
	
	angular.value("$Class", $Class);

/***/ },

/***/ "./components/squid/dist/core/error.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$FallbackError = exports.$BatchShortCircuit = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
	    var message = _ref[0],
	        file = _ref[1],
	        line = _ref[2],
	        col = _ref[3],
	        err = _ref[4];
	
	
	    original();
	
	    _event.$event.emit('$windowError', {
	        message: message && (message.stack || message).toString(),
	        file: file && file.toString(),
	        line: line && line.toString(),
	        col: col && col.toString(),
	        stack: err && (err.stack || err).toString()
	    });
	});
	
	var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {
	
	    construct: function construct(err, properties) {
	
	        if (err instanceof Error) {
	            err = err.message;
	        }
	
	        if (properties) {
	            _util.$util.extend(this, properties);
	        }
	
	        this.payload = properties;
	
	        this.message = err;
	    }
	});
	
	var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
	    handle: function handle(handlers) {
	        var handler = handlers[this.message] || handlers['DEFAULT'];
	        if (handler) {
	            var result = handler.call(this, this.message, this);
	            if (typeof result !== 'undefined') {
	                return result;
	            }
	            return true;
	        }
	    }
	});
	
	var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');
	
	var $ApiError = exports.$ApiError = $Error.extend('$ApiError');
	
	var $BatchShortCircuit = exports.$BatchShortCircuit = $Error.extend('$BatchShortCircuit');
	
	var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
	    init: function init() {
	        this.reason = this.reason || '';
	        this.product = this.product || '';
	        this.entryPoint = this.entryPoint || '';
	    }
	});
	
	angular.value("$Error", $Error);
	angular.value("$Contingency", $Contingency);
	angular.value("$Forbidden", $Forbidden);
	angular.value("$ApiError", $ApiError);
	angular.value("$BatchShortCircuit", $BatchShortCircuit);
	angular.value("$FallbackError", $FallbackError);
	_event.$event;
	
	_class.$Class;
	
	_util.$util;

/***/ },

/***/ "./components/squid/dist/core/loader.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$loader = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _firstLoad = false;
	
	var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded');
	
	var $loader = exports.$loader = {
	
	    isLoading: function isLoading() {
	        return Boolean(loader.getCount());
	    },
	    firstLoad: function firstLoad() {
	        return _firstLoad;
	    },
	    reset: function reset() {
	        loader.reset();
	    }
	};
	
	_event.$event.on('allLoaded', function () {
	    _firstLoad = true;
	});
	
	angular.value("$loader", $loader);
	_event.$event;

/***/ },

/***/ "./components/squid/dist/core/model.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Model = undefined;
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var $Model = exports.$Model = _class.$Class.extend('$Model', {
	
	    init: function init() {
	
	        if (this.keys().length) {
	            this.onPopulate();
	        }
	
	        if (this.id) {
	            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};
	            _cache[this.id] = this;
	        }
	
	        this.meta = {
	            populated: false
	        };
	    },
	
	    /**
	     * Add the passed in properties to this Model.
	     * Sets the meta.populated to true. This flag
	     * can be used later to determine if the model is populated.
	     * Calls onPopulate() in the end.
	     */
	    populate: function populate() {
	
	        this.meta.populated = true;
	        this.setProperties.apply(this, arguments);
	        delete this.meta.invalidated;
	        this.onPopulate();
	        return this;
	    },
	
	    fetchChildren: function fetchChildren() {
	        return _promise.$promise.resolve();
	    },
	
	    /**
	     * Override this method, to execute any logic after model is populated.
	     */
	    onPopulate: function onPopulate() {},
	
	    /**
	     * Override this method to return a Mock instance. Must return a promise which resolves to model.
	     */
	    fetchMock: function fetchMock() {},
	
	    /**
	     * Retrieves the model.
	     *
	     * If model is already populated just returns a promise which resolves to `this`
	     * If there is a retriever for this model, then return the retreiver.
	     * Else calls the api to retrieve the model.
	     *
	     * @param options
	     * @returns {*}
	     */
	    retrieve: function retrieve(options) {
	        var self = this;
	
	        options = options || {};
	
	        if (self.meta.populated) {
	
	            if (options.success) {
	                return _promise.$promise.resolve(options.success(self));
	            }
	
	            return _promise.$promise.resolve(this);
	        }
	
	        if (this.retriever) {
	            return this.retriever;
	        }
	
	        if (!this.api) {
	            throw new Error('Tried to populate a model with no api');
	        }
	
	        options.model = this;
	
	        this.retriever = this.api.retrieve(options).then(function (res) {
	            return self;
	        })['finally'](function () {
	            delete self.retriever;
	        });
	
	        return this.retriever;
	    },
	
	    /**
	     * Calls a post on the api to save this model. Takes options as parameters.
	     * options will passed down to api.post.
	     *
	     * @param options
	     * @returns {*|HttpPromise}
	     */
	    save: function save(options) {
	        options = options || {};
	        options.model = this;
	
	        options.data = options.data || this.serialize();
	
	        return this.api.post(options);
	    },
	
	    /**
	     * Calls Api.action to perform any action on the model.
	     *
	     * Takes action name and optional 'options' object as parameters.
	     *
	     * Ex: $CheckoutSession.actions('create', [options])
	     *
	     * @param action
	     * @param options
	     * @returns {*}
	     */
	    action: function action(_action, options) {
	        options = options || {};
	        options.model = this;
	
	        return this.api.action(_action, options);
	    },
	
	    /**
	     * Use this method to force a api call to get the data.
	     *
	     * @param options
	     * @returns {*}
	     */
	    reload: function reload(options) {
	        this.meta.populated = false;
	        return this.retrieve(options);
	    },
	
	    stringify: function stringify() {
	        return JSON.stringify(this, 2);
	    },
	
	    log: function log() {
	        console.log(this.stringify());
	    },
	
	    serialize: function serialize() {},
	
	    /**
	     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
	     */
	    invalidate: function invalidate() {
	        this.meta.populated = false;
	        this.meta.invalidated = true;
	    },
	
	    /**
	     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
	     *
	     * @param Cls
	     * @param child
	     * @returns {*}
	     */
	    child: function child(Cls, _child) {
	
	        if (!_child) {
	            return;
	        }
	
	        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
	    },
	
	    /**
	     *
	     * @param Cls
	     * @param children
	     * @returns {*}
	     */
	    children: function children(Cls, _children) {
	        var self = this;
	
	        if (!_children) {
	            return _children;
	        }
	
	        return _util.$util.map(_children, function (child) {
	            return self.child(Cls, child);
	        });
	    }
	});
	
	var cache = {};
	
	$Model.reopenClass({
	
	    instance: function instance(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] || this.create.apply(this, arguments);
	
	        return instance;
	    },
	
	    retrieveInstance: function retrieveInstance() {
	        return this.instance.apply(this, arguments).retrieve();
	    },
	
	    create: function create(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
	            id: id || 0
	        });
	
	        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));
	
	        return instance;
	    },
	
	    fetch: function fetch() {
	        console.warn('Model.fetch is deprecated, please use Model.instance');
	        return this.instance.apply(this, arguments);
	    },
	
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	angular.value("$Model", $Model);
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/squid/dist/core/dom.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$dom = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var $dom = exports.$dom = {
	
	    elementReady: function elementReady(id) {
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            if (document.getElementById(id)) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (document.getElementById(id)) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, 10);
	
	            setTimeout(60000, reject);
	        });
	    },
	
	    loadScript: function loadScript(name, src, timeout) {
	        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	            var script = document.createElement('script');
	            var loadTimeout = void 0;
	
	            function clearScriptLoadTimeout() {
	                if (loadTimeout) {
	                    clearTimeout(loadTimeout);
	                    loadTimeout = undefined;
	                }
	            }
	
	            script.onload = function () {
	                clearScriptLoadTimeout();
	                setTimeout(resolve, 10);
	            };
	
	            // For Internet explorer 8 support
	            script.onreadystatechange = function () {
	                if (this.readyState === 'complete' || this.readyState === 'loaded') {
	                    clearScriptLoadTimeout();
	                    setTimeout(resolve, 10);
	                }
	            };
	
	            script.onerror = function (event) {
	                _logger.$logger.info('script_error', {
	                    script: src
	                });
	                return reject(new Error(name + '_loading_error'));
	            };
	
	            if (timeout) {
	                loadTimeout = setTimeout(function () {
	                    _logger.$logger.info('script_load_timedout', {
	                        script: src
	                    });
	                    return reject(new Error(name + '_loading_timed_out'));
	                }, timeout);
	            }
	
	            script.setAttribute('src', src);
	
	            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var attribute = _ref;
	
	                script.setAttribute(attribute, attributes[attribute]);
	            }
	
	            document.body.appendChild(script);
	        });
	    },
	
	    cssReady: function cssReady(id) {
	
	        var el = document.getElementById(id);
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            var timeout = void 0;
	            var interval = void 0;
	
	            function check() {
	                _util.$util.forEach(document.styleSheets, function (stylesheet) {
	                    if (stylesheet.href === el.href) {
	                        clearInterval(interval);
	                        clearTimeout(timeout);
	                        resolve();
	                    }
	                });
	            }
	
	            timeout = setTimeout(function () {
	                clearInterval(interval);
	                reject();
	                throw new Error('css_loading_timed_out');
	            }, 30000);
	
	            interval = setInterval(check, 20);
	            check();
	        });
	    }
	};
	
	angular.value("$dom", $dom);
	_logger.$logger;
	
	_promise.$promise;
	
	_util.$util;

/***/ },

/***/ "./components/squid/dist/ng/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ComponentRoute = exports.$Route = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {
	
	    childSpec: {},
	
	    init: function init() {
	        var _this = this;
	
	        this.validate();
	
	        this.url = '/' + (this.path || this.name);
	
	        if (this.query) {
	            this.url += '?' + this.query.join('&');
	        }
	
	        this.hasResolver = Boolean(this.resolve);
	
	        var controller = this.controller = function ($scope) {
	            $scope.route = _this;
	            if ($scope.componentScope) {
	                delete $scope.componentScope.view;
	            }
	        };
	
	        if (this.get('resolve.action')) {
	            this.controller = function ($scope, action) {
	                _angular.$injector.invoke(controller, this, { $scope: $scope });
	                if (action) {
	                    _angular.$location.replace();
	                    if (angular.isObject(action) && action.to && action.params) {
	                        _uiRouter.$state.go(action.to, action.params);
	                    } else {
	                        _uiRouter.$state.go(action);
	                    }
	                }
	            };
	        }
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var routeName = this.constructor.name;
	
	        if (!this.name && !this.path) {
	            throw new Error(routeName + ' :: expected property \'path\'');
	        }
	
	        if (this.url) {
	            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
	        }
	
	        if (this.query && !(this.query instanceof Array)) {
	            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
	        }
	
	        if (this.controller) {
	            // throw new Error(`${routeName} :: unexpected property 'controller'`);
	        }
	
	        if (this.resolve) {
	            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
	                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
	            }
	
	            Object.keys(this.resolve).forEach(function (name) {
	                if (name === 'data') {
	                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
	                } else if (name !== 'action') {
	                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
	                }
	            });
	        }
	
	        if (this.template) {
	            throw new Error(routeName + ' :: unexpected property \'template\'');
	        }
	
	        if (!this.directive && !this.resolve && !this.resolve.action) {
	            throw new Error(routeName + ' :: expected property \'directive\'');
	        }
	
	        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
	            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
	        }
	
	        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
	            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
	        }
	
	        if (this.children) {
	            this.children.forEach(function (childSpec) {
	
	                if (!childSpec.route && !childSpec.name) {
	                    throw new Error(routeName + ' :: child expected property \'route\'');
	                }
	
	                var ChildRoute = childSpec.route;
	                var childName = childSpec.name || ChildRoute.name;
	
	                if (!ChildRoute && childSpec.name) {
	                    try {
	                        ChildRoute = _angular.$injector.get(childSpec.name);
	                    } catch (err) {
	                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
	                    }
	                }
	
	                if (!$Route.isChild(ChildRoute)) {
	                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
	                }
	            });
	        }
	    },
	    goto: function goto(route) {
	        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
	    },
	    getDirective: function getDirective() {
	        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
	    },
	    getDirectiveTag: function getDirectiveTag() {
	        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
	    },
	
	
	    bootstrap: function bootstrap(defaultState, middleware) {
	        var _this2 = this;
	
	        return (0, _ng.$angularInvoke)(function () {
	
	            // only bootstrap if not bootstrapped already
	            var element = angular.element(document.body);
	            if (!element.injector()) {
	                angular.bootstrap(element, ['app']);
	            }
	
	            return _this2.load(defaultState, middleware);
	        });
	    },
	
	    load: function load(defaultState, middleware) {
	
	        defaultState = defaultState || this.defaultState;
	        middleware = middleware || this.middleware;
	
	        _logger.$logger.info('bootstrap_route', {
	            route: this.path || this.name
	        });
	
	        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
	            event.preventDefault();
	
	            _logger.$logger.error('state_not_found', {
	                name: unfoundState.to,
	                from: fromState.name,
	                fromParams: fromParams,
	                hash: window.location.hash
	            });
	
	            throw new Error('state_not_found: ' + unfoundState.to);
	        });
	
	        this.register();
	
	        _uiRouter.$urlRouterProvider.otherwise(function () {
	            return _logger.$logger.info('otherwise_after_bootstrap', {
	                hash: window.location.hash
	            });
	        });
	
	        this.runMiddleware(middleware).then(function () {
	
	            var targetState = void 0,
	                targetParams = void 0;
	
	            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {
	
	                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');
	
	                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
	            }
	
	            _logger.$logger.info('initializing_route', {
	                target: targetState,
	                defaultState: defaultState,
	                hash: window.location.hash
	            });
	
	            _angular.$location.replace();
	
	            if (targetState) {
	                if (_uiRouter.$state.get(targetState)) {
	                    _logger.$logger.info('existing_state', {
	                        stateName: targetState
	                    });
	                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
	                        // lib/js/security.js event listener handles auth required state changes
	                        // and cancels transitions if user not authenticated
	                        if (err.message === 'transition prevented') {
	                            _logger.$logger.warn('transition_prevented', {
	                                targetState: targetState
	                            });
	                            return _core.$promise.resolve();
	                        }
	                        return _core.$promise.reject(err);
	                    });
	                }
	
	                _logger.$logger.info('unknown_state', {
	                    stateName: targetState
	                });
	            }
	
	            if (_uiRouter.$state.get(defaultState)) {
	                _logger.$logger.info('default_state', {
	                    stateName: defaultState
	                });
	                return _uiRouter.$state.go(defaultState)['catch'](function (err) {
	                    if (err.message === 'transition prevented') {
	                        _logger.$logger.warn('transition_prevented', {
	                            targetState: defaultState
	                        });
	                        return _core.$promise.resolve();
	                    }
	                    return _core.$promise.reject(err);
	                });
	            }
	
	            throw new Error('Default state not found: ' + defaultState);
	        })['catch'](function (err) {
	            return _angular.$injector.get('$exceptionHandler')(err);
	        });
	    },
	
	    runMiddleware: function runMiddleware(middleware) {
	
	        _logger.$logger.info('middleware', {
	            priority: _core.$util.map(middleware, function (method) {
	                return method.name;
	            }).join('|')
	        });
	
	        var promise = _core.$promise.resolve();
	
	        angular.forEach(middleware, function (method) {
	            promise = promise.then(function () {
	
	                if (method.name) {
	                    _logger.$logger.info('middleware_' + method.name);
	                }
	
	                return method();
	            });
	        });
	
	        return promise;
	    },
	
	    register: function register() {
	        var _this3 = this;
	
	        this.template = this.constructTemplate(this.childAttributes || {});
	
	        this.absolutePath = this.path || this.name;
	
	        if (this.parent) {
	            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
	        }
	
	        if (!_uiRouter.$state.get(this.absolutePath)) {
	            _uiRouter.$stateProvider.state(this.absolutePath, this);
	        }
	
	        angular.forEach(this.children, function (childSpec) {
	
	            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);
	
	            var childRoute = new ChildRoute({
	                parent: _this3,
	                childSpec: childSpec,
	                childAttributes: childSpec.attributes
	            });
	
	            childRoute.register();
	        });
	    },
	
	    /**
	     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
	     * '<xo-add-bank/>'.
	     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
	     *
	     * @param attributes - A map of name value pairs - {name: value}.
	     * @returns {string}
	     */
	    constructTemplate: function constructTemplate(attributes) {
	        var self = this;
	
	        if (!self.directive) {
	            return;
	        }
	
	        attributes['component-route'] = 'route';
	
	        if (this.parent) {
	            attributes['export'] = 'view';
	        }
	
	        var tag = this.getDirectiveTag();
	
	        var paramString = '';
	
	        angular.forEach(attributes, function (value, key) {
	            paramString += ' ' + key + '="' + value + '"';
	        });
	
	        return '<div ' + tag + ' ' + paramString + '></div>';
	    }
	});
	
	_uiRouter.$stateProvider.state('default', {
	    auth: false
	});
	
	$Route.reopenClass({
	    render: function render() {
	
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	
	        _core.$event.emit('$resetState');
	        (0, _locale.$flushContent)();
	
	        _core.$loader.reset();
	
	        _uiRouter.$state.go('default');
	
	        setTimeout.flush();
	
	        var $scope = _angular.$rootScope.$new();
	
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	
	        var element = (0, _angular.$compile)('<div><ui-view></ui-view></div>')($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	            _core.$loader.reset();
	            _core.$Model.clearCache();
	            _core.$Api.clearCache();
	        }));
	
	        var route = new this();
	        route.bootstrap();
	
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    },
	
	
	    assertActive: function assertActive() {
	        assert(_uiRouter.$state.current instanceof this, 'Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
	    }
	});
	
	function getPageTitle(stateName) {
	
	    var state = _uiRouter.$state.get(stateName);
	
	    if (!state) {
	        return;
	    }
	
	    if (state.titleContent) {
	        return _locale.$locale.content.get(state.titleContent);
	    }
	}
	
	function changePageTitle() {
	
	    document.documentElement.setAttribute('lang', _locale.$locale.lang);
	
	    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
	        return;
	    }
	
	    var fullStateTitle = [];
	
	    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {
	
	        var stateName = [a, b].filter(Boolean).join('.');
	        var stateTitle = getPageTitle(stateName);
	
	        if (stateTitle) {
	            fullStateTitle.push(stateTitle);
	        }
	
	        return stateName;
	    }, null);
	
	    document.title = _core.$util.unique(fullStateTitle).join(' - ');
	}
	
	_core.$event.on('$stateChangeSuccess', changePageTitle);
	_core.$event.on('contentChange', changePageTitle);
	
	var $ComponentRoute = exports.$ComponentRoute = $Route;
	
	angular.value("$Route", $Route);
	angular.value("$ComponentRoute", $ComponentRoute);
	_angular.$rootScope;
	
	_angular.$location;
	
	_angular.$injector;
	
	_angular.$compile;
	
	_uiRouter.$state;
	
	_uiRouter.$stateProvider;
	
	_uiRouter.$urlRouterProvider;
	
	_logger.$logger;
	
	_core.$config;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_core.$loader;
	
	_locale.$locale;
	
	_locale.$flushContent;
	
	_component.$Component;
	
	_ng.$cleanRootScope;
	
	_ng.$once;
	
	_ng.$angularInvoke;

/***/ },

/***/ "./components/squid/dist/locale/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	Object.keys(_currency).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _currency[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/locale/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _name = __webpack_require__("./components/squid/dist/locale/name.js");
	
	Object.keys(_name).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _name[key];
	    }
	  });
	});
	
	var _quantity = __webpack_require__("./components/squid/dist/locale/quantity.js");
	
	Object.keys(_quantity).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _quantity[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/locale/locale.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
	exports.sanitize = sanitize;
	exports.Content = Content;
	exports.$contentVersion = $contentVersion;
	exports.$flushContent = $flushContent;
	exports.$renderContent = $renderContent;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function sanitize(html) {
	    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
	}
	
	var JSONStringify = JSON.stringify;
	
	JSON.stringify = function (item) {
	    if (item instanceof Content) {
	        return item.toString();
	    }
	    return JSONStringify.apply(this, arguments);
	};
	
	function Content(key, props) {
	    this.key = key;
	    this.props = props;
	}
	
	Content.cache = {};
	
	Content.get = function (key, props) {
	
	    if (!key) {
	        return '';
	    }
	
	    props = props || {};
	
	    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
	    var cacheVal = Content.cache[cacheKey];
	
	    if (cacheVal !== undefined) {
	        return cacheVal;
	    }
	
	    cacheVal = Content.cache[cacheKey] = new Content(key, props);
	
	    return cacheVal;
	};
	
	Content.prototype.toString = Content.prototype.valueOf = function () {
	    if (this.string) {
	        return this.string;
	    }
	
	    this.string = this.render(false);
	
	    return this.string;
	};
	
	Content.prototype.toSafeString = function () {
	    if (this.safeString) {
	        return this.safeString;
	    }
	
	    this.safeString = this.render(true);
	
	    return this.safeString;
	};
	
	Content.prototype.render = function (safe) {
	    var _this = this;
	
	    if (!this.key) {
	        return '';
	    }
	
	    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
	    var keys = this.key.split('.');
	
	    for (var i = 0; i < keys.length; i++) {
	        if (value) {
	            value = value[keys[i]];
	        } else {
	            break;
	        }
	    }
	
	    if (!value) {
	        return '';
	    }
	
	    return value.replace(/\{\w+\}/g, function (prop) {
	        prop = prop.slice(1, prop.length - 1);
	
	        if (prop === 'country') {
	            return $locale.country;
	        }
	
	        if (prop === 'lang') {
	            return $locale.lang;
	        }
	
	        if (_this.props[prop] === undefined) {
	            if (!_core.$loader.isLoading()) {
	                _logger.$logger.warn('missing_content_prop', {
	                    key: _this.key,
	                    prop: prop
	                }, { unique: true });
	            }
	
	            return '';
	        }
	
	        var propStr = _this.props[prop].toString();
	
	        if (safe) {
	            return sanitize(propStr);
	        }
	
	        return propStr;
	    });
	};
	
	var contentCache = {};
	var currentVersion = void 0;
	
	window.addContent = function (country, lang, content, version) {
	    var countryCache = contentCache[country] = contentCache[country] || {};
	    countryCache[lang] = content;
	    currentVersion = version;
	};
	
	var metadataCache = {};
	
	window.addMetadata = function (country, lang, metadata) {
	    var countryCache = metadataCache[country] = metadataCache[country] || {};
	    countryCache[lang] = metadata;
	};
	
	function $contentVersion() {
	    return currentVersion || '';
	}
	
	function $flushContent() {
	    contentCache = {};
	    metadataCache = {};
	}
	
	var PP_SPECIAL_COUNTRIES_ISO_CODES = {
	    C2: 'CN'
	};
	
	var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
	
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/locales/:countryCode/:lang',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                    _logger.$logger.info('cached_content');
	                    return contentCache[model.countryCode][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_content', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
	                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                            _logger.$logger.info('content_retrieved');
	                            return contentCache[model.countryCode][model.lang];
	                        }
	
	                        throw new Error('content_not_available');
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (content) {
	                model.setProperties(content);
	                return content;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	
	        if (country === this.countryCode && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        this.countryCode = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            _core.$event.broadcast('contentChange');
	        });
	    }
	});
	
	var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {
	
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/metadata/:country/:lang/metadata',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                    _logger.$logger.info('cached_metadata');
	                    return metadataCache[model.country][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_metadata', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
	                        if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                            _logger.$logger.info('metadata_retrieved', {
	                                uri: uri
	                            });
	                            return metadataCache[model.country][model.lang];
	                        }
	
	                        // Retry if not found in cache
	                        _logger.$logger.info('metadata_not_available', {
	                            uri: uri
	                        });
	                        return _core.$promise.reject(new Error('metadata_not_available'));
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (metadata) {
	                model.setProperties(metadata);
	                return metadata;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	        var _this2 = this;
	
	        this.country = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            if (!_this2.noBroadcast) {
	                _core.$event.broadcast('metadataChange');
	            }
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (_core.$config.supportedCountries) {
	            if (!_core.$config.supportedCountries[country]) {
	                country = this.country;
	            }
	
	            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	                lang = _core.$config.supportedCountries[country][0];
	            }
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    normalizeAddressFields: function normalizeAddressFields(content) {
	
	        var CONTENT_MAPPING = {
	            line1Label: 'streetAddress',
	            line2Label: 'streetAddress2',
	            cityLabel: 'city',
	            stateLabel: 'state',
	            postcodeLabel: 'postalCode'
	        };
	
	        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
	        for (var prop in CONTENT_MAPPING) {
	            if (this.addressEntry && this.addressEntry.strings[prop]) {
	                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
	            }
	        }
	    }
	});
	
	function mapLanguage(lang) {
	    var unselectableLanguages = _core.$config.unselectableLanguages || [];
	    if (unselectableLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            return 'en';
	        }
	    }
	
	    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];
	    if (unsupportedLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            var s = lang + '_locale_not_supported';
	            throw new Error(s);
	        }
	    }
	
	    return lang;
	}
	
	var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
	
	    api: new _core.$Api({
	        uri: '/api/locale'
	    }),
	
	    init: function init() {
	        this._super.init.apply(this);
	        this.content = $ContentModel.instance();
	        this.metadata = $MetadataModel.instance();
	    },
	
	    retrieve: function retrieve() {
	        var self = this;
	        return this._super.retrieve.apply(this, arguments).then(function (result) {
	            self.lang = mapLanguage(self.lang);
	            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {
	
	                // TODO: This at build time... or make sure griffin metadata is complete
	                self.metadata.normalizeAddressFields(self.content);
	
	                return result;
	            });
	        });
	    },
	
	    change: function change(country, lang) {
	
	        var self = this;
	
	        lang = mapLanguage(lang);
	
	        if (country === this.country && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        _logger.$logger.info('locale_change', {
	            country: country,
	            lang: lang
	        });
	
	        this.country = country;
	        this.lang = lang;
	
	        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {
	
	            // TODO: This at build time... or make sure griffin metadata is complete
	            self.metadata.normalizeAddressFields(self.content);
	
	            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
	            return loadedData;
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (!_core.$config.supportedCountries[country]) {
	            country = this.country;
	        }
	
	        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	            lang = _core.$config.supportedCountries[country][0];
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    chooseCountry: function chooseCountry(country) {
	        return this.choose(country, null);
	    },
	
	    chooseLang: function chooseLang(lang) {
	        return this.choose(null, lang);
	    },
	
	    getLocaleCode: function getLocaleCode() {
	        return this.lang + '_' + this.country;
	    },
	
	    getCountryCodeISO: function getCountryCodeISO() {
	        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
	    }
	});
	
	var $locale = exports.$locale = $LocaleModel.instance();
	
	function $renderContent(key, props) {
	    return Content.get(key, props);
	}
	
	var $localeHelper = exports.$localeHelper = {
	    /**
	     *
	     * @param locale - Ex: en_US
	     * @returns {{country: *, dialect}}
	     */
	    normalizeLocale: function normalizeLocale(locale) {
	        if (!locale) {
	            return {};
	        }
	
	        locale = locale.replace('-', '_');
	
	        var country = void 0,
	            language = void 0;
	
	        if (locale.match(/^\w{2}_\w{2}$/)) {
	            locale = locale.split('_');
	
	            language = locale[0];
	            country = locale[1];
	        } else {
	            language = locale;
	        }
	
	        return {
	            country: country,
	            language: language
	        };
	    }
	};
	
	angular.value("sanitize", sanitize);
	angular.value("Content", Content);
	angular.value("$contentVersion", $contentVersion);
	angular.value("$flushContent", $flushContent);
	angular.value("$ContentModel", $ContentModel);
	angular.value("$MetadataModel", $MetadataModel);
	angular.value("$LocaleModel", $LocaleModel);
	angular.value("$locale", $locale);
	angular.value("$renderContent", $renderContent);
	angular.value("$localeHelper", $localeHelper);
	_logger.$logger;
	
	_core.$event;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$meta;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$loader;
	
	_core.$dom;

/***/ },

/***/ "./components/squid/dist/locale/currency.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // everything to do with currency formatting
	
	// quick Griffin reference on currency format:
	// ¤ : Currency Symbol = $
	// # : Amount = 186432.431
	// C : Currency Code = USD
	
	exports.roundingAndSeparators = roundingAndSeparators;
	exports.formatCurrency = formatCurrency;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// This seems to be the only currency / locale specific exception in Griffin
	var STYLE_EXCEPTION = {
	    'tr TR TRY': '# ¤;-# ¤'
	};
	
	var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g');
	var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
	var ENDS_IN_WHITESPACE = new RegExp('\s$');
	var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
	
	// Griffin "fuzzy logic"
	// apparently if the symbol is at least "66% similar" to the code, ignore it
	function maybeIgnoreSymbol(style, symbol, code) {
	
	    // THIS IS NOT COMMUTATIVE
	    function fuzzyMatch(code, symbol) {
	        // eslint-disable-line no-shadow
	        if (code === symbol) {
	            return 100;
	        } else {
	            var _ret = function () {
	                var codeParts = code.split('');
	                var symbolParts = symbol.split('');
	
	                var equivalency = codeParts.reduce(function (equiv, codePart) {
	                    var symbolPos = symbolParts.indexOf(codePart);
	
	                    if (symbolPos !== -1) {
	                        symbolParts.splice(symbolPos, 1);
	                        return equiv + 1;
	                    }
	                    return equiv;
	                }, 0);
	
	                var weight = equivalency / codeParts.length;
	
	                return {
	                    v: weight * 100
	                };
	            }();
	
	            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        }
	    }
	
	    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;
	
	    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
	}
	
	// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
	// and thousand separators
	function roundingAndSeparators(amountString, _ref) {
	    var decimalPlaces = _ref.decimalPlaces,
	        dot = _ref.dot,
	        comma = _ref.comma;
	
	    var value = parseFloat(amountString);
	    var truncate = decimalPlaces === 0;
	
	    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
	    var wholeString = amountParts[0].replace(THOUSANDS_SPLITTER, comma);
	    var decimalString = amountParts[1] || '00';
	
	    return truncate ? wholeString : '' + wholeString + dot + decimalString;
	}
	
	// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
	function forceCodeToRight(style) {
	    var parts = CODE_IN_FRONT.exec(style) || [];
	    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
	    var newStyle = style;
	
	    // if CODE_IN_FRONT regex matches, array indexes -
	    // [1] negative symbol plus whitespace, if any,
	    // [2] the "C" plus any whitespace,
	    // [3] whatever is after "C"
	    if (parts.length === 4) {
	        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
	    }
	
	    return newStyle;
	}
	
	// deal with
	// 1. exceptions for specific locales
	// 2. positive and negative styles
	// 3. griffin fuzzy logic
	// 4. UED consistency logic
	function getFinalStyle() {
	    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
	    var _ref2 = arguments[1];
	    var lang = _ref2.lang,
	        country = _ref2.country;
	    var _ref3 = arguments[2];
	    var value = _ref3.value,
	        _ref3$symbol = _ref3.symbol,
	        symbol = _ref3$symbol === undefined ? '' : _ref3$symbol,
	        code = _ref3.code;
	
	
	    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
	    var currencyStyle = exception || styleString;
	
	    var _currencyStyle$split = currencyStyle.split(';'),
	        positiveStyle = _currencyStyle$split[0],
	        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;
	
	    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
	    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions
	
	    return forceCodeToRight(griffinStyle);
	}
	
	// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
	// and produce the final result.
	//
	// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
	function applyCurrencyStyle(finalStyle, amountFormatted, _ref4) {
	    var symbol = _ref4.symbol,
	        code = _ref4.code,
	        _ref4$wrapCodeInSpan = _ref4.wrapCodeInSpan,
	        wrapCodeInSpan = _ref4$wrapCodeInSpan === undefined ? false : _ref4$wrapCodeInSpan;
	
	    // the style will take care of negative symbol (see getFinalStyle function above)
	    var absoluteAmountFormatted = amountFormatted.replace('-', '');
	
	    // parallel operation is safer than serial replace
	    return finalStyle.split('').map(function (char) {
	        switch (char) {
	            case 'C':
	                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
	            case '¤':
	                return symbol;
	            case '#':
	                return absoluteAmountFormatted;
	            default:
	                return char;
	        }
	    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
	}
	
	function formatCurrency(amount, code, wrapCodeInSpan) {
	    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';
	
	    var _ref5 = _locale.$locale.metadata || {},
	        _ref5$number = _ref5.number,
	        numberConfig = _ref5$number === undefined ? {} : _ref5$number,
	        _ref5$currency = _ref5.currency,
	        currencyConfig = _ref5$currency === undefined ? {} : _ref5$currency;
	
	    var _currencyConfig$digit = currencyConfig.digits,
	        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
	        _currencyConfig$style = currencyConfig.styles,
	        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
	        _currencyConfig$suppo = currencyConfig.supportedSymbols,
	        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;
	
	    var value = parseFloat(amount);
	
	    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    var amountFormatted = roundingAndSeparators(amount.toString(), { decimalPlaces: digits[code], dot: dot, comma: comma });
	
	    if (code) {
	        var symbol = currencySymbols[code];
	        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });
	
	        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
	    }
	
	    return amountFormatted; // HTML?
	}
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/feature.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$feature = $feature;
	exports.$featureCountries = $featureCountries;
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	function $feature(prop, def, country) {
	
	    var features = _core.$config.features || {};
	
	    country = country || _locale.$locale.country;
	    // 1. Check the feature is present in country
	    var result = _core.$Class.get(features[country], prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 2. Check the feature is present in feature group
	    _core.$util.some(_core.$config.regions, function (countries, region) {
	        if (countries.indexOf(country) !== -1) {
	            result = _core.$Class.get(features[region], prop);
	            return result !== undefined;
	        }
	    });
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 3. Check the feature is present in default group
	    result = _core.$Class.get(features.DEFAULT, prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    return def;
	}
	
	// Build a list of all countries in our feature list and regions
	// populate countries with out REGION names in the list
	var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
	    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
	});
	
	// populate all the region countries in to allcountries
	_core.$util.forEach(_core.$config.regions, function (countries, region) {
	    _core.$util.forEach(countries, function (country) {
	        if (allCountries.indexOf(country) === -1) {
	            allCountries.push(country);
	        }
	    });
	});
	
	function $featureCountries(prop) {
	    // Find the countries with a certain feature enabled
	    return allCountries.filter(function (country) {
	        return $feature(prop, false, country);
	    });
	}
	
	angular.value("$feature", $feature);
	angular.value("$featureCountries", $featureCountries);
	_core.$config;
	
	_core.$Class;
	
	_core.$util;
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/name.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatNameInformal = formatNameInformal;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// Mapping of Griffin fields to name fields that should be used
	var SUBSTITUTED_FIELDS = {
	    givenName: 'first_name',
	    surname: 'last_name'
	};
	
	// Taken from griffin-paypal: test if a string is Latin
	function isLatin(str) {
	    if (!str) {
	        return true;
	    }
	
	    for (var i = 0; i < str.length; i++) {
	        if (str.charCodeAt(i) > 0x24F) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Formats name into informal format based on Griffin metadata
	 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
	 * @return {String}      The formatted string, or null if data is missing
	 */
	function formatNameInformal(name) {
	    var layoutMetadata = _locale.$locale.metadata.nameInformal;
	    var layout = null;
	
	    if (!layoutMetadata) {
	        return name.first_name || null; // Default to first name if metadata not loaded
	    }
	
	    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
	    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
	        layout = layoutMetadata['latinLayout'];
	    } else {
	        layout = layoutMetadata['layout'];
	    }
	
	    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
	    var formattedName = [];
	    for (var i = 0; i < layout.length; i++) {
	        var namePart = layout[i];
	
	        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
	            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
	        }
	    }
	
	    return formattedName.join('');
	}
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/quantity.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatQuantity = formatQuantity;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	// format a quantity to add a thousand separator based on a locality
	function formatQuantity(quantity) {
	    var _ref = _locale.$locale.metadata || {},
	        _ref$number = _ref.number,
	        numberConfig = _ref$number === undefined ? {} : _ref$number;
	
	    var dot = '';
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    return (0, _currency.roundingAndSeparators)(quantity.toString(), { decimalPlaces: 0, dot: dot, comma: comma });
	}
	
	_locale.$locale;
	
	_currency.roundingAndSeparators;

/***/ },

/***/ "./components/squid/dist/ng/component.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Component = undefined;
	exports.$populate = $populate;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	(0, _directive.$registerDirective)('prevent-default', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click', function (event) {
	                event.preventDefault();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('stop-propagation', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click', function (event) {
	                event.stopPropagation();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('validate-submit', function () {
	
	    return {
	        link: function link($scope, $element, $attrs) {
	
	            var $form = $element.closest('form');
	            var form = $scope[$form.prop('name')];
	
	            $element.on('click', function (event) {
	                event.preventDefault();
	
	                $form.addClass('validated');
	                $scope.validated = true;
	                form.$setSubmitted();
	
	                if (form.$valid) {
	                    try {
	                        $scope.$eval($attrs.validateSubmit);
	                    } catch (err) {
	                        _angular.$injector.get('$exceptionHandler')(err);
	                    }
	                } else {
	                    $form.find('.ng-invalid:first').focus();
	                }
	            });
	        }
	    };
	});
	
	function assertModelsRetrievedOrEmpty(items) {
	    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
	        angular.forEach(items, function (item, name) {
	            if (item instanceof _core.$Model) {
	                if (item.meta.populated) {
	                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
	                }
	            }
	        });
	    }
	}
	
	var $Component = exports.$Component = _core.$Class.extend('$Component', {
	
	    onPopulate: angular.noop,
	
	    init: function init() {
	        var _this = this,
	            _arguments = arguments;
	
	        this.validate();
	
	        this.name = _core.$util.dasherizeToCamel(this.tag);
	        this.template = '<div class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</div>';
	
	        this.scope = this.scope || {};
	        this.resolve = this.resolve || {};
	        this.props = this.props || {};
	        this.rootEvents = this.rootEvents || {};
	
	        this.actions = this.actions || {};
	
	        this.lifecycle = this.lifecycle || {};
	        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
	        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
	        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
	        this.lifecycle.populate = this.lifecycle.populate || angular.noop;
	
	        if (this.scope && Object.keys(this.scope).length) {
	
	            if (this.props && Object.keys(this.props).length) {
	                throw new Error('Can not defined scope and props on the same component');
	            }
	
	            this.scope.componentRoute = '=';
	            this.scope['export'] = '@';
	
	            this.props = _core.$util.map(this.scope, function (type, key) {
	                return {
	                    type: {
	                        '=': 'var',
	                        '@': 'str'
	                    }[type],
	                    required: false
	                };
	            });
	        } else {
	
	            this.props.componentRoute = {
	                type: 'var',
	                required: false
	            };
	
	            this.props['export'] = {
	                type: 'str',
	                required: false
	            };
	
	            this.scope = _core.$util.map(this.props, function (spec, key) {
	                return {
	                    'var': '=',
	                    'str': '@'
	                }[spec.type || 'var'];
	            });
	        }
	
	        var originalController = this.controller || angular.noop;
	
	        this.controller = function ($scope, $element) {
	            $scope.$element = $element;
	
	            $scope.$on('$destroy', function () {
	                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
	                    delete $scope.componentRoute.parent.scope.viewConfig;
	                }
	                _this.lifecycle.exit.call($scope);
	            });
	
	            $scope.props = {};
	
	            if ($scope.componentRoute) {
	                (function () {
	                    var componentRoute = $scope.componentRoute;
	
	                    componentRoute.scope = $scope;
	
	                    componentRoute.scope.goto = function (route) {
	                        componentRoute.goto(route);
	                    };
	
	                    var parentRoute = componentRoute.parent;
	
	                    if (parentRoute) {
	
	                        var parentScope = parentRoute.scope;
	                        var parentDirective = parentRoute.getDirective();
	                        var childSpec = componentRoute.childSpec;
	
	                        if (childSpec.config) {
	                            if (parentDirective instanceof $Component) {
	                                parentScope.viewConfig = childSpec.config.call(parentScope);
	                            } else {
	                                throw new Error('In order to use config() for child routes, ' + parentRoute.getDirectiveTag() + ' must be instance of new style $Component');
	                            }
	                        }
	
	                        if (childSpec.props) {
	
	                            if (parentDirective instanceof $Component) {
	                                angular.extend($scope, childSpec.props.call(parentScope));
	                            } else {
	                                throw new Error('In order to use props() for child routes, ' + parentRoute.getDirectiveTag() + ' must be instance of new style $Component');
	                            }
	                        }
	                    }
	                })();
	            }
	
	            angular.forEach(_this.props, function (type, key) {
	
	                var prop = _this.props[key];
	                var required = prop.required !== false;
	                var def = void 0;
	
	                if (prop['default'] instanceof Function) {
	                    def = _core.$util.memoize(prop['default'].bind($scope));
	                } else {
	                    def = function def() {
	                        return prop['default'];
	                    };
	                }
	
	                var UNDEFINED = {
	                    'var': undefined,
	                    str: ''
	                }[prop.type];
	
	                Object.defineProperty($scope.props, key, {
	                    get: function get() {
	                        var val = $scope[key];
	
	                        if (val === UNDEFINED) {
	                            if (required) {
	                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
	                            }
	
	                            return def();
	                        }
	
	                        return val;
	                    },
	
	                    set: function set() {
	                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
	                    }
	                });
	            });
	
	            $scope.fields = {};
	
	            $scope.actions = _core.$util.bindObject(_this.actions, $scope);
	
	            Object.keys(_this.rootEvents).forEach(function (eventName) {
	                var cancel = _core.$event.on(eventName, function (event) {
	                    _this.rootEvents[eventName].apply($scope, _arguments);
	                });
	
	                $scope.$on('$destroy', cancel);
	            });
	
	            $scope.display = true;
	
	            $scope.reload = function () {
	
	                if (!$scope.populated) {
	                    throw new Error('Can not reload unpopulated component');
	                }
	
	                $scope.display = false;
	                setTimeout(function () {
	                    $scope.display = true;
	                });
	            };
	
	            $scope.componentScope = $scope;
	
	            if ($scope.props['export'] && $scope.$parent.componentScope) {
	
	                $scope.exports = angular.extend({}, _this.exports || {}, {
	                    reload: $scope.reload
	                });
	
	                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
	                    get: function get() {
	                        return $scope.exports;
	                    },
	
	                    configurable: true
	                });
	            }
	
	            $scope._enablePopulateEvents = true;
	
	            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
	            _this.lifecycle.enter.call($scope);
	
	            $scope._enablePopulateEvents = false;
	
	            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
	                if (toState === $scope.props.componentRoute) {
	                    _this.lifecycle.reenter.call($scope);
	                }
	            });
	
	            $scope.$on('$destroy', cancelReEnterEvent);
	
	            return _core.$promise.sequential([function () {
	                $scope.$emit('_populating');
	            }, function () {
	                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {
	
	                    if (angular.isObject(resolver)) {
	                        $scope[name] = resolver;
	                        return resolver;
	                    }
	
	                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
	                        assertModelsRetrievedOrEmpty(data);
	
	                        return _core.$promise.hash(data).then(function (resolvedData) {
	
	                            $scope[name] = resolvedData;
	                            return resolvedData;
	                        });
	                    });
	                });
	            }, function () {
	
	                $scope.populated = true;
	
	                $scope.$emit('_populated');
	
	                _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	
	                    $scope.$on('populated', function (populatedEvent) {
	                        populatedEvent.stopPropagation();
	                    });
	
	                    $scope.$emit('populated');
	                    _this.onPopulate.call($scope);
	                    _this.lifecycle.populate.call($scope);
	                });
	            }]);
	        };
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var componentName = this.constructor.name;
	
	        if (!this.tag) {
	            throw new Error(componentName + ' :: expected property \'tag\'');
	        }
	
	        if (!this.tag.match(/^[a-z0-9-]+$/)) {
	            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
	        }
	
	        if (!this.template) {
	            throw new Error(componentName + ' :: expected property \'template\'');
	        }
	
	        if (this.resolve) {
	            angular.forEach(this.resolve, function (resolver, name) {
	                if (!(resolver instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.props) {
	            angular.forEach(this.props, function (prop, name) {
	
	                if (!(prop instanceof Object)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
	                }
	
	                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
	                }
	
	                if (prop['default'] && prop.required) {
	                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
	                }
	
	                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
	                }
	            });
	        }
	
	        if (this.actions) {
	            angular.forEach(this.actions, function (action, name) {
	                if (!(action instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.lifecycle) {
	            Object.keys(this.lifecycle).forEach(function (name) {
	                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
	                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
	                }
	            });
	        }
	    }
	});
	
	$Component.reopenClass({
	
	    extend: function extend() {
	
	        var SubClass = _core.$Class.extend.apply(this, arguments);
	
	        var spec = new SubClass();
	
	        angular.module().directive(spec.name, function () {
	            return spec;
	        });
	
	        return SubClass;
	    },
	
	    render: function render(scope) {
	
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	
	        _core.$event.emit('$resetState');
	        (0, _locale.$flushContent)();
	
	        var $scope = _angular.$rootScope.$new();
	        angular.extend($scope, scope);
	
	        var attrs = Object.keys(scope).map(function (key) {
	            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
	        }.bind(this)).join(' ');
	
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	
	        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';
	
	        console.log('RENDER', html, scope);
	
	        var element = (0, _angular.$compile)(html)($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	        }));
	
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    }
	});
	
	function autoConvertDirectiveToComponent(_ref, original) {
	    var name = _ref[0],
	        factory = _ref[1];
	
	
	    if (!angular.isFunction(factory)) {
	        return original();
	    }
	
	    var tag = _core.$util.camelToDasherize(name);
	    var spec = _angular.$injector.invoke(factory);
	
	    if (spec.controller) {
	        (function () {
	            var originalController = spec.controller;
	
	            spec.controller = function ($scope, $element) {
	                $scope._enablePopulateEvents = true;
	                var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });
	                $scope._enablePopulateEvents = false;
	                return result;
	            };
	        })();
	    }
	
	    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
	        return original(this, [name, function () {
	            return spec;
	        }]);
	    }
	
	    if (spec.componentize) {
	
	        $Component.extend('$' + name + 'Component', spec, {
	            tag: tag
	        });
	
	        return this;
	    }
	
	    return original(this, [name, function () {
	        return spec;
	    }]);
	}
	
	_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
	_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);
	
	// $populate needs to go away
	
	function $populate($scope, instances) {
	
	    $scope.$on = $scope.$on || angular.noop;
	    $scope.$emit = $scope.$emit || angular.noop;
	
	    var _enablePopulateEvents = $scope._enablePopulateEvents;
	
	    if (_enablePopulateEvents) {
	        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	            $scope.$emit('populated');
	        });
	    }
	
	    $scope.$on('populated', function (populatedEvent) {
	        populatedEvent.stopPropagation();
	    });
	
	    if (_enablePopulateEvents) {
	        $scope.$emit('_populating');
	    }
	
	    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {
	
	        var promise = void 0;
	
	        if (instance.then) {
	            promise = instance;
	        } else {
	            promise = instance.retrieve();
	            $scope[name] = instance;
	        }
	
	        return promise.then(function (result) {
	            $scope[name] = result;
	            return result;
	        });
	    })).then(function (result) {
	
	        if (_enablePopulateEvents) {
	            $scope.$emit('_populated');
	        }
	
	        return result;
	    });
	}
	
	angular.value("$Component", $Component);
	angular.value("$populate", $populate);
	_angular.$rootScope;
	
	_angular.$compile;
	
	_angular.$injector;
	
	_angular.$compileProvider;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$event;
	
	_locale.$flushContent;
	
	_ng.$cleanRootScope;
	
	_directive.$registerDirective;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/squid/dist/ng/ng.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$angularInvoke = $angularInvoke;
	exports.$once = $once;
	exports.$cleanRootScope = $cleanRootScope;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function $angularInvoke(method) {
	    try {
	        return method();
	    } catch (err) {
	        _angular.$injector.get('$exceptionHandler')(err);
	    }
	}
	
	function $once(name, handler) {
	    var cancel = _core.$event.on(name, function () {
	        cancel();
	        handler.apply(this, arguments);
	    }, true);
	}
	
	function $cleanRootScope(rootScope) {
	
	    var keys = Object.keys(rootScope);
	
	    var autoCleanupEventHandlers = [];
	    var eventHandlers = [];
	    var eventCancelers = [];
	
	    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
	        var name = _ref[0],
	            handler = _ref[1],
	            once = _ref[2];
	
	
	        var cancel = original();
	
	        var $state = void 0;
	
	        try {
	            $state = _angular.$injector.get('$state');
	        } catch (err) {
	            // pass
	        }
	
	        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
	            autoCleanupEventHandlers.push(cancel);
	            return function autoCleanedUpCancel() {};
	        }
	
	        if (once) {
	            eventCancelers.push(cancel);
	            return cancel;
	        }
	
	        // Let ng-router do its thing
	        if (handler.toString().indexOf('updateView') !== -1) {
	            return cancel;
	        }
	
	        var stack = void 0;
	
	        try {
	            throw new Error('$rootScope.$on');
	        } catch (err) {
	            stack = err.stack;
	        }
	
	        var reference = {
	            name: name,
	            handler: handler.toString(),
	            stack: stack
	        };
	        eventHandlers.push(reference);
	
	        return function () {
	            cancel();
	            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
	        };
	    });
	
	    return function () {
	
	        _core.$event.emit('$destroy');
	
	        autoCleanupEventHandlers.forEach(function (canceler) {
	            return canceler();
	        });
	        autoCleanupEventHandlers = [];
	
	        Object.keys(rootScope).forEach(function (key) {
	            if (keys.indexOf(key) === -1) {
	                delete rootScope[key];
	            }
	        });
	
	        if (eventHandlers.length) {
	            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
	                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
	            }).join('\n\n'));
	        }
	
	        eventCancelers.forEach(function (cancel) {
	            return cancel();
	        });
	    };
	}
	
	angular.value("$angularInvoke", $angularInvoke);
	angular.value("$once", $once);
	angular.value("$cleanRootScope", $cleanRootScope);
	_angular.$injector;
	
	_core.$util;
	
	_core.$event;

/***/ },

/***/ "./components/squid/dist/ng/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$registerDirective = $registerDirective;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function $registerDirective(tag, definition) {
	
	    var directiveName = tag.replace(/-([a-z])/g, function (g) {
	        return g[1].toUpperCase();
	    });
	
	    return _angular2["default"].module().directive(directiveName, definition);
	}
	
	_angular2["default"].value("$registerDirective", $registerDirective);

/***/ },

/***/ "./components/squid/dist/ng/feature.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	(0, _directive.$registerDirective)('feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
	            };
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('unless-feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="!enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
	            };
	        }
	    };
	});
	_directive.$registerDirective;
	
	_locale.$feature;
	
	_core.$integration;

/***/ },

/***/ "./components/squid/dist/ng/locale.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	(0, _angular.$registerDirective)('content', function () {
	    return {
	        restrict: 'A',
	
	        link: function link($scope, element, attributes) {
	            $scope.content = $scope.htmlContent = function (key, props) {
	                if (attributes.content) {
	                    key = attributes.content + '.' + key;
	                }
	                var content = _locale.Content.get(key, props);
	
	                if (content.toString()) {
	                    return content;
	                } else {
	                    return;
	                }
	            };
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('bind-html-compile', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.$watch(function () {
	                return $scope.$eval($attrs.bindHtmlCompile);
	            }, function (value) {
	                $element.html(value && value.toString());
	                (0, _angular.$compile)($element.contents())($scope);
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('format-currency', function () {
	
	    return {
	        restrict: 'E',
	        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
	        scope: {
	            amount: '=',
	            symbol: '=',
	            code: '=',
	            currencyStyle: '@'
	        },
	        controller: function controller($scope) {
	
	            function format() {
	                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
	            }
	
	            $scope.$on('$destroy', _core.$event.on('localeChange', format));
	
	            $scope.$watch('amount', function (newValue, oldValue) {
	                if (newValue !== oldValue && _locale.$locale.country) {
	                    format();
	                }
	            });
	
	            if (_locale.$locale.country) {
	                format();
	            }
	        } // controller
	    }; // return
	}); // registerDirective
	
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	angular.module().value('$sanitize', function (val) {
	    if (val instanceof _locale.Content) {
	        return val.toSafeString();
	    }
	    return (0, _locale.sanitize)(val);
	});
	
	_angular.$sce;
	
	_angular.$registerDirective;
	
	_angular.$compile;
	
	_core.$event;
	
	_locale.formatCurrency;
	
	_locale.sanitize;
	
	_locale.Content;
	
	_locale.$locale;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/squid/dist/ng", "components/squid/dist/ng/locale.js"))

/***/ },

/***/ "./components/squid/dist/ng/module.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.module = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _module = _angular2['default'].module;
	exports.module = _module;

/***/ },

/***/ "./components/squid/dist/ng/events.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	angular.module().run(function () {
	
	    _core.$event.on('$stateChangeStart', function (event) {
	        _core.$event.emit('loading');
	        _core.$event.emit('loaded');
	    });
	
	    var startLoadTime = 0;
	    var currentState = 'checkout_init';
	
	    function currentStateName() {
	        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
	    }
	
	    _core.$event.on('startLoad', function () {
	
	        if (startLoadTime) {
	            startLoadTime = _core.$util.now();
	        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {
	
	            var performance = window.performance;
	            var timing = window.performance.timing || {};
	            var now = performance.now();
	
	            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	        }
	    });
	
	    _core.$event.on('allLoaded', function () {
	
	        var newState = currentStateName();
	
	        if (!newState) {
	            return;
	        }
	
	        if (currentState === newState) {
	            _core.$event.emit('page_reloaded', currentState);
	        } else {
	
	            var duration = void 0;
	
	            if (startLoadTime) {
	                duration = _core.$util.now() - startLoadTime;
	            }
	
	            var payload = {
	                start: currentState,
	                end: newState,
	                time: duration,
	                duration: duration
	            };
	
	            _core.$event.emit('$transition', {
	                from: currentState,
	                toState: _uiRouter.$state.current,
	                duration: duration
	            });
	
	            _logger.$logger.info('transition', payload);
	            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);
	
	            _core.$event.emit('page_loaded', currentState, newState);
	
	            currentState = newState;
	        }
	    });
	
	    _core.$event.emit('loading');
	
	    var cancel = _core.$event.on('$stateChangeSuccess', function () {
	        if (_uiRouter.$state.current.template) {
	            cancel();
	            setTimeout(function () {
	                _core.$event.emit('loaded');
	            }, 50);
	        }
	    });
	});
	
	_uiRouter.$state;
	
	_logger.$logger;
	
	_core.$event;
	
	_core.$util;

/***/ },

/***/ "./components/squid/dist/ng/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.on('pxp_res', function (event, pxpRes) {
	    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
	    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
	    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
	});
	
	_uiRouter.$state;
	
	_core.$event;

/***/ },

/***/ "./components/squid/dist/paypal/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	Object.keys(_env).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _env[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/paypal/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/paypal/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/paypal/env.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var $env = exports.$env = {
	
	    isLocal: function isLocal() {
	        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
	    },
	
	    isStage: function isStage() {
	        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
	    },
	
	    isSandbox: function isSandbox() {
	        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
	    },
	
	    isLive: function isLive() {
	        return window.location.hostname === 'www.paypal.com';
	    },
	
	    isTest: function isTest() {
	        return false;
	    }
	};
	
	angular.value("$env", $env);

/***/ },

/***/ "./components/squid/dist/paypal/config.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	_core.$config.deploy = _core.$config.deploy || _env.$env;
	
	_core.$config;
	
	_env.$env;

/***/ },

/***/ "./components/squid/dist/paypal/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$PXPModel = undefined;
	exports.$getPxpTreatments = $getPxpTreatments;
	exports.$pxp = $pxp;
	exports.$pxpMatch = $pxpMatch;
	exports.$pxpFactors = $pxpFactors;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var $PXPModel = exports.$PXPModel = _core.$Model.extend({
	    api: new _core.$Api({
	        uri: '/api/pxp/:pagename'
	    })
	});
	
	function logPxp(pxpRes, params, logPayload) {
	
	    var exp_name = [],
	        xe = [],
	        xt = [];
	
	    angular.forEach(pxpRes.treatments, function (treatment) {
	
	        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
	            experiment: pxpRes.pagename,
	            treatment: treatment.treatment_name,
	            experiment_id: treatment.experiment_id,
	            treatment_id: treatment.treatment_id,
	            loc_country: _locale.$locale.country,
	            loc_lang: _locale.$locale.lang
	        }, params, logPayload));
	
	        exp_name.push(treatment.treatment_name);
	        xe.push(treatment.experiment_id);
	        xt.push(treatment.treatment_id);
	    });
	
	    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
	        pxp_exp_id: xe.join('|'),
	        pxp_trtmnt_id: xt.join('|'),
	        treatments: exp_name.join('|'),
	        loc_country: _locale.$locale.country,
	        loc_lang: _locale.$locale.lang
	    }, params, logPayload));
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: xe.join(','),
	        pxp_trtmnt_id: xt.join(',')
	    });
	
	    _core.$event.emit('pxp_res', pxpRes);
	}
	
	function $getPxpTreatments(id, params, logPayload) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	    return _core.$promise.run(function () {
	
	        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
	
	        var forceTreatments = _core.$util.param('pxp_' + id);
	
	        if (forceTreatments) {
	            pxp.treatments = _core.$util.map(forceTreatments.split(','), function (treatment_name) {
	                return {
	                    treatment_name: treatment_name
	                };
	            });
	
	            return pxp;
	        }
	
	        if (forceApiCall) {
	            return pxp.reload({
	                params: params
	            });
	        }
	
	        return pxp.retrieve({
	            params: params
	        });
	    }).then(function (pxp) {
	
	        if (!pxp.cached) {
	            logPxp(pxp, params, logPayload);
	        }
	
	        pxp.cached = true;
	
	        return pxp;
	    });
	}
	
	function $pxp(id, params, pattern) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	    if (!pattern) {
	        pattern = params;
	        params = {};
	    }
	    pattern = new RegExp('^' + pattern + '$');
	
	    return $getPxpTreatments(id, params, null, forceApiCall).then(function (pxpResponse) {
	        var result = void 0;
	        _core.$util.some(pxpResponse.treatments, function (treatment) {
	            if (pattern.test(treatment.treatment_name)) {
	                result = {
	                    treatment_name: treatment.treatment_name,
	                    factors: treatment.factors
	                };
	                return result;
	            }
	        });
	        return result;
	    });
	}
	
	function $pxpMatch(id, params, patterns, logPayload) {
	
	    if (!patterns) {
	        patterns = params;
	        params = {};
	    }
	    return $getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
	
	        var result = {};
	
	        angular.forEach(patterns, function (pattern, name) {
	            pattern = new RegExp('^' + pattern + '$');
	
	            result[name] = false;
	
	            _core.$util.some(pxpResponse.treatments, function (treatment) {
	                if (pattern.test(treatment.treatment_name)) {
	                    result[name] = true;
	                    return result[name];
	                }
	            });
	        });
	
	        return result;
	    });
	}
	
	function $pxpFactors(id, params, pattern) {
	    params.factors = 'true';
	    return $pxp(id, params, pattern).then(function (pxpResponse) {
	        var result = void 0;
	        if (pxpResponse && pxpResponse.factors) {
	            result = { treatment_name: pxpResponse.treatment_name };
	            var pxpFactors = pxpResponse.factors;
	            var length = pxpFactors.length;
	            for (var i = 0; i < length; i++) {
	                result[pxpFactors[i].name] = pxpFactors[i].value;
	            }
	        }
	        return result;
	    });
	}
	
	window.$pxp = $pxp;
	
	angular.value("$PXPModel", $PXPModel);
	angular.value("$getPxpTreatments", $getPxpTreatments);
	angular.value("$pxp", $pxp);
	angular.value("$pxpMatch", $pxpMatch);
	angular.value("$pxpFactors", $pxpFactors);
	_logger.$logger;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_locale.$locale;

/***/ },

/***/ "./components/xo-models/src/auth/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.auth', ['squid']).factory('$AuthApi', function ($Api, $config) {
	        return $Api.extend('AuthApi', {
	            baseURI: $config.urls.baseUrl,
	            uri: '/api/auth',
	            postAttempts: 3
	        });
	    }).factory('$AuthModel', function ($Model, $AuthApi) {
	
	        return $Model.extend('AuthModel', {
	            api: new $AuthApi(),
	
	            loggedIn: function loggedIn() {
	                return this.logged_in;
	            },
	
	            visitorId: function visitorId() {
	                return this.visitor_id;
	            },
	
	            accessToken: function accessToken() {
	                return this.access_token;
	            },
	
	            accessTokenPresent: function accessTokenPresent() {
	                return this.access_token_present;
	            },
	
	            refreshToken: function refreshToken() {
	                return this.refresh_token;
	            }
	        });
	    }).factory('$ULoginModel', function ($Model, $Api) {
	
	        return $Model.extend('ULoginModel', {
	            api: new $Api({
	                uri: '/api/auth/ulogin',
	                postAttempts: 1,
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/auth", "components/xo-models/src/auth/index.js"))

/***/ },

/***/ "./js/lib/fallback.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _constants = __webpack_require__("./js/lib/constants.js");
	
	var _customUtil = __webpack_require__("./js/lib/customUtil.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// handler for UI fallbacks for all unhandled and handled errors
	// fallbacks to Legacy in case of Open button flow
	// fallbacks to generic error page in case of Add to cart flow
	// All Legacy fallbacks are POST fallbacks. After the POST request - it goes to routes/index.js (/fallback POST handler)
	
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$fallbackErrorHandler', function ($q, $config, $meta, $timeout, $window, $logger, $log, $feature, $ReturnToMerchant, $locale, $util, $FallbackError, $state, $rootScope, $populate) {
	    return function (err) {
	        var reason = err.reason;
	        var product = err.product || 'ux';
	        var entry_point = err.entryPoint;
	        var params = err.params;
	
	        // construct url to the backend route - /fallback located in the routes/index.js
	        function getFallbackOpenButtonUrl(urlParams) {
	            var base = $config.urls.fallbackUrl['openButton'];
	            return $util.paypalURL(base, urlParams);
	        }
	
	        function getFallbackShoppingCartUrl(urlParams) {
	            var base = $config.urls.fallbackUrl['shoppingCart'];
	            return $util.paypalURL(base, urlParams);
	        }
	
	        function doFallback() {
	            $util.assert(reason, 'expected fallback reason');
	            var xClickParams = _customUtil.customUtil.decodeAndParse($meta.xclickParams);
	
	            // if open button flow we fallback to the legacy and form log messages
	            var urlParams = params || {};
	
	            _angular2['default'].extend(urlParams, {
	                fallback: 1,
	                landing: entry_point,
	                useraction: $util.param('useraction'),
	                flowlogging_id: $util.param('flowlogging_id')
	            });
	
	            var eventName = void 0;
	            if (xClickParams.wa_type === _constants.BUYNOW_WA_TYPE) {
	                eventName = 'shoppingcart_open_button_fallback';
	            } else {
	                eventName = 'shoppingcart_fallback';
	            }
	            $logger.info(eventName, {
	                reason: reason,
	                xClickParams: xClickParams
	            });
	
	            $logger.log(product ? 'info' : 'error', 'fallback', {
	                reason: reason,
	                product: product,
	                entry_point: entry_point,
	                error_desc: reason,
	                from: $rootScope.currentState || 'fallback',
	                to: product ? 'process_fallback_' + product : 'process_fallback'
	            });
	
	            var url = void 0;
	            if (xClickParams.wa_type === _constants.SHOPPINGCART_WA_TYPE) {
	                url = getFallbackShoppingCartUrl(urlParams);
	                if (reason !== 'shoppingcart_checkout_fallback') {
	                    xClickParams['shopping_cart_node_fallback'] = true;
	                } else {
	                    delete xClickParams['add'];
	                    xClickParams['display'] = 1;
	                }
	            } else {
	                url = getFallbackOpenButtonUrl(urlParams);
	            }
	            $rootScope.$emit('loading');
	            // remove cmd param before falling back to the legacy
	            // since fallback url already have it and it will cause the fallback error
	            delete xClickParams['cmd'];
	            delete xClickParams['submit'];
	            return $ReturnToMerchant.postTo(url, xClickParams);
	        }
	
	        return doFallback();
	    };
	});
	
	_constants.BUYNOW_WA_TYPE;
	
	_constants.SHOPPINGCART_WA_TYPE;
	
	_customUtil.customUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ },

/***/ "./components/xo-return-to-merchant/dist/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var postRobot = void 0;
	
	if (window.ppxo && window.ppxo.PayPalCheckout.isXComponent()) {
	    postRobot = window.ppxo.postRobot;
	} else {
	    if (window.ppxo && window.ppxo.postRobot) {
	        window.ppxo.postRobot.disable();
	    }
	    postRobot = __webpack_require__("./components/post-robot/dist/post-robot.min.js");
	}
	
	function match(str, pattern) {
	    var regmatch = str.match(pattern);
	    if (regmatch) {
	        return regmatch[1];
	    }
	}
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-return-to-merchant', ['squid', 'xo-device-info']).factory('$ReturnToMerchant', function ($window, $DeviceInfo, $rootScope, $util, $feature, $logger, $state, $timeout, $CheckoutSessionModel) {
	        return {
	            goTo: function goTo(url, forceRedirect) {
	
	                $logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
	                    url: url
	                });
	
	                if (window.xchild && !window.paypalCheckout) {
	                    window.paypalCheckout = window.xchild;
	                }
	
	                if (window.paypalCheckout) {
	                    $logger.done();
	                    $rootScope.$emit('loading');
	
	                    var params = {
	                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
	                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
	                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
	                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
	                    };
	
	                    if (params.payerID || params.billingToken) {
	                        params.returnUrl = url;
	                        return window.paypalCheckout.props.onAuthorize(params);
	                    }
	
	                    if (window.paypalCheckout.props.onPaymentCancel) {
	                        params.cancelUrl = url;
	                        return window.paypalCheckout.props.onCancel(params);
	                    }
	
	                    return window.paypalCheckout.close();
	                }
	
	                var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
	                var showPaymentSuccess = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);
	
	                if (showPaymentSuccess) {
	                    $logger.info('redirect', {
	                        url: url
	                    });
	                    $window.onunload = $window.onbeforeunload = function () {};
	                    $window.location = url;
	                    return $state.go('checkout.genericMessage', {
	                        code: 'PAYMENT_SUCCESS'
	                    });
	                }
	
	                if (forceRedirect) {
	                    $util.redirect(url);
	                }
	
	                var isVZeroIframe = Boolean($rootScope.partnerIntegration) && $util.isIFrame();
	
	                if (isVZeroIframe) {
	                    $util.redirect(url, { redirectImmediateParent: true });
	                }
	
	                // If we are not in minibrowser, do a hard redirect
	                else if ($rootScope.partnerIntegration || !$rootScope.miniBrowser && !$util.isIFrame()) {
	                        $util.redirect(url);
	                    } else {
	
	                        // Construct a message to send to the parent
	                        var result = this.postToMerchant({
	                            operation: 'return_to_merchant',
	                            returnUrl: url,
	                            updateParent: true
	                        });
	
	                        // Otherwise we have no choice but to return to the merchant
	                        if (!result) {
	                            $util.redirect(url);
	                        }
	
	                        postRobot.sendToParent('return', {
	                            url: url
	
	                        }, function (err) {
	
	                            if (err) {
	                                return;
	
	                                /*
	                                    TODO: uncomment this when integration script moves to post-robot
	                                     $logger.error('post_return_error', {
	                                        error: err.stack || err.toString()
	                                    });
	                                  return $util.redirect(url);
	                                */
	                            }
	                        });
	                    }
	
	                var userStatus = function userStatus() {
	                    $logger.info('redirected_user_still_on_page_second_checkpoint');
	                };
	
	                $timeout(function () {
	                    $logger.info('redirected_user_still_on_page_first_checkpoint');
	                    $timeout(userStatus, 10000);
	                }, 10000);
	            },
	
	            postToMerchant: function postToMerchant(msg) {
	
	                try {
	                    msg = angular.toJson(msg, 0);
	
	                    // If we are not in IE, attempt to send a postMessage
	                    if ($window.opener && ($window.navigator.userAgent.match(/edge/i) || $window.opener.postMessage && !$window.navigator.userAgent.match(/msie|trident/i))) {
	                        $window.opener.postMessage(msg, '*');
	                        $logger.info('minibrowser_postmessage');
	                        return true;
	                    }
	                    // Otherwise, attempt to send a message through the iframe bridge
	                    var bridge = $window.opener && $window.opener.frames && $window.opener.frames.length && $window.opener.frames.PayPalBridge;
	
	                    if (bridge && bridge.returnToParent) {
	                        bridge.returnToParent(msg);
	                        $logger.info('minibrowser_bridgemessage');
	                        return true;
	                    }
	
	                    $logger.warn('minibrowser_nopostback');
	                } catch (err) {
	                    $logger.error('minibrowser_postback_error', {
	                        error: err.stack || err.toString()
	                    });
	                }
	
	                return false;
	            },
	
	            postTo: function postTo(url, msg) {
	                var form = document.createElement('form');
	                form.method = 'POST';
	                form.action = url;
	                form.className = 'hide';
	
	                for (var key in msg) {
	                    var input = document.createElement('input');
	                    input.name = key;
	                    input.value = msg[key];
	                    form.appendChild(input);
	                }
	
	                $window.document.body.appendChild(form);
	                form.submit();
	                $logger.info('web_postmessage');
	                return true;
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-return-to-merchant/dist", "components/xo-return-to-merchant/dist/util.js"))

/***/ },

/***/ "./components/post-robot/dist/post-robot.min.js":
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("postRobot",[],t):"object"==typeof exports?exports.postRobot=t():e.postRobot=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){function r(){(0,a.registerGlobals)(),u.util.debug("ID",(0,i.getWindowID)()),u.util.listen(window,"message",s.messageListener),u.childWindows.register((0,i.getWindowID)(),window,u.util.getType()),(0,u.propagate)((0,i.getWindowID)())}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(3),u=n(13),s=n(11),a=n(15);r(),t["default"]=e.exports},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.util=t.openBridge=t.reset=t.parent=void 0;var r=n(2);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(23);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(24);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})});var u=n(25);Object.keys(u).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}})});var s=n(11);Object.defineProperty(t,"reset",{enumerable:!0,get:function(){return s.resetListeners}});var a=n(16);Object.defineProperty(t,"openBridge",{enumerable:!0,get:function(){return a.openBridge}});var c=n(7);Object.defineProperty(t,"util",{enumerable:!0,get:function(){return c.util}});t.parent=c.util.getParent()},function(e,t,n){function r(e){return a.promise.nodeify(new a.promise.Promise(function(t,n){if(!e.name)throw new Error("Expected options.name");if(!e.window)throw new Error("Expected options.window");if(u.CONFIG.MOCK_MODE)e.window=window;else if("string"==typeof e.window){var r=document.getElementById(e.window);if(!r)throw new Error("Expected options.window "+e.window+" to be a valid element id");if("iframe"!==r.tagName.toLowerCase())throw new Error("Expected options.window "+e.window+" to be an iframe");if(e.window=r.contentWindow,!e.window)throw new Error("Expected options.window")}var o=e.name+"_"+a.util.uniqueID();if(s.listeners.response[o]=e,e.window.closed)throw new Error("Target window is closed");e.timeout&&setTimeout(function(){return n(new Error("Post message response timed out after "+e.timeout+" ms"))},e.timeout),e.respond=function(e,r){return e?n(e):t(r)},(0,s.sendMessage)(e.window,{hash:o,type:u.CONSTANTS.POST_MESSAGE_TYPE.REQUEST,name:e.name,data:e.data||{}})["catch"](n),setTimeout(function(){return e.ack?void 0:n(new Error("No ack for postMessage "+e.name))},u.CONFIG.ACK_TIMEOUT)}),e.callback)}function o(e,t,n,o){return!o&&n instanceof Function&&(o=n,n={}),r({window:e,name:t,data:n,callback:o})}function i(e,t,n){if(!a.util.getParent())throw new Error("Window does not have a parent");return o(a.util.getParent(),e,t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.request=r,t.send=o,t.sendToParent=i;var u=n(3),s=n(11),a=n(13)},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(4);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(5);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(6);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t){Object.defineProperty(t,"__esModule",{value:!0});t.CONFIG={ALLOW_POSTMESSAGE_POPUP:!0,DEBUG:!1,ACK_TIMEOUT:3e3,LOG_TO_PAGE:!1,MOCK_MODE:!1}},function(e,t){Object.defineProperty(t,"__esModule",{value:!0});t.CONSTANTS={POST_MESSAGE_TYPE:{REQUEST:"postrobot_message_request",RESPONSE:"postrobot_message_response",ACK:"postrobot_message_ack"},POST_MESSAGE_ACK:{SUCCESS:"success",ERROR:"error"},POST_MESSAGE_NAMES:{IDENTIFY:"identify"},WINDOW_TYPES:{FULLPAGE:"fullpage",POPUP:"popup",IFRAME:"iframe"},WINDOW_PROPS:{POSTROBOT:"__postRobot__"}}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.getWindowID=void 0;var r=n(7);t.getWindowID=r.util.memoize(function(){return window.name||r.util.uniqueID()})},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.util=void 0;var r=n(3),o=n(8),i=t.util={isPopup:function(){return Boolean(window.opener)},isIframe:function(){return Boolean(window.parent&&window!==window.parent)},isFullpage:function(){return Boolean(!i.isIframe()&&!i.isPopup())},windowReady:new o.promise.Promise(function(e,t){return"complete"===document.readyState?e():void window.addEventListener("load",e)}),getType:function(){return i.isPopup()?r.CONSTANTS.WINDOW_TYPES.POPUP:i.isIframe()?r.CONSTANTS.WINDOW_TYPES.IFRAME:r.CONSTANTS.WINDOW_TYPES.FULLPAGE},once:function(e){if(!e)return e;var t=!1;return function(){return t?void 0:(t=!0,e.apply(this,arguments))}},getParent:function(){return i.isPopup()?window.opener:i.isIframe()?window.parent:void 0},eachParent:function(e,t){var n=window;for(t&&e(window);;){var r=n.opener||n.parent;if(n===r)return;n=r,e(n)}},eachFrame:function(e,t){for(var n=0;n<e.frames.length;n++){var r=void 0;try{r=e.frames[n]}catch(o){continue}t(r)}},noop:function(){},getDomain:function(){return window.location.host},clearLogs:function(){if(window.console&&window.console.clear&&window.console.clear(),r.CONFIG.LOG_TO_PAGE){var e=document.getElementById("postRobotLogs");e&&e.parentNode.removeChild(e)}},writeToPage:function(e,t){setTimeout(function(){var n=document.getElementById("postRobotLogs");n||(n=document.createElement("div"),n.id="postRobotLogs",n.style.cssText="width: 800px; font-family: monospace; white-space: pre-wrap;",document.body.appendChild(n));var r=document.createElement("div"),o=(new Date).toString().split(" ")[4],u=i.map(t,function(e){if("string"==typeof e)return e;if(!e)return toString.call(e);var t=void 0;try{t=JSON.stringify(e,0,2)}catch(n){t="[object]"}return"\n\n"+t+"\n\n"}).join(" "),s=o+" "+e+" "+u;r.innerHTML=s;var a={log:"#ddd",warn:"orange",error:"red",info:"blue",debug:"#aaa"}[e];r.style.cssText="margin-top: 10px; color: "+a+";",n.childNodes.length?n.insertBefore(r,n.childNodes[0]):n.appendChild(r)})},logLevel:function(e,t){t=Array.prototype.slice.call(t),t.unshift(i.getDomain()),t.unshift(i.getType().toLowerCase()),t.unshift("[post-robot]"),r.CONFIG.LOG_TO_PAGE&&i.writeToPage(e,t),window.console&&(window.console[e]||(e="log"),window.console[e]&&window.console[e].apply(window.console,t))},log:function(){i.logLevel("info",arguments)},debug:function(){r.CONFIG.DEBUG&&i.logLevel("debug",arguments)},debugError:function(){r.CONFIG.DEBUG&&i.logLevel("error",arguments)},safeHasProp:function(e,t){try{return!!e[t]}catch(n){return!1}},warn:function(){i.logLevel("warn",arguments)},error:function(){i.logLevel("error",arguments)},listen:function(e,t,n){return e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,n),{cancel:function(){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)}}},apply:function(e,t,n){return e.apply instanceof Function?e.apply(t,n):e(n[0],n[1],n[2],n[3],n[4],n[5],n[6],n[7],n[8],n[9])},find:function(e,t,n){if(!e)return n;for(var r=0;r<e.length;r++)if(t(e[r]))return e[r];return n},map:function(e,t){for(var n=[],r=0;r<e.length;r++)n.push(t(e[r]));return n},some:function(e,t){t=t||Boolean;for(var n=0;n<e.length;n++)if(t(e[n]))return!0;return!1},keys:function(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t},values:function(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(e[n]);return t},getByValue:function(e,t){for(var n in e)if(e.hasOwnProperty(n)&&e[n]===t)return n},uniqueID:function(){var e="0123456789abcdef";return"xxxxxxxxxx".replace(/./g,function(){return e.charAt(Math.floor(Math.random()*e.length))})},isFrameOwnedBy:function(e,t){try{return t.parent===e}catch(n){try{for(var r=0;r<e.frames.length;r++)if(e.frames[r]===t)return!0}catch(o){return!1}}return!1},memoize:function(e){var t={};return function(){var n=JSON.stringify(Array.prototype.slice.call(arguments));return t.hasOwnProperty(n)||(t[n]=e.apply(this,arguments)),t[n]}}}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.promise=void 0;var r=n(9),o=t.promise={get Promise(){return window.Promise?window.Promise:r.Promise},asyncPromise:function(e){return new o.Promise(function(t,n){setTimeout(function(){try{return e(t,n)}catch(r){return n(r)}})})},run:function(e){return o.Promise.resolve().then(e)},method:function(e){return function(){var t=this,n=arguments;return o.Promise.resolve().then(function(){return e.apply(t,n)})}},nodeify:function(e,t){return t?void e.then(function(e){t(null,e)},function(e){t(e)}):e}}},function(e,t,n){var r;(function(o,i){/*!
		 * @overview es6-promise - a tiny implementation of Promises/A+.
		 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
		 * @license   Licensed under MIT license
		 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
		 * @version   2.0.1
		 */
	(function(){function u(e,t){W[C]=e,W[C+1]=t,C+=2,2===C&&A()}function s(e){return"function"==typeof e}function a(){return function(){o.nextTick(l)}}function c(){var e=0,t=new j(l),n=document.createTextNode("");return t.observe(n,{characterData:!0}),function(){n.data=e=++e%2}}function f(){var e=new MessageChannel;return e.port1.onmessage=l,function(){e.port2.postMessage(0)}}function d(){return function(){setTimeout(l,1)}}function l(){for(var e=0;C>e;e+=2)(0,W[e])(W[e+1]),W[e]=void 0,W[e+1]=void 0;C=0}function p(){}function w(e,t,n,r){try{e.call(t,n,r)}catch(o){return o}}function h(e,t,n){u(function(e){var r=!1,o=w(n,t,function(n){r||(r=!0,t!==n?g(e,n):S(e,n))},function(t){r||(r=!0,v(e,t))});!r&&o&&(r=!0,v(e,o))},e)}function O(e,t){1===t.a?S(e,t.b):2===e.a?v(e,t.b):m(t,void 0,function(t){g(e,t)},function(t){v(e,t)})}function g(e,t){if(e===t)v(e,new TypeError("You cannot resolve a promise with itself"));else if("function"==typeof t||"object"==typeof t&&null!==t)if(t.constructor===e.constructor)O(e,t);else{var n;try{n=t.then}catch(r){R.error=r,n=R}n===R?v(e,R.error):void 0===n?S(e,t):s(n)?h(e,t,n):S(e,t)}else S(e,t)}function E(e){e.f&&e.f(e.b),y(e)}function S(e,t){void 0===e.a&&(e.b=t,e.a=1,0!==e.e.length&&u(y,e))}function v(e,t){void 0===e.a&&(e.a=2,e.b=t,u(E,e))}function m(e,t,n,r){var o=e.e,i=o.length;e.f=null,o[i]=t,o[i+1]=n,o[i+2]=r,0===i&&e.a&&u(y,e)}function y(e){var t=e.e,n=e.a;if(0!==t.length){for(var r,o,i=e.b,u=0;u<t.length;u+=3)r=t[u],o=t[u+n],r?P(n,r,o,i):o(i);e.e.length=0}}function T(){this.error=null}function P(e,t,n,r){var o,i,u,a,c=s(n);if(c){try{o=n(r)}catch(f){G.error=f,o=G}if(o===G?(a=!0,i=o.error,o=null):u=!0,t===o)return void v(t,new TypeError("A promises callback cannot return that same promise."))}else o=r,u=!0;void 0===t.a&&(c&&u?g(t,o):a?v(t,i):1===e?S(t,o):2===e&&v(t,o))}function b(e,t){try{t(function(t){g(e,t)},function(t){v(e,t)})}catch(n){v(e,n)}}function _(e,t,n,r){this.n=e,this.c=new e(p,r),this.i=n,this.o(t)?(this.m=t,this.d=this.length=t.length,this.l(),0===this.length?S(this.c,this.b):(this.length=this.length||0,this.k(),0===this.d&&S(this.c,this.b))):v(this.c,this.p())}function N(e){if(D++,this.b=this.a=void 0,this.e=[],p!==e){if(!s(e))throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");if(!(this instanceof N))throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");b(this,e)}}var A,M=Array.isArray?Array.isArray:function(e){return"[object Array]"===Object.prototype.toString.call(e)},C=0,I="undefined"!=typeof window?window:{},j=I.MutationObserver||I.WebKitMutationObserver,I="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,W=Array(1e3);A="undefined"!=typeof o&&"[object process]"==={}.toString.call(o)?a():j?c():I?f():d();var R=new T,G=new T;_.prototype.o=function(e){return M(e)},_.prototype.p=function(){return Error("Array Methods must be provided an Array")},_.prototype.l=function(){this.b=Array(this.length)},_.prototype.k=function(){for(var e=this.length,t=this.c,n=this.m,r=0;void 0===t.a&&e>r;r++)this.j(n[r],r)},_.prototype.j=function(e,t){var n=this.n;"object"==typeof e&&null!==e?e.constructor===n&&void 0!==e.a?(e.f=null,this.g(e.a,t,e.b)):this.q(n.resolve(e),t):(this.d--,this.b[t]=this.h(e))},_.prototype.g=function(e,t,n){var r=this.c;void 0===r.a&&(this.d--,this.i&&2===e?v(r,n):this.b[t]=this.h(n)),0===this.d&&S(r,this.b)},_.prototype.h=function(e){return e},_.prototype.q=function(e,t){var n=this;m(e,void 0,function(e){n.g(1,t,e)},function(e){n.g(2,t,e)})};var D=0;N.all=function(e,t){return new _(this,e,!0,t).c},N.race=function(e,t){function n(e){g(o,e)}function r(e){v(o,e)}var o=new this(p,t);if(!M(e))return v(o,new TypeError("You must pass an array to race.")),o;for(var i=e.length,u=0;void 0===o.a&&i>u;u++)m(this.resolve(e[u]),void 0,n,r);return o},N.resolve=function(e,t){if(e&&"object"==typeof e&&e.constructor===this)return e;var n=new this(p,t);return g(n,e),n},N.reject=function(e,t){var n=new this(p,t);return v(n,e),n},N.prototype={constructor:N,then:function(e,t){var n=this.a;if(1===n&&!e||2===n&&!t)return this;var r=new this.constructor(p),o=this.b;if(n){var i=arguments[n-1];u(function(){P(n,r,i,o)})}else m(this,r,e,t);return r},"catch":function(e){return this.then(null,e)}};var x={Promise:N,polyfill:function(){var e;e="undefined"!=typeof i?i:"undefined"!=typeof window&&window.document?window:self,"Promise"in e&&"resolve"in e.Promise&&"reject"in e.Promise&&"all"in e.Promise&&"race"in e.Promise&&function(){var t;return new e.Promise(function(e){t=e}),s(t)}()||(e.Promise=N)}};r=function(){return x}.call(t,n,t,e),!(void 0!==r&&(e.exports=r))}).call(this)}).call(t,n(10),function(){return this}())},function(e,t){function n(){c=!1,u.length?a=u.concat(a):f=-1,a.length&&r()}function r(){if(!c){var e=setTimeout(n);c=!0;for(var t=a.length;t;){for(u=a,a=[];++f<t;)u&&u[f].run();f=-1,t=a.length}u=null,c=!1,clearTimeout(e)}}function o(e,t){this.fun=e,this.array=t}function i(){}var u,s=e.exports={},a=[],c=!1,f=-1;s.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];a.push(new o(e,t)),1!==a.length||c||setTimeout(r,0)},o.prototype.run=function(){this.fun.apply(null,this.array)},s.title="browser",s.browser=!0,s.env={},s.argv=[],s.version="",s.versions={},s.on=i,s.addListener=i,s.once=i,s.off=i,s.removeListener=i,s.removeAllListeners=i,s.emit=i,s.binding=function(e){throw new Error("process.binding is not supported")},s.cwd=function(){return"/"},s.chdir=function(e){throw new Error("process.chdir is not supported")},s.umask=function(){return 0}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(12);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(19);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(21);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t,n){function r(e){try{e=JSON.parse(e)}catch(t){return}if(e.type&&l.RECEIVE_MESSAGE_TYPES[e.type])return e}function o(e,t){if(!s.CONFIG.MOCK_MODE&&t&&(t.type!==s.CONSTANTS.POST_MESSAGE_TYPE.REQUEST||!t.name||!d.listeners.request[t.name]||d.listeners.request[t.name].proxy!==!1)){var n=(t.type===s.CONSTANTS.POST_MESSAGE_TYPE.REQUEST||t.type===s.CONSTANTS.POST_MESSAGE_TYPE.ACK)&&d.listeners.response[t.hash];if(!n)for(var r=0;r<d.listeners.proxies.length;r++){var o=d.listeners.proxies[r];if(e===o.from)return o.to}if("parent.opener"===t.target){var i=void 0;try{i=window.parent.opener}catch(u){throw new Error("Can not get window.parent.opener to proxy to")}if(!i)throw new Error("Can not get window.parent.opener to proxy to");return i}if(t.target&&t.target!==(0,s.getWindowID)()){var c=a.childWindows.getWindowById(t.target);if(!c)throw new Error("Unable to find window to proxy message to: "+t.target);return c}}}function i(e,t){var n=r(t);if(n&&-1===p.indexOf(n.id)){p.push(n.id),a.childWindows.register(n.source,e,n.windowType);var i=o(e,n);return i?(delete n.target,(0,f.sendMessage)(i,n,!0)):(a.util.log("#receive",n.type,n.name,n),s.CONFIG.MOCK_MODE?l.RECEIVE_MESSAGE_TYPES[n.type](e,n):void l.RECEIVE_MESSAGE_TYPES[n.type](e,n))}}function u(e){var t=e.source||e.sourceElement,n=e.data;(0,c.emulateIERestrictions)(t,window),i(t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.receiveMessage=i,t.messageListener=u;var s=n(3),a=n(13),c=n(15),f=n(19),d=n(21),l=n(22),p=[]},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(8);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(7);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(14);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t,n){function r(e,t){return u.util.find(a,function(n){return n[e]===t},{})}function o(e){function t(t,r){t&&t!==window&&-1===n.indexOf(t)&&(u.util.debug("propagating to",r,t),n.push(t),u.util.safeHasProp(t,i.CONSTANTS.WINDOW_PROPS.POSTROBOT)?t[i.CONSTANTS.WINDOW_PROPS.POSTROBOT].registerSelf(e,window,u.util.getType()):(0,s.send)(t,i.CONSTANTS.POST_MESSAGE_NAMES.IDENTIFY,{id:e,type:u.util.getType()}).then(function(e){c.register(e.id,t,e.type)},function(e){u.util.debugError("Error sending identify:",e.stack||e.toString())}))}(0,s.on)(i.CONSTANTS.POST_MESSAGE_NAMES.IDENTIFY,function(t,n,r){return t?void 0:{id:e}});var n=[];u.util.eachParent(function(e){t(e,"parent"),u.util.eachFrame(e,function(e){t(e,"frame")})},!0)}Object.defineProperty(t,"__esModule",{value:!0}),t.childWindows=void 0,t.propagate=o;var i=n(3),u=n(13),s=n(1),a=[],c=t.childWindows={getWindowId:function(e){return r("win",e).id},getWindowById:function(e){return r("id",e).win},getWindowType:function(e){var t=r("win",e);if(t&&t.type)return t.type;if(u.util.safeHasProp(e,"parent")&&e.parent!==e)return i.CONSTANTS.WINDOW_TYPES.IFRAME;if(u.util.safeHasProp(e,"opener"))return i.CONSTANTS.WINDOW_TYPES.POPUP;var n=u.util.some(a,function(t){return u.util.isFrameOwnedBy(t.win,e)});return n?i.CONSTANTS.WINDOW_TYPES.IFRAME:void 0},register:function(e,t,n){var r=u.util.find(a,function(n){return n.id===e&&n.win===t});r||(u.util.debug("Registering window:",n,e,t),a.push({id:e,win:t,type:n}))}},f=window.open;window.open=function(e,t,n,r){t||(t=u.util.uniqueID(),arguments[1]=t);var o=u.util.apply(f,this,arguments);return c.register(t,o,i.CONSTANTS.WINDOW_TYPES.POPUP),o}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(16);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(17);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(18);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t,n){function r(){return s}function o(e){try{if(!e||!e.frames||!e.frames.length)return;for(var t=0;t<e.frames.length;t++)try{var n=e.frames[t];if(n&&n[i.CONSTANTS.WINDOW_PROPS.POSTROBOT])return n}catch(r){continue}}catch(r){return}}Object.defineProperty(t,"__esModule",{value:!0}),t.openBridge=void 0,t.getBridge=r,t.getBridgeFor=o;var i=n(3),u=n(13),s=void 0;t.openBridge=u.util.memoize(function(e){if(s)throw new Error("Only one bridge supported");return s=new u.promise.Promise(function(t,n){u.util.debug("Opening bridge:",e);var r=document.createElement("iframe");r.setAttribute("id","postRobotBridge"),r.setAttribute("style","margin: 0; padding: 0; border: 0px none; overflow: hidden;"),r.setAttribute("frameborder","0"),r.setAttribute("border","0"),r.setAttribute("scrolling","no"),r.setAttribute("allowTransparency","true"),r.setAttribute("tabindex","-1"),r.setAttribute("hidden","true"),r.setAttribute("title",""),r.setAttribute("role","presentation"),r.onload=function(){return t(r)},r.onerror=n,r.src=e,document.body.appendChild(r)})})},function(e,t,n){function r(){if(window[o.CONSTANTS.WINDOW_PROPS.POSTROBOT])throw new Error("Attempting to load postRobot twice on the same window");window[o.CONSTANTS.WINDOW_PROPS.POSTROBOT]={registerSelf:function(e,t,n){i.childWindows.register(e,t,n)},postMessage:i.promise.method(function(e,t){(0,u.receiveMessage)(e,t)}),postMessageParent:i.promise.method(function(e,t){window.parent.postMessage(t,"*")})}}Object.defineProperty(t,"__esModule",{value:!0}),t.registerGlobals=r;var o=n(3),i=n(13),u=n(11)},function(e,t,n){function r(e,t){if(!o.CONFIG.ALLOW_POSTMESSAGE_POPUP){var n=i.childWindows.getWindowType(e)===o.CONSTANTS.WINDOW_TYPES.IFRAME&&i.util.isFrameOwnedBy(t,e),r=i.childWindows.getWindowType(t)===o.CONSTANTS.WINDOW_TYPES.IFRAME&&i.util.isFrameOwnedBy(e,t);if(!n&&!r)throw e===window?new Error("Can not send post messages to another window (disabled by config to emulate IE)"):new Error("Can not receive post messages sent from another window (disabled by config to emulate IE)")}}Object.defineProperty(t,"__esModule",{value:!0}),t.emulateIERestrictions=r;var o=n(3),i=n(13)},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.sendMessage=void 0;var r=n(3),o=n(13),i=n(20);t.sendMessage=o.promise.method(function(e,t,n){if(t.id=t.id||o.util.uniqueID(),t.source=(0,r.getWindowID)(),t.originalSource=t.originalSource||(0,r.getWindowID)(),t.windowType=o.util.getType(),t.originalWindowType=t.originalWindowType||o.util.getType(),t.target||(t.target=o.childWindows.getWindowId(e)),o.util.log(n?"#proxy":"#send",t.type,t.name,t),r.CONFIG.MOCK_MODE)return delete t.target,window[r.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessage(window,JSON.stringify(t));if(e===window)throw new Error("Attemping to send message to self");return o.util.debug("Waiting for window to be ready"),o.util.windowReady.then(function(){return o.util.debug("Running send message strategies",t),o.promise.Promise.all(o.util.map(o.util.keys(i.SEND_MESSAGE_STRATEGIES),function(n){return i.SEND_MESSAGE_STRATEGIES[n](e,t).then(function(){return o.util.debug(n,"success"),!0},function(e){return o.util.debugError(n,"error\n\n",e.stack||e.toString()),!1})})).then(function(e){if(!o.util.some(e))throw new Error("No post-message strategy succeeded")})})})},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.SEND_MESSAGE_STRATEGIES=void 0;var r=n(3),o=n(13),i=n(15);t.SEND_MESSAGE_STRATEGIES={POST_MESSAGE:o.promise.method(function(e,t){return(0,i.emulateIERestrictions)(window,e),e.postMessage(JSON.stringify(t,0,2),"*")}),POST_MESSAGE_GLOBAL_METHOD:o.promise.method(function(e,t){if(!o.util.safeHasProp(e,r.CONSTANTS.WINDOW_PROPS.POSTROBOT))throw new Error("postRobot not found on window");return e[r.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessage(window,JSON.stringify(t,0,2))}),POST_MESSAGE_UP_THROUGH_BRIDGE:o.promise.method(function(e,t){var n=(0,i.getBridgeFor)(e);if(!n)throw new Error("No bridge available in window");if(!o.util.safeHasProp(n,r.CONSTANTS.WINDOW_PROPS.POSTROBOT))throw new Error("postRobot not installed in bridge");return n[r.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessageParent(window,JSON.stringify(t,0,2))}),POST_MESSAGE_DOWN_THROUGH_BRIDGE:o.promise.method(function(e,t){var n=(0,i.getBridge)();if(!n)throw new Error("Bridge not initialized");if(e===n.contentWindow)throw new Error("Message target is bridge");if(!t.target){if(e!==window.opener)throw new Error("Can not post message down through bridge without target");t.target="parent.opener"}return n.then(function(e){e.contentWindow.postMessage(JSON.stringify(t,0,2),"*")})})}},function(e,t){function n(){t.listeners=r={request:{},response:{},proxies:[]}}Object.defineProperty(t,"__esModule",{value:!0}),t.resetListeners=n;var r=t.listeners=void 0;n()},function(e,t,n){function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0}),t.RECEIVE_MESSAGE_TYPES=void 0;var o,i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(3),s=n(13),a=n(19),c=n(21);t.RECEIVE_MESSAGE_TYPES=(o={},r(o,u.CONSTANTS.POST_MESSAGE_TYPE.ACK,function(e,t){var n=c.listeners.response[t.hash];if(!n)throw new Error("No handler found for post message ack for message: "+t.name+" in "+window.location.href);n.ack=!0}),r(o,u.CONSTANTS.POST_MESSAGE_TYPE.REQUEST,function(e,t){function n(n){return(0,a.sendMessage)(e,i({target:t.originalSource?t.originalSource:s.childWindows.getWindowId(e),hash:t.hash,name:t.name},n))["catch"](function(e){if(r)return r.handleError(e);throw e})}var r=c.listeners.request[t.name],o=s.util.once(function(e){return n({type:u.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,ack:u.CONSTANTS.POST_MESSAGE_ACK.SUCCESS,response:e||{}})}),f=s.util.once(function(e){return n({type:u.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,ack:u.CONSTANTS.POST_MESSAGE_ACK.ERROR,error:e.stack||e.toString()})});if(!r)return f(new Error("No postmessage request handler for "+t.name+" in "+window.location.href));if(!r.window||!e||r.window===e){n({type:u.CONSTANTS.POST_MESSAGE_TYPE.ACK});var d=void 0;try{d=r.handler(null,t.data,function(e,t){return e?f(e):o(t)})}catch(l){return f(l)}return d&&d.then instanceof Function?d.then(o,f):r.handler.length<=2?o(d):void 0}}),r(o,u.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,function(e,t){var n=c.listeners.response[t.hash];if(!n)throw new Error("No response handler found for post message response "+t.name+" in "+window.location.href);return delete c.listeners.response[t.hash],t.ack===u.CONSTANTS.POST_MESSAGE_ACK.ERROR?n.respond(t.error):t.ack===u.CONSTANTS.POST_MESSAGE_ACK.SUCCESS?n.respond(null,t.response):void 0}),o)},function(e,t,n){function r(e){if(!e.name)throw new Error("Expected options.name");if(a.listeners.request[e.name]&&!e.override&&!u.CONFIG.MOCK_MODE)throw new Error("Post message response handler already registered: "+e.name);if(!e.handler)throw new Error("Expected options.handler");return e.errorHandler=e.errorHandler||s.util.noop,e.once&&(e.handler=s.util.once(e.handler)),a.listeners.request[e.name]=e,e.handleError=function(t){delete a.listeners.request[e.name],e.errorHandler(t)},e.window&&e.errorOnClose&&!function(){var t=setInterval(function(){e.window.closed&&(clearInterval(t),e.handleError(new Error("Post message target window is closed")))},50)}(),{cancel:function(){delete a.listeners.request[e.name]}}}function o(e,t,n,o){return t instanceof Function&&(o=n,n=t,t={}),t.name=e,t.handler=n||t.handler,t.errorHandler=o||t.errorHandler,r(t)}function i(e,t,n,o){return t instanceof Function&&(o=n,n=t,t={}),t.name=e,t.handler=n||t.handler,t.errorHandler=o||t.errorHandler,t.once=!0,r(t)}Object.defineProperty(t,"__esModule",{value:!0}),t.listen=r,t.on=o,t.once=i;var u=n(3),s=n(13),a=n(11)},function(e,t,n){function r(e,t){i.listeners.proxies.push({from:e,to:t}),i.listeners.proxies.push({from:t,to:e})}function o(e,t){for(var n=[],r=0;r<i.listeners.proxies.length;r++){var o=i.listeners.proxies[r];(o.to===e&&o.from===t||o.to===t&&o.from===e)&&n.push(o)}for(var u=0;u<n.length;u++)i.listeners.proxies.splice(i.listeners.proxies.indexOf(n[u]),1)}Object.defineProperty(t,"__esModule",{value:!0}),t.proxy=r,t.unproxy=o;var i=n(11)},function(e,t,n){function r(){i.CONFIG.MOCK_MODE=!0}function o(){i.CONFIG.MOCK_MODE=!1}Object.defineProperty(t,"__esModule",{value:!0}),t.enableMockMode=r,t.disableMockMode=o;var i=n(3)}])});


/***/ },

/***/ "./components/xo-device-info/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-device-info', ['squid']).factory('$DeviceInfo', function ($window, $meta, $logger) {
	        var userAgent = $window.navigator.userAgent;
	        var standalone = $window.navigator.standalone;
	        var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
	        var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
	
	        // Supports iOS and Android. Updated / more accurate method of detecting webviews
	        function isWebView() {
	            var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
	
	            var ios = /iphone|ipod|ipad/i.test(ua),
	                android = /Android/i.test(ua);
	
	            if (ios) {
	                // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
	                // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
	                var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
	
	                if (!standalone && ios_uiwebview && !isSafariViewController()) {
	                    // uiwebview
	                    logWebView('iOS');
	                    return true;
	                }
	            } else if (android) {
	                // not iOS, Android platform handling
	                // Whitelist for x-requested-with header values for web view detection
	                var allowedXRequestedWithRegexMap = {
	                    ajax: /XMLHttpRequest/i,
	                    baiduBrowser: /com.baidu.browser.inter/i,
	                    operaMini: /com.opera.mini.native/i,
	                    maxthon: /com.mx.browser/i,
	                    litterPenguinBrowser: /com.explore.web.browser/i
	                };
	                var xRequestedWithHeaderVal = $meta.requestHeaders['x-requested-with'];
	
	                if (xRequestedWithHeaderVal) {
	                    // check if x-requested-with header val is in whitelist
	                    for (var key in allowedXRequestedWithRegexMap) {
	                        if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
	                            if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
	                                return false;
	                            }
	                        }
	                    }
	                    logWebView('Android');
	                    return true;
	                }
	            }
	
	            return false;
	
	            function logWebView(device) {
	                if (!logEnabled) {
	                    return;
	                }
	                // cal log
	                $logger.info('WebView :: ' + device);
	            }
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a device.
	         */
	        function isDevice() {
	            if (angular.isString(userAgent)) {
	                return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a tablet.
	         */
	        function isTablet() {
	            if (angular.isString(userAgent)) {
	                return TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a mobile
	         */
	        function isMobile() {
	            return isDevice(userAgent) && !isTablet(userAgent);
	        }
	
	        /**
	         * Get the mobile platform value given the user-agent string.
	         */
	        function getDevicePlatform() {
	            if (angular.isString(userAgent)) {
	                var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);
	
	                if (matched && matched.length > 0) {
	                    return matched[0];
	                }
	            }
	        }
	
	        /**
	         * Check if the give user agent is from an app.
	         */
	        function isApp(uaString) {
	            userAgent = uaString || userAgent;
	
	            if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
	                if (getDevicePlatform(userAgent) === 'Android') {
	                    return (/Version\/\d.\d/i.test(userAgent)
	                    );
	                }
	
	                return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
	                );
	            }
	
	            return false;
	        }
	
	        function isSafariViewController() {
	            if (angular.isString(userAgent)) {
	                var ios = /iphone|ipod|ipad/i.test(userAgent);
	                return ios && $window.indexedDB && isApp();
	            } else {
	                return false;
	            }
	        }
	
	        /**
	         * Get the device capabilities
	         */
	        function getCapabilities() {
	            var capabilities = {},
	                device = DEVICE_PATTERN.test(userAgent),
	                tablet = TABLET_PATTERN.test(userAgent),
	                app = isApp(userAgent);
	
	            if (angular.isString(userAgent)) {
	                capabilities.isWireless = device || tablet;
	                capabilities.isTablet = tablet;
	                capabilities.isMobile = device && !tablet;
	                capabilities.isDesktop = !device;
	                capabilities.isApp = app;
	            }
	
	            return capabilities;
	        }
	
	        /**
	         * Get various AppIntegrationType
	         */
	        function getAppIntegrationType() {
	            var app_int_type;
	            if (isDevice()) {
	                if (isApp()) {
	                    if (isSafariViewController()) {
	                        app_int_type = 'SFVC';
	                    } else {
	                        app_int_type = 'WebView';
	                    }
	                } else {
	                    app_int_type = 'Browser';
	                }
	            }
	            return app_int_type;
	        }
	
	        return {
	            isDevice: isDevice,
	            isTablet: isTablet,
	            isMobile: isMobile,
	            isApp: isApp,
	            isSafariViewController: isSafariViewController,
	            getCapabilities: getCapabilities,
	            getAppIntegrationType: getAppIntegrationType,
	            isWebView: isWebView
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-device-info/dist", "components/xo-device-info/dist/index.js"))

/***/ },

/***/ "./components/xo-models/src/checkout/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CheckoutSessionModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/cart',
	        cache: true
	    }),
	
	    isPurchase: function isPurchase() {
	        return Boolean(this.purchase);
	    },
	
	    isBilling: function isBilling() {
	        return Boolean(this.billing);
	    },
	
	    isBillingPurchase: function isBillingPurchase() {
	        return this.isPurchase() && this.isBilling();
	    },
	
	    isBillingNoPurchase: function isBillingNoPurchase() {
	        return this.isBilling() && !this.isPurchase();
	    },
	
	    getBillingDescription: function getBillingDescription() {
	        return this.billing && this.billing.description;
	    },
	
	    isMultiSellerPurchase: function isMultiSellerPurchase() {
	        return this.purchaseUnits && this.purchaseUnits.length > 1;
	    },
	
	    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
	        return this.purchase && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
	    },
	
	    isWalletTokenization: function isWalletTokenization() {
	        return this.billing && this.billing.intent === 'TOKENIZED_WALLET';
	    }
	});
	
	var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/appData'
	    }),
	
	    useraction: function useraction() {
	        // user_action from session takes precedence over CGI param.
	        var user_action = this.flags && this.flags.user_action === 'PAY' ? 'commit' : undefined;
	
	        return user_action || _squid.$util.param('useraction');
	    },
	
	    doec_on_approve: function doec_on_approve() {
	        return this.flags && this.flags.doec_on_approve;
	    }
	});
	
	var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {
	
	    formatLast4: function formatLast4() {
	        var last4;
	
	        if (this.last4) {
	            last4 = this.last4;
	
	            if (!this.parent.isAuthRequired) {
	                last4 = 'x-' + last4;
	            }
	        }
	
	        return last4;
	    }
	});
	
	var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/fundingOptions',
	        postAttempts: 2
	    }),
	
	    hasECheck: function hasECheck() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'ECHECK' || instrument.subtype === 'ECHECK';
	        });
	    },
	
	    hasCredit: function hasCredit() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'CREDIT';
	        });
	    }
	});
	
	var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/installmentOptions/',
	        postAttempts: 2
	    })
	});
	
	var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/flowEligibility'
	    })
	});
	
	var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:parent.id/shipping/:id'
	    })
	});
	
	var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping/add'
	    }),
	
	    serialize: function serialize() {
	        return {
	            first_name: this.first_name,
	            last_name: this.last_name,
	            recipient_name: this.recipient_name,
	            line1: this.line1,
	            line2: this.line2,
	            city: this.city,
	            state: this.state,
	            postal_code: this.postal_code,
	            country: this.country
	        };
	    }
	});
	
	var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/payee'
	    }),
	
	    getId: function getId() {
	        return this.merchant && this.merchant.id;
	    },
	
	    isGambling: function isGambling() {
	        return this.merchant && this.merchant.isGambling;
	    }
	});
	
	var $CreditOptionsModel = exports.$CreditOptionsModel = {
	    sacEligibleAmount: {
	        US: 99,
	        GB: 150
	    }
	};
	
	var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping'
	    }),
	
	    onPopulate: function onPopulate() {
	        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
	    },
	
	    getPreferredShippingAddress: function getPreferredShippingAddress() {
	        var preferredAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.preferred_address) {
	                    preferredAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return preferredAddress;
	    },
	
	    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
	        var primaryAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.primary_address) {
	                    primaryAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return primaryAddress;
	    }
	});
	
	var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {
	
	    onPopulate: function onPopulate() {
	        this.sources = this.children($FundingSourceModel, this.sources);
	    },
	
	    eachSource: function eachSource(method, context) {
	        angular.forEach(this.sources, method, this);
	    },
	
	    hasFundingMethodType: function hasFundingMethodType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.sub_type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    isPAD: function isPAD() {
	        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
	    },
	
	    isMSB: function isMSB() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
	    },
	
	    isBalance: function isBalance() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
	    }
	});
	
	var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/session',
	        postAttempts: 2
	    }),
	
	    onPopulate: function onPopulate() {
	        this.plan = new $CheckoutPlanModel(this.plan);
	        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
	        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);
	    },
	
	    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
	
	        if (this.selectedFuturePaymentInstrument) {
	            return this.selectedFuturePaymentInstrument;
	        }
	
	        if (!this.futurePaymentInstruments) {
	            return;
	        }
	
	        if (!(this.plan && this.plan.sources) && this.futurePaymentInstruments) {
	            return this.futurePaymentInstruments[0];
	        }
	
	        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
	            return fi.instrument_id ? fi.instrument_id : undefined;
	        });
	
	        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
	            return fi.instrument_id === selectedInstrumentId;
	        });
	
	        return stickyInstrument;
	    },
	
	    getPlanList: function getPlanList() {
	        return this.fundingOptions && this.fundingOptions.plans;
	    },
	
	    getDisallowedInstruments: function getDisallowedInstruments() {
	        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
	    },
	
	    getDisallowedPreferred: function getDisallowedPreferred() {
	        var disallowedInstrument = this.getDisallowedInstruments();
	
	        // find only the disallowed instrument that has been marked as preferred.
	        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
	            return fi.isPreferred;
	        });
	
	        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
	        // we do not show it in the disallowed section.
	        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
	            var instrumentID = plan.primaryFs && plan.primaryFs.id;
	            if (instrumentID && disallowedInstrument.id) {
	                return instrumentID === disallowedInstrument.id;
	            } else {
	                return false;
	            }
	        });
	
	        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
	    },
	
	    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
	        return {
	            'line1': this.shipping.line1,
	            'line2': this.shipping.line2,
	            'city': this.shipping.city,
	            'state': this.shipping.state,
	            'postal_code': this.shipping.postal_code,
	            'country_code': this.shipping.country
	        };
	    }
	});
	
	angular.value("$CheckoutCartModel", $CheckoutCartModel);
	angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
	angular.value("$FundingSourceModel", $FundingSourceModel);
	angular.value("$FundingOptionsModel", $FundingOptionsModel);
	angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
	angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
	angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
	angular.value("$ShippingAddressModel", $ShippingAddressModel);
	angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
	angular.value("$CreditOptionsModel", $CreditOptionsModel);
	angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
	angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
	angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
	_squid.$Model;
	
	_squid.$Api;
	
	_squid.$util;

/***/ },

/***/ "./js/lib/constants.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var BUYNOW_WA_TYPE = exports.BUYNOW_WA_TYPE = 'BuyNow';
	var SHOPPINGCART_WA_TYPE = exports.SHOPPINGCART_WA_TYPE = 'ShoppingCart';
	var EN_DEFAULTS = exports.EN_DEFAULTS = {
	    'CH': 'en_US',
	    'ID': 'en_US',
	    'JP': 'en_US',
	    'PT': 'en_US',
	    'TH': 'en_GB'
	};

/***/ },

/***/ "./js/lib/customUtil.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.customUtil = undefined;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var paramCache = {};
	
	function parameters(string) {
	
	    if (typeof string !== 'string') {
	        string = _index.$util.queryString().slice(1);
	    }
	
	    var params = {};
	
	    if (!string) {
	        return params;
	    }
	
	    if (paramCache[string]) {
	        return paramCache[string];
	    }
	
	    _index.$util.forEach(string.split('&'), function (pair) {
	        pair = pair.split('=');
	
	        if (pair[0] && pair[1]) {
	            try {
	                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	            } catch (err) {
	                _logger.$logger.info('decodeURIComponentError', { key: pair[0], value_mapped: pair[1] });
	                params[decodeURIComponent(pair[0])] = pair[1];
	            }
	        }
	    });
	
	    paramCache[string] = params;
	
	    return params;
	}
	
	var customUtil = exports.customUtil = {
	    /*
	     * decodeAndParse :
	     * 1 - Base64Decode
	     * 2 - URI Decode
	     * 3 - Split string into a nvp object
	     * return obj
	     */
	    decodeAndParse: function decodeAndParse(encodedString) {
	        if (encodedString) {
	            return parameters(decodeURIComponent(_index.$util.base64Decode(encodedString)));
	        }
	    }
	};
	
	_index.$util;
	
	_logger.$logger;

/***/ },

/***/ "./js/lib/metaBuilder.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$metaBuilder = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function buildMeta() {
	    return {
	        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
	        flowlogging_id: _squid.$util.param('flowlogging_id'),
	        calc: _model.$CalDataModel.getCalCorrId(),
	        csci: _model.$CalDataModel.getUUID(),
	        locale: {
	            country: _squid.$locale && _squid.$locale.country,
	            language: _squid.$locale && _squid.$locale.lang
	        },
	        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
	        app_name: 'shoppingcartnodeweb'
	    };
	}
	
	_squid.$Api.registerMetaBuilder(buildMeta);
	
	var $metaBuilder = exports.$metaBuilder = {
	    build: buildMeta
	};
	
	angular.value("$metaBuilder", $metaBuilder);
	_angular.$rootScope;
	
	_model.$CalDataModel;
	
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$Api;
	
	_squid.$locale;
	
	_squid.$config;

/***/ },

/***/ "./components/xo-tracking/dist/model.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js") // Using the same module as used in NodeInfra
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.model', ['squid']).constant('$FptiConstants', {
	        // The prototype of buzname data object
	        buznameMap: {
	            country: {
	                placeHolder: 'glb',
	                fptiKey: 'ccpg'
	            },
	
	            flowgatename: {
	                placeHolder: '',
	                fptiKey: 'fltp'
	            },
	
	            'flowname': {
	                placeHolder: 'ec:hermes:',
	                fptiKey: 'flnm'
	            },
	            'hier1': {
	                placeHolder: 'main_ec_hermes_',
	                fptiKey: 'shir'
	            },
	            /*
	             * No key defined in FPTI
	             */
	            //            'hier2': '',
	            //            'hier3': '',
	            //            'hier4': '',
	            //            'hier5': '',
	            'inout': {
	                placeHolder: 'inout',
	                fptiKey: 'lgin'
	            },
	            'pagename': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'pgrp'
	            },
	            'pagename2': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'page'
	            },
	            'version': {
	                placeHolder: 'hermes',
	                fptiKey: 'vers'
	            }
	            /*
	             * Deprecated SiteCatalyst keys
	             */
	            //            'feature': 'ec',
	            //            'oldpagename': '',
	            //            'product': ';ec',
	            //            'subfeature1': 'hermes',
	            //            'subfeature2': '',
	            //            'website': 'main'
	        },
	
	        // Full list of FPTI keys indexed by readable names
	        // This mapping can also be served as default decorator
	        fptiKeys: {
	            'businessType': 'bztp',
	            'correlationId': 'calc', // CalDataModel
	            'countryOfPage': 'ccpg', // buzname
	            'cust': 'cust',
	            'errorCode': 'eccd',
	            'fieldError': 'erfd',
	            'flowgatename': 'fltp', // buzname
	            'flowname': 'flnm', // buzname
	            'locale': 'rsta', // LocaleModel
	            'loggedIn': 'lgin', // buzname
	            'merchantId': 'mrid',
	            'merchantType': 'mbtp',
	            'pageError': 'erpg',
	            'pageGoal': 'goal', // route
	            'pageGroup': 'pgrp', // buzname
	            'pageName': 'page', // buzname
	            'pageQualifer': 'qual', // buzname
	            'pageStartTime': 'pgst', // FptiBuilder
	            'pageTechnologyFlag': 'pgtf', // productConfig
	            'paymentFlowId': 'pfid',
	            'rLogId': 'teal',
	            'sessionId': 'fpti',
	            'siteHierarchy': 'shir', // buzname
	            'sourceCi': 's', // productConfig
	            'tealeaf': 'teal',
	            'templateName': 'tmpl', // route
	            'transition_time': 'transition_time',
	            'uuid': 'csci', // CalDataModel
	            'version': 'vers', // buzname
	            'visitorId': 'vid',
	            'ecToken': 'fltk', // metadata
	            'pxpExpSelected': 'xe',
	            'pxpTreatementSelected': 'xt',
	            'pxpQualifiedTreatment': 'qt',
	            'pxpContextId': 'qc',
	            'dc': 'dc',
	            'az': 'az'
	        },
	
	        landing_page: {
	            login: 'LOGIN',
	            econsent: 'eConsent',
	            review: 'Review',
	            error_page: 'error_page',
	            add_card: 'add_card',
	            add_bank: 'add_bank',
	            billing: 'billing',
	            done_page: 'done_page',
	            shoppingCart: 'shoppingCart',
	            emptyCart: 'emptyCart',
	            soldout: 'soldout',
	            openButton: 'openButton'
	        },
	
	        stateName: {
	            checkout_login: 'login',
	            checkout_genericError: 'error_page',
	            checkout_fastlogin: 'login',
	            checkout_econsent: 'econsent',
	            checkout_review: 'review',
	            checkout_pageAddCard_addCardFlow_addCard: 'add_card',
	            checkout_updateCard_addCardFlow_addCard: 'add_card',
	            checkout_pageAddFi_bank_add: 'add_bank',
	            guest: 'billing',
	            checkout_done: 'done_page',
	            checkout_guest: 'billing',
	            checkout_signup: 'billing',
	            guestupgrade_genericError: 'error_page',
	            checkout_multistepsignup_multistepsignupaddcard: 'billing',
	            checkout_shoppingCart: 'shoppingCart',
	            checkout_emptyCart: 'emptyCart',
	            checkout_soldout: 'soldout',
	            checkout_openButton: 'openButton'
	        }
	    }).factory('$FptiDataModel', function ($Class, $FptiConstants, $util, $config) {
	        var productConfig = {};
	        // TODO to read from config.json
	        productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
	        productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';
	
	        /**
	         * Utilizing Decorator pattern to allow defining additional logic for specific keys
	         */
	        return $Class.extend('FptiDataModel', {
	            init: function init() {
	                this._dataObj = angular.extend({}, productConfig);
	                this._decoratorList = [];
	            },
	            decorators: {
	                buzname: function buzname(trackingData, pageQualifier, isInContext) {
	
	                    if (!trackingData) {
	                        return;
	                    }
	
	                    var buzname = trackingData.buzname;
	                    if (!buzname) {
	                        return;
	                    }
	
	                    var buznameDiff = buzname[pageQualifier];
	                    if (!buznameDiff) {
	                        return;
	                    }
	
	                    var dataObj = this._dataObj;
	                    var buznameMap = $FptiConstants.buznameMap;
	                    // read app specific place holder from config
	                    var placeHolderConfig = $config && $config.fpti && $config.fpti.buznameEntryPlaceHolder;
	
	                    Object.keys(buznameMap).forEach(function (key) {
	                        var buznameEntry = buznameMap[key];
	                        var fptiKey = buznameEntry.fptiKey;
	                        var placeHolder = buznameEntry.placeHolder;
	
	                        if (buznameDiff[key]) {
	                            if (placeHolderConfig && placeHolderConfig[key]) {
	                                placeHolder = placeHolderConfig[key];
	                            }
	                            dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
	                        } else {
	                            dataObj[fptiKey] = placeHolder;
	                        }
	                    });
	                    dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
	                },
	
	                locale: function locale(_locale) {
	                    if (_locale && _locale.country) {
	                        this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
	                    }
	                },
	
	                pxptrackingdata: function pxptrackingdata(pxpData) {
	                    var qt = [];
	                    var qc = [];
	                    var xe = [];
	                    var xt = [];
	                    $util.some(pxpData, function (trackInfo) {
	                        var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');
	                        if (match) {
	                            qt.push(match[1]);
	                        }
	
	                        match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
	                        if (match) {
	                            qc.push(match[1]);
	                        }
	
	                        $util.some(trackInfo.treatments, function (treatment) {
	                            xe.push(treatment.experiment_id);
	                            xt.push(treatment.treatment_id);
	                        });
	                    });
	
	                    this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
	                },
	
	                templateName: function templateName(trackingData, pageQualifier, isInContext) {
	                    if (trackingData && trackingData.templateName) {
	                        var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');
	
	                        this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
	                    }
	                },
	
	                fieldError: function fieldError(err) {
	                    if (err && err.type === 'fieldError') {
	                        this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                },
	
	                pageError: function pageError(err) {
	                    if (err && err.type === 'pageError') {
	
	                        this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                }
	
	            },
	            decorate: function decorate(name) {
	                this._decoratorList.push({
	                    name: name,
	                    params: Array.prototype.slice.call(arguments, 1)
	                });
	                return this;
	            },
	            getDataObject: function getDataObject(isInContext) {
	                var i;
	                var decorator;
	
	                for (i = 0; i < this._decoratorList.length; i++) {
	                    decorator = this._decoratorList[i];
	                    if (!decorator) {
	                        continue;
	                    }
	                    var name = decorator.name;
	                    var params = decorator.params;
	                    if (angular.isFunction(this.decorators[name])) {
	                        // Invoke the decorator and pass in the parameter list
	                        this.decorators[name].apply(this, params);
	                    } else {
	                        var fptiKey = $FptiConstants.fptiKeys[name];
	                        // If the fptiKey is defined and value is present, add the k-v pair
	                        if (fptiKey && params && params.length > 0) {
	                            this._dataObj[fptiKey] = params[0];
	                        }
	                    }
	                }
	
	                // 'fullpage' was widely used as default key in page routs definition
	                // finally replace it here if it's incontext
	                var dataObj = this._dataObj;
	                if (isInContext) {
	                    Object.keys(dataObj).forEach(function (k) {
	                        if (angular.isString(dataObj[k])) {
	                            // some values can be number
	                            dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
	                        }
	                    });
	                }
	
	                return this._dataObj;
	            }
	        });
	    }).factory('$CalDataModel', function ($Model) {
	
	        var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	        var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';
	
	        function _generateCorrelationId() {
	            var uidRandomArr = (uuid.v4() || uuid_v4_mask).split('-');
	            var uidTime = (uuid.v1() || uuid_v1_mask).split('-');
	            return uidTime[0] + uidRandomArr[0].substr(0, 5);
	        }
	
	        function _generateUUID() {
	            return (uuid.v4() || uuid_v4_mask).replace(/-/g, '');
	        }
	
	        var CalModel = $Model.extend({
	            _calCorrId: _generateCorrelationId(),
	            _uuid: _generateUUID(),
	
	            generateCalCorrId: function generateCalCorrId() {
	                this._calCorrId = _generateCorrelationId();
	            },
	            generateUUID: function generateUUID() {
	                this._uuid = _generateUUID();
	            },
	            generateMetaIds: function generateMetaIds() {
	                this.generateCalCorrId();
	                this.generateUUID();
	            },
	
	            getCalCorrId: function getCalCorrId() {
	                return this._calCorrId;
	            },
	
	            getUUID: function getUUID() {
	                return this._uuid;
	            }
	        });
	
	        return new CalModel();
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/model.js"))

/***/ },

/***/ "./components/node-uuid/uuid.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	/*global window, require, define */
	(function (_window) {
	  
	
	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;
	
	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;
	
	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch (e) {}
	    }
	
	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var _rnds = new Array(16);
	      _mathRNG = _rng = function _rng() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) {
	            r = Math.random() * 0x100000000;
	          }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	
	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }
	
	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
	        _nodeRNG = _rng = _rb && function () {
	          return _rb(16);
	        };
	        _rng();
	      } catch (e) {}
	    }
	  }
	
	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }
	
	  // Buffer class to use
	  var BufferClass = 'function' === typeof Buffer ? Buffer : Array;
	
	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }
	
	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = buf && offset || 0,
	        ii = 0;
	
	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
	      if (ii < 16) {
	        // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });
	
	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }
	
	    return buf;
	  }
	
	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0,
	        bth = _byteToHex;
	    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
	  }
	
	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html
	
	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();
	
	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];
	
	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	  // Previous uuid creation time
	  var _lastMSecs = 0,
	      _lastNSecs = 0;
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];
	
	    options = options || {};
	
	    var clockseq = options.clockseq != null ? options.clockseq : _clockseq;
	
	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = options.msecs != null ? options.msecs : new Date().getTime();
	
	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = options.nsecs != null ? options.nsecs : _lastNSecs + 1;
	
	    // Time since last uuid creation (in msecs)
	    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
	
	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }
	
	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }
	
	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }
	
	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;
	
	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;
	
	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;
	
	    // `time_mid`
	    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;
	
	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;
	
	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;
	
	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;
	
	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }
	
	    return buf ? buf : unparse(b);
	  }
	
	  // **`v4()` - Generate random UUID**
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;
	
	    if (typeof options === 'string') {
	      buf = options === 'binary' ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};
	
	    var rnds = options.random || (options.rng || _rng)();
	
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = rnds[6] & 0x0f | 0x40;
	    rnds[8] = rnds[8] & 0x3f | 0x80;
	
	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }
	
	    return buf || unparse(rnds);
	  }
	
	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;
	
	  if ('undefined' !== typeof module && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return uuid;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;
	
	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function () {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };
	
	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./js/lib/middleware.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-models/src/cartButtonParams/index.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _constants = __webpack_require__("./js/lib/constants.js");
	
	var _customUtil = __webpack_require__("./js/lib/customUtil.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$Middleware', function ($rootScope, $q, $util, $DeviceInfo, $config, $meta, $FallbackError, $locale, $promise, $populate, $window, $dispatch, $logger, $CartButtonParamsModel) {
	    return [function angularDebug() {
	
	        window.root = $rootScope;
	        window.injector = _angular2['default'].element(document.body).injector();
	    }, function resolveLocale() {
	
	        function retrieveLocale(lc) {
	            return $locale.retrieve({
	                params: {
	                    ipCountry: $meta.ipcountry,
	                    checkoutSessionLocale: lc,
	                    countryParam: $util.param('country.x'),
	                    localeParam: $util.param('locale.x') || lc
	                }
	            });
	        }
	
	        var jsonXclick = _customUtil.customUtil.decodeAndParse($meta.xclickParams);
	        var lcParam = jsonXclick.lc;
	
	        if (jsonXclick && jsonXclick.wa_type === _constants.SHOPPINGCART_WA_TYPE && _constants.EN_DEFAULTS[lcParam]) {
	            lcParam = _constants.EN_DEFAULTS[lcParam];
	        }
	
	        return retrieveLocale(lcParam);
	    }, function logPage() {
	
	        $logger.info('href', {
	            href: window.location.href,
	            windowName: $window.name
	        });
	
	        /* let match = document.cookie.toString().match(/ectoken=([^;]+)/);
	         if (match && match[1] === $rootScope.token) {
	            $logger.info('returning_user_same_token');
	        } else if (match && match[1] !== $rootScope.token) {
	            $logger.info('returning_user_diff_token');
	        } else {
	            $logger.info('non_returning_user');
	        }
	         document.cookie = 'ectoken=' + $rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
	        */
	        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
	
	            var navigationType = {
	                0: 'regular',
	                1: 'reload',
	                2: 'back_forward'
	            }[window.performance.navigation.type];
	
	            if (navigationType) {
	                $logger.info('navigation_' + navigationType);
	            }
	        }
	    }, function logPerformance() {
	        if (window.enablePerformance) {
	            (function () {
	
	                var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
	
	                var timing = {};
	
	                _angular2['default'].forEach(keys, function (key) {
	                    timing[key] = parseInt(window.performance.timing[key], 10) || 0;
	                });
	
	                var offset = timing.connectEnd - timing.navigationStart;
	
	                if (timing.connectEnd && window.clientStartTime) {
	                    _angular2['default'].forEach(timing, function (time, name) {
	                        if (time && _angular2['default'].isNumber(time)) {
	                            $logger.info('timing_' + name, {
	                                client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
	                                req_elapsed: time - timing.connectEnd
	                            });
	                        }
	                    });
	                }
	
	                $logger.info('timing', timing);
	
	                if (window.performance.memory) {
	                    $logger.info('memory', window.performance.memory);
	                }
	
	                if (window.performance.navigation) {
	                    $logger.info('navigation', window.performance.navigation);
	                }
	
	                if (window.performance.getEntries) {
	                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
	                        if (['link', 'script', 'img', 'css'].indexOf(resource.initiatorType) > -1) {
	                            $logger.info(resource.initiatorType, resource);
	                        }
	                    });
	                }
	
	                if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
	                    $logger.info('js_init', {
	                        client_elapsed: 0,
	                        req_elapsed: window.clientStartTime - offset
	                    });
	                }
	            })();
	        } else {
	            $logger.info('no_performance_data');
	        }
	    }];
	});
	
	_constants.SHOPPINGCART_WA_TYPE;
	
	_constants.EN_DEFAULTS;
	
	_customUtil.customUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ },

/***/ "./components/xo-models/src/app/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.app', ['squid']).factory('$TransactionEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('TransactionEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/transaction/:id'
	            })
	        });
	    }).factory('$BuyerEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('BuyerEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/buyer/:id'
	            })
	        });
	    }).factory('$PXPModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/pxp/:id'
	            })
	        });
	    }).factory('$LocaleConfigModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/localeConfig'
	            })
	        });
	    }).factory('$AppDataModel', function ($Model, $Api) {
	        return $Model.extend('AppDataModel', {
	            api: new $Api({
	                uri: '/api/app'
	            }),
	
	            isMobile: function isMobile() {
	                return this.platform === 'mobile';
	            }
	        });
	    }).factory('$MessengerIntegrationDataModel', function ($Model, $Api) {
	        return $Model.extend('MessengerIntegrationDataModel', {
	            api: new $Api({
	                uri: '/api/messenger'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/app", "components/xo-models/src/app/index.js"))

/***/ },

/***/ "./components/xo-models/src/cartButtonParams/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.cartbuttonparams', ['squid']).factory('$CartButtonParamsModel', function ($Model, $Api) {
	        return $Model.extend('$CartButtonParamsModel', {
	            api: new $Api({
	                uri: '/api/cartbuttonparams',
	                postAttempts: 2,
	                cache: true
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/cartButtonParams", "components/xo-models/src/cartButtonParams/index.js"))

/***/ },

/***/ "./js/lib/security.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-models/src/auth/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_angular2['default'].module().run(function ($rootScope, $log, $state, $Forbidden, $logger, $timeout, $interval) {
	
	    // let errorCount = 0;
	
	
	    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
	});
	
	_squid.$util;

/***/ },

/***/ "./components/xo-tracking/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	/**
	 * xo-tracking encapsulates all the details about instrumentation
	 * and only register event listeners during bootstrap
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-tracking/dist/listener.js"), __webpack_require__("./components/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    // Declare the dependency to register the listeners
	    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-tracking/dist/listener.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-tracking/dist/fpti.js"), __webpack_require__("./components/xo-tracking/dist/button.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, $) {
	    angular.module('tracking.listener', ['beaver', 'tracking.fpti', 'button.tracking']).run(function ($rootScope, $logger, $CalDataModel, $AuthModel, $fpti, $fptiError, $FptiConstants, $ButtonTrackingService, $timeout, $FptiBuilder, $meta, $config) {
	
	        function logTransition(state) {
	            return !(state.trackingData && state.trackingData.suppressTransitionLog);
	        }
	
	        function logStateExit(state) {
	            return state.trackingData && state.trackingData.trackStateExit;
	        }
	
	        /*
	         * Triggers pa.js recordClick with custom parameters
	         */
	        function fptiCustomRecordClick(route, customData) {
	            var analyticsInstance, fptiData, pxpData, fptiDataObj;
	            var PAYPAL = window.PAYPAL;
	
	            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                PAYPAL.core = PAYPAL.core || {};
	
	                analyticsInstance = new PAYPAL.analytics.Analytics();
	
	                fptiData = new $FptiBuilder({
	                    trackingData: route.trackingData,
	                    isInContext: $rootScope.miniBrowser
	                    // ... Other flow data pass-in here to resolve page qualifier
	                }).build();
	
	                // Add the pxp data in fptiData as custom Attributes
	                fptiDataObj = fptiData._dataObj;
	                if (fptiDataObj) {
	                    pxpData = {
	                        qc: fptiDataObj.qc,
	                        qt: fptiDataObj.qt,
	                        xe: fptiDataObj.xe,
	                        xt: fptiDataObj.xt
	                    };
	                    $.extend(customData, pxpData);
	                }
	
	                // Logic to switch between production/staging urls. This way we don't pollute live logs,
	                // and we are able to test on stage using the fpti log viewing tool.
	                var _beaconUrl;
	                if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                    _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
	                } else {
	                    _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
	                }
	
	                analyticsInstance.setRequestData(customData);
	                analyticsInstance.recordClick({
	                    url: _beaconUrl
	                });
	            }
	        }
	
	        $rootScope.$on('trackInput', function (event, trackInput) {
	            if (!trackInput) {
	                return;
	            }
	            var customData = {
	                link: trackInput.transition,
	                page: trackInput.page
	            };
	
	            fptiCustomRecordClick(trackInput.currentRoute, customData);
	        });
	
	        $rootScope.$on('trackSubmit', function (event, trackSubmit) {
	            if (!trackSubmit) {
	                return;
	            }
	            var currentRoute = trackSubmit.currentRoute;
	            var routeName = currentRoute ? currentRoute.name : 'noRoute';
	
	            $logger.info('track_submit', {
	                route_name: routeName
	                // ID stuff here later
	            });
	
	            if (logTransition(currentRoute)) {
	                routeName = routeName.replace(/\./g, '_');
	                var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	                var transition = trackSubmit.transition || state;
	
	                $logger.info(routeName + '_exit', {
	                    fptiState: state,
	                    fptiTransition: transition
	                });
	            }
	
	            var errors = trackSubmit.errors;
	            if (angular.isArray(errors)) {
	                errors.forEach(function (err) {
	                    $logger.debug('track_submit_error', err);
	                    if ($fpti) {
	                        $fpti.setupDataString(currentRoute, new $fptiError({
	                            type: 'fieldError',
	                            field: err.fieldName,
	                            code: err.errorMessage
	                        }));
	                    }
	                });
	
	                if (errors.length) {
	                    $logger.flush(true);
	                }
	            }
	        });
	
	        $rootScope.$on('unhandled_error', function (event, exception) {
	            if ($fpti) {
	                $fpti.setupDataString(exception.currentRoute, new $fptiError({
	                    type: 'pageError',
	                    message: exception.message,
	                    code: exception.cause
	                }));
	            }
	        });
	
	        $rootScope.$on('trackLink', function (event, trackLink) {
	            if (!trackLink) {
	                return;
	            }
	
	            var currentRoute = trackLink.currentRoute;
	            var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
	            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	
	            $logger.info(routeName + '_exit', {
	                fptiState: state,
	                fptiTransition: trackLink.transition
	            });
	        });
	
	        $rootScope.$on('$transition', function (event, data) {
	
	            $timeout(function () {
	                if ($fpti) {
	
	                    var $auth = $AuthModel.instance();
	
	                    var fptiData = $fpti.setupDataString(data.toState, null, {
	                        transition_time: data.duration,
	                        dc: $meta.dc,
	                        az: $meta.az,
	                        cust: $auth.buyer_id || ''
	                    });
	
	                    // Fire and forget button tracking beacon.
	                    $ButtonTrackingService.fireBeacon(fptiData);
	                }
	            });
	        });
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
	
	            var from = fromState.name.replace(/\./g, '_');
	            var to = toState.name.replace(/\./g, '_');
	            if (from && logTransition(fromState) && logStateExit(fromState)) {
	                var trackingData = fromState.trackingData && fromState.trackingData || {};
	                $logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
	            }
	
	            $logger.info('state_change', {
	                from: from || 'start',
	                to: to || 'end'
	            });
	
	            $logger.flush(true);
	
	            // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
	            if (toState.template) {
	                $CalDataModel.generateMetaIds();
	            }
	
	            $rootScope.currentState = to;
	
	            if (to && logTransition(toState)) {
	                $logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
	            }
	        });
	
	        $rootScope.$on('page_loaded', function (event, from, to) {
	            if (from !== 'checkout_init') {
	                return;
	            }
	            var key = $FptiConstants.stateName[to] || 'review';
	            var landing_page = $FptiConstants.landing_page[key];
	            $logger.info('landing_page', {
	                'from': landing_page,
	                'to': 'process_page_loaded',
	                fpti_landing_page: landing_page
	            });
	        });
	
	        $rootScope.$on('page_reloaded', function () {
	            $logger.flush(true);
	            $CalDataModel.generateMetaIds();
	        });
	
	        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	            var to = toState.name.replace(/\./g, '_');
	            if (toState.hasResolver && to) {
	                $logger.info(to + '_load');
	            } else if (to) {
	                $logger.info(to + '_rendering');
	            }
	        });
	
	        $rootScope.$on('addrDiff', function (event, addrDiff) {
	            if (!addrDiff) {
	                return;
	            }
	
	            $logger.info('checkout_fpti', addrDiff);
	        });
	
	        function getHash(url) {
	            if (!url || !~url.indexOf('#')) {
	                // eslint-disable-line no-bitwise
	                return;
	            }
	
	            url = url.split('#');
	            return url[url.length - 1];
	        }
	
	        var oldHash = window.location.hash;
	
	        window.addEventListener('hashchange', function (event) {
	            $logger.info('hashchange', {
	                from: getHash(event.oldURL || oldHash),
	                to: getHash(event.newURL || window.location.hash)
	            });
	            oldHash = window.location.hash;
	        });
	
	        $(document).on('click', function (event) {
	            if (event && event.target && event.target.tagName) {
	                var name = event.target.tagName.toLowerCase();
	
	                if (event.target.id) {
	                    name += '#' + event.target.id;
	                } else if (event.target.attributes && event.target.attributes['ng-model']) {
	                    name += ':' + event.target.attributes['ng-model'].value;
	                } else if (event.target.className) {
	                    name += '.' + event.target.className.split(' ').join('.');
	                }
	
	                $logger.info('click', {
	                    el: name
	                });
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-tracking/dist/fpti.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/builder.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.fpti', ['squid', 'tracking.builder']).factory('$fpti', function ($config, $FptiBuilder, $rootScope, $window, $util) {
	
	        var _beaconUrl;
	
	        // Logic to switch between production/staging urls. This way we don't pollute live logs,
	        // and we are able to test on stage using the fpti log viewing tool.
	        if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	            _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
	        } else {
	            _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
	        }
	
	        // Get all the tracking data defined at the page level
	        function getPageTrackingData(route) {
	            route = route || {};
	
	            var trackingData = route.trackingData || {};
	            var routeParent = route.parent;
	
	            trackingData.token = $rootScope.token;
	
	            while (routeParent) {
	                trackingData = angular.merge({}, routeParent.trackingData || {}, trackingData);
	                routeParent = routeParent.parent;
	            }
	            return trackingData;
	        }
	
	        return {
	            setupDataString: function setupDataString(route, err, data) {
	
	                var trackingData = getPageTrackingData(route);
	                var fptiData;
	
	                var PAYPAL = window.PAYPAL;
	                if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                    PAYPAL.core = PAYPAL.core || {};
	
	                    var payload = {
	                        trackingData: trackingData,
	                        error: err,
	                        isInContext: $rootScope.miniBrowser
	                    };
	
	                    angular.extend(payload, data || {});
	
	                    fptiData = new $FptiBuilder(payload).build().toString();
	
	                    // FPTI client side tracking only if we have template
	                    if (route && route.template) {
	                        PAYPAL.core.pta = PAYPAL.analytics.setup({
	                            data: fptiData,
	                            url: _beaconUrl
	                        });
	                    }
	                }
	
	                return fptiData;
	            }
	        };
	    }).factory('$fptiError', function ($Error) {
	        function stringifyErrorMessage(msg) {
	            return encodeURIComponent(angular.isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
	            : (angular.toJson(msg) || 'undefined').substring(0, 128));
	        }
	
	        return $Error.extend({
	            construct: function construct(err) {
	                if (!err) {
	                    return;
	                }
	                this.type = err.type;
	                this.field = err.field;
	                this.msg = stringifyErrorMessage(err.message || err.error);
	                this.code = err.code || err.cause;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/fpti.js"))

/***/ },

/***/ "./components/xo-tracking/dist/builder.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/model.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.builder', ['squid', 'tracking.model']).factory('$FptiBuilder', function ($Class, $locale, $rootScope, $FptiConstants, $FptiDataModel, $CalDataModel, $util, $getLatestCorrelationID) {
	        /**
	         *  Build the front-end FPTI event from three data sources
	         *      1. the per-product configuration
	         *      2. the buzname defined per-route
	         *      3. the additional attributes that only available at a specific checkpoint
	         *
	         */
	
	        return $Class.extend('FptiBuilder', {
	
	            resolvePageQualifier: function resolvePageQualifier(trackingData) {
	                // The pages can populated pageQualifier to override the default one
	                this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
	                // because 'fullpage' has been widely embedded into routes
	                // we had better to keep it as a place holder
	                : 'fullpage'; // update later if it's in-context
	            },
	
	            build: function build() {
	
	                if (!this.trackingData && !this.error) {
	                    // do nothing if neither page nor error tracking
	                    return this;
	                }
	
	                this.resolvePageQualifier(this.trackingData);
	
	                this._dataObj = new $FptiDataModel().decorate('buzname', this.trackingData, this.pageQualifier).decorate('templateName', this.trackingData, this.pageQualifier).decorate('locale', $locale).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', $getLatestCorrelationID()).decorate('uuid', $CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).getDataObject(this.isInContext);
	
	                return this;
	            },
	
	            toString: function toString() {
	
	                var dataAry = [];
	                angular.forEach(this._dataObj, function (v, k) {
	                    dataAry.push(k + '=' + v);
	                });
	
	                return dataAry.join('&');
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/builder.js"))

/***/ },

/***/ "./components/xo-tracking/dist/button.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('button.tracking', ['squid', 'xomodel.checkout']).factory('$ButtonTrackingService', function ($rootScope, $http, $populate, $CheckoutAppDataModel, $CheckoutPayeeModel, $meta, $cookies) {
	
	        var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
	        var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
	        var _alreadyFired = false;
	
	        function _strToElements(str) {
	            var elements = {};
	            if (str && str.length) {
	                str.split('&').forEach(function (param) {
	                    var nvp = param.split('=');
	                    elements[nvp[0]] = nvp[1];
	                });
	            }
	            return elements;
	        }
	
	        function _fireButtonTrackingBeacon(elements) {
	            var url = _beaconUrl;
	            var xoData = {};
	
	            function buildParam(param, value) {
	                var p = '&' + param + '=' + (value ? value : 'null');
	                return p;
	            }
	
	            function getGUIID(ts) {
	                return _strToElements(ts).vr;
	            }
	
	            function addToDocument(uri) {
	                var img = document.createElement('img');
	                img.setAttribute('src', uri);
	                document.body.appendChild(img);
	            }
	
	            // Get some params from FPTI data.
	            _beaconParams.forEach(function (param) {
	                url += buildParam(param, elements[param]);
	            });
	
	            // Build the rest of the params.
	            url += buildParam('fpti', getGUIID($cookies && $cookies.ts));
	            url += buildParam('WWW_AKA_MVT_BUTTONS', $cookies && $cookies.WWW_AKA_MVT_BUTTONS);
	            url += buildParam('WWW_AKA_MVT_ID', $cookies && $cookies.WWW_AKA_MVT_ID);
	            url += buildParam('ip', $meta && $meta.ipaddress);
	
	            if ($rootScope.token) {
	                $populate(xoData, {
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    appData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    url += buildParam('mrid', xoData.payee && xoData.payee.getId());
	                    url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
	
	                    addToDocument(url);
	                });
	            } else {
	                url += buildParam('mrid', null);
	                url += buildParam('calf', null);
	                addToDocument(url);
	            }
	        }
	
	        return {
	            fireBeacon: function fireBeacon(fptiData) {
	                if (!_alreadyFired && fptiData) {
	                    var elements = _strToElements(fptiData);
	
	                    // Fire the beacon if this is a page render.
	                    if (elements.page) {
	                        _alreadyFired = true;
	                        return _fireButtonTrackingBeacon(elements);
	                    }
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/button.js"))

/***/ },

/***/ "./components/xo-tracking/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular) {
	
	    angular.module('tracking.directive', ['ui.router']).directive('trackSubmit', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	                    var transition = attr && attr.trackSubmit;
	
	                    var trackSubmit = {
	                        currentRoute: $state.current,
	                        transition: transition,
	                        errors: []
	                    };
	                    angular.forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
	                        var modelName = $(el).attr('ng-model');
	                        var errorText = $(el).attr('data-error-text');
	                        trackSubmit.errors.push({
	                            fieldName: modelName ? modelName : 'no-model',
	                            errorMessage: errorText ? errorText : // eslint-disable-line no-nested-ternary
	                            $(el).has('required') ? 'required' : 'no error text'
	                        });
	                    });
	
	                    $rootScope.$broadcast('trackSubmit', trackSubmit);
	                });
	            }
	        };
	    }).directive('trackLink', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	
	                    var state = attr && attr.trackLink;
	
	                    if (state) {
	                        var trackLink = {
	                            currentRoute: $state.current,
	                            transition: state
	                        };
	                        $rootScope.$broadcast('trackLink', trackLink);
	                    }
	                });
	            }
	        };
	    }).directive('trackInput', function ($state, $rootScope) {
	        /*
	         * Track an input tag with track-input attribute
	         * you can use the value of track-input attribute as
	         * a tracking attr Eg.: track-input="xo_guest_yes"
	         */
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('click', function (event) {
	
	                    var state;
	
	                    if (event.target.type === 'checkbox') {
	                        if (event.target.checked) {
	                            state = attr && attr.trackInput + '_CHECKED';
	                        } else {
	                            state = attr && attr.trackInput + '_UNCHECKED';
	                        }
	                    } else {
	                        state = attr && attr.trackInput;
	                    }
	
	                    var trackInput = {
	                        currentRoute: $state.current,
	                        page: 'main:ec:hermes::fullpage-billing:guest:aries:'
	                    };
	
	                    if (state) {
	                        trackInput.transition = state;
	                    }
	
	                    $rootScope.$broadcast('trackInput', trackInput);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-landing/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$LandingRoute = undefined;
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/shoppingcart/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
	
	    path: 'landing',
	
	    trackingData: {
	        fptiState: 'landing',
	        trackStateExit: true
	    },
	
	    auth: false,
	    resolve: {
	
	        action: function action($state, $populate, $ShoppingCartModel) {
	            if (_angular.$rootScope.isOpenButton) {
	                _logger.$logger.info('open_button_start_flow');
	                return 'checkout.openButton';
	            } else {
	                return 'checkout.shoppingCart';
	            }
	        }
	    }
	
	});
	
	angular.value("$LandingRoute", $LandingRoute);
	_squid.$ComponentRoute;
	
	_angular.$rootScope;
	
	_logger.$logger;

/***/ },

/***/ "./components/xo-models/src/shoppingcart/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shoppingcart', ['squid']).factory('$ShoppingCartModel', function ($Model, $Api) {
	        return $Model.extend('$ShoppingCartModel', {
	            api: new $Api({
	                uri: '/api/shoppingcart/:id',
	                postAttempts: 2,
	                cache: true
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shoppingcart", "components/xo-models/src/shoppingcart/index.js"))

/***/ },

/***/ "./pages/xo-generic-error/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$GenericErrorRoute = undefined;
	
	__webpack_require__("./pages/xo-generic-error/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $GenericErrorRoute = exports.$GenericErrorRoute = _squid.$ComponentRoute.extend('$GenericErrorRoute', {
	
	    path: 'genericError',
	    directive: 'xo-generic-error-page',
	    titleContent: 'genericError.pleaseTryAgain',
	    query: ['code'],
	    // need to find these values
	    trackingData: {
	        fptiState: 'fatal_error',
	        templateName: 'genericError.dust',
	        pageGoal: 'Generic Error',
	        pageQualifier: 'blockNonDomesticShipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-generic-error',
	                'pagename2': '%::fullpage-generic-error:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$GenericErrorRoute", $GenericErrorRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-generic-error/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoGenericErrorPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	var _customUtil = __webpack_require__("./js/lib/customUtil.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
	    tag: 'xo-generic-error-page',
	    template: _template2['default'],
	    lifecycle: {
	        enter: function enter() {
	            var xClickParams = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams);
	
	            this.cancelUrl = xClickParams.cancel_return;
	        }
	    },
	    controller: function controller($scope, $rootScope, $logger) {
	        var cancelBlockStateChange = $rootScope.$on('$stateChangeStart', function (event) {
	            $logger.info('state_change_from_generic_error_blocked');
	            event.preventDefault();
	        });
	
	        $scope.$on('$destroy', cancelBlockStateChange);
	        $('#outerWrapper').addClass('error-page');
	    }
	});
	
	angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
	_squid.$Component;
	
	_squid.$meta;
	
	_customUtil.customUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-generic-error/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-generic-error cancel-url=\"{{cancelUrl}}\"></xo-generic-error>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./components/xo-ui-components/src/generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TITLE_KEY_MAPPING = {
	    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
	    PAYER_COUNTRY_NOT_ALLOWED: 'sorry',
	    PAYER_COUNTRY_NOT_ENABLED: 'sorry',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'sorry',
	    TRANSACTION_REFUSED: 'transactionRefusedTitle',
	    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
	    STUDENT_ACCOUNT: 'studentAccountTitle',
	    RETRY: 'sorry'
	};
	
	var CONTENT_KEY_MAPPING = {
	    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
	    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
	    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
	    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
	    PAYER_CANNOT_PAY: 'paymentDeniedError',
	    RESTRICTED_USER: 'buyerRestrictedError',
	    PAYMENT_DENIED: 'paymentDeniedError',
	    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
	    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
	    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
	    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
	    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
	    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
	    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
	    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
	    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
	    TRANSACTION_REFUSED: 'transactionRefusedMessage',
	    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
	    DEFAULT: 'genericError',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
	    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
	    STUDENT_ACCOUNT: 'studentAccountMessage',
	    RETRY: 'genericError',
	    DEFAULT_ANDROID_PAY_ERROR: 'androidPayGenericError',
	    ANDROID_PAY_ELIGIBILITY_ERROR: 'genericError'
	};
	
	// handle non-standard merchant error title strings
	var TITLE_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: function DOMESTIC_TRANSACTION_REQUIRED(key) {
	        var merchantName = this.props.merchant;
	
	        if (merchantName) {
	            return (0, _squid.$renderContent)(key, { merchantName: merchantName });
	        }
	
	        return (0, _squid.$renderContent)(key + 'Default');
	    }
	};
	
	// handle non-standard merchant error content strings
	var CONTENT_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: TITLE_KEY_HANDLER.DOMESTIC_TRANSACTION_REQUIRED
	};
	
	var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];
	
	var RETRY_LINK = ['RETRY'];
	
	/* eslint-disable fasec/no-unsafe-regex */
	var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');
	
	exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
	
	    tag: 'xo-generic-error',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        isUnbranded: {
	            type: 'var',
	            required: false
	        },
	        cancelUrl: {
	            type: 'str',
	            required: false
	        },
	        merchant: {
	            type: 'str',
	            required: false,
	            'default': function _default() {
	                if (this.models) {
	                    var merchant = this.models.checkoutAppData.merchant;
	                    return merchant.brand_name || merchant.merchant_name;
	                }
	            }
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop)
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var errorCode = void 0;
	
	            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                event.preventDefault();
	            });
	
	            this.$on('$destroy', cancelPreventStateChange);
	
	            var self = this;
	            self.noWalletTokenizationButtonMapping = false;
	
	            // to not break other application's error integration, we'll still support base64 decoded code parameters
	            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
	                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
	            } else {
	                self.errorCode = _uiRouter.$stateParams.code;
	            }
	
	            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
	            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;
	
	            _angular.$rootScope.allowUnload = true;
	            self.cancelLink = self.props.cancelUrl;
	
	            self.cancelRedirect = function ($event) {
	                $event.preventDefault();
	                var redirectUrl = self.cancelLink;
	
	                if (_angular.$rootScope.partnerIntegration) {
	                    _logger.$logger.info('genericerror_partner_integration');
	                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
	                }
	
	                _util.$ReturnToMerchant.goTo(redirectUrl);
	            };
	
	            self.retryCheckout = function ($event) {
	                $event.preventDefault();
	
	                _squid.$util.reload();
	            };
	
	            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
	            (0, _jquery2['default'])('#defaultCancelLink').hide();
	            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');
	
	            self.$on('$destroy', function (event) {
	                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
	                (0, _jquery2['default'])('#defaultCancelLink').show();
	                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
	            });
	
	            // Returns the title string, based on custom key handler
	            self.getTitle = function () {
	                var key = self.titleKey;
	
	                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the content string, based on custom key handler
	            self.getContent = function () {
	
	                var key = self.contentKey;
	
	                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the cancel button label, based on presence of brand/merchant name
	            self.getCancelLabel = function () {
	                if (self.walletTokenization && !self.noWalletTokenizationButtonMapping) {
	                    return (0, _squid.$renderContent)('common.backToAndroidPay');
	                } else {
	                    var merchantName = _this.props.merchant;
	
	                    if (merchantName) {
	                        return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
	                    }
	
	                    return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
	                }
	            };
	        },
	        populate: function populate() {
	            if (this.models.checkoutAppData) {
	                this.cancelLink = this.models.checkoutAppData.urls.cancel_url;
	            }
	            if (this.models.cart) {
	                this.walletTokenization = this.models.cart.isWalletTokenization();
	            }
	
	            // Map error code for Android Pay
	            if (this.walletTokenization) {
	                // ANDROID_PAY_ELIGIBILITY_ERROR is a temporary error code that is mapped to DEFAULT error content.
	                // We need to change once content has been adapted.
	                if (this.errorCode !== 'ANDROID_PAY_ELIGIBILITY_ERROR') {
	                    this.errorCode = 'DEFAULT_ANDROID_PAY_ERROR';
	                } else {
	                    this.noWalletTokenizationButtonMapping = true;
	                }
	            }
	
	            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
	            if (titleKey) {
	                this.titleKey = 'genericError.' + titleKey;
	            }
	
	            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
	            this.contentKey = 'genericError.' + contentKey;
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_uiRouter.$stateParams;
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$renderContent;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutCartModel;
	
	_util.$ReturnToMerchant;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p class=\"retryLink\" ng-if=\"retryLink\">\n            <a link-button ng-click=\"retryCheckout($event)\" id=\"retryLink\" class=\"btn full\">\n                {{ content('genericError.pleaseTryAgain') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\">\n            <a href=\"{{cancelLink}}\" ng-click=\"cancelRedirect($event)\" id=\"cancelLink\" ng-class=\"['btn', 'full', {'btn-secondary': retryLink}]\">\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url('https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png') no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:''}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-ui-components/src/message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-message.directive', ['squid']).directive('xoMessage', function ($timeout, $loader, $rootScope) {
	        return {
	            scope: {
	                message: '=' // Expected type - {msgs: [], type: "info|error|success|warning"}
	            },
	            template: template,
	            link: function link(scope, element, attrs) {
	
	                // Hide and show the alerts so that messages can be registered by
	                // screen reader even if they are repeats. Uses $timeout to
	                // wait for DOM before showing alerts again.
	                var toggleAlert = function toggleAlert() {
	                    var $alert = element.find('ul');
	                    $alert.detach();
	                    $timeout(function () {
	                        element.find('#pageLevelErrors').append($alert);
	                    });
	                };
	
	                // Toggle the alert whenever message changes by removing it and reappending it
	                // to the DOM. Should fire even if message
	                // is changed to the same, as assumes that the message should be reapplied.
	                var cancel;
	                scope.$watchCollection('message', function () {
	                    if ($loader.isLoading() && !cancel) {
	                        // If loading, toggle the alert after all loading calls have been made.
	                        // This is so that the alert can be read by screen reader after focus
	                        cancel = $rootScope.$on('allLoaded', function () {
	                            cancel();
	                            toggleAlert();
	
	                            cancel = null;
	                        });
	                    } else {
	                        toggleAlert();
	                    }
	                });
	
	                scope.$on('$destroy', function () {
	                    if (cancel) {
	                        cancel();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html":
/***/ function(module, exports) {

	module.exports = "<div role=\"alert\" aria-live=\"assertive\">\n    <div id=\"notifications\" ng-if=\"message.msgs || message.msgKeys\" content >\n        <div id=\"pageLevelErrors\" class=\"msgPage msg-{{message.type}}\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs\">\n                    <span data-ng-bind-html=\"msg\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys)\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-generic-message/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$GenericMessageRoute = undefined;
	
	__webpack_require__("./pages/xo-generic-message/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $GenericMessageRoute = exports.$GenericMessageRoute = _squid.$ComponentRoute.extend('$GenericMessageRoute', {
	
	    path: 'genericMessage',
	
	    directive: 'xo-generic-message-page',
	
	    query: ['code'],
	
	    // need to find these values
	    trackingData: {},
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$GenericMessageRoute", $GenericMessageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-generic-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoGenericMessagePageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-generic-message/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/generic-message/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
	    tag: 'xo-generic-message-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	    $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {
	
	        $scope.token = $rootScope.token;
	
	        (0, _jquery2['default'])('#defaultCancelLink').hide();
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	            event.preventDefault();
	        });
	    }
	});
	
	angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-generic-message/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-generic-message.directive', ['squid', 'xomodel.checkout']).directive('xoGenericMessage', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate) {
	
	                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                    event.preventDefault();
	                });
	
	                $('.paypalHeaderWrapper').hide();
	                $('.footerWrapper').addClass('genericMessage');
	
	                var titleKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
	                    DEFAULT: 'paymentSuccessTitle'
	                };
	
	                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;
	
	                var contentKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
	                    DEFAULT: 'paymentSuccessMessage'
	                };
	                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];
	
	                if (contentKey) {
	                    $scope.contentKey = 'genericMessage.' + contentKey;
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    var merchant = $scope.checkoutAppData.merchant;
	                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	                });
	
	                $scope.$on('$destroy', function (event) {
	                    $('.paypalHeaderWrapper').show();
	                    $('.footerWrapper').removeClass('genericMessage');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-openbutton/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoOpenButtonRoute = undefined;
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("./components/angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-tracking/dist/index.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./pages/xo-openbutton/directive.js");
	
	var $xoOpenButtonRoute = exports.$xoOpenButtonRoute = _index.$Route.extend('$xoOpenButtonRoute', {
	    path: 'openButton',
	    directive: 'xo-openbutton-page',
	    auth: false,
	    trackingData: {
	        fptiState: 'openButton',
	        templateName: 'openButton.dust',
	        pageGoal: 'openButton page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-openButton',
	                'pagename2': '%::fullpage-openButton:wps:openbutton:',
	                'version': 'member:%:'
	            }
	        },
	        trackStateExit: true
	    }
	});
	
	angular.value("$xoOpenButtonRoute", $xoOpenButtonRoute);
	_index.$Route;

/***/ },

/***/ "./pages/xo-openbutton/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-openbutton/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/footer/directive.js");
	
	var _index = __webpack_require__("./components/xo-models/src/openButton/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoOpenButton', {
	    tag: 'xo-openbutton-page',
	    template: _template2['default'],
	
	    resolve: {
	        models: function models() {
	            var _this = this;
	
	            _logger.$logger.info('checkout_fpti', { 'from': 'XO_INIT', 'to': 'prepare_openButton' });
	            // set jsonWPSParams as one of our models to use cancel_return for example for our template
	            this.jsonWPSParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
	            this.item = {};
	
	            // send an action to get editable flags and fields for the form and a merchant name
	            _index.$OpenButtonModel.instance().action('getData', {
	                data: {
	                    xClickParams: _squid.$meta.xclickParams
	                },
	                success: function success(result) {
	                    _this.item = result;
	                    _this.originalItem = Object.assign({}, result);
	                    // if field is non editable and exist - format amount and quantity
	                    // to have locale based thousand separators and decimal separators
	                    // note: we decided to not have formatted fields when fields are editable
	                    if (_this.item.amount && !_this.item.is_editable_amount) {
	                        _this.item.amount = (0, _squid.formatCurrency)(_this.item.amount);
	                    }
	                    if (_this.item.quantity && !_this.item.is_editable_quantity) {
	                        _this.item.quantity = (0, _squid.formatQuantity)(_this.item.quantity);
	                    }
	
	                    _logger.$logger.info('open_button_data_recieved', result);
	                }
	            });
	        }
	    },
	
	    controller: function controller($scope) {
	
	        function isValidAmount(thing) {
	            return thing !== undefined && isNaN(thing) === false && +thing > 0;
	        }
	
	        $scope.validPrice = function (input) {
	            // allow user to enter only a valid price
	            if (this.item.is_editable_amount && !isValidAmount(input)) {
	                return false;
	            }
	            return true;
	        };
	
	        $scope.validQuantity = function (input) {
	            // allow user to enter only a positive integer
	            if (this.item.is_editable_quantity && !/^\d*$/.test(input)) {
	                return false;
	            }
	            return true;
	        };
	
	        $scope.positionToErrorField = function () {
	            var errorFields = $('input:visible.ng-invalid');
	            var firstErrorField = errorFields && errorFields.length && errorFields[0];
	
	            // Sets the styling for validation
	            $scope.validated = true;
	            if (firstErrorField) {
	                firstErrorField.focus();
	            }
	
	            return true;
	        };
	
	        // create a cart and redirect to Hermes after we click Continue
	        $scope.onSubmit = function () {
	            var _item = this.item,
	                amount = _item.amount,
	                quantity = _item.quantity,
	                item_name = _item.item_name,
	                is_editable_amount = _item.is_editable_amount,
	                is_editable_quantity = _item.is_editable_quantity;
	
	
	            if (!is_editable_amount) {
	                amount = this.originalItem.amount;
	            }
	            if (!is_editable_quantity) {
	                quantity = this.originalItem.quantity;
	            }
	            _index.$OpenButtonModel.instance().action('createCart', {
	                data: {
	                    formData: {
	                        amount: amount,
	                        quantity: quantity,
	                        item_name: item_name
	                    },
	                    xClickParams: _squid.$meta.xclickParams
	                },
	                success: function success(result) {
	                    var hermesUrl = result.hermesUrl;
	
	                    // redirect to hermes
	
	                    _logger.$logger.info('open_button_redirect_to_hermes', { url: hermesUrl });
	                    _logger.$logger.info('checkout_fpti', { 'from': 'OPENBUTTON', 'to': 'process_openButton' });
	                    _squid.$util.redirect(hermesUrl);
	                },
	                contingencies: {
	                    DEFAULT: function DEFAULT(errorName) {
	                        _logger.$logger.info('open_button_create_cart_error', errorName);
	                        throw new _squid.$FallbackError({
	                            product: 'wps',
	                            reason: errorName
	                        });
	                    }
	                }
	            });
	        };
	
	        $scope.cancelRedirect = function ($event) {
	            $event.preventDefault();
	            _logger.$logger.info('checkout_fpti', {
	                'from': 'OPENBUTTON',
	                'to': 'openButton_return_to_merchant'
	            });
	            _logger.$logger.info('redirect', {
	                url: this.jsonWPSParams.cancel_return
	            });
	            _squid.$util.redirect(this.jsonWPSParams.cancel_return);
	        };
	    },
	
	    actions: {
	        keyUp: function keyUp(event) {
	            event = event || window.event;
	            if (event) {
	                // 38 : up arrow, 40: down arrow
	                if (event.keyCode === 38) {
	                    this.actions.increment();
	                } else if (event.keyCode === 40) {
	                    this.actions.decrement();
	                }
	            }
	        },
	        increment: function increment() {
	            this.item.quantity++;
	        },
	        decrement: function decrement() {
	            if (this.item.quantity > 1) {
	                this.item.quantity--;
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$FallbackError;
	
	_squid.formatCurrency;
	
	_squid.formatQuantity;
	
	_logger.$logger;
	
	_index.$OpenButtonModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-openbutton/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"openbutton-wrapper\">\n    <div class=\"header\">\n        <h1 class=\"alpha\" directionality-text=\"item.business_name\">{{ item.business_name }}</h1>\n    </div>\n    <div class=\"form-wrap\" content>\n        <form name=\"buyNowForm\" ng-submit=\"buyNowForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n            <h2 class=\"gamma description-txt\">{{ content('shoppingCartBuyNow.header') }}</h2>\n\n            <div class=\"inputField\" floating-label directionality>\n                <input type=\"text\"\n                    class=\"ng-pristine\"\n                    ng-model=\"item.item_name\"\n                    name=\"item_number\"\n                    id=\"itemName\"\n                    xo-error-tooltip\n                    ng-disabled=\"!item.is_editable_item_name\"\n                 />\n                <label for=\"itemName\">{{ content('shoppingCartBuyNow.item_name') }}</label>\n            </div>\n\n            <div class=\"amount-col\">\n                <div class=\"input-group\">\n                    <div class=\"inputField\" floating-label directionality>\n\n                    <input\n                        type=\"text\"\n                        name=\"amount\"\n                        id=\"itemPrice\"\n                        ng-model=\"item.amount\"\n                        ui-validate=\"{amount: 'validPrice($value)'}\"\n                        data-error-text=\"{{ content('validation.validPrice') }}\"\n                        xo-error-tooltip\n                        ng-disabled=\"!item.is_editable_amount\"\n                        required\n                     />\n                     <label for=\"itemPrice\" class=\"focus\">{{ content('shoppingCartBuyNow.amount') }}</label>\n                    </div>\n                    <span class=\"currency input-group-addon\">{{jsonWPSParams.currency_code || 'USD'}}</span>\n                </div>\n            </div>\n\n            <div class=\"quantity-col\">\n                <div class=\"inputField\" floating-label directionality>\n                    <input\n                        type=\"text\"\n                        name=\"quantity\"\n                        id=\"quantity\"\n                        ng-model=\"item.quantity\"\n                        ui-validate=\"{quantity: 'validQuantity($value)'}\"\n                        ng-keyup=\"actions.keyUp(event)\"\n                        data-error-text=\"{{ content('validation.validQuantity') }}\"\n                        xo-error-tooltip\n                        ng-disabled=\"!item.is_editable_quantity\"\n                        required\n                    />\n                    <label for=\"quantity\" class=\"focus\">{{ content('shoppingCartBuyNow.quantity') }}</label>\n                </div>\n            </div>\n\n            <div class=\"clearfix\"></div>\n\n            <div class=\"buttons ng-scope\">\n                <input\n                    class=\"continue-btn btn\"\n                    type=\"submit\"\n                    value=\"{{ content('shoppingCartBuyNow.continue') }}\"\n                    ng-click=\"positionToErrorField()\"\n                />\n            </div>\n            <div class=\"cancel-link\" ng-if=\"jsonWPSParams.cancel_return\">\n                <a  href=\"{{jsonWPSParams.cancel_return}}\"\n                    ng-click=\"cancelRedirect($event)\"\n                    role=\"button\"\n                    id=\"cancelLink\">{{ content('shoppingCartBuyNow.cancel') }}</a>\n            </div>\n        </form>\n        <div class=\"powered-by\">\n            <span>{{ content('shoppingCartBuyNow.powered') }}</span>\n            <span class=\"logo\">\n                <span class=\"accessAid\">{{ content('base.payPal') }}</span>\n            </span>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/accessibility/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _ui = __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adds role='button' and tabindex='0' to anchor elements
	// so that it is keyboard navigable and recognized by screen
	// readers as a button.
	//
	// As anchors without href do not fire their click event
	// automatically on a Space or ENTER key, this directive forces
	// that functionality.
	//
	// If something is assigned to the link-button attribute, then
	// it is used as an aria-label.
	(0, _angular.$registerDirective)('link-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
	            var $element = (0, _jquery2['default'])(element);
	
	            $element.attr('role', 'button');
	            $element.attr('tabindex', '0');
	            if (ariaLabel) {
	                $element.attr('aria-label', ariaLabel);
	            }
	            $element.on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// select element in terms of keyboard navigation. It becomes reachable
	// via the tab key, reflects screenreader characteristics and
	// can be activated by any of the DOWN, SPACE or ENTER KEYS.
	(0, _angular.$registerDirective)('select-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var $element = (0, _jquery2['default'])(element);
	            $element.attr('role', 'button').attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive makes a container with links act as if it were a select dropdown
	// in terms of keyboard accessibility. The following characteristics are implemented:
	//
	// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
	// * ESC cancels and closes the dropdown
	// * SPACE or ENTER select an option
	// * You cannot TAB out of a dropdown until you select or cancel
	//
	// in addition, the following extra characteristics are implemented
	//
	// * The TAB (and SHIFT-TAB) key will also function to move between options
	// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
	//
	// How to use:
	// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
	//    The expression is run whenever the ESC key is pressed.
	// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
	//    tabs to escape the select-box element.
	(0, _angular.$registerDirective)('select-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);
	
	            function escapeToggle() {
	                if (attrs.selectCancel) {
	                    (0, _angular.$parse)(attrs.selectCancel)(scope);
	                    scope.$apply();
	                }
	            }
	
	            element.attr('role', 'menu');
	
	            element.on('keydown.selectBox', function (event) {
	                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                var $origin = (0, _jquery2['default'])(event.target);
	
	                if (!(event.altKey || event.ctrlKey)) {
	                    var index = $allTabbable.index($origin);
	
	                    switch (event.keyCode) {
	                        case _ui.KEYS.TAB:
	                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
	                                // Enable default behavior to escape select-box
	                                escapeToggle();
	                                break;
	                            } else if (event.shiftKey) {
	                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            } else {
	                                index = (index + 1) % $allTabbable.length;
	                            }
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.RIGHT:
	                            index = (index + 1) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.UP:
	                        case _ui.KEYS.LEFT:
	                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            $origin.click();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.ESC:
	                            escapeToggle();
	                            break;
	                        default:
	                            break;
	                    }
	                }
	            });
	        }
	    };
	});
	
	// similar to select-box, this directive restrains tabbing within a container
	// to the container itself.
	//
	// 1. modal-cancel is the equivalent of select-cancel from select-box, and
	// should define a cancellation / ESC function.
	(0, _angular.$registerDirective)('modal-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function escapeToggle() {
	                (0, _angular.$parse)(attrs.modalCancel)(scope);
	                scope.$apply();
	            }
	
	            // Gets the index of the element that should be focused after pressing Tab
	            function getNextIndex($element, $elements, shift) {
	                if (shift) {
	                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
	                } else {
	                    return ($elements.index($element) + 1) % $elements.length;
	                }
	            }
	
	            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
	                element.on('keydown.modalBox', function (event) {
	                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                    var $origin = (0, _jquery2['default'])(event.target);
	
	                    if (!(event.altKey || event.ctrlKey)) {
	                        switch (event.keyCode) {
	                            case _ui.KEYS.TAB:
	                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
	                                $allTabbable.eq(index).focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            case _ui.KEYS.ESC:
	                                escapeToggle();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            default:
	                                break;
	                        }
	                    }
	                });
	            }
	        }
	    };
	});
	
	// A simple version of modal that doesn't rely on controlling keyboard behavior
	// as strictly. Should be used in cases where tab items are not as easily accessible
	// via JS (ie. iframes)
	// Redirects focus to container when focusin event fired on element not in container
	(0, _angular.$registerDirective)('simple-modal', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.attr('tabindex', '-1');
	
	            var cancelFn;
	            if (attrs.modalCancel) {
	                cancelFn = function cancelFn() {
	                    (0, _angular.$parse)(attrs.modalCancel)(scope);
	                    scope.$apply();
	                };
	            }
	
	            function registerModal() {
	                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
	                    if (!element[0].contains(event.target)) {
	                        event.stopPropagation();
	                        element.focus();
	                    }
	                });
	                if (cancelFn) {
	                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
	                        if (!element[0].contains(event.target)) {
	                            deregisterModal();
	                            cancelFn();
	                        }
	                    });
	                }
	            }
	
	            function deregisterModal() {
	                (0, _jquery2['default'])(document).off('focusin.simple-modal');
	                (0, _jquery2['default'])(document).off('click.simple-modal');
	            }
	
	            // Watch the expression provided to simpleModal and add modal behavior when
	            // expression result changes to truthy
	            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
	                scope.$watch(attrs['simpleModal'], function (newVal) {
	                    if (newVal) {
	                        registerModal();
	                    } else {
	                        deregisterModal();
	                    }
	                });
	            } else {
	                registerModal();
	            }
	
	            scope.$on('$destroy', deregisterModal);
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// option element in terms of aria attributes. It must be used
	// as a child of a selectBox for proper keyboard behavior as it
	// disables default tabbing behavior.
	//
	// The expression provided to the directive is used to set the
	// aria-selected attribute when the expression evaluates to true.
	(0, _angular.$registerDirective)('select-option', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            (0, _jquery2['default'])(element).attr('role', 'menuitem');
	            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
	                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
	            }
	        }
	    };
	});
	
	// adapted from http://stackoverflow.com/a/24416690
	// This directive makes the element focused when the expression
	// provided _changes_ to true.
	//
	// In order to avoid conflicts with autofocus when a page first loads,
	// adding the focused-once-before attribute will enable the expression
	// only if it has been focused on before.
	//
	// * if the element itself is not focusable, then it will locate the first focusable
	// element within it.
	// * if the additional attribute focus-element is provided, it is wrapped
	// as a jQuery element (could be selector string or actual element) and focused on
	// it will be parsed when the focus-when attribute is true
	// * if the attribute focus-on is provided, then the focus-when attribuet is ignored and
	// the directive listens to the event specified by focus-on
	(0, _angular.$registerDirective)('focus-when', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            function locateAndFocus(active) {
	                (0, _angular.$timeout)(function () {
	                    if (active) {
	                        // deal with figuring out which element to focus on
	                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
	                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);
	
	                        // this works by fallthrough. it will try each one
	                        // in succession until an element is found
	                        if (attrs.focusElement) {
	                            // scenario 1 - specific element provided
	                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
	                        }
	
	                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
	                            // scenario 2 - element with directive is not focusable
	                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
	                        }
	
	                        // default / scenario 3 - no valid targets specified or found
	                        if ($elementToFocus.length === 0) {
	                            $elementToFocus = (0, _jquery2['default'])(element);
	                        }
	
	                        $elementToFocus.first().focus();
	                    }
	                });
	            }
	
	            var active = true;
	
	            if ('focusedOnceBefore' in attrs) {
	                active = false;
	                (0, _jquery2['default'])(element).on('focus', function () {
	                    active = true;
	                });
	            }
	
	            if (attrs.focusRefreshOn) {
	                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
	                    locateAndFocus(active);
	                });
	            } else {
	                scope.$watch(attrs.focusWhen, function (val) {
	                    locateAndFocus(active && val);
	                });
	            }
	        }
	    };
	});
	
	// angularUI router specific - listens to a specific transition
	// defined in two attributes, focusWhenState (this directive) and TransitionsTo
	var FOCUS_EVENT_NAME = 'accessible-focus';
	(0, _angular.$registerDirective)('focus-when-state', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var startState = attrs.focusWhenState;
	            var endState = attrs.transitionsTo;
	            var transitionMessage = startState + ' > ' + endState;
	            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                if (fromState.name === startState && toState.name === endState) {
	                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
	                }
	            });
	
	            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
	                if (message === transitionMessage) {
	                    (0, _angular.$timeout)(function () {
	                        return element[0].focus();
	                    });
	                }
	            });
	
	            // see http://stackoverflow.com/a/27016855
	            scope.$on('$destroy', unregisterEventFn);
	        }
	    };
	});
	
	// Listens for the next state transition and focuses an element provided by selector
	// Use with links where focus is needed to return to a specific element after the transition
	(0, _angular.$registerDirective)('focus-after-transition', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.on('click', function () {
	                var focusSelector = attrs['focusAfterTransition'];
	                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                    cancel();
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])(focusSelector).focus();
	                    });
	                });
	            });
	        }
	    };
	});
	
	// focuses on the first focusable element on a container containing form elements
	(0, _angular.$registerDirective)('form-autofocus', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            // wait for the entire DOM to settle down first
	            (0, _angular.$timeout)(function () {
	                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
	                if ($allFocusable.length > 0) {
	                    $allFocusable.first().focus();
	                }
	            });
	        }
	    };
	});
	
	// Change element to be focusable and tabbable or unfocusable if it is
	// not typically a focusable element by removing the tabindex attribute.
	(0, _angular.$registerDirective)('focusable', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function setFocusable(value) {
	                if (value) {
	                    element.attr('tabindex', 0);
	                } else {
	                    element.removeAttr('tabindex');
	                }
	            }
	
	            if (attrs.focusable) {
	                scope.$watch(attrs.focusable, function (newVal) {
	                    if (newVal) {
	                        setFocusable(true);
	                    } else {
	                        setFocusable(false);
	                    }
	                });
	            } else {
	                setFocusable(true);
	            }
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.isDefined;
	
	_ui.KEYS;
	
	_ui.focusable;
	
	_ui.tabbable;
	
	_ui.findAll;
	
	_ui.filterAll;

/***/ },

/***/ "./components/xo-ui-components/src/accessibility/ui.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var KEYS = {
	    TAB: 0x09,
	    ENTER: 0x0D,
	    ESC: 0x1B,
	    SPACE: 0x20,
	    LEFT: 0x25,
	    UP: 0x26,
	    RIGHT: 0x27,
	    DOWN: 0x28
	};
	
	function visible(element) {
	    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
	        return _jquery2['default'].css(this, 'visibility') === 'hidden';
	    }).length;
	}
	
	// ripped from http://stackoverflow.com/a/7668761
	/* istanbul ignore next */
	function focusable(element) {
	    var nodeName = element.nodeName.toLowerCase();
	    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
	    var map;
	    var mapName;
	    var img;
	
	    if (nodeName === 'area') {
	        map = element.parentNode;
	        mapName = map.name;
	        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
	            return false;
	        }
	        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
	        return !!img && visible(img);
	    }
	    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
	    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
	    // the element and all of its ancestors must be visible
	    visible(element);
	}
	
	/* istanbul ignore next */
	function tabbable(element) {
	    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
	    var isTabIndexNaN = isNaN(tabIndex);
	
	    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
	}
	
	function filterAll(elements, filterFn) {
	    return (0, _jquery2['default'])(elements).filter(function () {
	        return filterFn(this);
	    });
	}
	
	function findAll(container, filterFn) {
	    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
	}
	
	exports.KEYS = KEYS;
	exports.visible = visible;
	exports.focusable = focusable;
	exports.tabbable = tabbable;
	exports.findAll = findAll;
	exports.filterAll = filterAll;

/***/ },

/***/ "./components/xo-ui-components/src/floating-label/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/styles.less");
	
	var treatmentType;
	var newLocale;
	var oldLocale;
	
	function getTreatment() {
	
	    if (treatmentType !== undefined) {
	        return treatmentType;
	    }
	    if ((0, _squid.$feature)('floatingLabels')) {
	        return true;
	    }
	    var token = _angular.$rootScope.token;
	    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
	    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;
	    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
	    return treatmentType;
	}
	
	(0, _angular.$registerDirective)('floating-label', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var input = element.find('input');
	
	                if (input.attr('placeholder')) {
	                    input.addClass('hasPlaceholder');
	                }
	
	                // To hide the placeholder labels for pre-populated input fields
	                scope.$watch(input.attr('ng-model'), function (value) {
	                    input.toggleClass('focused', !!value);
	                });
	
	                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
	                input.on('keyup', function (event) {
	                    var val = event.target.value;
	                    input.toggleClass('focused', !!val);
	                });
	
	                input.on('focus blur click', function (event) {
	                    if (scope.showFloatingLabels) {
	                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
	                    }
	                }).trigger('blur');
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('floating-label-dropdown', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var select = element.find('select');
	                var label = element.find('label');
	                var flSpan = element.find('.custom-select span span');
	
	                select.on('change mouseenter mouseleave blur', function (event) {
	                    select.toggleClass('focused', event.type === 'change' || this.value.length > 0);
	                    flSpan.toggleClass('noValue', this.value.length < 1);
	                    label.toggleClass('hide', this.value.length < 1);
	                }).trigger('mouseleave');
	            });
	        }
	    };
	});
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.$registerDirective;
	
	_squid.$locale;
	
	_squid.$experiment;
	
	_squid.$config;
	
	_squid.$feature;

/***/ },

/***/ "./components/xo-ui-components/src/floating-label/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png') no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url('https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png') no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png') no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:''}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url('https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png');background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.inputField.floatingLabel input{height:49px}.inputField.floatingLabel select{height:48px;font-size:15px}.inputField.floatingLabel select.focused~label.hide,.inputField.floatingLabel select:focus~label.hide{display:none}.inputField.floatingLabel.dropdown label{color:transparent}.inputField.floatingLabel.dropdown .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.floatingLabel.dropdown .custom-select span span{top:18px;padding:0}.inputField.floatingLabel.dropdown .custom-select span span.noValue{top:9px}.inputField.floatingLabel input.focused,.inputField.floatingLabel input:focus,.inputField.floatingLabel select.focused,.inputField.floatingLabel select:focus{padding-top:16px}.inputField.floatingLabel input.focused::-webkit-input-placeholder,.inputField.floatingLabel input:focus::-webkit-input-placeholder,.inputField.floatingLabel select.focused::-webkit-input-placeholder,.inputField.floatingLabel select:focus::-webkit-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-moz-placeholder,.inputField.floatingLabel input.focused::-moz-placeholder,.inputField.floatingLabel input:focus:-moz-placeholder,.inputField.floatingLabel input:focus::-moz-placeholder,.inputField.floatingLabel select.focused:-moz-placeholder,.inputField.floatingLabel select.focused::-moz-placeholder,.inputField.floatingLabel select:focus:-moz-placeholder,.inputField.floatingLabel select:focus::-moz-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-ms-input-placeholder,.inputField.floatingLabel input:focus:-ms-input-placeholder,.inputField.floatingLabel select.focused:-ms-input-placeholder,.inputField.floatingLabel select:focus:-ms-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused~label,.inputField.floatingLabel input:focus~label,.inputField.floatingLabel select.focused~label,.inputField.floatingLabel select:focus~label{color:#0070ba;-webkit-transform:translate3d(0,-7px,0) scale(.8);transform:translate3d(0,-7px,0) scale(.8);text-overflow:ellipsis;overflow-x:hidden;width:100%;display:inline-block;white-space:nowrap}.inputField.floatingLabel input.focused:not(:focus)~label,.inputField.floatingLabel select.focused:not(:focus)~label{color:#6c7378}.inputField.floatingLabel input::-webkit-input-placeholder,.inputField.floatingLabel select::-webkit-input-placeholder{color:transparent}.inputField.floatingLabel input:-moz-placeholder,.inputField.floatingLabel input::-moz-placeholder,.inputField.floatingLabel select:-moz-placeholder,.inputField.floatingLabel select::-moz-placeholder{color:transparent}.inputField.floatingLabel input:-ms-input-placeholder,.inputField.floatingLabel select:-ms-input-placeholder{color:transparent}.inputField.floatingLabel label{color:#6c7378;position:absolute;top:14px;left:14px;pointer-events:none;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1);transform-origin:left top 0;transition:all .25s ease-in-out;text-overflow:ellipsis;overflow-x:hidden;width:90%;display:inline-block;white-space:nowrap}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-webkit-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-moz-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-ms-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.floatingLabel input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.noFloatingLabel input.ng-invalid:not(:focus):not(.focused)~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-webkit-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-moz-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-ms-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid~label,.validated .inputField.floatingLabel input.ng-invalid~label,.validated .inputField.noFloatingLabel input.ng-invalid~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid~label.hide,.validated .inputField.floatingLabel input.ng-invalid~label.hide,.validated .inputField.noFloatingLabel input.ng-invalid.focused~label,.validated .inputField.noFloatingLabel input.ng-invalid~label.hide{color:transparent}.inputField.noFloatingLabel label{color:transparent;left:14px;text-overflow:ellipsis;overflow-x:hidden;width:90%;white-space:nowrap;pointer-events:none}.inputField.noFloatingLabel input{height:49px}.inputField.noFloatingLabel input::-webkit-input-placeholder{color:transparent}.inputField.noFloatingLabel input:-moz-placeholder,.inputField.noFloatingLabel input::-moz-placeholder{color:transparent}.inputField.noFloatingLabel input:-ms-input-placeholder{color:transparent}.inputField.noFloatingLabel input:focus.focused~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus~label{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-webkit-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-moz-placeholder,.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-moz-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-ms-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(:focus):not(.focused)~label{color:#6c7378}.inputField.noFloatingLabel select{height:48px;font-size:15px}.inputField.noFloatingLabel select.focused~label,.inputField.noFloatingLabel select:focus~label{color:transparent}.inputField.noFloatingLabel .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.noFloatingLabel .custom-select span span{top:11px;padding:0}.inputField.noFloatingLabel#countryOfResidenceDropDown,.inputField.noFloatingLabel#nationalityDropDown{min-height:87px}.inputField.noFloatingLabel#countryOfResidenceDropDown .custom-select,.inputField.noFloatingLabel#countryOfResidenceDropDown select,.inputField.noFloatingLabel#nationalityDropDown .custom-select,.inputField.noFloatingLabel#nationalityDropDown select{top:20px}.inputField.noFloatingLabel#countryOfResidenceDropDown label,.inputField.noFloatingLabel#nationalityDropDown label{color:#6c7378;top:0;left:0}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-ui-components/src/directionality/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/styles.less");
	
	/**
	 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
	 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
	 *
	 * Add directionality to the container html div element of a input field.
	 * <div directionality><input type=text ng-model="user.name"></div>
	 */
	(0, _angular.$registerDirective)('directionality', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            var currentWatchDeregister = void 0;
	            var input = element.find('input');
	            if (!input.length) {
	                listenForInputRendered();
	                return;
	            }
	
	            // If the input has not yet been rendered inside the container, listen for dom node inserted
	            // then, if the node inserted is an input, we will use that element and init the directionality 
	            // listeners. The first input rendered is the one that will be captured by this directive.
	            function listenForInputRendered() {
	                element.bind('DOMNodeInserted', checkDOMNodeInserted);
	
	                function checkDOMNodeInserted(event) {
	                    if (event && event.target && event.target.tagName === 'INPUT') {
	                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
	                        input = angular.element(event.target);
	                        init();
	                    }
	                }
	            }
	
	            function setDirectionality(value) {
	                if (value) {
	                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
	                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
	                } else {
	                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
	                }
	            }
	
	            function jqueryOnKeyupHandler(event) {
	                setDirectionality(event.target.value);
	            }
	
	            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
	            function resetDirectionalityListener() {
	                // remove directionality listeners that were set on prior locale
	                input.unbind('keyup', jqueryOnKeyupHandler);
	                if (currentWatchDeregister) {
	                    currentWatchDeregister();
	                }
	
	                // set new directionality listeners for the current locale if 'rtl'
	                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                    (0, _angular.$timeout)(function () {
	                        // Watch ng-model on input to set directionality if it contains RTL char
	                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
	                            setDirectionality(value);
	                        });
	                        // jQuery listener for cases where ng-model is not populated until post validation
	                        input.on('keyup', jqueryOnKeyupHandler);
	                    });
	                }
	            }
	
	            function init() {
	                resetDirectionalityListener();
	                scope.$on('localeChange', function () {
	                    resetDirectionalityListener();
	                });
	            }
	
	            init();
	        }
	    };
	});
	
	/**
	 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
	 * or dir="ltr" attribute to the html element.
	 *
	 * Add directionality-text="<<model>>" to the div or span or any element containing text.
	 * <span directionality-text="user.name"><{{user.name}}</span>
	 */
	(0, _angular.$registerDirective)('directionality-text', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            if (document.documentElement.getAttribute('dir') === 'rtl') {
	                var $element = $(element);
	
	                (0, _angular.$timeout)(function () {
	                    if (attrs.directionalityText) {
	                        scope.$watch(attrs.directionalityText, function () {
	                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
	                        });
	                    } else {
	                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
	                    }
	                });
	            }
	        }
	    };
	});
	
	_angular.$document;
	
	_angular.$parse;
	
	_angular.$registerDirective;
	
	_angular.$timeout;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-ui-components/src/directionality/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".ltrOverride{direction:ltr!important;unicode-bidi:bidi-override!important}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-page-components/src/footer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html"), __webpack_require__("./components/xo-page-components/src/footer/opinionlab.js"), __webpack_require__("./components/xo-page-components/src/footer/footerMap.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/modal/directive.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, opinionlab, footerMap) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-footer.directive', ['squid', 'xomodel.checkout', 'xo-modal.directive', 'xo-return-to-merchant', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).factory('$GetPomaFlowStatus', function ($pxp, $q) {
	        return function (country) {
	            return $pxp('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': country }, 'XO_XOONBOARDING_POMA_GLOBAL_TREATMENT').then(function (result) {
	                if (result && result.treatment_name) {
	                    return $q.resolve(true);
	                } else {
	                    return $q.resolve(false);
	                }
	            });
	        };
	    }).directive('xoFooter', function () {
	
	        return {
	            template: template,
	            restrict: 'EA',
	            scope: {
	                token: '=',
	                escapeHatchIncontext: '=',
	                cancel: '@',
	                merchant: '@',
	                languageSwitch: '=?'
	            },
	            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $ReturnToMerchant, $util, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel, $GetPomaFlowStatus, $logger) {
	
	                $scope.isIFrame = $util.isIFrame();
	                if ($scope.escapeHatchIncontext) {
	                    $scope.showEscapeHatch = $scope.isIFrame;
	                }
	                $scope.locale = $locale;
	                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
	                $scope.year = new Date().getFullYear();
	
	                $scope.isApac = function () {
	                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
	                };
	
	                // Determine if country belongs to a region to serve correct footer links
	                var getRegion = function getRegion(country) {
	                    var regions = $config.regions;
	                    for (var region in regions) {
	                        if (regions[region].indexOf(country) > -1) {
	                            return region;
	                        }
	                    }
	
	                    return false;
	                };
	
	                $scope.footerLinks = function () {
	                    if ($scope.isApac()) {
	                        return footerMap.APAC;
	                    }
	
	                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
	                };
	
	                $scope.showPolicyInfo = function () {
	                    return $scope.isApac() || $scope.locale.country === 'AU';
	                };
	
	                $scope.cancelRedirect = function ($event) {
	                    $event.preventDefault();
	
	                    $GetPomaFlowStatus($scope.locale.country).then(function (poma_flag) {
	                        var currentRoute = $state.current;
	                        var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
	                        var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	
	                        if (poma_flag) {
	                            state = 'guest_POMA';
	                        }
	
	                        $logger.info('checkout_fpti', {
	                            'from': state,
	                            'to': 'process_cancel_and_return_to_merchant'
	                        });
	
	                        $ReturnToMerchant.goTo($scope.cancel);
	                    });
	                };
	
	                if ($scope.token) {
	                    $populate($scope, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                    }).then(function () {
	                        var merchant = $scope.checkoutAppData.merchant;
	                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
	                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	                        // for ebay transactions, override the merchant name to ebay instead of the actual merchant.
	                        if ($scope.proxSignUpFlow) {
	                            $scope.merchant = $locale.content.signup.ebay;
	                        }
	                    });
	                }
	
	                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
	                    $scope.popupUrl = config && config.popupUrl;
	                    $scope.show = true;
	                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                });
	
	                $scope.$on('$destroy', cancelShowModal);
	
	                $scope.showOL = function showOL(event) {
	                    event.preventDefault();
	
	                    var placeholder = 'main:ec:hermes';
	                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
	
	                    var data = {
	                        opVars: {
	                            rlogId: $window.meta.rlogId || '',
	                            page: page || window.location.hash,
	                            csci: 'Unknown',
	                            calc: $window.meta.correlationId,
	                            custId: 'Unknown',
	                            merchantId: 'Unknown',
	                            token: $scope.token || 'Unknown'
	                        },
	                        locale: {
	                            country: $locale.country,
	                            languageCode: $locale.lang + '_' + $locale.country
	                        }
	                    };
	
	                    opinionlab(data);
	                };
	
	                $scope.showFeedback = function () {
	                    if ($DeviceInfo.isDevice()) {
	                        return false;
	                    }
	                    return true;
	                };
	
	                $scope.hideReturnCancelUrl = function () {
	                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/footer", "components/xo-page-components/src/footer/directive.js"))

/***/ },

/***/ "./components/xo-page-components/src/footer/opinionlab.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var _doc = document;
	    var _w = window;
	    var _tm = new Date().getTime();
	    var _sH = screen.height;
	    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
	    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
	    var _sW = screen.width;
	
	    function popUp(opinionlabURL) {
	        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
	    }
	
	    function updateCustomVars(data) {
	
	        var opVars = data.opVars;
	        var locale = data.locale;
	
	        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef
	
	        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
	        return customVar;
	    }
	
	    function _fC(_u) {
	        var _sp = '%3A\\/\\/';
	        var _rp = '%3A//';
	        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
	        var _aA = _aT.split(',');
	
	        for (var i = 0; i < 5; i++) {
	            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
	        }
	        return _u;
	    }
	
	    return function (locale) {
	
	        var custom_var = updateCustomVars(locale);
	
	        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
	        popUp(opinionlabURL);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/footer/footerMap.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	!(module.exports = {
	    CA: [{
	        id: 'policy',
	        content: 'footer.policiesCA'
	    }, {
	        id: 'terms',
	        content: 'footer.termsCA'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacyCA'
	    }],
	
	    BE: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DE: [{
	        id: 'imprint',
	        content: 'footer.DEImprint'
	    }, {
	        id: 'legal',
	        content: 'footer.DELegal'
	    }, {
	        id: 'privacy',
	        content: 'footer.DEPrivacy'
	    }, {
	        id: 'paymentdesc',
	        content: 'footer.DEKeyPaymentDesc'
	    }],
	
	    ES: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    FR: [{
	        id: 'legal',
	        content: 'footer.FRLegal'
	    }, {
	        id: 'useragreement',
	        content: 'footer.FRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.FRPrivacy'
	    }],
	
	    IT: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    NL: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    IE: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    APAC: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EMEA: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EM: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    LATAM: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    AU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    AT: [{
	        id: 'imprint',
	        content: 'footer.ATImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    CH: [{
	        id: 'imprint',
	        content: 'footer.CHImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    DK: [{
	        id: 'useragreement',
	        content: 'footer.DKUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    SE: [{
	        id: 'useragreement',
	        content: 'footer.SEUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    PL: [{
	        id: 'useragreement',
	        content: 'footer.PLUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    NO: [{
	        id: 'useragreement',
	        content: 'footer.NOUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    TR: [{
	        id: 'useragreement',
	        content: 'footer.TRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    BR: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    MX: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    RU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DEFAULT: [{
	        id: 'policy',
	        content: 'footer.policies'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }]
	});

/***/ },

/***/ "./components/xo-ui-components/src/modal/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-ui-components/src/modal/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(0, _squid.$registerDirective)('xoModal', function () {
	    return {
	        template: _template2['default'],
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	
	        scope: {
	            show: '=?',
	            showCloseButton: '=?',
	            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
	        },
	
	        controller: function controller($scope) {
	            var $body = (0, _jquery2['default'])('body');
	            var keyupEvent = 'keyup.modal';
	
	            $scope.hideModal = function ($event) {
	                $event.preventDefault();
	                $scope.show = false;
	            };
	
	            $scope.$watch('show', function (showModal) {
	
	                if (showModal) {
	                    // move the focus to modal
	                    (0, _jquery2['default'])('.modalContent').focus();
	
	                    // when the esc key is pressed
	                    $body.on(keyupEvent, function ($event) {
	                        if ($event.which === 27) {
	                            $scope.$apply(function () {
	                                $scope.hideModal($event);
	                            });
	                            $body.off(keyupEvent);
	                        }
	                    });
	                } else {
	                    $body.off(keyupEvent);
	                }
	            });
	        }
	    };
	});
	
	_squid.$registerDirective;

/***/ },

/***/ "./components/xo-ui-components/src/modal/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-wrapper\" ng-show='show'>\n\t<div class=\"modal-overlay\" ng-click='hideModal()'></div>\n\t<div class=\"modal-dialog\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\">\n            <a href=\"#\" ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\">&nbsp;</a>\n            <div ng-transclude>\n            </div>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html":
/***/ function(module, exports) {

	module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" role=\"contentinfo\" ng-class=\"{APAC: isApac()}\">\n        <p id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a href=\"{{cancel}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n                {{ merchant ? content('base.cancelUrl', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant') }}\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\">\n                <li class=\"first\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\" ng-repeat=\"link in footerLinks()\"\n                    id=\"footer_{{link.id}}\"></li>\n                <li class=\"feedback last\">\n                    <a ng-if=\"showFeedback()\" href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('OpinionLab.SiteFeedback')\n                        }}</a>\n                </li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options ng-if=\"languageSwitch\"></xo-language-options>\n            <span ng-if=\"showEscapeHatch\" class=\"escape-hatch-incontext\">{{content('footer.escHatch')}}</span>\n            <xo-escape-hatch ng-hide=\"!showEscapeHatch\"></xo-escape-hatch>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal>\n        <p>{{ content('footer.openLinks') }}</p>\n        <p class=\"popLink\">{{popupUrl}}</p>\n        <input class=\"btn btn-submit full\" type=\"button\" ng-click=\"hideModal()\" value=\"{{ content('footer.okBtn') }}\">\n    </xo-modal>\n</footer>\n"

/***/ },

/***/ "./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            controller: function controller($scope, $rootScope, $window, $util, $logger) {
	                $scope.isIFrame = $util.isIFrame();
	                $scope.closeFrame = function (event) {
	                    var url = $window.location.href && $window.location.href.split('#')[0] || '';
	
	                    if (url.indexOf('proxflow') > -1) {
	                        url = url.replace('proxflow', 'webapps/helios');
	                    }
	
	                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';
	
	                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
	                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
	                    } else {
	                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
	                    }
	
	                    $window.top.location = url;
	                    $scope.$emit('exitFrame');
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ function(module, exports) {

	module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ },

/***/ "./components/xo-form-components/src/language-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	    squid.module('xo-language-options.directive', ['squid', 'xo-accessibility.directive']).directive('xoLanguageOptions', function () {
	        return {
	            template: template,
	
	            scope: {},
	
	            controller: function controller($scope, $populate, $locale, $Class, $config) {
	                $scope.showLanguages = false;
	                setLanguageVars();
	
	                function setLanguageVars() {
	                    $scope.localeModel = $locale;
	                    $scope.currentLanguage = $scope.localeModel.lang;
	                    $scope.currentCountry = $scope.localeModel.country;
	                    $scope.supportedLanguages = $config.supportedCountries[$scope.currentCountry];
	                    $scope.languageList = $scope.localeModel.metadata.languageLabel;
	                }
	
	                if ($scope.supportedLanguages && $scope.supportedLanguages.length > 1) {
	                    $scope.hasMultipleLanguages = true;
	                }
	
	                $scope.selectLanguage = function (language) {
	                    $scope.currentLanguage = language;
	                    $locale.chooseLang(language);
	                };
	
	                $scope.toggle = function ($event) {
	                    if ($event) {
	                        $event.preventDefault();
	                    }
	
	                    $scope.showLanguages = !$scope.showLanguages;
	                };
	
	                // Reset locale properties for languageToggle
	                $scope.$on('localeChange', function () {
	                    setLanguageVars();
	                });
	
	                // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
	                $scope.$on('clickBody', function ($event, target) {
	                    if ($(target).parents('.languageToggleDisplay div').length === 0) {
	                        $scope.showLanguages = false;
	                        $scope.$apply();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"bottom\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages\" lang=\"{{ lang }}\">\n                    <a class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ },

/***/ "./components/xo-models/src/user/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.user', ['squid']).factory('$CheckoutClientDataModel', function ($Model, $Api) {
	
	        return $Model.extend('CheckoutClientDataModel', {
	
	            api: new $Api({
	                uri: '/api/user/:id/clientData'
	            }),
	
	            merchantIdentityData: function merchantIdentityData() {
	                return {
	                    email: this.email,
	                    brand_name: this.display_name,
	                    logo_uri: this.logo_uri,
	                    identity_uri: this.identity_uri
	                };
	            },
	
	            validateClient: function validateClient() {
	                if (this.partner_id && this.identity_uri) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_client'
	                    };
	                }
	            },
	            validateRedirectUri: function validateRedirectUri(redirectUrl) {
	                if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_redirect_url'
	                    };
	                }
	            }
	        });
	    }).factory('$CheckoutInputDataModel', function ($Model, $Api, $config, $util) {
	
	        var ACTION = {
	            login: 'login',
	            resolve: 'resolve',
	            addCard: 'addCard',
	            addBank: 'addBank',
	            changeCurrencyConv: 'changeCurrencyConv',
	            signup: 'signup',
	            mandate: 'mandate',
	            addCredit: 'addCredit',
	            ulReturn: 'ulReturn',
	            creditReturn: 'creditReturn'
	        };
	
	        return $Model.extend('CheckoutInputDataModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.setProperties({
	                    client_id: $util.param('client_id'),
	                    action: $util.param('action'),
	                    redirect_uri: $util.param('redirect_uri'),
	                    scope: $util.param('scope'),
	                    state: $util.param('state'),
	                    flow: $util.param('flow'),
	                    payer_id: $util.param('payer_id'),
	                    mandate_reference_number: $util.param('mandate_reference_number'),
	                    funding_option_id: $util.param('funding_option_id'),
	                    locale: $util.param('locale'),
	                    logout: $util.param('logout'),
	                    refresh_parent: $util.param('refresh_parent'),
	                    escape_hatch: $util.param('escape_hatch'),
	                    failedBecause: $util.param('failedBecause'),
	                    redirectReferrer: $util.param('redirectReferrer'),
	                    id_token: $util.param('prox_id'),
	                    nonce: $util.param('nonce'),
	                    hide_rm: $util.param('hideRM'),
	                    payloadEnc: $util.param('payloadEnc'),
	                    xcancel: $util.param('x-cancel'),
	                    xsuccess: $util.param('x-success')
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/user/:id/payerId'
	            }),
	
	            isEbayTxn: function isEbayTxn() {
	                return Boolean(this.client_id);
	            },
	
	            validAction: function validAction() {
	                var actions = {
	                    login: 'login',
	                    resolve: 'resolve',
	                    addCard: 'addCard',
	                    addBank: 'addBank',
	                    changeCurrencyConv: 'changeCurrencyConv',
	                    signup: 'signup',
	                    mandate: 'mandate',
	                    addCredit: 'addCredit',
	                    ulReturn: 'ulReturn',
	                    creditReturn: 'creditReturn'
	                };
	
	                return actions.hasOwnProperty(this.action);
	            },
	
	            showRYP: function showRYP() {
	                return !this.isEbayTxn();
	            },
	
	            requiresOAuth: function requiresOAuth() {
	                return this.action === ACTION.login || this.action === ACTION.signup;
	            },
	
	            requiresRedirectUri: function requiresRedirectUri() {
	                return this.action === ACTION.mandate || !this.requiresOAuth();
	            },
	
	            validRedirectUri: function validRedirectUri() {
	                if (this.requiresRedirectUri()) {
	                    return Boolean(this.redirect_uri);
	                }
	                return true;
	            },
	
	            validate: function validate() {
	                var error;
	                var success = true;
	
	                if (this.isEbayTxn()) {
	                    if (!this.validAction()) {
	                        success = false;
	                        error = 'invalid_action';
	                    } else if (!this.validRedirectUri()) {
	                        success = false;
	                        error = 'invalid_redirect_uri';
	                    }
	                }
	
	                return {
	                    success: success,
	                    error: error
	                };
	            },
	
	            errorUrl: function errorUrl(err, errorDesc) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                if (err) {
	                    url += '&error=' + err;
	                }
	                if (errorDesc) {
	                    url += '&error_description=' + errorDesc;
	                }
	
	                return url;
	            },
	
	            successUrl: function successUrl(code) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                url += '&code=' + code;
	
	                return url;
	            },
	
	            rmEnabled: function rmEnabled(featureEnabled) {
	                return featureEnabled && this.action === ACTION.login;
	            },
	
	            hideRM: function hideRM() {
	                return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
	            }
	        });
	    }).factory('$UserInfoModel', function ($Model, $Api) {
	        return $Model.extend('UserInfoModel', {
	            api: new $Api({
	                uri: '/api/user/:id/session'
	            })
	        });
	    }).factory('$ValidatePhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('validatePhoneModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/validatePhone',
	                cache: false
	            })
	        });
	    }).factory('$AddKYCModel', function ($Model, $Api) {
	        return $Model.extend('AddKYCModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/addKYC'
	            })
	        });
	    }).factory('$PatchPhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('patchPhoneModel', {
	            api: new $Api({
	                uri: '/api/checkout/:token/session/patch',
	                cache: false
	            })
	        });
	    }).factory('$WaxUserModel', function ($Model, $Api) {
	        return $Model.extend('WaxUserModel', {
	            api: new $Api({
	                uri: '/api/user/:id/waxUser'
	            })
	        });
	    }).factory('$EConsentModel', function ($Model, $Api) {
	        return $Model.extend('EConsentModel', {
	            api: new $Api({
	                uri: '/api/user/eConsent'
	            })
	        });
	    }).factory('$UserPhotoModel', function ($Model, $Api, $config) {
	        return $Model.extend('UserPhotoModel', {
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: 'api/user/photo'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/user", "components/xo-models/src/user/index.js"))

/***/ },

/***/ "./components/xo-models/src/openButton/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.openbutton', ['squid']).factory('$OpenButtonModel', function ($Model, $Api) {
	        return $Model.extend('$OpenButtonModel', {
	            api: new $Api({
	                uri: '/api/openbutton',
	                postAttempts: 2,
	                cache: true
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/openButton", "components/xo-models/src/openButton/index.js"))

/***/ },

/***/ "./pages/xo-shopping-cart/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ShoppingCartRoute = undefined;
	
	__webpack_require__("./pages/xo-shopping-cart/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $ShoppingCartRoute = exports.$ShoppingCartRoute = _squid.$ComponentRoute.extend('$ShoppingCartRoute', {
	
	    path: 'shoppingCart',
	
	    directive: 'xo-shopping-cart-page',
	
	    query: ['noUpdateRequired'],
	
	    // TODO: need to find these values
	    trackingData: {
	        fptiState: 'shoppingCart',
	        templateName: 'shoppingCart.dust',
	        pageGoal: 'shoppingCart page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-shoppingCart',
	                'pagename2': '%::fullpage-shoppingCart:wps:shoppingcart:',
	                'version': 'member:%:'
	            }
	        },
	        trackStateExit: true
	    },
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$ShoppingCartRoute", $ShoppingCartRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-shopping-cart/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	__webpack_require__("./pages/xo-shopping-cart/lib/ui.js");
	
	var _template = __webpack_require__("./pages/xo-shopping-cart/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/shoppingcart/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/ppcartMapper/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/cartButtonParams/index.js");
	
	var _index4 = __webpack_require__("./components/xo-models/src/inventory/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _cartUtil = __webpack_require__("./pages/xo-shopping-cart/cartUtil.js");
	
	var _cartUtil2 = _interopRequireDefault(_cartUtil);
	
	var _cartUiUtil = __webpack_require__("./pages/xo-shopping-cart/cartUiUtil.js");
	
	var _cartUiUtil2 = _interopRequireDefault(_cartUiUtil);
	
	var _customUtil = __webpack_require__("./js/lib/customUtil.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var sCart = void 0,
	    buttonParams = void 0,
	    cartItems = void 0,
	    cartRequest = void 0,
	    checkoutCartDetails = void 0,
	    soldoutItems = void 0,
	    additionalCharges = void 0,
	    checkoutXclickParam = void 0;
	var setAdditionalParameters = void 0,
	    getShoppingCart = void 0,
	    callUpdateCart = void 0,
	    callDeleteCart = void 0,
	    initiateUpdateQuantity = void 0,
	    itemsToUpdate = void 0,
	    fallback = void 0,
	    prepareCheckout = void 0;
	var memberXOButtonScript = void 0,
	    guestXOButtonScript = void 0;
	
	exports['default'] = _squid.$Component.extend('$xoShoppingCart', {
	    tag: 'xo-shopping-cart-page',
	    template: _template2['default'],
	
	    resolve: {
	        models: function models() {
	            var _this = this;
	
	            if (this.stateChanged) {
	                return;
	            }
	
	            // TODO: replace this hard coded token with the mayfly Id that will be coming in the url
	            var shoppingCartModel = _index.$ShoppingCartModel.instance(_squid.$meta.correlationId);
	            var buttonParamsModel = _index3.$CartButtonParamsModel.instance();
	            var noUpdateRequired = _uiRouter.$state.params.noUpdateRequired;
	
	            var viewCart = buttonParams.viewCart;
	            var buttonDetails = {};
	            if (buttonParams) {
	                if (buttonParams.buttonItem && buttonParams.buttonItem.items[0] && buttonParams.buttonItem.items[0].customized_info) {
	                    buttonDetails.hosted_button_id = buttonParams.buttonItem.items[0].customized_info.hosted_button_id;
	                }
	                _logger.$logger.info('merchant_id', {
	                    merchant_id: buttonParams.merchantId
	                });
	            }
	            buttonDetails['button_type'] = viewCart ? 'view_cart' : 'add_to_cart';
	            _logger.$logger.info('button_details', buttonDetails);
	            setAdditionalParameters = function setAdditionalParameters(shoppingCart) {
	                sCart = $.extend(true, {}, shoppingCart);
	                if (shoppingCart) {
	                    _this.itemsInCart = $.extend(true, [], shoppingCart.items);
	                    cartItems = $.extend(true, [], shoppingCart.items);
	                    if (shoppingCart.items && shoppingCart.items[0]) {
	                        _this.currencyCode = shoppingCart.items && shoppingCart.items[0].currency;
	                    }
	                }
	                _this.continueShoppingUrl = shoppingCart && shoppingCart.urls && shoppingCart.urls.shopping_url || _this.previousPageUrl;
	                var additionalChargesRes = _cartUtil2['default'].validateAndGetAdditionalCharges(sCart);
	                if (additionalChargesRes && additionalChargesRes.cartValid) {
	                    additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
	                    _this.additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
	                } else {
	                    _logger.$logger.info('cart_invalid', additionalChargesRes);
	                    _this.stateChanged = true;
	                    return _uiRouter.$state.go('checkout.genericError');
	                }
	                _logger.$logger.info('additional_parameters', {
	                    continue_shopping_url: _this.continueShoppingUrl,
	                    additional_charges: additionalCharges
	                });
	                if (cartItems) {
	                    var itemsDetails = cartItems.map(function (item) {
	                        return {
	                            sku: item.sku,
	                            name: item.name
	                        };
	                    });
	                    _logger.$logger.info('items_details', itemsDetails);
	                }
	            };
	
	            var createShoppingCart = function createShoppingCart(itemFromButton, payeeEmail, visitorId) {
	                if (!itemFromButton.total_weight && itemFromButton.items && itemFromButton.items[0] && itemFromButton.items[0].weight) {
	                    itemFromButton.total_weight = {
	                        'value': '',
	                        'unit': itemFromButton.items[0].weight.unit
	                    };
	                }
	                return shoppingCartModel.action('createShoppingCart', {
	                    data: {
	                        request: itemFromButton
	                    },
	                    success: function success(result) {
	                        setAdditionalParameters(result);
	                    },
	                    contingencies: {
	                        DUPLICATE_REQUEST: function DUPLICATE_REQUEST(err) {
	                            _logger.$logger.info('DUPLICATE_REQUEST_error', err);
	                            _this.duplicateRequest = true;
	                            _this.payeeEmail = payeeEmail;
	                            _this.visitorId = visitorId;
	                        }
	                    }
	                });
	            };
	
	            getShoppingCart = function getShoppingCart() {
	                shoppingCartModel.invalidate();
	                return shoppingCartModel.retrieve({
	                    params: {
	                        payee_email: _this.payeeEmail,
	                        visitor_id: _this.visitorId
	                    },
	                    success: function success(response) {
	                        sCart = $.extend(true, {}, response);
	                        _this.itemsInCart = $.extend(true, [], response.items);
	                        cartItems = $.extend(true, [], response.items);
	                        _this.currencyCode = response.items && response.items[0] && response.items[0].currency;
	                        _this.continueShoppingUrl = response.urls && response.urls.shopping_url || _this.previousPageUrl;
	                        setAdditionalParameters(response);
	                    }
	                });
	            };
	
	            callUpdateCart = function callUpdateCart(shoppingCart) {
	                if (!_this.quantityChanged) {
	                    _angular.$timeout.cancel(_this.timer);
	                    return;
	                } else {
	                    _this.quantityChanged = false;
	                }
	                var itemFromButton = buttonParams.buttonItem;
	                if (itemFromButton && !itemFromButton.total_weight && !shoppingCart.total_weight && itemFromButton.items && itemFromButton.items[0] && itemFromButton.items[0].weight) {
	                    if (shoppingCart.items && shoppingCart.items[0] && shoppingCart.items[0].weight) {
	                        shoppingCart.total_weight = {
	                            'value': '',
	                            'unit': shoppingCart.items[0].weight.unit
	                        };
	                    } else {
	                        shoppingCart.total_weight = {
	                            'value': '',
	                            'unit': 'lbs'
	                        };
	                    }
	                }
	                return shoppingCartModel.action('updateShoppingcart', {
	                    data: {
	                        id: shoppingCart.id,
	                        request: shoppingCart
	                    },
	                    success: function success(result) {
	                        _angular.$timeout.cancel(_this.timer);
	                        setAdditionalParameters(result);
	                    }
	                });
	            };
	
	            callDeleteCart = function callDeleteCart(shoppingCart) {
	                return shoppingCartModel.action('deleteShoppingcart', {
	                    data: {
	                        id: shoppingCart.id
	                    }
	                });
	            };
	
	            return buttonParamsModel.retrieve({
	                params: {
	                    raw_params: _squid.$meta.xclickParams
	                },
	                success: function success(resp) {
	                    var payeeEmail = void 0,
	                        visitorId = void 0,
	                        shoppingUrl = void 0;
	                    _underscore2['default'].forEach(resp, function (param) {
	                        if (typeof param === 'string') {
	                            var key = param.split('=')[0];
	                            var value = param.split('=')[1];
	                            if (key === 'merchant_email') {
	                                payeeEmail = value;
	                            } else if (key === 'visitor_id') {
	                                visitorId = value;
	                            }
	                        }
	                    });
	                    shoppingUrl = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams)['shopping_url'];
	                    shoppingCartModel.invalidate();
	                    return _angular.$q.all([shoppingCartModel.retrieve({
	                        params: {
	                            payee_email: payeeEmail,
	                            visitor_id: visitorId
	                        },
	                        success: function success(response) {
	                            if (response.resourceNotFound) {
	                                if (viewCart) {
	                                    _logger.$logger.info('cart_empty');
	                                    _this.stateChanged = true;
	                                    _this.continueShoppingUrl = shoppingUrl || _this.previousPageUrl;
	                                    _angular.$rootScope.continueShoppingUrl = _this.continueShoppingUrl;
	                                    return _uiRouter.$state.go('checkout.emptyCart');
	                                } else {
	                                    _logger.$logger.info('cart_empty_create_cart');
	                                    return createShoppingCart(buttonParams.buttonItem, payeeEmail, visitorId);
	                                }
	                            } else {
	                                sCart = $.extend(true, {}, response);
	                                _this.itemsInCart = $.extend(true, [], response.items);
	                                cartItems = $.extend(true, [], response.items);
	                                _this.currencyCode = response.items && response.items[0] && response.items[0].currency;
	                                _this.continueShoppingUrl = response.urls && response.urls.shopping_url || _this.previousPageUrl;
	                                if (!viewCart && noUpdateRequired !== 'true') {
	                                    _logger.$logger.info('cart_exists_update_cart');
	                                    var shoppingcartToUpdate = _cartUtil2['default'].addItemToCart(buttonParams.buttonItem, response);
	                                    _this.quantityChanged = true;
	                                    return callUpdateCart(shoppingcartToUpdate);
	                                } else {
	                                    setAdditionalParameters(response);
	                                    _logger.$logger.info('cart_exists_show_cart');
	                                }
	                            }
	                        }
	                    })]).then(function () {
	                        if (_this.duplicateRequest) {
	                            return getShoppingCart();
	                        }
	                    });
	                }
	            });
	        }
	    },
	
	    actions: {
	        continueShopping: function continueShopping($event) {
	            if ($event) {
	                $event.preventDefault();
	            }
	
	            // TODO: add a util function to do this logic which is in multiple pages now
	            if (window.opener && window.opener !== null && !window.opener.closed) {
	                _logger.$logger.info('continue_shopping_target_not_self');
	                try {
	                    window.opener.location.href = this.continueShoppingUrl;
	                } catch (err) {
	                    _logger.$logger.info('window_opener_location_error', { err: err });
	                } finally {
	                    self.close();
	                }
	            } else {
	                _logger.$logger.info('continue_shopping_target_self');
	                _squid.$util.redirect(this.continueShoppingUrl);
	            }
	        },
	        increment: function increment(index) {
	            this.itemsInCart[index].quantity++;
	            cartItems[index].quantity = this.itemsInCart[index].quantity;
	            this.quantityChanged = true;
	            initiateUpdateQuantity();
	        },
	        decrement: function decrement(index) {
	            if (this.itemsInCart[index].quantity > 0) {
	                this.itemsInCart[index].quantity--;
	                cartItems[index].quantity = this.itemsInCart[index].quantity;
	                this.quantityChanged = true;
	                initiateUpdateQuantity();
	            }
	        },
	        remove: function remove(index) {
	            var _this2 = this;
	
	            this.itemsInCart[index].removed = true;
	            cartItems[index].removed = true;
	            if (this.currentExpandedDetails === index) {
	                this.currentExpandedDetails = undefined;
	            }
	            var cart = $.extend(true, {}, sCart);
	            _cartUiUtil2['default'].setOrderSummaryColor();
	            cart.items = itemsToUpdate();
	            if (cart.items.length === 0) {
	                _logger.$logger.info('all_items_removed');
	                this.quantityChanged = false;
	                _angular.$q.all([callDeleteCart(cart)]).then(function () {
	                    _this2.stateChanged = true;
	                    _angular.$rootScope.continueShoppingUrl = _this2.continueShoppingUrl;
	                    return _uiRouter.$state.go('checkout.emptyCart');
	                });
	            } else {
	                this.quantityChanged = true;
	                (0, _angular.$timeout)(function () {
	                    _angular.$q.all([callUpdateCart(cart)]).then(function () {
	                        return;
	                    });
	                }, 500);
	            }
	        },
	        keyUp: function keyUp(event, index) {
	            event = event || window.event;
	            if (event) {
	                // 38 : up arrow, 40: down arrow
	                if (event.keyCode === 38) {
	                    this.actions.increment(index);
	                } else if (event.keyCode === 40) {
	                    this.actions.decrement(index);
	                }
	            }
	        },
	        checkValidity: function checkValidity(index, oldValue) {
	            // allow user to enter only a positive integer
	            if (!/^\d*$/.test(this.itemsInCart[index].quantity)) {
	                cartItems[index].quantity = this.itemsInCart[index].quantity = oldValue;
	            } else if (this.itemsInCart[index].quantity !== '') {
	                this.quantityChanged = true;
	            } else {
	                this.quantityChanged = false;
	            }
	        },
	        showMore: function showMore(index) {
	            var _this3 = this;
	
	            var delay = 0;
	
	            if (this.currentExpandedDetails !== index) {
	                if (this.currentExpandedDetails !== undefined) {
	                    delay = 500;
	                    this.actions.showLess(this.currentExpandedDetails);
	                }
	            }
	
	            (0, _angular.$timeout)(function () {
	                if (_this3.itemsInCart[index]) {
	                    _this3.itemsInCart[index].showDetails = true;
	                    _this3.itemsInCart[index].showExtraText = true;
	                } else {
	                    _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: _this3.itemsInCart && _this3.itemsInCart.length });
	                }
	                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
	                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
	                if (angular.element('#item' + index + 'name').hasClass('nowrap')) {
	                    angular.element('#item' + index + 'name').removeClass('nowrap');
	                }
	                if (angular.element('#item' + index + 'number').hasClass('nowrap')) {
	                    angular.element('#item' + index + 'number').removeClass('nowrap');
	                }
	                if (angular.element('#item' + index + 'number').hasClass('hide')) {
	                    angular.element('#item' + index + 'number').removeClass('hide');
	                }
	
	                _this3.currentExpandedDetails = index;
	            }, delay);
	        },
	        showLess: function showLess(index) {
	            if (this.itemsInCart[index]) {
	                this.itemsInCart[index].showDetails = false;
	                this.itemsInCart[index].showExtraText = false;
	            } else {
	                _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: this.itemsInCart && this.itemsInCart.length });
	            }
	            angular.element('#item' + index + 'name').addClass('ellipsisEffect');
	            angular.element('#item' + index + 'number').addClass('ellipsisEffect');
	            if (this.itemsInCart[index].itemNameLong) {
	                angular.element('#item' + index + 'number').addClass('hide');
	            }
	            (0, _angular.$timeout)(function () {
	                angular.element('#item' + index + 'name').addClass('nowrap');
	                angular.element('#item' + index + 'number').addClass('nowrap');
	            }, 500); // same time duration specified in max-height transition
	            this.currentExpandedDetails = undefined;
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this4 = this;
	
	            var loadJsButton = function loadJsButton(checkoutType, localeInfo) {
	                var script = document.createElement('script');
	                script.type = 'text/javascript';
	                script.async = true;
	                script.setAttribute('data-merchant', 'PP_ADD_TO_CART');
	                script.setAttribute('data-button', 'checkout');
	                script.setAttribute('data-type', 'button');
	                script.setAttribute('data-size', 'medium');
	                script.setAttribute('data-lc', localeInfo);
	                script.setAttribute('data-shape', 'pill');
	                if (checkoutType === 'member') {
	                    script.setAttribute('data-color', 'gold');
	                } else {
	                    script.setAttribute('data-color', 'silver');
	                    script.setAttribute('data-label', _squid.$locale.content.get('shoppingCart.checkoutOut'));
	                    script.setAttribute('data-tagline', 'false');
	                }
	                script.src = 'https://www.paypalobjects.com/api/button.js';
	                return script;
	            };
	
	            angular.element('.merchantHeader').css('display', 'none');
	            var localeInfo = _squid.$locale.lang + '_' + _squid.$locale.country;
	            _logger.$logger.info('localeInfo', { country: _squid.$locale.country, lang: _squid.$locale.lang });
	
	            memberXOButtonScript = loadJsButton('member', localeInfo);
	            guestXOButtonScript = loadJsButton('guest', localeInfo);
	
	            buttonParams = _cartUtil2['default'].getButtonParams(_squid.$meta.xclickParams);
	            this.previousPageUrl = document.referrer;
	
	            this.getCartItemsTotal = function () {
	                return _cartUtil2['default'].getCartItemsTotal(_this4.itemsInCart);
	            };
	
	            this.getNetTotal = function () {
	                var sum = _this4.getCartItemsTotal() || 0;
	                _underscore2['default'].forEach(_this4.additionalCharges, function (detail) {
	                    if (detail.name === 'discount') {
	                        sum -= detail.value;
	                    } else {
	                        sum += detail.value;
	                    }
	                });
	                return sum;
	            };
	
	            this.toggleArrowDirection = function () {
	                _this4.expandSummary = !_this4.expandSummary;
	                if (_this4.expandSummary) {
	                    _this4.orderSummaryMaxHeight = $('.details-expand').prop('scrollHeight');
	                }
	                (0, _angular.$timeout)(function () {
	                    _cartUiUtil2['default'].setOrderSummaryColor();
	                }, 500);
	            };
	
	            this.getEachItemMaxHeight = function (index) {
	                return _cartUiUtil2['default'].getEachItemMaxHeight(_this4.itemsInCart, index);
	            };
	
	            this.getItemsMaxHeight = function (index) {
	                return _cartUiUtil2['default'].getItemsMaxHeight(_this4.itemsInCart, index, _this4.scrolledToEnd);
	            };
	
	            this.getDetailsMaxHeight = function (index) {
	                return _cartUiUtil2['default'].getDetailsMaxHeight(index);
	            };
	
	            this.getItemNameMaxHeight = function (index) {
	                return _cartUiUtil2['default'].getItemNameMaxHeight(index);
	            };
	
	            this.tooLong = function (index, field) {
	                if (field === 'name') {
	                    _this4.itemsInCart[index].itemNameLong = true;
	                } else if (field === 'number') {
	                    _this4.itemsInCart[index].itemNumberLong = true;
	                }
	            };
	
	            this.getContainerColWidth = function () {
	                return _cartUiUtil2['default'].getContainerColWidth();
	            };
	        },
	        populate: function populate() {
	            var _this5 = this;
	
	            if (this.stateChanged) {
	                return;
	            }
	            $('#wrapper').addClass('cartBody');
	            this.$on('$destroy', function () {
	                $('#wrapper').removeClass('cartBody');
	            });
	            var memberCheckoutElement = document.getElementById('memberCheckout');
	            var guestCheckoutElement = document.getElementById('guestCheckout');
	            if (memberCheckoutElement) {
	                memberCheckoutElement.appendChild(memberXOButtonScript);
	            }
	            if (guestCheckoutElement) {
	                guestCheckoutElement.appendChild(guestXOButtonScript);
	            }
	
	            var buttonItemDetails = buttonParams && buttonParams.buttonItem;
	            var merchantDetails = _cartUtil2['default'].getMerchantDetails(sCart, buttonItemDetails);
	            _angular.$rootScope.$broadcast('merchantDetails', merchantDetails);
	
	            _cartUiUtil2['default'].initWindowScrollActions();
	            this.areAllItemsVisible = _cartUiUtil2['default'].areAllItemsVisible();
	            _cartUiUtil2['default'].setOrderSummaryColor();
	            this.expandSummary = this.itemsInCart && this.itemsInCart.length < 4;
	            if (this.itemsInCart && this.itemsInCart.length >= 4 && !this.areAllItemsVisible) {
	                $('#orderSummary').css('transform', 'translateY(' + Number($('.footer').prop('scrollHeight') + 1) + 'px)');
	            }
	
	            var itemsElement = document.getElementById('items');
	            var scrollTopLimit = 999999;
	            var scrolled = function scrolled() {
	                if (_this5.itemsInCart && _this5.itemsInCart.length < 4) {
	                    return;
	                }
	                // visible height + pixel scrolled = total height
	                if (itemsElement.offsetHeight + itemsElement.scrollTop === itemsElement.scrollHeight) {
	                    scrollTopLimit = itemsElement.scrollTop;
	                    _this5.scrolledToEnd = true;
	                    $('#orderSummary').removeClass('pushDown');
	                    $('#orderSummary').css('transform', 'translateY(0)');
	                    _this5.getItemsMaxHeight();
	                } else if (itemsElement.scrollTop <= scrollTopLimit) {
	                    _this5.scrolledToEnd = false;
	                    $('#orderSummary').addClass('pushDown');
	                    $('#orderSummary').css('transform', 'translateY(' + Number($('.footer').prop('scrollHeight') + 1) + 'px)');
	                    _this5.getItemsMaxHeight();
	                }
	            };
	            if (itemsElement) {
	                itemsElement.onscroll = scrolled;
	            }
	            if (this.itemsInCart && this.itemsInCart.length < 4) {
	                this.scrolledToEnd = true;
	            }
	            initiateUpdateQuantity = function initiateUpdateQuantity() {
	                if (_this5.timer) {
	                    _angular.$timeout.cancel(_this5.timer);
	                }
	                _this5.timer = (0, _angular.$timeout)(function () {
	                    var cart = $.extend(true, {}, sCart);
	                    cart.items = itemsToUpdate();
	                    callUpdateCart(cart);
	                }, 1000);
	            };
	
	            this.initiateUpdateQuantity = function (index) {
	                cartItems[index].quantity = _this5.itemsInCart[index].quantity;
	                initiateUpdateQuantity();
	            };
	
	            itemsToUpdate = function itemsToUpdate() {
	                var items = [];
	                _underscore2['default'].forEach(cartItems, function (item) {
	                    if (!item.removed) {
	                        if (item.quantity === '') {
	                            item.quantity = 1;
	                        }
	                        items.push(item);
	                    }
	                });
	                return items;
	            };
	
	            var insertXclickParamsInMayfly = function insertXclickParamsInMayfly() {
	                checkoutXclickParam = _cartUtil2['default'].getParamsForCheckout(_squid.$meta.xclickParams);
	                return _index.$ShoppingCartModel.instance(_squid.$meta.correlationId).action('insertMayflyData', {
	                    data: checkoutXclickParam,
	                    success: function success(result) {
	                        return result && result.mayflyId;
	                    },
	                    error: function error(err) {
	                        _logger.$logger.info('Insert_MayFly_Error', err.name);
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(errorName) {
	                            _logger.$logger.info('Insert_MayFly_Error', errorName);
	                        }
	                    }
	                });
	            };
	
	            var createSymphonyCartRequest = function createSymphonyCartRequest() {
	                _cartUtil2['default'].removeHashKey(sCart);
	                return _index2.$PPCartMapperModel.instance().action('getCartRequest', {
	                    data: {
	                        request: sCart,
	                        flowLoggingId: _squid.$util.param('flowlogging_id')
	                    },
	                    success: function success(result) {
	                        cartRequest = result;
	                    },
	                    error: function error(err) {
	                        _logger.$logger.info('error', err.name);
	                        return fallback('wps', 'shoppingcart_checkout_fallback');
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(errorName) {
	                            _logger.$logger.info('ppcart_mapper_get_cart_request_error', errorName);
	                            return fallback('wps', 'shoppingcart_checkout_fallback');
	                        }
	                    }
	                });
	            };
	
	            var createSymphonyCart = function createSymphonyCart() {
	                var cart = cartRequest;
	
	                return _index2.$PPCartMapperModel.instance().action('createCart', {
	                    data: {
	                        request: cart,
	                        flowLoggingId: _squid.$util.param('flowlogging_id')
	                    },
	                    success: function success(result) {
	                        checkoutCartDetails = result;
	                        _logger.$logger.info('checkoutCartId', checkoutCartDetails.cartId);
	                    },
	                    error: function error(err) {
	                        _logger.$logger.info('error', err.name);
	                        return fallback('wps', 'shoppingcart_checkout_fallback');
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(errorName) {
	                            _logger.$logger.info('ppcart_mapper_create_cart_error', errorName);
	                            return fallback('wps', 'shoppingcart_checkout_fallback');
	                        }
	                    }
	                });
	            };
	
	            var checkInventory = function checkInventory() {
	                var shoppingCart = cartRequest && cartRequest.cart;
	                var purchaseUnit = shoppingCart && shoppingCart.purchase_units && shoppingCart.purchase_units[0];
	                var items = purchaseUnit && purchaseUnit.item_list && purchaseUnit.item_list.items;
	                var inventoryModel = _index4.$InventoryModel.instance(_squid.$meta.correlationId);
	                return inventoryModel.action('getInventory', {
	                    data: {
	                        items: items,
	                        merchantId: buttonParams.merchantId
	                    },
	                    success: function success(result) {
	                        soldoutItems = undefined;
	                        var isInventory = result.isInventory ? 1 : 0;
	                        _logger.$logger.info('checkout_fpti', {
	                            'from': 'shoppingCart',
	                            'to': 'check_inventory',
	                            'is_inventory_enabled': isInventory
	                        });
	                        if (result.soldoutItems && result.soldoutItems.length > 0) {
	                            soldoutItems = result.soldoutItems;
	                            _angular.$rootScope.soldoutUrl = result.soldoutUrl;
	                        }
	                    },
	                    error: function error(err) {
	                        _logger.$logger.info('error', err.name);
	                        _logger.$logger.info('checkout_fpti', {
	                            'from': 'shoppingCart',
	                            'to': 'process_cart_creation',
	                            'int_error_description': 'invetory_error',
	                            'reason': 'CART_CREATION_FAILURE'
	                        });
	                        return fallback('wps', 'shoppingcart_checkout_fallback');
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name, err) {
	                            _logger.$logger.info('error', err.name);
	                            _logger.$logger.info('checkout_fpti', {
	                                'from': 'shoppingCart',
	                                'to': 'process_cart_creation',
	                                'int_error_description': 'invetory_error',
	                                'reason': 'CART_CREATION_FAILURE'
	                            });
	                            return fallback('wps', 'shoppingcart_checkout_fallback');
	                        }
	                    }
	                });
	            };
	
	            fallback = function fallback(product, reason) {
	                throw new _squid.$FallbackError({
	                    product: product || 'wps',
	                    reason: reason
	                });
	            };
	
	            prepareCheckout = function prepareCheckout(flow) {
	
	                var redirectUrl = void 0;
	                if (flow === 'member') {
	                    _logger.$logger.info('checkout_type_member');
	                    redirectUrl = _squid.$config.urls.hermesUrl;
	                } else {
	                    if (!_squid.$config.guestCheckoutEnabled) {
	                        _logger.$logger.info('checkout_fpti', {
	                            'from': 'shoppingCart',
	                            'to': 'prepare_guest_checkout',
	                            'int_error_description': 'guest_checkout_disabled',
	                            'reason': 'GUEST_CHECKOUT_DISABLED'
	                        });
	                        return fallback('wps', 'shoppingcart_checkout_fallback');
	                    }
	                    _logger.$logger.info('checkout_type_guest');
	                    redirectUrl = _squid.$config.urls.xoonUrl;
	                }
	                var cart = $.extend(true, {}, sCart);
	                cart.items = _cartUtil2['default'].getItemsForCheckout(cartItems);
	                if (cart.items.length !== sCart.items.length) {
	                    _this5.quantityChanged = true;
	                }
	                if (cart.items.length === 0) {
	                    _logger.$logger.info('cart_empty');
	                    return _angular.$q.all([callUpdateCart(cart)]).then(function () {
	                        _this5.stateChanged = true;
	                        _angular.$rootScope.continueShoppingUrl = _this5.continueShoppingUrl;
	                        return _uiRouter.$state.go('checkout.emptyCart');
	                    });
	                } else {
	                    return _angular.$q.all([callUpdateCart(cart)]).then(function () {
	                        return createSymphonyCartRequest();
	                    }).then(function () {
	                        return checkInventory();
	                    }).then(function () {
	                        if (!soldoutItems) {
	                            return createSymphonyCart();
	                        }
	                        return _angular.$q.when();
	                    }).then(function () {
	                        if (!soldoutItems) {
	                            return insertXclickParamsInMayfly();
	                        }
	                        return _angular.$q.when();
	                    }).then(function (mayflyId) {
	                        if (soldoutItems) {
	                            _logger.$logger.info('item(s)_sold_out');
	                            var itemsSoldout = void 0,
	                                count = void 0;
	                            if ((typeof soldoutItems === 'undefined' ? 'undefined' : _typeof(soldoutItems)) === 'object') {
	                                itemsSoldout = JSON.stringify(soldoutItems);
	                                count = _this5.itemsInCart.length === soldoutItems.length ? 'all' : 'many';
	                            } else {
	                                itemsSoldout = soldoutItems;
	                                count = 'one';
	                            }
	                            _this5.stateChanged = true;
	                            return _uiRouter.$state.go('checkout.soldout', {
	                                items: encodeURIComponent(itemsSoldout),
	                                count: encodeURIComponent(count)
	                            });
	                        } else {
	                            _logger.$logger.info('item(s)_available');
	                            redirectUrl += checkoutCartDetails.cartId;
	                            redirectUrl += '&xclick_params=' + ('' + checkoutXclickParam);
	                            if (checkoutCartDetails.rm) {
	                                redirectUrl += '&rm=' + ('' + checkoutCartDetails.rm);
	                            }
	                            if (mayflyId) {
	                                redirectUrl += '&mfid=' + ('' + mayflyId);
	                            }
	                            redirectUrl += '&country.x=' + ('' + _squid.$locale.country);
	                            redirectUrl += '&locale.x=' + (_squid.$locale.lang + '_' + _squid.$locale.country);
	                            _squid.$util.redirect(redirectUrl);
	                        }
	                    });
	                }
	            };
	
	            this.prepareCheckout = function (flow) {
	                prepareCheckout(flow);
	            };
	        },
	        exit: function exit() {
	            angular.element('.merchantHeader').css('display', 'inherit');
	            clearInterval(this.timer);
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_angular.$q;
	
	_angular.$rootScope;
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$locale;
	
	_squid.$FallbackError;
	
	_uiRouter.$state;
	
	_logger.$logger;
	
	_index.$ShoppingCartModel;
	
	_index2.$PPCartMapperModel;
	
	_index3.$CartButtonParamsModel;
	
	_index4.$InventoryModel;
	
	_customUtil.customUtil;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-shopping-cart/lib/ui.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	/* eslint angular/angularelement: 0 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	    return squid.module('xo-shopping-cart.ui', []).directive('onEllipsis', function ($timeout, $parse, $window) {
	        // if an element has an ellipsis text-overflow in effect (it must already have
	        // the appropriate css styling) then invoke the function that is passed to the directive
	        function getVisibleWidth(elem) {
	            // cross browser, returns decimals for ultra-precision
	            return elem.getBoundingClientRect().right - elem.getBoundingClientRect().left;
	        }
	
	        function getNaturalWidth(elem) {
	            var old = {
	                overflow: elem.style.overflow,
	                width: elem.style.width,
	                display: elem.style.display
	            };
	            var result;
	
	            elem.style.overflow = 'visible';
	            elem.style.width = 'auto';
	            elem.style.display = 'inline-block';
	            result = getVisibleWidth(elem);
	            elem.style.overflow = old.overflow;
	            elem.style.width = old.width;
	            elem.style.display = old.display;
	
	            return result;
	        }
	
	        function getStyle(elem, style) {
	            if ($window.getComputedStyle) {
	                return $window.getComputedStyle(elem)[style]; // modern browsers
	            }
	
	            return elem.currentStyle[style]; // IE
	        }
	
	        function hasEllipsis(elem) {
	            var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
	            var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
	            var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';
	
	            if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
	                return getVisibleWidth(elem) < getNaturalWidth(elem);
	            }
	
	            return false;
	        }
	
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                function invokeSubscriber() {
	                    $parse(attrs.onEllipsis)(scope);
	                    scope.$apply();
	                }
	
	                $timeout(function () {
	                    if (hasEllipsis(element[0])) {
	                        invokeSubscriber();
	                    }
	                });
	            }
	        };
	    }).directive('dynamicMaxheight', function ($timeout, $parse) {
	        // Makes an element examine the outerHeight of its siblings
	        // and the max-height of its parent, then sets a max-height for itself
	        // so that everything fits within the limits of the parent. Note that it assumes
	        // no other sibling also has dynamic-maxheight.
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                function resizeContainer() {
	                    var $element = $(element);
	                    var parentHeight = parseFloat($element.parent().css('max-height'));
	                    var siblings = $element.siblings().filter(function () {
	                        var pos = $(this).css('position');
	                        return pos !== 'fixed' && pos !== 'absolute';
	                    }).map(function getOuterHeights() {
	                        return $(this).outerHeight();
	                    });
	                    var siblingsHeight = 0;
	                    var i;
	
	                    for (i = 0; i < siblings.length; i += 1) {
	                        siblingsHeight += siblings[i];
	                    }
	
	                    var spaceAvailable = parentHeight - siblingsHeight;
	
	                    if (!isNaN(spaceAvailable)) {
	                        $element.css('max-height', spaceAvailable + 'px');
	                    }
	                }
	
	                // if an expression is provided, it is used as an event to listen for and recalculate the height
	                if (attrs.dynamicMaxheight) {
	                    scope.$on($parse(attrs.dynamicMaxheight)(scope), resizeContainer);
	                }
	
	                $timeout(resizeContainer);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-shopping-cart/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"shoppingCart\" content>\n    <div class=\"header\">\n        <p id=\"headerText\" aria-label=\"{{content('shoppingCart.shoppingCart')}}\">{{content('shoppingCart.shoppingCart')}}</p>\n        <a class=\"continueLink\" ng-click=\"actions.continueShopping($event)\">\n            <span>{{content('shoppingCart.continueShopping')}}</span>\n            <span class=\"frontArrow\"></span></a>\n    </div>\n    <div id=\"cartContents\">\n        <div id=\"items\" ng-style=\"{'max-height' : getItemsMaxHeight() + 'px'}\">\n            <div class=\"row rowHead\">\n                <div class=\"col description\">\n                    <h4>{{content('shoppingCart.description')}}</h4>\n                </div>\n                <div class=\"col price wrapword\">\n                    <h4>{{content('shoppingCart.price')}}</h4>\n                </div>\n                <div class=\"col quantity alignCenter\">\n                    <h4>{{content('shoppingCart.quantity')}}</h4>\n                </div>\n                <div class=\"col itemTotalCost alignDirection wrapword\">\n                    <h4>{{content('header.total')}}</h4>\n                </div>\n            </div>\n            <div class=\"showItem\" ng-repeat=\"item in itemsInCart\" id=\"{{ 'item' + $index}}\" ng-class=\"{ 'hideItem': item.removed}\" ng-style=\"!item.removed && {'max-height': getEachItemMaxHeight($index) + 'px'}\">\n                <div class=\"row\">\n                    <div class=\"col description\" id=\"itemProperties\">\n                        <div id=\"{{ 'item' + $index + 'name'}}\" class=\"nameOfItem ellipsisEffect nowrap\" on-ellipsis=\"tooLong($index, 'name')\" ng-style=\"{width: getContainerColWidth() + 'px'}\">{{item.name | limitTo:127}}</div>\n                        <div id=\"{{ 'item' + $index + 'number'}}\" ng-if=\"item.sku\" class=\"itemNumber ellipsisEffect nowrap\" ng-class=\"{'hide': item.itemNameLong}\" on-ellipsis=\"tooLong($index, 'number')\" ng-style=\"{width: getContainerColWidth() + 'px'}\">{{content('header.itemNumber')}} {{item.sku | limitTo:127}}</div>\n                        <a class=\"moreLessDetails\" select-button ng-show=\"(item.itemNameLong || item.itemNumberLong) && (item.item_option_selections && item.item_option_selections.length === 0) && item.showExtraText\" ng-click=\"actions.showLess($index)\">{{content('shoppingCart.less')}}</a>\n                        <a class=\"moreLessDetails\" select-button ng-show=\"(item.itemNameLong || item.itemNumberLong || (item.item_option_selections && item.item_option_selections.length > 0)) && !item.showExtraText\" ng-click=\"actions.showMore($index)\">{{content('shoppingCart.more')}}</a>\n                    </div>\n                    <div id=\"{{ 'price' + $index}}\" class=\"col price itemPrice wrapword\">\n                        <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"item.price\"></format-currency>\n                    </div>\n                    <div id=\"quantity\" class=\"col quantity\">\n                        <div>\n                            <a id=\"decr\" class=\"stepper\" ng-click=\"actions.decrement($index)\">-</a>\n                            <label for=\"{{'quantityInput' + $index}}\"></label>\n                            <input id=\"{{'quantityInput' + $index}}\" role=\"spinbutton\" aria-required=\"true\" aria-valuemin=\"0\" type=\"text\" class=\"alignCenter ltrOverride\" ng-model=\"item.quantity\" ng-change=\"actions.checkValidity($index,'{{item.quantity}}')\" ng-keyup=\"actions.keyUp(event, $index)\" ng-blur=\"initiateUpdateQuantity($index)\" value=\"{{item.quantity}}\"/>\n                            <a id=\"incr\" class=\"stepper\" ng-click=\"actions.increment($index)\">+</a>\n                        </div>\n                        <a class=\"remove\" select-button ng-click=\"actions.remove($index)\">{{content('shoppingCart.remove')}}</a>\n                    </div>\n                    <div id=\"{{ 'itemTotal' + $index }}\" class=\"col itemTotalCost alignDirection itemTotal wrapword\">\n                        <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"(item.price * item.quantity).toFixed(2)\"></format-currency>\n                    </div>\n                    <div class=\"itemDetails hideDetails\" id=\"{{ 'itemDetails' + $index}}\" ng-if=\"item.item_option_selections\" ng-class=\"{ 'showDetails': item.showDetails}\" ng-style=\"item.showDetails && {'max-height': getDetailsMaxHeight($index) + 'px'}\">\n                        <span class=\"options\" ng-repeat=\"option in item.item_option_selections\">\n                            <span class=\"key\" data-ng-bind-html=\"htmlContent('shoppingCart.optionNames', {key: option.name})\"></span> {{option.select}}{{$last ? '' : ', '}}\n                        </span>\n                    </div>\n                    <a class=\"lessDetails\" select-button ng-show=\"(item.item_option_selections && item.item_option_selections.length > 0) && item.showExtraText\" ng-click=\"actions.showLess($index)\">{{content('shoppingCart.less')}}</a>\n                </div>\n            </div>\n        </div>\n        <div id=\"orderSummary\" class=\"transparentBgr\" ng-class=\"{ 'pushDown' : (itemsInCart.length >= 4 && !areAllItemsVisible)}\">\n            <div id=\"orderSummaryHead\" class=\"row rowHead bold transparent\" ng-click=\"toggleArrowDirection()\">\n                <div class=\"col summaryElementHead\">\n                    <h4>{{content('shoppingCart.orderSummary')}}</h4>\n                </div>\n                <div class=\"col summaryElementCost alignDirection wrapword\">\n                    <format-currency ng-show=\"!expandSummary\" class=\"formatCurrency orderTotal\" code=\"currencyCode\" amount=\"getNetTotal().toFixed(2)\"></format-currency>\n                    <span class=\"arrow ng-scope\" ng-class=\"{ 'downward': !expandSummary }\"></span>\n                </div>\n            </div>\n            <div class=\"details-expand\" ng-class=\"{ 'expansion': expandSummary}\" ng-style=\"expandSummary && {'max-height': orderSummaryMaxHeight + 'px'}\">\n                <div class=\"firstRow\">\n                    <div class=\"col summaryElement\">\n                        <span>{{content('header.itemTotal')}}</span>\n                    </div>\n                    <div class=\"col summaryElementCost alignDirection wrapword\">\n                        <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"getCartItemsTotal().toFixed(2)\"></format-currency>\n                    </div>\n                </div>\n                <div class=\"row\" ng-repeat=\"element in additionalCharges\" ng-show=\"element.value !== 0.00\">\n                    <div class=\"col summaryElement\">\n                        <span>{{content('header.' + element.name)}}</span>\n                    </div>\n                    <div class=\"col summaryElementCost alignDirection wrapword\">\n                        <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"element.value.toFixed(2)\"></format-currency>\n                    </div>\n                </div>\n                <div class=\"total\">\n                    <div class=\"col summaryElement\">\n                        <span>{{content('header.total')}}</span>\n                    </div>\n                    <div class=\"col summaryElementCost alignDirection wrapword\">\n                        <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"getNetTotal().toFixed(2)\"></format-currency>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row checkoutButtons\">\n                <div class=\"buttonsContainer\">\n                    <div id=\"memberCheckout\" class=\"memberCheckout alignCenter\" ng-click=\"prepareCheckout('member')\"></div>\n                    <div class=\"optionLine\">\n                        <span class=\"optionText\">\n                            {{content('shoppingCart.or')}}\n                        </span>\n                    </div>\n                    <div id=\"guestCheckout\" class=\"guestCheckout alignCenter\" ng-click=\"prepareCheckout('guest')\"></div>\n                    <div class=\"alignCenter\">\n                        <span class=\"guestText\">{{content('shoppingCart.payWithoutAccount')}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/ppcartMapper/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.ppcartMapper', ['squid']).factory('$PPCartMapperModel', function ($Model, $Api) {
	        return $Model.extend('$PPCartMapperModel', {
	            api: new $Api({
	                uri: '/api/ppcartmapper',
	                postAttempts: 2,
	                cache: true
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/ppcartMapper", "components/xo-models/src/ppcartMapper/index.js"))

/***/ },

/***/ "./components/xo-models/src/inventory/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.inventory', ['squid']).factory('$InventoryModel', function ($Model, $Api) {
	        return $Model.extend('$InventoryModel', {
	            api: new $Api({
	                uri: '/api/catalog/:id/item/',
	                postAttempts: 2,
	                cache: true
	            }),
	
	            setInvetoryItems: function setInvetoryItems(inventoryItems) {
	                this.inventoryItems = inventoryItems;
	            },
	
	            getInventoryItems: function getInventoryItems() {
	                return this.inventoryItems;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/inventory", "components/xo-models/src/inventory/index.js"))

/***/ },

/***/ "../node_modules/underscore/underscore.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },

/***/ "./pages/xo-shopping-cart/cartUtil.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _base = __webpack_require__("./pages/xo-shopping-cart/base64.js");
	
	var _validators = __webpack_require__("./pages/xo-shopping-cart/validators.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _customUtil = __webpack_require__("./js/lib/customUtil.js");
	
	var _ = __webpack_require__("../node_modules/underscore/underscore.js");
	// TODO: add a constants file and move all the constants to that file
	
	module.exports = {
	
	    getButtonParams: function getButtonParams(urlParams) {
	        if (!urlParams) {
	            return;
	        }
	        var jsonParams = _customUtil.customUtil.decodeAndParse(urlParams);
	        var buttonItem = void 0,
	            viewCart = void 0;
	        if (isAddToCart(jsonParams)) {
	            buttonItem = mapAddToCartParams(jsonParams);
	            viewCart = false;
	        } else {
	            viewCart = true;
	        }
	        var buttonParams = {};
	        buttonParams.buttonItem = buttonItem;
	        buttonParams.visitorId = jsonParams['visitor_id'];
	        buttonParams.payeeEmail = jsonParams['merchant_email'];
	        buttonParams.viewCart = viewCart;
	        buttonParams.merchantId = jsonParams['merchant_id'];
	        return buttonParams;
	    },
	
	    validateAndGetAdditionalCharges: function validateAndGetAdditionalCharges(shoppingCart) {
	        var items = shoppingCart && shoppingCart.items;
	        if (!items || items.length === 0) {
	            return;
	        }
	        var additionalCharges = void 0,
	            shipping = void 0,
	            tax = void 0,
	            handlingCost = void 0,
	            discount = void 0;
	
	        if (items === undefined || items.length === 0) {
	            return additionalCharges;
	        }
	        _.forEach(items, function (item) {
	            shipping = sumCharge(shipping, item.shipping_cost);
	            if (!item.tax_rate && item.tax) {
	                tax = sumCharge(tax, (item.tax * item.quantity).toFixed(2));
	            } else if (item.tax) {
	                tax = sumCharge(tax, item.tax);
	            }
	            handlingCost = sumCharge(handlingCost, item.handling_cost);
	            discount = sumCharge(discount, item.discount);
	        });
	        if (shoppingCart.total_handling_charges) {
	            handlingCost = +shoppingCart.total_handling_charges.value || handlingCost;
	        }
	        additionalCharges = addCharge(additionalCharges, 'shipping', shipping);
	        var formattedTax = formatValue(tax, 2);
	        if (formattedTax) {
	            formattedTax = Number(formattedTax);
	            additionalCharges = addCharge(additionalCharges, 'tax', formattedTax);
	        }
	        additionalCharges = addCharge(additionalCharges, 'handling', handlingCost);
	        if (discount) {
	            if (discount < addItemAmounts(shoppingCart.items)) {
	                var formattedDiscount = formatValue(discount, 2);
	                if (formattedDiscount) {
	                    additionalCharges = addCharge(additionalCharges, 'discount', Number(formattedDiscount));
	                }
	            } else {
	                _logger.$logger.info('discount_exceeds_itemTotal');
	            }
	        }
	        // total shipping and total handlingCost must be positive
	        return {
	            cartValid: (shipping === undefined || shipping >= 0) && (handlingCost === undefined || handlingCost >= 0),
	            charges: additionalCharges
	        };
	    },
	
	    addItemToCart: function addItemToCart(buttonItem, shoppingCart) {
	        if (!buttonItem || !buttonItem.items || !buttonItem.items.length === 0) {
	            return shoppingCart;
	        }
	        if (!shoppingCart) {
	            return buttonItem;
	        }
	        if (!shoppingCart.items || shoppingCart.items.length === 0) {
	            shoppingCart.items = [buttonItem.items[0]];
	            return shoppingCart;
	        }
	        var index = isItemPresentInList(buttonItem.items[0], shoppingCart.items);
	        _logger.$logger.info('isItemPresentInList', { index: index });
	        if (index > -1) {
	            shoppingCart.items[index].quantity = parseInt(shoppingCart.items[index].quantity, 10) + parseInt(buttonItem.items[0].quantity, 10);
	            if (buttonItem.items[0].tax_rate) {
	                shoppingCart.items[index].tax_rate = buttonItem.items[0].tax_rate;
	            } else if (buttonItem.items[0].tax) {
	                shoppingCart.items[index].tax = buttonItem.items[0].tax;
	            }
	        } else {
	            shoppingCart.items.push(buttonItem.items[0]);
	            if (buttonItem.total_handling_charges && !shoppingCart.total_handling_charges) {
	                shoppingCart['total_handling_charges'] = buttonItem.total_handling_charges;
	            }
	            if (buttonItem.total_weight && !shoppingCart.total_weight) {
	                shoppingCart['total_weight'] = buttonItem.total_weight;
	            }
	        }
	        shoppingCart = updateParamsFromButtonItem(shoppingCart, buttonItem);
	        return shoppingCart;
	    },
	
	    getMerchantDetails: function getMerchantDetails(shoppingCart, buttonItemDetails) {
	        if (!shoppingCart) {
	            return {};
	        }
	        var merchantDetails = {
	            imageUrl: shoppingCart && shoppingCart.urls && shoppingCart.urls.image_url,
	            brand_name: shoppingCart && shoppingCart.payee && shoppingCart.payee.business_name,
	            merchant_email: buttonItemDetails && buttonItemDetails.payee && buttonItemDetails.payee.email
	        };
	        return merchantDetails;
	    },
	
	    getItemsForCheckout: function getItemsForCheckout(itemList) {
	        var updatedList = [];
	        if (itemList && itemList.length !== 0) {
	            _.forEach(itemList, function (item) {
	                if (item.quantity !== '0') {
	                    updatedList.push(item);
	                }
	            });
	        }
	        return updatedList;
	    },
	
	    removeHashKey: function removeHashKey(shoppingCart) {
	        _.forEach(shoppingCart.items, function (item) {
	            if (item.item_option_selections) {
	                _.forEach(item.item_option_selections, function (option, index) {
	                    if (option.$$hashKey) {
	                        delete option.$$hashKey;
	                    }
	                });
	            }
	        });
	    },
	
	    getParamsForCheckout: function getParamsForCheckout(xclickParams) {
	        var decodedParams = (0, _base.base64Decode)(xclickParams);
	        var urlParams = decodeURIComponent(decodedParams);
	        var paramsList = urlParams.split('&');
	        var usedParams = void 0;
	        var unUsedParams = ['visitor_id', 'merchant_email', 'business_name', 'merchant_id', 'cmd'];
	        _.forEach(paramsList, function (param) {
	            var key = param.split('=')[0];
	            if (key && unUsedParams.indexOf(key) === -1) {
	                if (key === 'add') {
	                    param = 'display=1';
	                }
	                usedParams = usedParams ? usedParams + '&' + param : param;
	            }
	        });
	        var encodedUrlParams = encodeURIComponent(usedParams);
	        var encodedParams = (0, _base.base64Encode)(encodedUrlParams);
	        return encodedParams;
	    },
	
	    getCartItemsTotal: function getCartItemsTotal(itemsInCart) {
	        return addItemAmounts(itemsInCart);
	    }
	};
	
	var updateParamsFromButtonItem = function updateParamsFromButtonItem(shoppingCart, buttonItem) {
	    var cartParams = ['urls', 'total_handling_charges', 'address_override'];
	    for (var key in cartParams) {
	        if (cartParams.hasOwnProperty(key) && buttonItem[cartParams[key]]) {
	            shoppingCart[cartParams[key]] = buttonItem[cartParams[key]];
	        }
	    }
	    // cannot override the button_source
	    var customizedParams = ['custom', 'note_to_seller_label', 'locale_code', 'return_url_label', 'return_method', 'mrb_code'];
	    if (buttonItem.items[0].customized_info) {
	        _.forEach(shoppingCart.items, function (item, index) {
	            if (!item.customized_info) {
	                shoppingCart.items[index].customized_info = {};
	            }
	            for (var i = 0; i < customizedParams.length; i += 1) {
	                var _key = customizedParams[i];
	                shoppingCart.items[index].customized_info[_key] = buttonItem.items[0].customized_info[_key];
	            }
	        });
	    }
	    return shoppingCart;
	};
	
	var sumCharge = function sumCharge(sum, value) {
	    if (value !== undefined) {
	        if (sum === undefined) {
	            sum = 0;
	        }
	        sum = Number(sum) + Number(value);
	    }
	    return sum;
	};
	
	var addCharge = function addCharge(additionalCharges, name, value) {
	    if (value !== undefined) {
	        if (additionalCharges === undefined) {
	            additionalCharges = [];
	        }
	        additionalCharges.push({ name: name, value: value });
	    }
	    return additionalCharges;
	};
	
	var isAddToCart = function isAddToCart(jsonParams) {
	    var addToCart = false;
	    if (jsonParams['add'] === '1') {
	        addToCart = true;
	    }
	    return addToCart;
	};
	
	var mapAddToCartParams = function mapAddToCartParams(jsonParams) {
	    var buttonParams = {};
	    buttonParams = mapCartParams(buttonParams, jsonParams);
	    buttonParams = mapCartAmounts(buttonParams, jsonParams);
	    buttonParams = mapItemParams(buttonParams, jsonParams);
	    buttonParams = mapDiscountParams(buttonParams, jsonParams);
	    buttonParams = mapShippingParams(buttonParams, jsonParams);
	    buttonParams = mapWeightParams(buttonParams, jsonParams);
	    buttonParams = mapCustomizedInfoParams(buttonParams, jsonParams);
	    buttonParams = mapCartUrlParams(buttonParams, jsonParams);
	    buttonParams = mapPayeePayerParams(buttonParams, jsonParams);
	    buttonParams = mapShippingAddress(buttonParams, jsonParams);
	    buttonParams = mapPaymentPreference(buttonParams, jsonParams);
	    buttonParams = mapItemOptionSelectionParams(buttonParams, jsonParams);
	    return buttonParams;
	};
	
	var mapCartParams = function mapCartParams(buttonParams, jsonParams) {
	    if (jsonParams['invoice']) {
	        buttonParams['invoice_number'] = jsonParams['invoice'];
	    }
	    if (jsonParams['no_note'] === '0') {
	        buttonParams['prompt_note'] = true;
	    } else {
	        buttonParams['prompt_note'] = false;
	    }
	    if (jsonParams['address_override'] === '0') {
	        buttonParams['address_override'] = false;
	    } else if (jsonParams['address_override'] === '1') {
	        buttonParams['address_override'] = true;
	    }
	    return buttonParams;
	};
	
	var mapCartAmounts = function mapCartAmounts(buttonParams, jsonParams) {
	    if ((0, _validators.isValidAmount)(jsonParams['handling_cart'])) {
	        buttonParams['total_handling_charges'] = moneyJson(jsonParams['currency_code'], jsonParams['handling_cart']);
	    }
	    return buttonParams;
	};
	
	var formatValue = function formatValue(amount, digits) {
	    if (amount !== undefined) {
	        return (+amount).toFixed(digits);
	    }
	    return amount;
	};
	
	var getCurrencyCode = function getCurrencyCode(currencyCode) {
	    if (currencyCode === undefined) {
	        return 'USD';
	    }
	    return currencyCode;
	};
	
	var moneyJson = function moneyJson(currencyCode, value) {
	    return {
	        currency_code: getCurrencyCode(currencyCode),
	        value: formatValue(value, 2)
	    };
	};
	
	var mapItemParams = function mapItemParams(buttonParams, jsonParams) {
	    var itemParams = {
	        'amount': 'price',
	        'item_name': 'name',
	        'item_number': 'sku',
	        'tax': 'tax',
	        'tax_rate': 'tax_rate',
	        'currency_code': 'currency',
	        'quantity': 'quantity',
	        'handling': 'handling_cost'
	    };
	    var item = {};
	
	    var validateAndMap = function validateAndMap(key, validator, digits) {
	        if (validator(jsonParams[key])) {
	            item[itemParams[key]] = digits ? formatValue(jsonParams[key], digits) : jsonParams[key];
	        }
	    };
	
	    item[itemParams['handling']] = formatValue(0, 2); // default to 0 as per legacy behavior
	    for (var key in itemParams) {
	        if (itemParams.hasOwnProperty(key) && jsonParams[key]) {
	            switch (key) {
	                case 'amount':
	                case 'tax':
	                case 'handling':
	                    validateAndMap(key, _validators.isNumber, 2);break;
	                case 'tax_rate':
	                    validateAndMap(key, _validators.isValidTaxRate, 3);break;
	                case 'quantity':
	                    validateAndMap(key, _validators.isValidQuantity);break;
	                default:
	                    item[itemParams[key]] = jsonParams[key];
	            }
	        }
	    }
	    item['currency'] = getCurrencyCode(jsonParams['currency_code']);
	
	    var shippingAddressOptions = {
	        '0': 'ALLOWED',
	        '1': 'NEVER',
	        '2': 'REQUIRED'
	    };
	    if (jsonParams['no_shipping']) {
	        item['shipping_address_options'] = shippingAddressOptions[jsonParams['no_shipping']] || shippingAddressOptions[jsonParams['0']];
	    }
	    buttonParams.items = [];
	    // if quantity is not passed make it 1 by default
	    // if quantity is not a number then make it 1 by default
	    if (item && (item.quantity === undefined || !Number.isInteger(+item.quantity) || item.quantity < 1)) {
	        item.quantity = 1;
	    }
	    buttonParams.items[0] = item;
	    return buttonParams;
	};
	
	var mapDiscountParams = function mapDiscountParams(buttonParams, jsonParams) {
	    if (jsonParams['discount_num'] && Number.isInteger(+jsonParams['discount_num'])) {
	        buttonParams.items[0].discount_options = {};
	        buttonParams.items[0].discount_options.additional_eligible_items_count = jsonParams['discount_num'];
	    }
	    buttonParams = mapDiscountAmountParams(buttonParams, jsonParams);
	    buttonParams = mapDiscountRateParams(buttonParams, jsonParams);
	    return buttonParams;
	};
	
	var mapShippingParams = function mapShippingParams(buttonParams, jsonParams) {
	    if (buttonParams.items === undefined) {
	        buttonParams.items = [];
	    }
	    if ((0, _validators.isNumber)(jsonParams['shipping'])) {
	        buttonParams.items[0].shipping_options = {};
	        buttonParams.items[0].shipping_options['first_item_shipping_cost'] = moneyJson(jsonParams['currency_code'], jsonParams['shipping']);
	        var additionalItemShippingCost = (0, _validators.isNumber)(jsonParams['shipping2']) ? jsonParams['shipping2'] : 0; // as per legacy behavior
	        buttonParams.items[0].shipping_options['additional_item_shipping_cost'] = moneyJson(jsonParams['currency_code'], additionalItemShippingCost);
	    }
	    return buttonParams;
	};
	
	var mapWeightParams = function mapWeightParams(buttonParams, jsonParams) {
	    if (jsonParams['weight_cart'] && (0, _validators.isWeightValid)(jsonParams['weight_cart'])) {
	        buttonParams.total_weight = measurementJson(jsonParams['weight_cart'], jsonParams['weight_unit']);
	    }
	    if (jsonParams['weight'] && (0, _validators.isWeightValid)(jsonParams['weight'])) {
	        buttonParams.items[0].weight = measurementJson(jsonParams['weight'], jsonParams['weight_unit']);
	    }
	    return buttonParams;
	};
	
	var measurementJson = function measurementJson(value, unit) {
	    if (String(unit).toLowerCase() !== 'kgs') {
	        unit = 'lbs';
	    }
	    return {
	        unit: unit,
	        value: value
	    };
	};
	
	var replacePlus = function replacePlus(jsonParams) {
	    var modifiedVal = void 0; // value after replacing + with ' '
	    var modifiedParams = {};
	    for (var key in jsonParams) {
	        if (jsonParams.hasOwnProperty(key)) {
	            if (jsonParams[key]) {
	                modifiedVal = jsonParams[key].replace(/\+/g, ' ');
	                if (jsonParams[key] !== modifiedVal) {
	                    modifiedParams[key] = { orig: jsonParams[key], 'new': modifiedVal };
	                    jsonParams[key] = modifiedVal;
	                }
	            }
	        }
	    }
	    if (modifiedParams) {
	        _logger.$logger.info('modifiedItemOptionsParams', modifiedParams);
	    }
	    return jsonParams;
	};
	
	var mapItemOptionSelectionParams = function mapItemOptionSelectionParams(buttonParams, jsonParams, retryAttempt) {
	    var regexVar = {
	        onX: { name: 'on', maxIndex: 29 },
	        osX: { name: 'os', maxIndex: 29 },
	        optionAmountSelection: { name: 'option_amount_selection', maxIndex: 29 },
	        optionAmount: { name: 'option_amount', maxIndex: 29 },
	        optionSelect: { name: 'option_select', maxIndex: 29 },
	        optionItemNumber: { name: 'option_item_number', maxIndex: 29 }
	    };
	
	    var optionAmountIndex = jsonParams['option_amount_index'] || jsonParams['option_index'] || 0;
	    var optionIndex = jsonParams['option_index'] || 0;
	    // reset item_option_selections in case of second mapping attempt
	    if (retryAttempt && buttonParams.items[0].item_option_selections) {
	        buttonParams.items[0].item_option_selections = [];
	    }
	    for (var i = 0; i < regexVar.onX.maxIndex; i += 1) {
	        var on = '' + regexVar.onX.name + i;
	        var os = '' + regexVar.osX.name + i;
	
	        var option = void 0;
	        var optionBasedParams = void 0;
	        if (jsonParams[on] || jsonParams[os]) {
	            option = { name: jsonParams[on] };
	            if (jsonParams[os]) {
	                option['select'] = jsonParams[os];
	                if (+optionAmountIndex === i) {
	                    optionBasedParams = selectAmountFromOption(os, jsonParams, regexVar);
	                    if (optionBasedParams.amount && (0, _validators.isValidAmount)(optionBasedParams.amount.value)) {
	                        // Set the amount in the item's top level price.
	                        buttonParams.items[0].price = formatValue(optionBasedParams.amount.value, 2);
	                    }
	                }
	                if (+optionIndex === i) {
	                    optionBasedParams = selectItemIdFromOption(os, jsonParams, regexVar);
	                    if (optionBasedParams.item_number) {
	                        buttonParams.items[0].sku = optionBasedParams.item_number;
	                    }
	                }
	            } else {
	                option['select'] = '-';
	            }
	        }
	
	        // set the option only when option name is present or else ignore
	        if (option && option.name) {
	            buttonParams.items[0].item_option_selections = buttonParams.items[0].item_option_selections || [];
	            buttonParams.items[0].item_option_selections.push(option);
	        }
	    }
	
	    if (!buttonParams.items[0].price) {
	        if (!retryAttempt) {
	            mapItemOptionSelectionParams(buttonParams, replacePlus(jsonParams), true);
	        }
	    }
	
	    return buttonParams;
	};
	
	var selectAmountFromOption = function selectAmountFromOption(os, jsonParams, regexVar) {
	    var amount = void 0;
	
	    for (var i = 0; i <= regexVar.optionAmount.maxIndex; i += 1) {
	        var optionAmountSelection = '' + regexVar.optionAmountSelection.name + i;
	        var optionSelect = '' + regexVar.optionSelect.name + i;
	        var optionAmount = '' + regexVar.optionAmount.name + i;
	
	        // The first match of many option_selectZ's matching always wins
	        if (!jsonParams[optionAmountSelection]) {
	            jsonParams[optionAmountSelection] = jsonParams[optionSelect];
	        }
	
	        if (jsonParams[os] === jsonParams[optionAmountSelection]) {
	            if ((0, _validators.isValidAmount)(jsonParams[optionAmount])) {
	                amount = {};
	                amount.value = formatValue(jsonParams[optionAmount], 2);
	                amount.currency = getCurrencyCode(jsonParams['currency_code']);
	            }
	            break; // First match wins even if option_amount not present!
	        }
	    }
	
	    var params = {
	        amount: amount
	    };
	    return params;
	};
	
	var selectItemIdFromOption = function selectItemIdFromOption(os, jsonParams, regexVar) {
	    var itemId = void 0;
	
	    for (var i = 0; i <= regexVar.optionSelect.maxIndex; i += 1) {
	        var optionSelect = '' + regexVar.optionSelect.name + i;
	        var optionItemNumber = '' + regexVar.optionItemNumber.name + i;
	
	        // The first match of many option_selectZ's matching always wins
	        if (jsonParams[os] === jsonParams[optionSelect]) {
	            if (jsonParams[optionItemNumber]) {
	                itemId = jsonParams[optionItemNumber];
	            }
	            break; // First match wins even if option_amount not present!
	        }
	    }
	    var params = {
	        item_number: itemId
	    };
	    return params;
	};
	
	var mapCustomizedInfoParams = function mapCustomizedInfoParams(buttonParams, jsonParams) {
	    if (buttonParams.items === undefined) {
	        buttonParams.items = [];
	    }
	    var customizedInfoParams = {
	        'custom': 'custom',
	        'cn': 'note_to_seller_label',
	        'lc': 'locale_code',
	        'bn': 'button_source',
	        'cbt': 'return_url_label',
	        'hosted_button_id': 'hosted_button_id',
	        'mrb': 'mrb_code'
	    };
	    buttonParams.items[0].customized_info = {};
	    for (var key in customizedInfoParams) {
	        if (customizedInfoParams.hasOwnProperty(key) && jsonParams[key]) {
	            buttonParams.items[0].customized_info[customizedInfoParams[key]] = jsonParams[key];
	        }
	    }
	    var rmMap = {
	        '0': 'GET',
	        '1': 'GET',
	        '2': 'POST'
	    };
	    if (jsonParams['rm'] === undefined) {
	        buttonParams.items[0].customized_info['return_method'] = rmMap['0'];
	    } else {
	        buttonParams.items[0].customized_info['return_method'] = rmMap[jsonParams['rm']];
	    }
	    return buttonParams;
	};
	
	var mapCartUrlParams = function mapCartUrlParams(buttonParams, jsonParams) {
	    var cartUrlParams = {
	        'shopping_url': 'shopping_url',
	        'image_url': 'image_url',
	        'return': 'return_url',
	        'cancel_return': 'cancel_url',
	        'notify_url': 'notify_url'
	    };
	    buttonParams.urls = {};
	    for (var key in cartUrlParams) {
	        if (cartUrlParams.hasOwnProperty(key) && jsonParams[key]) {
	            buttonParams.urls[cartUrlParams[key]] = jsonParams[key];
	        }
	    }
	    return buttonParams;
	};
	
	var mapPayeePayerParams = function mapPayeePayerParams(buttonParams, jsonParams) {
	    buttonParams = mapPayeeParams(buttonParams, jsonParams);
	    buttonParams = mapPayerParams(buttonParams, jsonParams);
	    return buttonParams;
	};
	
	var mapPayeeParams = function mapPayeeParams(buttonParams, jsonParams) {
	    buttonParams.visitor_id = jsonParams['visitor_id'];
	    buttonParams.payee = {};
	    buttonParams.payee.email = jsonParams['merchant_email'];
	    buttonParams.payee.business_name = jsonParams['business_name'];
	    if (!buttonParams.payee.business_name) {
	        buttonParams.payee.business_name = buttonParams.payee.email;
	    }
	    return buttonParams;
	};
	
	var mapPayerParams = function mapPayerParams(buttonParams, jsonParams) {
	    var payerParams = {
	        email: 'email',
	        first_name: 'first_name',
	        last_name: 'last_name'
	    };
	    for (var key in payerParams) {
	        if (payerParams.hasOwnProperty(key) && jsonParams[key]) {
	            if (!buttonParams.payer_info) {
	                buttonParams.payer_info = {};
	            }
	            buttonParams.payer_info[payerParams[key]] = jsonParams[key];
	        }
	    }
	    buttonParams = mapPhone(buttonParams, jsonParams);
	    return buttonParams;
	};
	
	var mapPhone = function mapPhone(buttonParams, jsonParams) {
	    var phoneParams = ['night_phone_a', 'night_phone_b', 'night_phone_c'];
	    var phone = void 0;
	    for (var i = 0; i < phoneParams.length; i += 1) {
	        if (jsonParams[phoneParams[i]]) {
	            phone = phone || '';
	            phone += jsonParams[phoneParams[i]];
	        }
	    }
	    if (phone) {
	        buttonParams.payer_info = buttonParams.payer_info || {};
	        buttonParams.payer_info.phone = phone;
	    }
	    return buttonParams;
	};
	
	var mapShippingAddress = function mapShippingAddress(buttonParams, jsonParams) {
	    var addressParams = {
	        address1: 'line1',
	        address2: 'line2',
	        city: 'city',
	        country: 'country_code',
	        zip: 'postal_code',
	        state: 'state'
	    };
	    for (var key in addressParams) {
	        if (addressParams.hasOwnProperty(key) && jsonParams[key]) {
	            if (!buttonParams.shipping_address) {
	                buttonParams.shipping_address = {};
	            }
	            buttonParams.shipping_address[addressParams[key]] = jsonParams[key];
	        }
	    }
	    if (buttonParams.shipping_address) {
	        if (!buttonParams.payer_info) {
	            buttonParams.payer_info = {};
	        }
	        buttonParams.payer_info.billing_address = buttonParams.shipping_address;
	    }
	    return buttonParams;
	};
	
	var mapPaymentPreference = function mapPaymentPreference(buttonParams, jsonParams) {
	    var paymentPreferenceOptions = {
	        'sale': 'SALE',
	        'auth': 'AUTH',
	        'authorization': 'AUTH',
	        'order': 'ORDER'
	    };
	    if (jsonParams['paymentaction']) {
	        buttonParams.payment_preference = paymentPreferenceOptions[String(jsonParams['paymentaction']).toLowerCase()] || paymentPreferenceOptions['sale'];
	    }
	    return buttonParams;
	};
	
	var mapDiscountAmountParams = function mapDiscountAmountParams(buttonParams, jsonParams) {
	    if ((0, _validators.isValidAmount)(jsonParams['discount_amount']) || (0, _validators.isValidAmount)(jsonParams['discount_amount2'])) {
	        if (buttonParams.items[0].discount_options === undefined) {
	            buttonParams.items[0].discount_options = {};
	        }
	        buttonParams.items[0].discount_options.discount_amount = [{}];
	    }
	    if ((0, _validators.isValidAmount)(jsonParams['discount_amount'])) {
	        buttonParams.items[0].discount_options.discount_amount[0].first_item_discount_amount = moneyJson(jsonParams['currency_code'], jsonParams['discount_amount']);
	    }
	    if ((0, _validators.isValidAmount)(jsonParams['discount_amount2'])) {
	        buttonParams.items[0].discount_options.discount_amount[0].additional_item_discount_amount = moneyJson(jsonParams['currency_code'], jsonParams['discount_amount2']);
	    }
	    return buttonParams;
	};
	
	var mapDiscountRateParams = function mapDiscountRateParams(buttonParams, jsonParams) {
	    if ((0, _validators.isValidDiscountRate)(jsonParams['discount_rate']) || (0, _validators.isValidDiscountRate)(jsonParams['discount_rate2'])) {
	        if (buttonParams.items[0].discount_options === undefined) {
	            buttonParams.items[0].discount_options = {};
	        }
	        buttonParams.items[0].discount_options.discount_rate = [{}];
	    }
	    if ((0, _validators.isValidDiscountRate)(jsonParams['discount_rate'])) {
	        buttonParams.items[0].discount_options.discount_rate[0].first_item_discount_rate = formatValue(jsonParams['discount_rate'], 3);
	    }
	    if ((0, _validators.isValidDiscountRate)(jsonParams['discount_rate2'])) {
	        buttonParams.items[0].discount_options.discount_rate[0].additional_item_discount_rate = formatValue(jsonParams['discount_rate2'], 3);
	    }
	    return buttonParams;
	};
	
	var isItemPresentInList = function isItemPresentInList(buttonItem, itemList) {
	
	    var buttonItemIndex = -1;
	    _.forEach(itemList, function (item, index) {
	        if (item.name === buttonItem.name && item.price === buttonItem.price && item.sku === buttonItem.sku) {
	
	            var itemOptions = isItemOptionsEqual(item, buttonItem);
	            var itemAmounts = isItemAmountsEqual(item, buttonItem);
	            _logger.$logger.info('isItemOptionsEqual', { result: itemOptions });
	            _logger.$logger.info('isItemAmountsEqual', { result: itemAmounts });
	            if (itemOptions && itemAmounts) {
	                buttonItemIndex = index;
	            }
	        }
	    });
	
	    return buttonItemIndex;
	};
	
	var isItemOptionsEqual = function isItemOptionsEqual(item, buttonItem) {
	    if (item && item.item_option_selections && item.item_option_selections.length === 0) {
	        delete item.item_option_selections;
	    }
	    if (!buttonItem.item_option_selections && !item.item_option_selections) {
	        return true;
	    } else if (!buttonItem.item_option_selections && item.item_option_selections) {
	        return false;
	    } else if (buttonItem.item_option_selections && !item.item_option_selections) {
	        return false;
	    } else if (buttonItem.item_option_selections && item.item_option_selections) {
	        var buttonItemJson = JSON.stringify(buttonItem.item_option_selections);
	        var itemJson = JSON.stringify(item.item_option_selections);
	        // TODO: Do a JSON comparison instead of string comparison.
	        // This still works because button item is always extracted in the same way
	        if (buttonItemJson === itemJson) {
	            return true;
	        }
	    }
	    return false;
	};
	
	var isItemAmountsEqual = function isItemAmountsEqual(item, buttonItem) {
	
	    if (!isShippingAmountEqual(item, buttonItem)) {
	        _logger.$logger.info('isShippingAmountEqual', { result: false });
	        return false;
	    }
	    if (!equalAmount(item.handling_cost, buttonItem.handling_cost)) {
	        _logger.$logger.info('isHandlingCostEqual', { result: false });
	        return false;
	    }
	    if (!equalAmount(item.insurance, buttonItem.insurance)) {
	        _logger.$logger.info('isInsuranceEqual', { result: false });
	        return false;
	    }
	    return true;
	};
	
	// checks if the first item shipping amount and additional item shipping amount is equal or not
	var isShippingAmountEqual = function isShippingAmountEqual(item, buttonItem) {
	    if (item.shipping_options && item.shipping_options.length === 0) {
	        // TODO: delete this empty array in output mapper of the wrapper module
	        delete item.shipping_options;
	    }
	    if (!buttonItem.shipping_options && !item.shipping_options) {
	        return true;
	    } else if (!buttonItem.shipping_options && item.shipping_options) {
	        return false;
	    } else if (buttonItem.shipping_options && !item.shipping_options) {
	        return false;
	    }
	    var buttonShipping = buttonItem.shipping_options.first_item_shipping_cost;
	    var itemShipping = item.shipping_options.first_item_shipping_cost;
	    if (buttonShipping && itemShipping) {
	        if (buttonShipping.value !== itemShipping.value) {
	            return false;
	        }
	    }
	    if (buttonShipping && !itemShipping || !buttonShipping && itemShipping) {
	        return false;
	    }
	
	    buttonShipping = buttonItem.shipping_options.additional_item_shipping_cost;
	    itemShipping = item.shipping_options.additional_item_shipping_cost;
	    if (buttonShipping && itemShipping) {
	        if (buttonShipping.value !== itemShipping.value) {
	            return false;
	        }
	    }
	    if (buttonShipping && !itemShipping || !buttonShipping && itemShipping) {
	        return false;
	    }
	    return true;
	};
	
	var equalAmount = function equalAmount(amount1, amount2) {
	    if (amount1 && !amount2) {
	        return false;
	    }
	    if (!amount1 && amount2) {
	        return false;
	    }
	    if (amount1 && amount2) {
	        return amount1 === amount2;
	    }
	    return true;
	};
	
	var addItemAmounts = function addItemAmounts(itemsInCart) {
	    if (!itemsInCart) {
	        return;
	    }
	    var sum = 0;
	    _.forEach(itemsInCart, function (item) {
	        sum += item.removed ? 0 : item.price * item.quantity;
	    });
	    return sum;
	};
	
	_base.base64Encode;
	
	_base.base64Decode;
	
	_validators.isValidAmount;
	
	_validators.isNumber;
	
	_validators.isValidQuantity;
	
	_validators.isValidTaxRate;
	
	_validators.isValidDiscountRate;
	
	_validators.isWeightValid;
	
	_logger.$logger;
	
	_customUtil.customUtil;

/***/ },

/***/ "./pages/xo-shopping-cart/base64.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.base64Encode = base64Encode;
	exports.base64Decode = base64Decode;
	var Buffer = __webpack_require__("../node_modules/buffer/index.js").Buffer;
	
	function base64Encode(data) {
	    return new Buffer(data).toString('base64');
	}
	
	function base64Decode(data) {
	    return new Buffer(data, 'base64').toString('utf8');
	}

/***/ },

/***/ "../node_modules/buffer/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	
	
	var base64 = __webpack_require__("../node_modules/base64-js/index.js")
	var ieee754 = __webpack_require__("../node_modules/ieee754/index.js")
	var isArray = __webpack_require__("../node_modules/buffer/node_modules/isarray/index.js")
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "../node_modules/base64-js/index.js":
/***/ function(module, exports) {

	
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },

/***/ "../node_modules/ieee754/index.js":
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },

/***/ "../node_modules/buffer/node_modules/isarray/index.js":
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },

/***/ "./pages/xo-shopping-cart/validators.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	exports.isValidAmount = isValidAmount;
	exports.isNumber = isNumber;
	exports.isValidQuantity = isValidQuantity;
	exports.isValidTaxRate = isValidTaxRate;
	exports.isValidDiscountRate = isValidDiscountRate;
	exports.isWeightValid = isWeightValid;
	// Is the given object a valid amount?
	// TODO/mm similar to: is_valid_discount_param() - refactor?
	function isValidAmount(input) {
	    return input !== undefined && isNaN(input) === false && +input >= 0;
	}
	
	// Is the input a valid shipping amount? Note: Individual negative shipping values are valid too.
	function isNumber(input) {
	    return input !== undefined && isNaN(input) === false;
	}
	
	// Is input a value quantity parameter value?
	// Has to be a positive integer.
	function isValidQuantity(input) {
	    if (isNaN(input) || +input <= 0 || !Number.isInteger(+input)) {
	        return false;
	    }
	    return true;
	}
	
	// Is the given value a valid WPS tax rate?
	// WPS Bummer: tax over 100 in theory should be ok, but doc and legacy says caps at 100.
	// Weird: has to be from 0.001 through 100, inclusive, or exactly zero.
	// This is due to:
	// - no tax field in Symphony cart means use merchants profile tax rate.
	// - tax of zero in Symphony cart means really use no tax, and don't use profile tax rate.
	function isValidTaxRate(input) {
	    return input !== undefined && isNaN(input) === false && (+input >= 0.001 && +input <= 100 || +input === 0);
	}
	
	// Is the given value a valid WPS discount rate?
	// "Less than 100" says the WPS docs. I'm adding also: non-negative.
	function isValidDiscountRate(input) {
	    return input !== undefined && isNaN(input) === false && +input >= 0 && +input <= 100;
	}
	
	function isWeightValid(value) {
	    return value !== undefined && isNaN(value) === false && value >= 0;
	}

/***/ },

/***/ "./pages/xo-shopping-cart/cartUiUtil.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	function positionOrderSummary(scroll) {
	    var orderSummary = $('#orderSummary');
	    if (orderSummary) {
	        orderSummary.css('transform', 'translateY(' + scroll + 'px)');
	    }
	}
	
	function areAllItemsVisible() {
	    var headerHeight = $('.header').prop('scrollHeight');
	    var osHeight = $('#orderSummary').prop('scrollHeight');
	    var itemsDivHeight = $('#items').prop('scrollHeight');
	    var footerHeight = 0;
	    if (!$('#orderSummary').hasClass('pushDown')) {
	        footerHeight = $('.footer').prop('scrollHeight');
	    }
	    var windowInnerHeight = window.innerHeight;
	    var availableSpaceForItems = windowInnerHeight - (headerHeight + osHeight + footerHeight);
	    return availableSpaceForItems > itemsDivHeight;
	}
	
	$.fn.isOnScreen = function () {
	
	    var win = $(window);
	
	    var viewport = {
	        top: win.scrollTop(),
	        left: win.scrollLeft()
	    };
	    viewport.right = viewport.left + win.width();
	    viewport.bottom = viewport.top + win.height();
	
	    var bounds = this.offset();
	    bounds.right = bounds.left + this.outerWidth();
	    bounds.bottom = bounds.top + this.outerHeight();
	
	    return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
	};
	
	module.exports = {
	
	    getEachItemMaxHeight: function getEachItemMaxHeight(cartItems, index) {
	        var itemDetailsHeight = 0,
	            itemNameHeight = 0,
	            itemNumberHeight = 0;
	        var itemDetails = $('#itemDetails' + index);
	        var itemName = $('#item' + index + 'name');
	        var itemNumber = $('#item' + index + 'number');
	        var item = $('#item' + index);
	
	        if (cartItems[index] && cartItems[index].details && itemDetails) {
	            itemDetailsHeight = itemDetails.prop('scrollHeight'); // to accommodate details
	        }
	
	        if (itemName) {
	            if (angular.element('#item' + index + 'name').hasClass('ellipsisEffect')) {
	                // to get maxHeight full max height (without ellipsis effect), we remove the effect and then add back
	                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
	                itemNameHeight = itemName.prop('scrollHeight');
	                angular.element('#item' + index + 'name').addClass('ellipsisEffect');
	            } else {
	                itemNameHeight = itemName.prop('scrollHeight');
	            }
	        }
	        if (itemNumber) {
	            if (angular.element('#item' + index + 'number').hasClass('ellipsisEffect')) {
	                // to get maxHeight full max height (without ellipsis effect), we remove the effect and then add back
	                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
	                itemNumberHeight = itemNumber.prop('scrollHeight');
	                angular.element('#item' + index + 'number').addClass('ellipsisEffect');
	            } else {
	                itemNumberHeight = itemNumber.prop('scrollHeight');
	            }
	        }
	        return item.prop('scrollHeight') + itemDetailsHeight + itemNameHeight + itemNumberHeight;
	    },
	
	    getItemsMaxHeight: function getItemsMaxHeight(cartItems, index, scrolledToEnd) {
	        var shoppingCartPageHeader = $('.header');
	        var orderSummaryHead = $('#orderSummaryHead');
	        var checkoutButtons = $('.checkoutButtons');
	        var footer = $('.footer');
	        var windowInnerHeight = window.innerHeight;
	        var itemsMaxHeight = void 0;
	        if (scrolledToEnd) {
	            itemsMaxHeight = windowInnerHeight - shoppingCartPageHeader.prop('scrollHeight') - orderSummaryHead.prop('scrollHeight') - checkoutButtons.prop('scrollHeight') - footer.prop('clientHeight');
	        } else {
	            itemsMaxHeight = windowInnerHeight - shoppingCartPageHeader.prop('scrollHeight') - orderSummaryHead.prop('scrollHeight') - checkoutButtons.prop('scrollHeight');
	        }
	        $('#items').css('max-height', itemsMaxHeight + 'px');
	        return itemsMaxHeight;
	    },
	
	    getDetailsMaxHeight: function getDetailsMaxHeight(index) {
	        return $('#itemDetails' + index).prop('scrollHeight');
	    },
	
	    getItemNameMaxHeight: function getItemNameMaxHeight(index) {
	        return $('#item' + index + 'name').prop('scrollHeight');
	    },
	
	    getContainerColWidth: function getContainerColWidth() {
	        return $('#itemProperties').width();
	    },
	
	    areAllItemsVisible: areAllItemsVisible,
	
	    setOrderSummaryColor: function setOrderSummaryColor() {
	
	        if (areAllItemsVisible()) {
	            $('#orderSummaryHead').addClass('opaque');
	            $('.details-expand').addClass('opaque');
	        } else {
	            $('#orderSummaryHead').removeClass('opaque');
	            $('.details-expand').removeClass('opaque');
	        }
	    },
	
	    initWindowScrollActions: function initWindowScrollActions() {
	        $('#orderSummary').css('bottom', $('.footer').prop('scrollHeight') + 1);
	        $(window).scroll(function (event) {
	            var scroll = $(window).scrollTop();
	            var cartContentsHeight = $('#cartContents').prop('scrollHeight');
	            var osHeight = $('#orderSummary').prop('scrollHeight');
	            var scrollLimit = cartContentsHeight - osHeight - 25; // allow for padding
	            if (!$('.footer').isOnScreen() && scroll < scrollLimit) {
	                positionOrderSummary(scroll);
	            } else {
	                positionOrderSummary(0);
	            }
	        });
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-empty-cart/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$EmptyCartRoute = undefined;
	
	__webpack_require__("./pages/xo-empty-cart/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $EmptyCartRoute = exports.$EmptyCartRoute = _squid.$ComponentRoute.extend('$EmptyCartRoute', {
	
	    path: 'emptyCart',
	
	    directive: 'xo-empty-cart-page',
	
	    trackingData: {
	        fptiState: 'emptyCart',
	        templateName: 'emptyCart.dust',
	        pageGoal: 'emptyCart page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-emptyCart',
	                'pagename2': '%::fullpage-emptyCart:wps:shoppingcart:',
	                'version': 'member:%:'
	            }
	        },
	        trackStateExit: true
	    },
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$EmptyCartRoute", $EmptyCartRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-empty-cart/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-empty-cart/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoEmptyCartPageComponent', {
	    tag: 'xo-empty-cart-page',
	    template: _template2['default'],
	
	    actions: {
	        continueShopping: function continueShopping($event) {
	            if ($event) {
	                $event.preventDefault();
	            }
	            if (window.opener !== null && !window.opener.closed) {
	                _logger.$logger.info('continue_shopping_target_not_self');
	                try {
	                    window.opener.location.href = this.continueShoppingUrl;
	                } catch (err) {
	                    _logger.$logger.info('window_opener_location_error', { err: err });
	                } finally {
	                    self.close();
	                }
	            } else {
	                _logger.$logger.info('continue_shopping_target_self');
	                _util.$ReturnToMerchant.goTo(this.continueShoppingUrl);
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            angular.element('.merchantHeader').css('display', 'none');
	            this.continueShoppingUrl = _angular.$rootScope.continueShoppingUrl;
	        },
	        exit: function exit() {
	            angular.element('.merchantHeader').css('display', 'inherit');
	        }
	    }
	
	});
	
	
	_squid.$Component;
	
	_util.$ReturnToMerchant;
	
	_logger.$logger;
	
	_angular.$rootScope;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-empty-cart/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"emptyCart\" content>\n    <div class=\"header\">\n        <p id=\"headerText\">{{content('shoppingCart.shoppingCart')}}</p>\n    </div>\n    <div class=\"emptyCartContainer\">\n        <div class=\"message\">{{content('shoppingCart.cartEmpty')}}</div>\n        <input type=\"button\" class=\"btn\" value=\"{{content('shoppingCart.continueShopping')}}\" ng-click=\"actions.continueShopping()\">\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-inventory-soldout/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSoldOutPageRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-inventory-soldout/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
	
	    path: 'soldout',
	    directive: _directive2['default'],
	    titleContent: 'soldout.title',
	    query: ['items', 'count'],
	    auth: false,
	    trackingData: {
	        fptiState: 'soldout',
	        templateName: 'soldout.dust',
	        pageGoal: 'soldout page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-soldout',
	                'pagename2': '%::fullpage-soldout:wps:shoppingcart:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-inventory-soldout/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	var _template = __webpack_require__("./pages/xo-inventory-soldout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
	    tag: 'xo-soldout-page',
	    template: _template2['default'],
	    auth: false,
	    actions: {
	        continueShoppingHandler: function continueShoppingHandler() {
	            if (window.opener !== null && !window.opener.closed) {
	                _logger.$logger.info('continue_shopping_target_not_self');
	                try {
	                    window.opener.location.href = _angular.$rootScope.soldoutUrl;
	                } catch (err) {
	                    _logger.$logger.info('window_opener_location_error', { err: err });
	                } finally {
	                    self.close();
	                }
	            } else {
	                _logger.$logger.info('continue_shopping_target_self');
	                _util.$ReturnToMerchant.goTo(_angular.$rootScope.soldoutUrl, true);
	            }
	        },
	        continueShoppingCartHandler: function continueShoppingCartHandler() {
	            return _uiRouter.$state.go('checkout.shoppingCart', { noUpdateRequired: true });
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            angular.element('.paypalHeader').css('display', 'none');
	            angular.element('#defaultCancelLink').css('display', 'none');
	        },
	        populate: function populate() {
	            this.flow = _squid.$config.flow;
	            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
	            this.count = decodeURIComponent(_uiRouter.$state.params.count);
	            this.messageKey = 'soldout.message';
	
	            if (this.count === 'many') {
	                this.item_name = JSON.parse(this.item_name);
	                this.messageKey = 'soldout.twoItemMessage';
	                this.items = this.item_name.slice(0, this.item_name.length - 1).join(', ');
	                this.lastItem = this.item_name[this.item_name.length - 1];
	            } else if (this.count === 'all') {
	                this.messageKey = 'soldout.allItemMessage';
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$config;
	
	_util.$ReturnToMerchant;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_angular.$rootScope;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-inventory-soldout/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div ng-if=\"count !== 'many'\" class=\"soldOutMessage\" ng-bind-html=\"htmlContent(messageKey, {item: item_name})\"></div>\n    <div ng-if=\"count === 'many'\" class=\"soldOutMessage\" ng-bind-html=\"htmlContent(messageKey, {item1: items, item2: lastItem})\"></div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n        <div ng-if=\"flow === 'shoppingcart'\">\n            <div class=\"optionLine\">\n                        <span class=\"optionText\">\n                            {{content('shoppingCart.or')}}\n                        </span>\n            </div>\n            <input id= \"Continue-ShoppingCart\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueToShoppingCartButton')}}\" ng-click=\"actions.continueShoppingCartHandler()\"/>\n        </div>\n    </div>\n\n</div>\n"

/***/ },

/***/ "./pages/xo-checkout/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/merchant-header/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/header/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/shopping-cart-footer/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/cart/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	var _template = __webpack_require__("./pages/xo-checkout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
	
	    tag: 'xo-checkout',
	    template: _template2['default'],
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            _logger.$logger.info('starting in shoppingcart enter');
	            this.isApp = _index.$DeviceInfo.isApp();
	            _angular.$document.bind('click', function (event) {
	                _this.$broadcast('clickBody', event.target);
	            });
	
	            // TODO: fetch merchant details in merchant header from a model instead of passing from here
	            this.merchant = {};
	            _angular.$rootScope.$on('merchantDetails', function (event, data) {
	                _this.merchant = data;
	            });
	            function fetchJsButtonScript() {
	                var head = document.getElementsByTagName('head')[0];
	                if (!head) {
	                    return;
	                }
	                var script = document.createElement('script');
	                script.type = 'text/javascript';
	                script.async = true;
	                script.src = 'https://www.paypalobjects.com/api/button.js';
	                head.appendChild(script);
	            }
	            fetchJsButtonScript();
	            this.isOpenButton = _angular.$rootScope.isOpenButton;
	            this.isShoppingCart = _angular.$rootScope.isShoppingCart;
	            function setDirectionality() {
	                _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
	            }
	
	            this.$on('metadataChange', setDirectionality);
	            setDirectionality();
	        }
	    }
	});
	
	
	_angular.$document;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_index.$DeviceInfo;
	
	_angular.$rootScope;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/spinner/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', function () {
	
	        return {
	            scope: {},
	            template: template,
	            controller: function controller($scope, $element, $rootScope, $Api, $locale, $logger, $loader, $timeout) {
	
	                var $body = angular.element(document.getElementsByTagName('body'));
	                var $priorActiveElement = $();
	                var $capturedElement = $();
	                var $header = $('header');
	                var $slidingArea = $('#sliding-area');
	                var $footer = $('footer');
	
	                /**
	                 * This hides page content from any screen readers.
	                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
	                 *
	                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
	                 * At the very least, let's cache these selectors :|
	                 */
	                function hidePageContentFromScreenReader(toggle) {
	                    $header.attr('aria-disabled', toggle);
	                    $slidingArea.attr('aria-disabled', toggle);
	                    $footer.attr('aria-disabled', toggle);
	                }
	
	                function preventDefault(event) {
	                    event.preventDefault();
	                }
	
	                function captureFocus(event) {
	                    if (!$element.has(event.target).length) {
	                        $capturedElement = $(event.target);
	                    }
	                }
	
	                function setLoadingMessage(message) {
	                    if (angular.isObject(message)) {
	                        $scope.message = message.heading;
	                        $('#spinnerMessage').css('font-size', '17.5px');
	                        $('#spinnerMessage').html(message.heading);
	                        $('#spinnerSubHeading').html(message.subHeading);
	                    } else {
	                        $scope.message = message;
	                        $('#spinnerMessage').html(message);
	                    }
	                }
	
	                function showSpinner() {
	                    $scope.loading = true;
	                    $logger.info('show_loading_spinner');
	                    $body.addClass('loading');
	
	                    // remember what was previously focused
	                    $priorActiveElement = $(':focus');
	
	                    $(':input, a').blur();
	
	                    hidePageContentFromScreenReader(true);
	
	                    if ($loader.firstLoad()) {
	                        setLoadingMessage($locale.content.get('base.processing'));
	                    }
	
	                    // focus on the message so that screen readers will let the user know the page is loading
	                    $(document).on('keydown', preventDefault);
	                    $(document).on('focusin', captureFocus);
	                    $timeout(function () {
	                        $('#spinner-message').focus();
	                    });
	                }
	
	                function hideSpinner() {
	                    $scope.loading = false;
	                    $logger.info('hide_loading_spinner');
	                    $('#preloaderSpinner').hide();
	                    $body.removeClass('loading');
	                    $(document).off('keydown', preventDefault);
	                    $(document).off('focusin', captureFocus);
	
	                    hidePageContentFromScreenReader(false);
	
	                    // Focus captured element if focus was given to an element while spinner was active.
	                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
	                        $capturedElement.focus();
	                        // Focus element that had focus before if it is still within the document
	                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
	                        $priorActiveElement.focus();
	                    } else {
	                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
	                        // the element last clicked, rather than top of page.
	                        $slidingArea.focus();
	                    }
	                    $priorActiveElement = $();
	                    $capturedElement = $();
	                }
	
	                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
	                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);
	
	                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
	                    setLoadingMessage(text);
	                });
	
	                $scope.$on('$destroy', function () {
	                    hideSpinner();
	                    cancelStartLoad();
	                    cancelAllLoaded();
	                    cancelSetLoadingMessage();
	                });
	
	                if ($loader.isLoading()) {
	                    showSpinner();
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/merchant-header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/merchant-header/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-merchant-header.directive', ['squid', 'xomodel.checkout', 'xomodel.user']).directive('xoMerchantHeader', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                token: '=',
	                merchant: '='
	            },
	
	            controller: function controller($scope, $populate, $config, $CheckoutAppDataModel, $CheckoutInputDataModel) {
	                if ($config.flow !== 'shoppingcart' && !$CheckoutInputDataModel.instance($scope.token).isEbayTxn()) {
	                    // show the merchant header only for non-ebay flows
	                    $populate($scope, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                    }).then(function () {
	                        $scope.merchant = $scope.checkoutAppData.merchant;
	                    });
	                }
	            }
	        };
	    }).directive('xoMerchantImageResize', function () {
	        return {
	            restrict: 'A',
	
	            link: function link(scope, element, attributes) {
	                element.bind('load', function (event) {
	                    var maxWidth = 780;
	                    var maxHeight = 90;
	                    var height = 90;
	                    var ratio = 0;
	
	                    if (this.width > maxWidth) {
	                        ratio = maxWidth / this.width;
	                        this.width = maxWidth;
	                        height = this.height * ratio;
	                        this.height = height > maxHeight ? maxHeight : height;
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/merchant-header/template.html":
/***/ function(module, exports) {

	module.exports = "<header role=\"banner\">\n    <div id=\"header\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n             {{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ },

/***/ "./components/xo-page-components/src/header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-page-components/src/header/styles.less");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html"), __webpack_require__("./components/xo-page-components/src/cart/directive.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
	        return {
	            template: template,
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '=',
	                isUnbranded: '=',
	                unbrandedTitle: '=',
	                unbrandedSubTitle: '=',
	                languageSwitch: '=?',
	                redirectiframe: '=',
	                redirectLightbox: '='
	            },
	            controller: function controller($scope, $rootScope, $util, $renderContent) {
	                // $util.assert($scope.token, 'Expected token');
	                $scope.title = $renderContent($scope.unbrandedTitle);
	                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/header/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".paypalHeader .languageToggleDisplay{position:relative;bottom:0;clear:left;right:0;top:20px;margin-bottom:20px}.paypalHeader #langDropdownBlock{right:auto}@media (max-width:41.3125em){.paypalHeaderWrapper.langDropdown{margin-bottom:30px}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\" >{{title}}</span>\n        <div id=\"paypalLogo\" class=\"logo\" ng-if=\"!isUnbranded\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n\n        <xo-cart token=\"token\" show-cart-total=\"showCartTotal\" render-cart-container=\"renderCartContainer\"></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/cart/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html"), __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/cart_pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/ui.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/cartWrapper/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/itemDetails/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-cart.directive', ['squid', 'xomodel.checkout', 'xo-cart.pxp', 'xo-cart.ui', 'xo-cart.cart-wrapper.directive', 'xo-cart.item-details.directive', 'xo-accessibility.directive']).directive('xoCart', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '='
	            },
	            controller: function controller( // eslint-disable-line max-params
	            $scope, $populate, $rootScope, $util, $state, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $pxpCartAmt, $pxpCartDesc) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then($pxpCartDesc).then(function loadCartData(canShowCart) {
	
	                    var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
	                    var cartDesc = $scope.checkoutCart.get('purchase.description');
	                    $scope.note = $scope.checkoutCart.get('note');
	
	                    if (!canShowCart) {
	                        cartDesc = '';
	                    } else
	                        // resolve string in descriptions array since the only element may be `null`
	                        // TODO: fix backend to return a string, to avoid this conditional
	                        if (cartDesc && angular.isString(cartDesc[0])) {
	                            cartDesc = cartDesc[0];
	                        } else {
	                            cartDesc = '';
	                        }
	
	                    $scope.desc = cartDesc;
	                    $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
	                    $scope.showArrow = !$scope.checkoutAppData.flags.hide_cart_details && (cartDesc || $scope.hasItems || $scope.note);
	
	                    // add details to render to the checkoutCart items
	                    $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
	                        item.details = {};
	
	                        if (item.quantity > 1) {
	                            item.details.price = item.price.amount;
	                            item.details.quantity = item.quantity;
	                        }
	
	                        if (item.description) {
	                            if (!item.name) {
	                                item.name = item.description;
	                            } else {
	                                item.details.description = item.description;
	                            }
	                        }
	
	                        // move options to detail section
	                        if (item.item_option_selections) {
	                            item.details.hasSelections = true;
	                            item.details.item_option_selections = item.item_option_selections;
	                        }
	
	                        if (item.sku) {
	                            item.details.sku = item.sku;
	                        }
	
	                        item.hasDetails = Object.keys(item.details).length > 0;
	                        item.details.hasMore = item.hasDetails || item.details.hasSelections;
	                    });
	
	                    // Mapping of field name as recieved by API to corresponding property key
	                    $scope.amountHeaders = {
	                        'total': 'header.total',
	                        'subtotal': 'header.itemTotal',
	                        'tax': 'header.tax',
	                        'shipping': 'header.shipping',
	                        'insurance': 'header.insurance',
	                        'handling_fee': 'header.handling',
	                        'shipping_discount': 'header.shippingDiscount',
	                        'description': 'header.description',
	                        'discount': 'header.discount'
	                    };
	
	                    // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	                    // are not available and purchase amount is not zero.
	                    var userAction = $scope.userAction = $util.param('useraction');
	                    var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;
	
	                    return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                        $scope.showAmt = showAmount;
	                    });
	                }).then(function handleCartOpenClose() {
	                    // the cart is only automatically open under the following criteria:
	                    // 1. the cart has a 'note to buyer' ($scope.note is defined)
	                    // 2. the cart was not previously automatically opened before
	                    // 3. the state has transitioned to checkout.review or checkout.guest
	                    function decideShowCart(currentState) {
	                        if ($scope.note && !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState)) {
	                            $scope.openedAlready = true; // may have been undefined before
	                            return true;
	                        }
	
	                        return false;
	                    }
	
	                    $scope.showCartItem = function (breakdown) {
	                        return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
	                    };
	
	                    $scope.showCart = decideShowCart($state.current.name);
	
	                    // TODO: Must we really couple this so tightly with the state transition names?
	                    var openCartListener = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	                        $scope.showCart = decideShowCart(toState.name);
	                    });
	                    $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy
	
	                    $scope.toggleCart = function ($event) {
	                        $scope.showCart = !$scope.showCart;
	                        $event.preventDefault();
	                    };
	
	                    $scope.closeCart = function ($event) {
	                        $scope.showCart = false;
	                        // for accessible autofocus on cart toggle link button
	                        $scope.$broadcast('cart-closed');
	                        if ($event) {
	                            $event.preventDefault();
	                        }
	                    };
	
	                    $scope.$on('clickBody', function ($event, target) {
	                        if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
	                            $scope.closeCart($event);
	                            $scope.$apply();
	                        }
	                    });
	
	                    // this listener / broadcast allows accessibility components to scan and focus inside the cart
	                    // when the cart is displayed
	                    $scope.$watch('showCart', function (showCart) {
	                        if (showCart) {
	                            $scope.$broadcast('cart-updated');
	                        }
	                    });
	                }).then(function handleEllipsisIssues() {
	                    // NOTE: the scattered broadcasts of "cart-updated" events are mostly
	                    // to allow the accessibility directives modal-box and focus-when to
	                    // know when to recalculate keyboard behavior / focus
	                    $scope.toolongTracker = {};
	
	                    // this function is invoked by the onEllipsis directive that tracks
	                    // if the item name won't fit within the restricted space.
	                    $scope.toolong = function (idx) {
	                        $scope.toolongTracker[idx] = true;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.showMore = function (idx, type) {
	                        // there are 2 types of more, "floating" when the name is too long
	                        // and "inline" when the name can fit, but there are additional details.
	                        //
	                        // Show a more if the item
	                        // 1. has an expanded state
	                        // 2. is not already expanded
	                        // 3. if it is appropriate to show that type.
	                        var itemIsTooLong = $scope.toolongTracker[idx];
	                        var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';
	
	                        return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
	                    };
	
	                    $scope.expandedIndex = -1; // initially, none of the line items are expanded
	                    $scope.isExpanded = function isExpanded(idx) {
	                        return idx === $scope.expandedIndex;
	                    };
	                    $scope.hasExpandedState = function hasExpandedState(idx) {
	                        // A line item is exandable if
	                        // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
	                        // 2. there are details (attached to purchase.items in the cart)
	                        // 3. there is item number (sku) in the item
	                        var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
	                        var nameTooLong = $scope.toolongTracker[idx];
	                        return nameTooLong || item.hasDetails || item.sku;
	                    };
	                    $scope.expand = function expand(idx) {
	                        $scope.expandedIndex = idx;
	                        $scope.$broadcast('cart-updated');
	                    };
	                    $scope.collapse = function collapse() {
	                        $scope.expandedIndex = -1;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.$emit('dataLoaded');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/ui.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _decode_entities = __webpack_require__("./components/xo-page-components/src/cart/lib/decode_entities.js");
	
	var _decode_entities2 = _interopRequireDefault(_decode_entities);
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Register entity decoding filter in Angular
	_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);
	
	// if an element has an ellipsis text-overflow in effect (it must already have
	// the appropriate css styling) then invoke the function that is passed to the directive
	function getVisibleWidth(elem) {
	    var elemRect = elem.getBoundingClientRect();
	    // cross browser, returns decimals for ultra-precision
	    return elemRect.right - elemRect.left;
	}
	
	function getNaturalWidth(elem) {
	    var old = {
	        overflow: elem.style.overflow,
	        width: elem.style.width,
	        display: elem.style.display
	    };
	    var result;
	
	    elem.style.overflow = 'visible';
	    elem.style.width = 'auto';
	    elem.style.display = 'inline-block';
	    result = getVisibleWidth(elem);
	    elem.style.overflow = old.overflow;
	    elem.style.width = old.width;
	    elem.style.display = old.display;
	
	    return result;
	}
	
	// pre-determine approach to reading styles
	var getStyle = _angular.$window.getComputedStyle ?
	// modern browsers
	function (elem, style) {
	    return _angular.$window.getComputedStyle(elem)[style];
	} :
	// IE
	function (elem, style) {
	    return elem.currentStyle[style];
	};
	
	function hasEllipsis(elem) {
	    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
	    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
	    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';
	
	    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
	        return getVisibleWidth(elem) < getNaturalWidth(elem);
	    }
	
	    return false;
	}
	
	(0, _angular.$registerDirective)('onEllipsis', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function invokeSubscriber() {
	                (0, _angular.$parse)(attrs.onEllipsis)(scope);
	                scope.$apply();
	            }
	
	            (0, _angular.$timeout)(function () {
	                if (hasEllipsis(element[0])) {
	                    invokeSubscriber();
	                }
	            });
	        }
	
	    };
	});
	
	// Makes an element examine the outerHeight of its siblings
	// and the max-height of its parent, then sets a max-height for itself
	// so that everything fits within the limits of the parent. Note that it assumes
	// no other sibling also has dynamic-maxheight.
	(0, _angular.$registerDirective)('dynamicMaxheight', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function resizeContainer() {
	                var $element = (0, _jquery2['default'])(element);
	                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
	                var siblings = $element.siblings().filter(function () {
	                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');
	                    return pos !== 'fixed' && pos !== 'absolute';
	                }).map(function getOuterHeights() {
	                    return (0, _jquery2['default'])(this).outerHeight();
	                });
	                var siblingsHeight = 0;
	                var i;
	
	                for (i = 0; i < siblings.length; i += 1) {
	                    siblingsHeight += siblings[i];
	                }
	
	                var spaceAvailable = parentHeight - siblingsHeight;
	
	                if (!isNaN(spaceAvailable)) {
	                    $element.css('max-height', spaceAvailable + 'px');
	                }
	            }
	
	            // if an expression is provided, it is used as an event to listen for and recalculate the height
	            if (attrs.dynamicMaxheight) {
	                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
	            }
	
	            (0, _angular.$timeout)(resizeContainer);
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$filterProvider;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$window;

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/decode_entities.js":
/***/ function(module, exports) {

	
	
	/**
	 * Takes a string with HTML entities within and renders it as the unicode
	 * characters they represent. This is done by leveraging the browser to
	 * perform this transformation internally. InnerText is chosen as the output
	 * so as to kill any HTML itself that was supplied.
	 *
	 * @param {Element} element any HTML element supporting innerText and
	 * innerHTML. Preferably one not connected to the DOM or visible in any way.
	 * @param {String} input a String containing HTML entities that need to be
	 * decoded and HTML stripped.
	 * @return {String} the same string with HTML tags removed and entities
	 * decoded.
	 */
	
	exports.__esModule = true;
	exports.decodeEntities = decodeEntities;
	exports['default'] = decodeEntitiesAngularFilter;
	function decodeEntities(element, input) {
	    element.innerHTML = input;
	    return element.textContent || element.innerText;
	}
	
	function decodeEntitiesAngularFilter() {
	    // A constant key that can be used to find the element
	    var ENTITY_ELEM = '__xpc_entitydecoder__';
	
	    // Create the element if this is the first time this is called
	    if (!window[ENTITY_ELEM]) {
	        window[ENTITY_ELEM] = document.createElement('p');
	    }
	
	    // Retrieve the converter element rather than create one every
	    // time. Angular may call this filter many times repeatedly and
	    // we should make a small effort to optimize the process
	    var converter = window[ENTITY_ELEM];
	
	    /**
	     * Takes a string with HTML entities within and renders it as the unicode
	     * characters they represent. This is done by leveraging the browser to
	     * perform this transformation internally. InnerText is chosen as the output
	     * so as to kill any HTML itself that was supplied.
	     *
	     * @param {String} input a String containing HTML entities that need to be
	     * decoded and HTML stripped.
	     * @return {String} the same string with HTML tags removed and entities
	     * decoded.
	     */
	    return decodeEntities.bind(null, converter);
	}

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-label=\"{{ content('base.shoppingCart') }}\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\" token=\"token\"></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"expandedIndex === -1 ? 'a.more': 'a.less'\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h3 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h3>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <div dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <ul class=\"detail-items\" ng-if=\"hasItems\">\n                        <li ng-repeat=\"item in checkoutCart.purchase.items\" class=\"items\">\n\n                            <div class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                            </div>\n                            <span class=\"itemPrice\">\n                                <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                            </span>\n                            <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                        </li>\n                    </ul>\n\n                    <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                        <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                            <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                <span class=\"itemPrice\">\n                                    <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                </span>\n                            </li>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"showAmt && checkoutCart.purchase.amounts.total\">\n                    <span class=\"itemNameContainer\">{{ userAction === 'commit' || showCartTotal === true ? content('header.total') : content('header.subTotal') }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-cart.pxp', ['squid.pxp']).factory('$pxpCartAmt', function ($pxp, $q) {
	        return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
	
	            if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
	
	                var pageName = 'xo_hermes_no_line_item_details';
	                var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
	                var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';
	
	                return $q.all([$pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtBlacklistTreatment), $pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtTreatment)]).then(function (results) {
	                    var showAmtBlacklist = results[0];
	                    var showAmt = results[1];
	
	                    if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
	                        return true;
	                    }
	
	                    if (showAmt && showAmt.treatment_name === showAmtTreatment) {
	                        return true;
	                    }
	
	                    return false; // default to hide
	                });
	            }
	
	            return $q.when(!noLineItemDetails && isPurchase);
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/cart/lib", "components/xo-page-components/src/cart/lib/pxp.js"))

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/cart_pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$pxpCartDesc = $pxpCartDesc;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function $pxpCartDesc() {
	    // ask if the show desc treatment is present
	    return (0, _squid.$pxp)('xo_hermesnodeweb_all_cart_DESC_v1', 'xo_hermesnodeweb_all_cart_DESC_Treatment').then(function (result) {
	        return !!result;
	    });
	}
	
	angular.value("$pxpCartDesc", $pxpCartDesc);
	_squid.$pxp;

/***/ },

/***/ "./components/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.cart-wrapper.directive', ['squid', 'xomodel.checkout']).directive('cartWrapper', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showAmt: '=',
	                showArrow: '=',
	                token: '='
	            },
	            controller: function controller($scope, $populate, $util, $CheckoutCartModel) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html":
/***/ function(module, exports) {

	module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt\">\n            <format-currency class=\"formatCurrency\" code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                             amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow && checkoutCart.purchase.items\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>"

/***/ },

/***/ "./components/xo-page-components/src/cart/itemDetails/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.item-details.directive', ['squid', 'xo-accessibility.directive']).directive('itemDetails', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                details: '=',
	                sku: '=',
	                currencyCode: '=',
	                onClickLess: '&'
	            },
	            controller: function controller() {/* dumb component */}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html":
/***/ function(module, exports) {

	module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} {{ details.quantity }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"!details.description && !details.item_option_selections\"\n      ng-click=\"onClickLess()\">{{ content('header.less') }}</a></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> {{ details.description }}\n    </div>\n    <a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n  </li>\n</ul>\n"

/***/ },

/***/ "./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                redirectiframe: '=',
	                redirectLightbox: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger, $ReturnToMerchant) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;
	
	                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
	                    $scope.isIFrame = $util.isIFrame();
	
	                    $scope.closeFrame = function (event) {
	                        event.preventDefault();
	                        event.stopPropagation();
	
	                        if (window.paypalCheckout) {
	                            if (window.paypalCheckout.props.onPaymentCancel) {
	                                return window.paypalCheckout.props.onPaymentCancel({
	                                    token: $scope.token,
	                                    cancelUrl: cancel_url
	                                });
	                            } else {
	                                return window.paypalCheckout.close();
	                            }
	                        }
	
	                        if ($scope.redirectLightbox) {
	                            var result = $ReturnToMerchant.postToMerchant({
	                                operation: 'return_to_merchant',
	                                returnUrl: cancel_url,
	                                updateParent: true
	                            });
	
	                            // Otherwise we have no choice but to return to the merchant
	                            if (!result) {
	                                $util.redirect(cancel_url);
	                            }
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else if ($scope.redirectiframe) {
	                            $window.location.replace(cancel_url);
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else {
	
	                            var iFrameFlow = $injector.get('$IFrameFlow');
	
	                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
	                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
	                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');
	
	                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');
	
	                            if ($scope.auth && $scope.auth.code) {
	                                url += '&code=' + $scope.auth.code;
	                            }
	
	                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
	                        }
	                        $scope.$emit('exitFrame');
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ function(module, exports) {

	module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ },

/***/ "./components/xo-page-components/src/shopping-cart-footer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-form-components/src/language-options/directive.js");
	
	__webpack_require__("./components/xo-models/src/user/index.js");
	
	var _template = __webpack_require__("./components/xo-page-components/src/shopping-cart-footer/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _opinionlab = __webpack_require__("./components/xo-page-components/src/footer/opinionlab.js");
	
	var _opinionlab2 = _interopRequireDefault(_opinionlab);
	
	var _footerMap = __webpack_require__("./components/xo-page-components/src/footer/footerMap.js");
	
	var _footerMap2 = _interopRequireDefault(_footerMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoShoppingCartFooter', {
	    tag: 'xo-shopping-cart-footer',
	    template: _template2['default'],
	
	    props: {
	        languageSwitch: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {}
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            this.year = new Date().getFullYear();
	            this.isApac = function () {
	                return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf(this.locale.country) > -1;
	            };
	            // Determine if country belongs to a region to serve correct footer links
	            var getRegion = function getRegion(country) {
	                var regions = _squid.$config.regions;
	                for (var region in regions) {
	                    if (regions[region].indexOf(country) > -1) {
	                        return region;
	                    }
	                }
	
	                return false;
	            };
	            this.footerLinks = function () {
	                if (this.isApac()) {
	                    return _footerMap2['default'].APAC;
	                }
	
	                return _footerMap2['default'][this.locale.country] || _footerMap2['default'][getRegion(this.locale.country)] || _footerMap2['default'].DEFAULT;
	            };
	
	            this.showPolicyInfo = function () {
	                return this.isApac() || this.locale.country === 'AU';
	            };
	
	            var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, config) {
	                this.popupUrl = config && config.popupUrl;
	                this.show = true;
	                this.$digest(); // eslint-disable-line angular/ng_no_digest
	            });
	
	            this.$on('$destroy', cancelShowModal);
	
	            this.showOL = function showOL(event) {
	                event.preventDefault();
	
	                var placeholder = 'main:ec:hermes';
	                var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
	
	                var data = {
	                    opVars: {
	                        rlogId: _angular.$window.meta.rlogId || '',
	                        page: page || window.location.hash,
	                        csci: 'Unknown',
	                        calc: _angular.$window.meta.correlationId,
	                        custId: 'Unknown',
	                        merchantId: 'Unknown',
	                        token: this.token || 'Unknown'
	                    },
	                    locale: {
	                        country: _squid.$locale.country,
	                        languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
	                    }
	                };
	
	                (0, _opinionlab2['default'])(data);
	            };
	
	            this.showFeedback = function () {
	                if (_index.$DeviceInfo.isDevice()) {
	                    return false;
	                }
	                return true;
	            };
	        }
	    }
	});
	
	
	_angular.$rootScope;
	
	_angular.$window;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$config;
	
	_uiRouter.$state;
	
	_index.$DeviceInfo;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-page-components/src/shopping-cart-footer/template.html":
/***/ function(module, exports) {

	module.exports = "<shopping-cart-footer content>\n    <div class=\"footer clearfix commonFooter\" role=\"contentinfo\" ng-class=\"{APAC: isApac()}\">\n        <div class=\"poweredBy\">\n            <div class=\"text\">{{ content('shoppingCart.poweredBy')}}</div>\n            <span class=\"paypalHeaderWrapper\">\n                <span id=\"paypalLogo\" class=\"logo\">\n                    <span class=\"accessAid\">{{ content('base.payPal') }}</span>\n                </span>\n            </span>\n        </div>\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\">\n                <li class=\"first\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\" ng-repeat=\"link in footerLinks()\"\n                    id=\"footer_{{link.id}}\"></li>\n                <li class=\"feedback last\">\n                    <a ng-if=\"showFeedback()\" href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('OpinionLab.SiteFeedback')\n                        }}</a>\n                </li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options ng-if=\"languageSwitch\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n    </div>\n    <xo-modal>\n        <p>{{ content('footer.openLinks') }}</p>\n        <p class=\"popLink\">{{popupUrl}}</p>\n        <input class=\"btn btn-submit full\" type=\"button\" ng-click=\"hideModal()\" value=\"{{ content('footer.okBtn') }}\">\n    </xo-modal>\n</shopping-cart-footer>\n"

/***/ },

/***/ "./components/xo-ui-components/src/error-tooltip/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angularAria = __webpack_require__("./components/angular-aria/angular-aria.min.js");
	
	// Configure angular aria.
	// Note that aria configuration applies globally
	_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
	    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
	    bindRoleForClick: false,
	
	    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
	    // These attributes should only be set once the form is submitted, to match what
	    // visually what we display
	    ariaInvalid: false,
	    ariaRequired: false
	});
	
	(0, _angular.$registerDirective)('xo-error-tooltip', function () {
	
	    return {
	        restrict: 'A',
	        require: ['?^form', '?ngModel'],
	        link: function link(scope, element, attrs, ctrls) {
	            var formCtrl = ctrls[0],
	                modelCtrl = ctrls[1];
	
	
	            function shouldBeRequired() {
	                if (formCtrl) {
	                    // If input is a checkbox and has error-text, show the error text instead of the required text.
	                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && attrs.errorText);
	                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
	                } else {
	                    return modelCtrl.$error.required;
	                }
	            }
	
	            function shouldBeInvalid() {
	                if (formCtrl) {
	                    return formCtrl.$submitted && modelCtrl.$invalid;
	                } else {
	                    return modelCtrl.$invalid;
	                }
	            }
	
	            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
	            function formatSpaceSplitString(str, id, add) {
	                var strArray;
	                if (str) {
	                    strArray = str.split(' ');
	                } else {
	                    strArray = [];
	                }
	
	                var idIndex = strArray.indexOf(id);
	
	                if (~idIndex && !add) {
	                    strArray.splice(idIndex, 1);
	                } else if (!~idIndex && add) {
	                    strArray.push(id);
	                }
	
	                return strArray.join(' ');
	            }
	
	            // Add tooltip behavior after DOM settles
	            (0, _angular.$timeout)(function () {
	                var generateId = function generateId() {
	                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	                };
	
	                var requiredId = generateId();
	                var invalidId = generateId();
	                var requiredError;
	                var invalidError;
	
	                if (attrs.errorText) {
	                    element.addClass('hasErrorTooltipRuleSpecific');
	                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
	                    element.after(invalidError);
	                }
	
	                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
	                    element.addClass('hasErrorTooltipRequired');
	                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
	                    element.after(requiredError);
	
	                    element.removeAttr('aria-required');
	                }
	
	                function setAriaAttributes() {
	                    var addTooltips = {
	                        required: false,
	                        invalid: false
	                    };
	
	                    // Do not associate "Required" error with aria-describedby
	                    // because this should already be read out either by "required"
	                    // attribute or "aria-required"=true, and only associate "Invalid"
	                    // error if "Required" is not showing to match visuals
	                    if (shouldBeRequired()) {
	                        addTooltips.required = true;
	                    } else if (shouldBeInvalid()) {
	                        addTooltips.invalid = true;
	                    }
	
	                    var describedby = element.attr('aria-describedby');
	                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
	                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
	                    element.attr('aria-describedby', describedby);
	                }
	
	                scope.$watch(shouldBeRequired, function (newVal) {
	                    setAriaAttributes();
	                });
	                scope.$watch(shouldBeInvalid, function (newVal) {
	                    element.attr('aria-invalid', newVal);
	                    setAriaAttributes();
	                });
	
	                // Set scroll so that the error message is in view when element receives focus
	                element.on('focus', function (event) {
	                    var windowBot = $(window).scrollTop() + $(window).height();
	                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
	                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;
	                    if (windowBot < Math.max(requiredBot, invalidBot)) {
	                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
	                    }
	                });
	            });
	        }
	    };
	});
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$compile;
	
	_angular.$timeout;
	
	_angularAria.$ariaProvider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-validation/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	    squid.module('xo-validation.directive', ['squid']).directive('xoValidation', function () {
	        return {
	            template: '',
	            restrict: 'A',
	            require: 'ngModel',
	
	            link: function link(scope, elem, attr, ngModel) {
	
	                var validationUtil = {
	
	                    // because IE8 doesnt have String.prototype.trim()
	                    trim: function trim(value) {
	                        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	                        return value.replace(rtrim, '');
	                    },
	
	                    /**
	                     * Generic function that runs a given input against
	                     * a given regular expression
	                     *
	                     * @param {String} value input to test
	                     * @param {String/RegExp} regex Regular expression to test against
	                     * @returns {Boolean} matches or does not match given pattern
	                     */
	                    valid: function valid(value, regex) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        if (angular.isString(regex)) {
	                            regex = new RegExp(regex);
	                        }
	
	                        return regex ? regex.test(value) : true;
	                    },
	
	                    // returns whether empty or not
	                    empty: function empty(value) {
	                        if (!value) {
	                            return true;
	                        }
	
	                        // IE8 and below doesn't have native .trim()
	                        return !this.trim(value);
	                    },
	
	                    // returns whether alphabetic or not
	                    alphabetic: function alphabetic(value) {
	                        return this.valid(value, /[A-Za-z]+$/);
	                    },
	
	                    // returns whether numeric or not
	                    numeric: function numeric(value) {
	                        var NUMERIC_REGEX = new RegExp('^[0-9]+$');
	
	                        return this.valid(value, NUMERIC_REGEX);
	                    },
	
	                    validBankAccount: function validBankAccount(value) {
	                        if (!scope.showIBAN) {
	                            return this.numeric(value);
	                        }
	
	                        return true;
	                    },
	
	                    validRouting: function validRouting(value) {
	                        if (!scope.showIBAN) {
	                            return this.valid(value, /^\d{8}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCode: function validIBANCode(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBAN: function validIBAN(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^DE\d{20}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCountry: function validIBANCountry(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
	                    },
	
	                    // first two letters are the country code the rest are the bank account numbers max length 32
	                    validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
	                    },
	
	                    validLast4: function validLast4(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex
	                        return this.valid(value, LAST_4);
	                    },
	
	                    validStreet: function validStreet(value) {
	                        return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
	                    },
	
	                    // Validating phone format with metadata from griffin
	                    validPhone: function validPhone(value) {
	                        var regex = scope.pattern;
	                        /*
	                         * User can enter phone format in various manner according to griffin mask
	                         * (00) 0000-0000
	                         * 00 000 0000
	                         * Since the griffin pattern only validates against numbers, need to trim the input
	                         * to only validate the numbers
	                         */
	                        value = value && value.replace(/[^0-9]/gi, '');
	                        return this.valid(value, regex);
	                    },
	
	                    validDobYear: function validDobYear(value) {
	                        return value !== 'YYYY';
	                    },
	
	                    validDobDay: function validDobDay(value) {
	                        return value !== 'DD';
	                    },
	
	                    validDobMonth: function validDobMonth(value) {
	                        return value !== 'MM';
	                    },
	
	                    validPoBox: function validPoBox(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex
	
	                        if (boxRE.test(value)) {
	                            return true;
	                        }
	                        return false;
	                    },
	
	                    validAddressSansPoBox: function validAddressSansPoBox(value) {
	                        var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
	                        var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;
	
	                        if (boxRE.test(value) || cassRE.test(value)) {
	                            return false;
	                        }
	                        return true;
	                    },
	
	                    validEmailOrPhone: function validEmailOrPhone(value) {
	                        if (!value) {
	                            return false;
	                        }
	
	                        return this.validEmail(value) || this.validPhone(value);
	                    },
	
	                    validEmail: function validEmail(value) {
	                        if (!value) {
	                            return false;
	                        }
	                        var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line
	
	                        return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
	                    },
	
	                    highAscii: function highAscii(value) {
	                        var trimmedValue = this.trim(value);
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex
	
	                        return this.valid(trimmedValue, HIGH_ASCII_REGEX);
	                    },
	
	                    // expected format: MM/DD/YYYY
	                    validDate: function validDate(value) {
	                        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
	                        var dArr = value.split('/');
	                        var d = new Date(value);
	                        var isValid = false;
	
	                        if (re.test(value)) {
	                            isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
	                        }
	
	                        return isValid;
	                    },
	
	                    /* Expects value and state. state can be "past" or "future".
	                     NOTE: This function validates only month and year, not day!
	                     Please use validDate() if you need to validate the whole date. */
	                    validDateWithoutDay: function validDateWithoutDay(value, options) {
	                        var state = options.state;
	
	                        value = value.replace(/\s/g, '');
	
	                        if (value === '') {
	                            return true;
	                        }
	
	                        var split = value.split('/');
	                        var month = split[0];
	                        var year = split[1];
	                        var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
	                        var validYear = true;
	                        var validMonth = true;
	
	                        if (value.length < 5) {
	                            return false;
	                        }
	
	                        if (this.validDobMonth(month)) {
	                            month = parseInt(month, 10);
	                        } else {
	                            return false;
	                        }
	
	                        year = parseInt(year, 10);
	
	                        if (state === 'past') {
	                            validYear = year <= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month <= currentMonth;
	                            }
	                        } else if (state === 'future') {
	                            validYear = year >= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month >= currentMonth;
	                            }
	                        }
	
	                        if (!validYear || !validMonth) {
	                            return false;
	                        }
	
	                        return true;
	                    },
	
	                    // formats to MM/DD/YYYY
	                    mmddyyyy: function mmddyyyy(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
	                    },
	
	                    // formats to YY-MMM-DDDD
	                    yyyymmdd: function yyyymmdd(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
	                    },
	
	                    // pads a number to two digits
	                    twoDigits: function twoDigits(value) {
	                        return value < 10 ? '0' + value : '' + value;
	                    },
	
	                    // expects YYYY-MM-DD
	                    legalAge: function legalAge(value) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        var dateParts = value.split('-'); // expecting YYYY-MM-DD
	                        var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
	                        var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
	                        var validBD = new Date(new Date() - 18 * yr);
	
	                        return validBD >= birthDate;
	                    },
	
	                    validZip: function validZip(value, options) {
	
	                        var postalCodeRegex = {
	                            // TODO: Once this is removed from the xo-add-address template, we can remove it...
	                            'GB': /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
	                            /*
	                             * Note: These are "nice to have".
	                             * Once we add support for these countries, we can remove these.
	                             */
	                            'BA': /^\d{5}$/,
	                            'CY': /^\d{4}$/,
	                            'EE': /^\d{5}$/,
	                            'HR': /^\d{5}$/,
	                            'LU': /^\d{4}$/,
	                            'LV': /^\d{4}$/,
	                            'MT': /^\d{3,4}$/,
	                            'SI': /^\d{4}$/,
	                            'SK': /^[0-9]{3}[\s][0-9]{2}$/,
	                            'NZ': /^\d{4}$/,
	                            'LT': /^\d{5}$/,
	                            'BG': /^\d{4}$/,
	                            'CZ': /^\d{5}$/,
	                            'GR': /^\d{3}[\s]\d{2}$/,
	                            'HU': /^\d{4}$/,
	                            'MX': /^\d{5}$/
	                        };
	
	                        var country = options && options.country;
	                        var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
	                        var isRequired = scope.zipEntry && scope.zipEntry.required;
	
	                        if (!isRequired && this.empty(value)) {
	                            return true;
	                        }
	
	                        // If there is no regex, or it's not populated yet...
	                        if (!regex || angular.isString(regex) && regex.indexOf('validationPattern') > -1) {
	                            return !this.empty(value);
	                        }
	
	                        value = value && value.toUpperCase();
	
	                        return this.valid(value, regex);
	                    },
	
	                    validExpiry: function validExpiry(value, options) {
	                        var $monthEl = $('[ng-model="card.expiry_month"]');
	                        var $yearEl = $('[ng-model="card.expiry_year"]');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	                        var isValid = false;
	                        var monthElName = 'card.expiry_month';
	                        var yearElName = 'card.expiry_year';
	                        var cardType = options.cardType;
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        if (month && year) {
	                            isValid = this.validExpires(month, year);
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	                        var monthFieldName = monthElName;
	                        var yearFieldName = yearElName;
	
	                        if (monthFieldName.indexOf('.') !== -1) {
	                            monthFieldName = monthFieldName.split('.')[1];
	                        }
	
	                        if (yearFieldName.indexOf('.') !== -1) {
	                            yearFieldName = yearFieldName.split('.')[1];
	                        }
	
	                        var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
	                            isValid = true;
	                        }
	
	                        if (form) {
	                            form[monthFieldName].$setValidity('validExpiry', isValid);
	                            form[yearFieldName].$setValidity('validExpiry', isValid);
	                        }
	
	                        return isValid;
	                    },
	
	                    validExpires: function validExpires(month, year) {
	                        var date = new Date();
	                        var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth;
	
	                        if (year < currentYear) {
	                            return false;
	                        } else if (year > currentYear) {
	                            return this.validDobMonth(month);
	                        }
	
	                        // account for display date vs. system date
	                        currentMonth = date.getMonth() + 1;
	                        return this.validDobMonth(month) && month >= currentMonth;
	                    },
	
	                    startDate: function startDate(value, options) {
	                        var valueOptions = {
	                            cardType: scope.card.type
	                        };
	                        valueOptions[elem.attr('id')] = value;
	
	                        return this.setStartDateValidity(valueOptions);
	                    },
	
	                    setExpiryValidity: function setExpiryValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '',
	                            expiryValidity = this.validExpiry(null, {
	                            cardType: cardType
	                        });
	
	                        return expiryValidity;
	                    },
	
	                    // start date validation for Maestro card
	                    setStartDateValidity: function setStartDateValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '';
	                        var startDateValidity = true;
	                        var $monthEl = $('#startmonth');
	                        var $yearEl = $('#startyear');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	
	                        if (cardType === 'MAESTRO') {
	                            if (!month || !year) {
	                                startDateValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id'),
	                            form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.startmonth.$setValidity('startDate', startDateValidity);
	                            form.startyear.$setValidity('startDate', startDateValidity);
	                        }
	
	                        return startDateValidity;
	                    },
	
	                    dobField: function dobField(value, options) {
	                        var valueOptions = {};
	                        var fieldMap = {
	                            'dobDayCC': 'day',
	                            'dobMonthCC': 'month',
	                            'dobYearCC': 'year'
	                        };
	
	                        valueOptions.cardType = scope.card.type;
	                        valueOptions[fieldMap[elem.attr('id')]] = value;
	
	                        return this.setDOBValidity(valueOptions);
	                    },
	
	                    setDOBValidity: function setDOBValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        var dobValidity = true;
	
	                        var $monthEl = $('#dobMonthCC');
	                        var $dayEl = $('#dobDayCC');
	                        var $yearEl = $('#dobYearCC');
	
	                        var month = options.month || $monthEl.val();
	                        var year = options.year || $yearEl.val();
	                        var day = options.day || $dayEl.val();
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (day) {
	                            day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        var cardType = options.cardType;
	                        if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
	                            if (!month || !year || !day) {
	                                dobValidity = false;
	                                // invalidate if < 18 y/o.
	                            } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
	                                dobValidity = false;
	                            } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
	                                dobValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.dobMonthCC.$setValidity('dobField', dobValidity);
	                            form.dobDayCC.$setValidity('dobField', dobValidity);
	                            form.dobYearCC.$setValidity('dobField', dobValidity);
	                        }
	
	                        return dobValidity;
	                    },
	
	                    validName: function validName(value) {
	                        return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
	                        // ' this comment is to un-confuse editors on synax coloring because of the single quote above
	                    },
	
	                    isChecked: function isChecked(value, options) {
	                        // $.is does not exist in $
	                        // eslint-disable-line angular/ng_angularelement
	                        var $el = $(options.el);
	
	                        return $el.is(':checked');
	                    },
	
	                    validRUPassport: function validRUPassport(value, options) {
	                        if (scope.user.countryOfResidence === 'RU') {
	                            return this.valid(value, /^\d{10}$/);
	                        }
	                        return true;
	                    }
	                };
	
	                var customValidator = function customValidator(value) {
	                    var ruleJson = angular.fromJson(elem.attr('xo-validation'));
	                    var validator = ruleJson.validator;
	                    var options = ruleJson.options;
	
	                    ngModel.$setValidity(validator, validationUtil[validator](value, options));
	
	                    return value;
	                };
	
	                ngModel.$parsers.unshift(customValidator);
	                ngModel.$formatters.unshift(customValidator);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-checkout/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"outerWrapper\" ng-class=\"{'shopping-cart-container': isShoppingCart, 'buy-now-container': isOpenButton}\" ng-class=\"[locale.country, locale.lang, '', isApp?'mobileApp':'']\" id=\"outerWrapper\" >\n    <xo-merchant-header merchant=\"merchant\" role=\"heading\" aria-level=\"1\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"sliding-area\" tabindex=\"-1\">\n            <div id=\"main\">\n                <div id=\"contents\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <xo-footer ng-if=\"isOpenButton\"></xo-footer>\n    <xo-shopping-cart-footer ng-if=\"isShoppingCart\"></xo-shopping-cart-footer>\n</div>\n"

/***/ },

/***/ "../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js":
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }

});


// WEBPACK FOOTER //
// js/main.js